"use strict";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n14 = 0, F = function F() {}; return { s: F, n: function n() { return _n14 >= r.length ? { done: !0 } : { done: !1, value: r[_n14++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(self.webpackChunkgttsgk = self.webpackChunkgttsgk || []).push([[792], {
  808: function _(hi, xg, kg) {
    var _Be, _Class3;
    function ra(e, t, n, r, o, i, s) {
      try {
        var a = e[i](s),
          u = a.value;
      } catch (c) {
        return void n(c);
      }
      a.done ? t(u) : Promise.resolve(u).then(r, o);
    }
    function ol(e, t) {
      return Object.is(e, t);
    }
    var Se = null,
      pi = !1,
      il = 1;
    var Fe = Symbol("SIGNAL");
    function B(e) {
      var t = Se;
      return Se = e, t;
    }
    var Qr = {
      version: 0,
      lastCleanEpoch: 0,
      dirty: !1,
      producerNode: void 0,
      producerLastReadVersion: void 0,
      producerIndexOfThis: void 0,
      nextProducerIndex: 0,
      liveConsumerNode: void 0,
      liveConsumerIndexOfThis: void 0,
      consumerAllowSignalWrites: !1,
      consumerIsAlwaysLive: !1,
      kind: "unknown",
      producerMustRecompute: function producerMustRecompute() {
        return !1;
      },
      producerRecomputeValue: function producerRecomputeValue() {},
      consumerMarkedDirty: function consumerMarkedDirty() {},
      consumerOnSignalRead: function consumerOnSignalRead() {}
    };
    function gi(e) {
      if (pi) throw new Error("");
      if (null === Se) return;
      Se.consumerOnSignalRead(e);
      var t = Se.nextProducerIndex++;
      ua(Se), t < Se.producerNode.length && Se.producerNode[t] !== e && yi(Se) && aa(Se.producerNode[t], Se.producerIndexOfThis[t]), Se.producerNode[t] !== e && (Se.producerNode[t] = e, Se.producerIndexOfThis[t] = yi(Se) ? Fg(e, Se, t) : 0), Se.producerLastReadVersion[t] = e.version;
    }
    function mi(e) {
      if ((!yi(e) || e.dirty) && (e.dirty || e.lastCleanEpoch !== il)) {
        if (!e.producerMustRecompute(e) && !ia(e)) return void oa(e);
        e.producerRecomputeValue(e), oa(e);
      }
    }
    function Og(e) {
      if (void 0 === e.liveConsumerNode) return;
      var t = pi;
      pi = !0;
      try {
        var _iterator = _createForOfIteratorHelper(e.liveConsumerNode),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var n = _step.value;
            n.dirty || qM(n);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } finally {
        pi = t;
      }
    }
    function Pg() {
      var _Se;
      return !1 !== ((_Se = Se) === null || _Se === void 0 ? void 0 : _Se.consumerAllowSignalWrites);
    }
    function qM(e) {
      var _e$consumerMarkedDirt;
      e.dirty = !0, Og(e), (_e$consumerMarkedDirt = e.consumerMarkedDirty) === null || _e$consumerMarkedDirt === void 0 ? void 0 : _e$consumerMarkedDirt.call(e, e);
    }
    function oa(e) {
      e.dirty = !1, e.lastCleanEpoch = il;
    }
    function Yr(e) {
      return e && (e.nextProducerIndex = 0), B(e);
    }
    function vi(e, t) {
      if (B(t), e && void 0 !== e.producerNode && void 0 !== e.producerIndexOfThis && void 0 !== e.producerLastReadVersion) {
        if (yi(e)) for (var n = e.nextProducerIndex; n < e.producerNode.length; n++) aa(e.producerNode[n], e.producerIndexOfThis[n]);
        for (; e.producerNode.length > e.nextProducerIndex;) e.producerNode.pop(), e.producerLastReadVersion.pop(), e.producerIndexOfThis.pop();
      }
    }
    function ia(e) {
      ua(e);
      for (var t = 0; t < e.producerNode.length; t++) {
        var n = e.producerNode[t],
          r = e.producerLastReadVersion[t];
        if (r !== n.version || (mi(n), r !== n.version)) return !0;
      }
      return !1;
    }
    function sa(e) {
      if (ua(e), yi(e)) for (var t = 0; t < e.producerNode.length; t++) aa(e.producerNode[t], e.producerIndexOfThis[t]);
      e.producerNode.length = e.producerLastReadVersion.length = e.producerIndexOfThis.length = 0, e.liveConsumerNode && (e.liveConsumerNode.length = e.liveConsumerIndexOfThis.length = 0);
    }
    function Fg(e, t, n) {
      if (Lg(e), 0 === e.liveConsumerNode.length && jg(e)) for (var r = 0; r < e.producerNode.length; r++) e.producerIndexOfThis[r] = Fg(e.producerNode[r], e, r);
      return e.liveConsumerIndexOfThis.push(n), e.liveConsumerNode.push(t) - 1;
    }
    function aa(e, t) {
      if (Lg(e), 1 === e.liveConsumerNode.length && jg(e)) for (var r = 0; r < e.producerNode.length; r++) aa(e.producerNode[r], e.producerIndexOfThis[r]);
      var n = e.liveConsumerNode.length - 1;
      if (e.liveConsumerNode[t] = e.liveConsumerNode[n], e.liveConsumerIndexOfThis[t] = e.liveConsumerIndexOfThis[n], e.liveConsumerNode.length--, e.liveConsumerIndexOfThis.length--, t < e.liveConsumerNode.length) {
        var _r2 = e.liveConsumerIndexOfThis[t],
          o = e.liveConsumerNode[t];
        ua(o), o.producerIndexOfThis[_r2] = t;
      }
    }
    function yi(e) {
      var _e$liveConsumerNode$l, _e$liveConsumerNode;
      return e.consumerIsAlwaysLive || ((_e$liveConsumerNode$l = e === null || e === void 0 || (_e$liveConsumerNode = e.liveConsumerNode) === null || _e$liveConsumerNode === void 0 ? void 0 : _e$liveConsumerNode.length) !== null && _e$liveConsumerNode$l !== void 0 ? _e$liveConsumerNode$l : 0) > 0;
    }
    function ua(e) {
      var _e$producerNode, _e$producerIndexOfThi, _e$producerLastReadVe;
      (_e$producerNode = e.producerNode) !== null && _e$producerNode !== void 0 ? _e$producerNode : e.producerNode = [], (_e$producerIndexOfThi = e.producerIndexOfThis) !== null && _e$producerIndexOfThi !== void 0 ? _e$producerIndexOfThi : e.producerIndexOfThis = [], (_e$producerLastReadVe = e.producerLastReadVersion) !== null && _e$producerLastReadVe !== void 0 ? _e$producerLastReadVe : e.producerLastReadVersion = [];
    }
    function Lg(e) {
      var _e$liveConsumerNode2, _e$liveConsumerIndexO;
      (_e$liveConsumerNode2 = e.liveConsumerNode) !== null && _e$liveConsumerNode2 !== void 0 ? _e$liveConsumerNode2 : e.liveConsumerNode = [], (_e$liveConsumerIndexO = e.liveConsumerIndexOfThis) !== null && _e$liveConsumerIndexO !== void 0 ? _e$liveConsumerIndexO : e.liveConsumerIndexOfThis = [];
    }
    function jg(e) {
      return void 0 !== e.producerNode;
    }
    var ur = Symbol("UNSET"),
      Jr = Symbol("COMPUTING"),
      jn = Symbol("ERRORED"),
      WM = _objectSpread(_objectSpread({}, Qr), {}, {
        value: ur,
        dirty: !0,
        error: null,
        equal: ol,
        kind: "computed",
        producerMustRecompute: function producerMustRecompute(e) {
          return e.value === ur || e.value === Jr;
        },
        producerRecomputeValue: function producerRecomputeValue(e) {
          if (e.value === Jr) throw new Error("Detected cycle in computations.");
          var t = e.value;
          e.value = Jr;
          var n = Yr(e);
          var r,
            o = !1;
          try {
            r = e.computation(), B(null), o = t !== ur && t !== jn && r !== jn && e.equal(t, r);
          } catch (i) {
            r = jn, e.error = i;
          } finally {
            vi(e, n);
          }
          o ? e.value = t : (e.value = r, e.version++);
        }
      });
    var Vg = function ZM() {
      throw new Error();
    };
    function Bg(e) {
      Vg(e);
    }
    function la(e, t) {
      Pg() || Bg(e), e.equal(e.value, t) || (e.value = t, function JM(e) {
        e.version++, function zM() {
          il++;
        }(), Og(e);
      }(e));
    }
    var al = _objectSpread(_objectSpread({}, Qr), {}, {
      equal: ol,
      value: void 0,
      kind: "signal"
    });
    var ul;
    function da() {
      return ul;
    }
    function Vn(e) {
      var t = ul;
      return ul = e, t;
    }
    var cl = Symbol("NotFound");
    function J(e) {
      return "function" == typeof e;
    }
    function ll(e) {
      var n = e(function (r) {
        Error.call(r), r.stack = new Error().stack;
      });
      return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
    }
    Error;
    var dl = ll(function (e) {
      return function (n) {
        e(this), this.message = n ? "".concat(n.length, " errors occurred during unsubscription:\n").concat(n.map(function (r, o) {
          return "".concat(o + 1, ") ").concat(r.toString());
        }).join("\n  ")) : "", this.name = "UnsubscriptionError", this.errors = n;
      };
    });
    function fl(e, t) {
      if (e) {
        var n = e.indexOf(t);
        0 <= n && e.splice(n, 1);
      }
    }
    var He = /*#__PURE__*/function () {
      function He(t) {
        _classCallCheck(this, He);
        this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
      }
      return _createClass(He, [{
        key: "unsubscribe",
        value: function unsubscribe() {
          var t;
          if (!this.closed) {
            this.closed = !0;
            var n = this._parentage;
            if (n) if (this._parentage = null, Array.isArray(n)) {
              var _iterator2 = _createForOfIteratorHelper(n),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var i = _step2.value;
                  i.remove(this);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else n.remove(this);
            var r = this.initialTeardown;
            if (J(r)) try {
              r();
            } catch (i) {
              t = i instanceof dl ? i.errors : [i];
            }
            var o = this._finalizers;
            if (o) {
              this._finalizers = null;
              var _iterator3 = _createForOfIteratorHelper(o),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _i = _step3.value;
                  try {
                    qg(_i);
                  } catch (s) {
                    t = t !== null && t !== void 0 ? t : [], s instanceof dl ? t = [].concat(_toConsumableArray(t), _toConsumableArray(s.errors)) : t.push(s);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
            if (t) throw new dl(t);
          }
        }
      }, {
        key: "add",
        value: function add(t) {
          var n;
          if (t && t !== this) if (this.closed) qg(t);else {
            if (t instanceof He) {
              if (t.closed || t._hasParent(this)) return;
              t._addParent(this);
            }
            (this._finalizers = null !== (n = this._finalizers) && void 0 !== n ? n : []).push(t);
          }
        }
      }, {
        key: "_hasParent",
        value: function _hasParent(t) {
          var n = this._parentage;
          return n === t || Array.isArray(n) && n.includes(t);
        }
      }, {
        key: "_addParent",
        value: function _addParent(t) {
          var n = this._parentage;
          this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
        }
      }, {
        key: "_removeParent",
        value: function _removeParent(t) {
          var n = this._parentage;
          n === t ? this._parentage = null : Array.isArray(n) && fl(n, t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var n = this._finalizers;
          n && fl(n, t), t instanceof He && t._removeParent(this);
        }
      }]);
    }();
    He.EMPTY = function () {
      var e = new He();
      return e.closed = !0, e;
    }();
    var $g = He.EMPTY;
    function zg(e) {
      return e instanceof He || e && "closed" in e && J(e.remove) && J(e.add) && J(e.unsubscribe);
    }
    function qg(e) {
      J(e) ? e() : e.unsubscribe();
    }
    var cr = {
        onUnhandledError: null,
        onStoppedNotification: null,
        Promise: void 0,
        useDeprecatedSynchronousErrorHandling: !1,
        useDeprecatedNextContext: !1
      },
      fa = {
        setTimeout: function (_setTimeout) {
          function setTimeout(_x2, _x3) {
            return _setTimeout.apply(this, arguments);
          }
          setTimeout.toString = function () {
            return _setTimeout.toString();
          };
          return setTimeout;
        }(function (e, t) {
          var r = fa.delegate;
          for (var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            n[_key - 2] = arguments[_key];
          }
          return r !== null && r !== void 0 && r.setTimeout ? r.setTimeout.apply(r, [e, t].concat(n)) : setTimeout.apply(void 0, [e, t].concat(n));
        }),
        clearTimeout: function (_clearTimeout) {
          function clearTimeout(_x4) {
            return _clearTimeout.apply(this, arguments);
          }
          clearTimeout.toString = function () {
            return _clearTimeout.toString();
          };
          return clearTimeout;
        }(function (e) {
          var t = fa.delegate;
          return ((t === null || t === void 0 ? void 0 : t.clearTimeout) || clearTimeout)(e);
        }),
        delegate: void 0
      };
    function Gg(e) {
      fa.setTimeout(function () {
        var t = cr.onUnhandledError;
        if (!t) throw e;
        t(e);
      });
    }
    function hl() {}
    var rS = pl("C", void 0, void 0);
    function pl(e, t, n) {
      return {
        kind: e,
        value: t,
        error: n
      };
    }
    var lr = null;
    function ha(e) {
      if (cr.useDeprecatedSynchronousErrorHandling) {
        var t = !lr;
        if (t && (lr = {
          errorThrown: !1,
          error: null
        }), e(), t) {
          var _lr = lr,
            n = _lr.errorThrown,
            r = _lr.error;
          if (lr = null, n) throw r;
        }
      } else e();
    }
    var gl = /*#__PURE__*/function (_He) {
      function gl(t) {
        var _this;
        _classCallCheck(this, gl);
        _this = _callSuper(this, gl), _this.isStopped = !1, t ? (_this.destination = t, zg(t) && t.add(_assertThisInitialized(_this))) : _this.destination = lS;
        return _this;
      }
      _inherits(gl, _He);
      return _createClass(gl, [{
        key: "next",
        value: function next(t) {
          this.isStopped ? yl(function iS(e) {
            return pl("N", e, void 0);
          }(t), this) : this._next(t);
        }
      }, {
        key: "error",
        value: function error(t) {
          this.isStopped ? yl(function oS(e) {
            return pl("E", void 0, e);
          }(t), this) : (this.isStopped = !0, this._error(t));
        }
      }, {
        key: "complete",
        value: function complete() {
          this.isStopped ? yl(rS, this) : (this.isStopped = !0, this._complete());
        }
      }, {
        key: "unsubscribe",
        value: function unsubscribe() {
          this.closed || (this.isStopped = !0, _superPropGet(gl, "unsubscribe", this, 3)([]), this.destination = null);
        }
      }, {
        key: "_next",
        value: function _next(t) {
          this.destination.next(t);
        }
      }, {
        key: "_error",
        value: function _error(t) {
          try {
            this.destination.error(t);
          } finally {
            this.unsubscribe();
          }
        }
      }, {
        key: "_complete",
        value: function _complete() {
          try {
            this.destination.complete();
          } finally {
            this.unsubscribe();
          }
        }
      }], [{
        key: "create",
        value: function create(t, n, r) {
          return new vl(t, n, r);
        }
      }]);
    }(He);
    var aS = Function.prototype.bind;
    function ml(e, t) {
      return aS.call(e, t);
    }
    var uS = /*#__PURE__*/function () {
      function uS(t) {
        _classCallCheck(this, uS);
        this.partialObserver = t;
      }
      return _createClass(uS, [{
        key: "next",
        value: function next(t) {
          var n = this.partialObserver;
          if (n.next) try {
            n.next(t);
          } catch (r) {
            pa(r);
          }
        }
      }, {
        key: "error",
        value: function error(t) {
          var n = this.partialObserver;
          if (n.error) try {
            n.error(t);
          } catch (r) {
            pa(r);
          } else pa(t);
        }
      }, {
        key: "complete",
        value: function complete() {
          var t = this.partialObserver;
          if (t.complete) try {
            t.complete();
          } catch (n) {
            pa(n);
          }
        }
      }]);
    }();
    var vl = /*#__PURE__*/function (_gl) {
      function vl(t, n, r) {
        var _this2;
        _classCallCheck(this, vl);
        var o;
        if (_this2 = _callSuper(this, vl), J(t) || !t) o = {
          next: t !== null && t !== void 0 ? t : void 0,
          error: n !== null && n !== void 0 ? n : void 0,
          complete: r !== null && r !== void 0 ? r : void 0
        };else {
          var i;
          _assertThisInitialized(_this2) && cr.useDeprecatedNextContext ? (i = Object.create(t), i.unsubscribe = function () {
            return _this2.unsubscribe();
          }, o = {
            next: t.next && ml(t.next, i),
            error: t.error && ml(t.error, i),
            complete: t.complete && ml(t.complete, i)
          }) : o = t;
        }
        _this2.destination = new uS(o);
        return _this2;
      }
      _inherits(vl, _gl);
      return _createClass(vl);
    }(gl);
    function pa(e) {
      cr.useDeprecatedSynchronousErrorHandling ? function sS(e) {
        cr.useDeprecatedSynchronousErrorHandling && lr && (lr.errorThrown = !0, lr.error = e);
      }(e) : Gg(e);
    }
    function yl(e, t) {
      var n = cr.onStoppedNotification;
      n && fa.setTimeout(function () {
        return n(e, t);
      });
    }
    var lS = {
        closed: !0,
        next: hl,
        error: function cS(e) {
          throw e;
        },
        complete: hl
      },
      Dl = "function" == typeof Symbol && Symbol.observable || "@@observable";
    function dr(e) {
      return e;
    }
    function Wg(e) {
      return 0 === e.length ? dr : 1 === e.length ? e[0] : function (n) {
        return e.reduce(function (r, o) {
          return o(r);
        }, n);
      };
    }
    var _e = function () {
      var e = /*#__PURE__*/function () {
        function e(n) {
          _classCallCheck(this, e);
          n && (this._subscribe = n);
        }
        return _createClass(e, [{
          key: "lift",
          value: function lift(n) {
            var r = new e();
            return r.source = this, r.operator = n, r;
          }
        }, {
          key: "subscribe",
          value: function subscribe(n, r, o) {
            var _this3 = this;
            var i = function hS(e) {
              return e && e instanceof gl || function fS(e) {
                return e && J(e.next) && J(e.error) && J(e.complete);
              }(e) && zg(e);
            }(n) ? n : new vl(n, r, o);
            return ha(function () {
              var s = _this3.operator,
                a = _this3.source;
              i.add(s ? s.call(i, a) : a ? _this3._subscribe(i) : _this3._trySubscribe(i));
            }), i;
          }
        }, {
          key: "_trySubscribe",
          value: function _trySubscribe(n) {
            try {
              return this._subscribe(n);
            } catch (r) {
              n.error(r);
            }
          }
        }, {
          key: "forEach",
          value: function forEach(n, r) {
            var _this4 = this;
            return new (r = Zg(r))(function (o, i) {
              var s = new vl({
                next: function next(a) {
                  try {
                    n(a);
                  } catch (u) {
                    i(u), s.unsubscribe();
                  }
                },
                error: i,
                complete: o
              });
              _this4.subscribe(s);
            });
          }
        }, {
          key: "_subscribe",
          value: function _subscribe(n) {
            var r;
            return null === (r = this.source) || void 0 === r ? void 0 : r.subscribe(n);
          }
        }, {
          key: Dl,
          value: function value() {
            return this;
          }
        }, {
          key: "pipe",
          value: function pipe() {
            for (var _len2 = arguments.length, n = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              n[_key2] = arguments[_key2];
            }
            return Wg(n)(this);
          }
        }, {
          key: "toPromise",
          value: function toPromise(n) {
            var _this5 = this;
            return new (n = Zg(n))(function (r, o) {
              var i;
              _this5.subscribe(function (s) {
                return i = s;
              }, function (s) {
                return o(s);
              }, function () {
                return r(i);
              });
            });
          }
        }]);
      }();
      return e.create = function (t) {
        return new e(t);
      }, e;
    }();
    function Zg(e) {
      var t;
      return null !== (t = e !== null && e !== void 0 ? e : cr.Promise) && void 0 !== t ? t : Promise;
    }
    var pS = ll(function (e) {
      return function () {
        e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
      };
    });
    var $e = function () {
      var e = /*#__PURE__*/function (_e2) {
        function e() {
          var _this6;
          _classCallCheck(this, e);
          _this6 = _callSuper(this, e), _this6.closed = !1, _this6.currentObservers = null, _this6.observers = [], _this6.isStopped = !1, _this6.hasError = !1, _this6.thrownError = null;
          return _this6;
        }
        _inherits(e, _e2);
        return _createClass(e, [{
          key: "lift",
          value: function lift(n) {
            var r = new Qg(this, this);
            return r.operator = n, r;
          }
        }, {
          key: "_throwIfClosed",
          value: function _throwIfClosed() {
            if (this.closed) throw new pS();
          }
        }, {
          key: "next",
          value: function next(n) {
            var _this7 = this;
            ha(function () {
              if (_this7._throwIfClosed(), !_this7.isStopped) {
                _this7.currentObservers || (_this7.currentObservers = Array.from(_this7.observers));
                var _iterator4 = _createForOfIteratorHelper(_this7.currentObservers),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var r = _step4.value;
                    r.next(n);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
            });
          }
        }, {
          key: "error",
          value: function error(n) {
            var _this8 = this;
            ha(function () {
              if (_this8._throwIfClosed(), !_this8.isStopped) {
                _this8.hasError = _this8.isStopped = !0, _this8.thrownError = n;
                var r = _this8.observers;
                for (; r.length;) r.shift().error(n);
              }
            });
          }
        }, {
          key: "complete",
          value: function complete() {
            var _this9 = this;
            ha(function () {
              if (_this9._throwIfClosed(), !_this9.isStopped) {
                _this9.isStopped = !0;
                var n = _this9.observers;
                for (; n.length;) n.shift().complete();
              }
            });
          }
        }, {
          key: "unsubscribe",
          value: function unsubscribe() {
            this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
          }
        }, {
          key: "observed",
          get: function get() {
            var n;
            return (null === (n = this.observers) || void 0 === n ? void 0 : n.length) > 0;
          }
        }, {
          key: "_trySubscribe",
          value: function _trySubscribe(n) {
            return this._throwIfClosed(), _superPropGet(e, "_trySubscribe", this, 3)([n]);
          }
        }, {
          key: "_subscribe",
          value: function _subscribe(n) {
            return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
          }
        }, {
          key: "_innerSubscribe",
          value: function _innerSubscribe(n) {
            var _this0 = this;
            var r = this.hasError,
              o = this.isStopped,
              i = this.observers;
            return r || o ? $g : (this.currentObservers = null, i.push(n), new He(function () {
              _this0.currentObservers = null, fl(i, n);
            }));
          }
        }, {
          key: "_checkFinalizedStatuses",
          value: function _checkFinalizedStatuses(n) {
            var r = this.hasError,
              o = this.thrownError,
              i = this.isStopped;
            r ? n.error(o) : i && n.complete();
          }
        }, {
          key: "asObservable",
          value: function asObservable() {
            var n = new _e();
            return n.source = this, n;
          }
        }]);
      }(_e);
      return e.create = function (t, n) {
        return new Qg(t, n);
      }, e;
    }();
    var Qg = /*#__PURE__*/function (_$e) {
      function Qg(t, n) {
        var _this1;
        _classCallCheck(this, Qg);
        _this1 = _callSuper(this, Qg), _this1.destination = t, _this1.source = n;
        return _this1;
      }
      _inherits(Qg, _$e);
      return _createClass(Qg, [{
        key: "next",
        value: function next(t) {
          var n, r;
          null === (r = null === (n = this.destination) || void 0 === n ? void 0 : n.next) || void 0 === r || r.call(n, t);
        }
      }, {
        key: "error",
        value: function error(t) {
          var n, r;
          null === (r = null === (n = this.destination) || void 0 === n ? void 0 : n.error) || void 0 === r || r.call(n, t);
        }
      }, {
        key: "complete",
        value: function complete() {
          var t, n;
          null === (n = null === (t = this.destination) || void 0 === t ? void 0 : t.complete) || void 0 === n || n.call(t);
        }
      }, {
        key: "_subscribe",
        value: function _subscribe(t) {
          var n, r;
          return null !== (r = null === (n = this.source) || void 0 === n ? void 0 : n.subscribe(t)) && void 0 !== r ? r : $g;
        }
      }]);
    }($e);
    var _t = /*#__PURE__*/function (_$e2) {
      function _t(t) {
        var _this10;
        _classCallCheck(this, _t);
        _this10 = _callSuper(this, _t), _this10._value = t;
        return _this10;
      }
      _inherits(_t, _$e2);
      return _createClass(_t, [{
        key: "value",
        get: function get() {
          return this.getValue();
        }
      }, {
        key: "_subscribe",
        value: function _subscribe(t) {
          var n = _superPropGet(_t, "_subscribe", this, 3)([t]);
          return !n.closed && t.next(this._value), n;
        }
      }, {
        key: "getValue",
        value: function getValue() {
          var t = this.hasError,
            n = this.thrownError,
            r = this._value;
          if (t) throw n;
          return this._throwIfClosed(), r;
        }
      }, {
        key: "next",
        value: function next(t) {
          _superPropGet(_t, "next", this, 3)([this._value = t]);
        }
      }]);
    }($e);
    function Yg(e) {
      return J(e === null || e === void 0 ? void 0 : e.lift);
    }
    function Le(e) {
      return function (t) {
        if (Yg(t)) return t.lift(function (n) {
          try {
            return e(n, this);
          } catch (r) {
            this.error(r);
          }
        });
        throw new TypeError("Unable to lift unknown Observable type");
      };
    }
    function ke(e, t, n, r, o) {
      return new gS(e, t, n, r, o);
    }
    var gS = /*#__PURE__*/function (_gl2) {
      function gS(t, n, r, o, i, s) {
        var _this11;
        _classCallCheck(this, gS);
        _this11 = _callSuper(this, gS, [t]), _this11.onFinalize = i, _this11.shouldUnsubscribe = s, _this11._next = n ? function (a) {
          try {
            n(a);
          } catch (u) {
            t.error(u);
          }
        } : _superPropGet((_assertThisInitialized(_this11), gS), "_next", _this11, 1), _this11._error = o ? function (a) {
          try {
            o(a);
          } catch (u) {
            t.error(u);
          } finally {
            this.unsubscribe();
          }
        } : _superPropGet((_assertThisInitialized(_this11), gS), "_error", _this11, 1), _this11._complete = r ? function () {
          try {
            r();
          } catch (a) {
            t.error(a);
          } finally {
            this.unsubscribe();
          }
        } : _superPropGet((_assertThisInitialized(_this11), gS), "_complete", _this11, 1);
        return _this11;
      }
      _inherits(gS, _gl2);
      return _createClass(gS, [{
        key: "unsubscribe",
        value: function unsubscribe() {
          var t;
          if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var n = this.closed;
            _superPropGet(gS, "unsubscribe", this, 3)([]), !n && (null === (t = this.onFinalize) || void 0 === t || t.call(this));
          }
        }
      }]);
    }(gl);
    function Y(e, t) {
      return Le(function (n, r) {
        var o = 0;
        n.subscribe(ke(r, function (i) {
          r.next(e.call(t, i, o++));
        }));
      });
    }
    var Jg = "https://angular.dev/best-practices/security#preventing-cross-site-scripting-xss";
    var E = /*#__PURE__*/function (_Error) {
      function E(t, n) {
        var _this12;
        _classCallCheck(this, E);
        _this12 = _callSuper(this, E, [function vn(e, t) {
          return "".concat(function mS(e) {
            return "NG0".concat(Math.abs(e));
          }(e)).concat(t ? ": " + t : "");
        }(t, n)]), _defineProperty(_assertThisInitialized(_this12), "code", void 0), _this12.code = t;
        return _this12;
      }
      _inherits(E, _Error);
      return _createClass(E);
    }(/*#__PURE__*/_wrapNativeSuper(Error));
    var ga = Symbol("InputSignalNode#UNSET"),
      Kg = _objectSpread(_objectSpread({}, al), {}, {
        transformFn: void 0,
        applyValueToInputSignal: function applyValueToInputSignal(e, t) {
          la(e, t);
        }
      });
    function Xg(e, t) {
      var n = Object.create(Kg);
      function r() {
        if (gi(n), n.value === ga) throw new E(-950, null);
        return n.value;
      }
      return n.value = e, n.transformFn = t === null || t === void 0 ? void 0 : t.transform, r[Fe] = n, r;
    }
    function yn(e) {
      return {
        toString: e
      }.toString();
    }
    var Xr = "__parameters__";
    function to(e, t, n) {
      return yn(function () {
        var r = function wl(e) {
          return function () {
            if (e) {
              var _r3 = e.apply(void 0, arguments);
              for (var _o in _r3) this[_o] = _r3[_o];
            }
          };
        }(t);
        function o() {
          for (var _len3 = arguments.length, i = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            i[_key3] = arguments[_key3];
          }
          if (this instanceof o) return r.apply(this, i), this;
          var s = _construct(o, i);
          return a.annotation = s, a;
          function a(u, c, l) {
            var d = u.hasOwnProperty(Xr) ? u[Xr] : Object.defineProperty(u, Xr, {
              value: []
            })[Xr];
            for (; d.length <= l;) d.push(null);
            return (d[l] = d[l] || []).push(s), u;
          }
        }
        return o.prototype.ngMetadataName = e, o.annotationCls = o, o;
      });
    }
    function re(e) {
      for (var t in e) if (e[t] === re) return t;
      throw Error("Could not find renamed property on target object.");
    }
    function Te(e) {
      if ("string" == typeof e) return e;
      if (Array.isArray(e)) return "[".concat(e.map(Te).join(", "), "]");
      if (null == e) return "" + e;
      var t = e.overriddenName || e.name;
      if (t) return "".concat(t);
      var n = e.toString();
      if (null == n) return "" + n;
      var r = n.indexOf("\n");
      return r >= 0 ? n.slice(0, r) : n;
    }
    function El(e, t) {
      return e ? t ? "".concat(e, " ").concat(t) : e : t || "";
    }
    globalThis;
    var yS = re({
      __forward_ref__: re
    });
    function Cl(e) {
      return e.__forward_ref__ = Cl, e.toString = function () {
        return Te(this());
      }, e;
    }
    function P(e) {
      return ma(e) ? e() : e;
    }
    function ma(e) {
      return "function" == typeof e && e.hasOwnProperty(yS) && e.__forward_ref__ === Cl;
    }
    function b(e) {
      return {
        token: e.token,
        providedIn: e.providedIn || null,
        factory: e.factory,
        value: void 0
      };
    }
    function va(e) {
      return {
        providers: e.providers || [],
        imports: e.imports || []
      };
    }
    function ya(e) {
      return tm(e, wa) || tm(e, nm);
    }
    function tm(e, t) {
      return e.hasOwnProperty(t) ? e[t] : null;
    }
    function Da(e) {
      return e && (e.hasOwnProperty(Il) || e.hasOwnProperty(_S)) ? e[Il] : null;
    }
    var wa = re({
        ɵprov: re
      }),
      Il = re({
        ɵinj: re
      }),
      nm = re({
        ngInjectableDef: re
      }),
      _S = re({
        ngInjectorDef: re
      });
    var I = /*#__PURE__*/function () {
      function I(t, n) {
        _classCallCheck(this, I);
        _defineProperty(this, "_desc", void 0);
        _defineProperty(this, "ngMetadataName", "InjectionToken");
        _defineProperty(this, "\u0275prov", void 0);
        this._desc = t, this.ɵprov = void 0, "number" == typeof n ? this.__NG_ELEMENT_ID__ = n : void 0 !== n && (this.ɵprov = b({
          token: this,
          providedIn: n.providedIn || "root",
          factory: n.factory
        }));
      }
      return _createClass(I, [{
        key: "multi",
        get: function get() {
          return this;
        }
      }, {
        key: "toString",
        value: function toString() {
          return "InjectionToken ".concat(this._desc);
        }
      }]);
    }();
    function Ml(e) {
      return e && !!e.ɵproviders;
    }
    var no = re({
        ɵcmp: re
      }),
      Sl = re({
        ɵdir: re
      }),
      Tl = re({
        ɵpipe: re
      }),
      om = re({
        ɵmod: re
      }),
      Dn = re({
        ɵfac: re
      }),
      Di = re({
        __NG_ELEMENT_ID__: re
      }),
      im = re({
        __NG_ENV_ID__: re
      });
    function L(e) {
      return "string" == typeof e ? e : null == e ? "" : String(e);
    }
    function sm(e, t) {
      throw new E(-200, e);
    }
    function Nl(e, t) {
      throw new E(-201, !1);
    }
    var $ = function (e) {
      return e[e.Default = 0] = "Default", e[e.Host = 1] = "Host", e[e.Self = 2] = "Self", e[e.SkipSelf = 4] = "SkipSelf", e[e.Optional = 8] = "Optional", e;
    }($ || {});
    var Rl;
    function am() {
      return Rl;
    }
    function it(e) {
      var t = Rl;
      return Rl = e, t;
    }
    function um(e, t, n) {
      var r = ya(e);
      return r && "root" == r.providedIn ? void 0 === r.value ? r.value = r.factory() : r.value : n & $.Optional ? null : void 0 !== t ? t : void Nl();
    }
    var hr = {},
      Al = "__NG_DI_FLAG__";
    var cm = /*#__PURE__*/function () {
      function cm(t) {
        _classCallCheck(this, cm);
        _defineProperty(this, "injector", void 0);
        this.injector = t;
      }
      return _createClass(cm, [{
        key: "retrieve",
        value: function retrieve(t, n) {
          return this.injector.get(t, n.optional ? cl : hr, n);
        }
      }]);
    }();
    var Ia = "ngTempTokenPath",
      NS = /\n/gm,
      lm = "__source";
    function AS(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $.Default;
      if (void 0 === da()) throw new E(-203, !1);
      if (null === da()) return um(e, void 0, t);
      {
        var n = da();
        var r;
        return r = n instanceof cm ? n.injector : n, r.get(e, t & $.Optional ? null : void 0, t);
      }
    }
    function T(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $.Default;
      return (am() || AS)(P(e), t);
    }
    function w(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $.Default;
      return T(e, _a(t));
    }
    function _a(e) {
      return _typeof(e) > "u" || "number" == typeof e ? e : (e.optional && 8) | (e.host && 1) | (e.self && 2) | (e.skipSelf && 4);
    }
    function xl(e) {
      var t = [];
      for (var n = 0; n < e.length; n++) {
        var r = P(e[n]);
        if (Array.isArray(r)) {
          if (0 === r.length) throw new E(900, !1);
          var o = void 0,
            i = $.Default;
          for (var s = 0; s < r.length; s++) {
            var a = r[s],
              u = xS(a);
            "number" == typeof u ? -1 === u ? o = a.token : i |= u : o = a;
          }
          t.push(T(o, i));
        } else t.push(T(r));
      }
      return t;
    }
    function wi(e, t) {
      return e[Al] = t, e.prototype[Al] = t, e;
    }
    function xS(e) {
      return e[Al];
    }
    var kl = wi(to("Optional"), 8),
      Ol = wi(to("SkipSelf"), 4);
    function pr(e, t) {
      return e.hasOwnProperty(Dn) ? e[Dn] : null;
    }
    function ro(e, t) {
      e.forEach(function (n) {
        return Array.isArray(n) ? ro(n, t) : t(n);
      });
    }
    function fm(e, t, n) {
      t >= e.length ? e.push(n) : e.splice(t, 0, n);
    }
    function ba(e, t) {
      return t >= e.length - 1 ? e.pop() : e.splice(t, 1)[0];
    }
    function gt(e, t, n) {
      var r = Ei(e, t);
      return r >= 0 ? e[1 | r] = n : (r = ~r, function pm(e, t, n, r) {
        var o = e.length;
        if (o == t) e.push(n, r);else if (1 === o) e.push(r, e[0]), e[0] = n;else {
          for (o--, e.push(e[o - 1], e[o]); o > t;) e[o] = e[o - 2], o--;
          e[t] = n, e[t + 1] = r;
        }
      }(e, r, t, n)), r;
    }
    function Pl(e, t) {
      var n = Ei(e, t);
      if (n >= 0) return e[1 | n];
    }
    function Ei(e, t) {
      return function VS(e, t, n) {
        var r = 0,
          o = e.length >> n;
        for (; o !== r;) {
          var i = r + (o - r >> 1),
            s = e[i << n];
          if (t === s) return i << n;
          s > t ? o = i : r = i + 1;
        }
        return ~(o << n);
      }(e, t, 1);
    }
    var Pt = {},
      K = [],
      bt = new I(""),
      gm = new I("", -1),
      Fl = new I("");
    var Sa = /*#__PURE__*/function () {
      function Sa() {
        _classCallCheck(this, Sa);
      }
      return _createClass(Sa, [{
        key: "get",
        value: function get(t) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : hr;
          if (n === hr) {
            var r = new Error("NullInjectorError: No provider for ".concat(Te(t), "!"));
            throw r.name = "NullInjectorError", r;
          }
          return n;
        }
      }]);
    }();
    function mt(e, t) {
      var n = e[om] || null;
      if (!n && !0 === t) throw new Error("Type ".concat(Te(e), " does not have '\u0275mod' property."));
      return n;
    }
    function G(e) {
      return e[no] || null;
    }
    function vt(e) {
      return e[Tl] || null;
    }
    function wn(e) {
      return {
        ɵproviders: e
      };
    }
    function BS() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }
      return {
        ɵproviders: Ll(0, e),
        ɵfromNgModule: !0
      };
    }
    function Ll(e) {
      var n = [],
        r = new Set();
      var o;
      var i = function i(s) {
        n.push(s);
      };
      for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        t[_key5 - 1] = arguments[_key5];
      }
      return ro(t, function (s) {
        var a = s;
        Ta(a, i, [], r) && (o || (o = []), o.push(a));
      }), void 0 !== o && mm(o, i), n;
    }
    function mm(e, t) {
      var _loop = function _loop() {
        var _e$n = e[n],
          r = _e$n.ngModule,
          o = _e$n.providers;
        jl(o, function (i) {
          t(i, r);
        });
      };
      for (var n = 0; n < e.length; n++) {
        _loop();
      }
    }
    function Ta(e, t, n, r) {
      if (!(e = P(e))) return !1;
      var o = null,
        i = Da(e);
      var s = !i && G(e);
      if (i || s) {
        if (s && !s.standalone) return !1;
        o = e;
      } else {
        var u = e.ngModule;
        if (i = Da(u), !i) return !1;
        o = u;
      }
      var a = r.has(o);
      if (s) {
        if (a) return !1;
        if (r.add(o), s.dependencies) {
          var _u2 = "function" == typeof s.dependencies ? s.dependencies() : s.dependencies;
          var _iterator5 = _createForOfIteratorHelper(_u2),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var c = _step5.value;
              Ta(c, t, n, r);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } else {
        if (!i) return !1;
        {
          if (null != i.imports && !a) {
            var _c2;
            r.add(o);
            try {
              ro(i.imports, function (l) {
                Ta(l, t, n, r) && (_c2 || (_c2 = []), _c2.push(l));
              });
            } finally {}
            void 0 !== _c2 && mm(_c2, t);
          }
          if (!a) {
            var _c3 = pr(o) || function () {
              return new o();
            };
            t({
              provide: o,
              useFactory: _c3,
              deps: K
            }, o), t({
              provide: Fl,
              useValue: o,
              multi: !0
            }, o), t({
              provide: bt,
              useValue: function useValue() {
                return T(o);
              },
              multi: !0
            }, o);
          }
          var _u3 = i.providers;
          if (null != _u3 && !a) {
            var _c4 = e;
            jl(_u3, function (l) {
              t(l, _c4);
            });
          }
        }
      }
      return o !== e && void 0 !== e.providers;
    }
    function jl(e, t) {
      var _iterator6 = _createForOfIteratorHelper(e),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var n = _step6.value;
          Ml(n) && (n = n.ɵproviders), Array.isArray(n) ? jl(n, t) : t(n);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    var US = re({
      provide: String,
      useValue: re
    });
    function Vl(e) {
      return null !== e && "object" == _typeof(e) && US in e;
    }
    function mr(e) {
      return "function" == typeof e;
    }
    var Bl = new I(""),
      Na = {},
      Dm = {};
    var Ul;
    function Ra() {
      return void 0 === Ul && (Ul = new Sa()), Ul;
    }
    var at = /*#__PURE__*/_createClass(function at() {
      _classCallCheck(this, at);
    });
    var vr = /*#__PURE__*/function (_at) {
      function vr(t, n, r, o) {
        var _this13;
        _classCallCheck(this, vr);
        _this13 = _callSuper(this, vr), _defineProperty(_assertThisInitialized(_this13), "parent", void 0), _defineProperty(_assertThisInitialized(_this13), "source", void 0), _defineProperty(_assertThisInitialized(_this13), "scopes", void 0), _defineProperty(_assertThisInitialized(_this13), "records", new Map()), _defineProperty(_assertThisInitialized(_this13), "_ngOnDestroyHooks", new Set()), _defineProperty(_assertThisInitialized(_this13), "_onDestroyHooks", []), _defineProperty(_assertThisInitialized(_this13), "_destroyed", !1), _defineProperty(_assertThisInitialized(_this13), "injectorDefTypes", void 0), _this13.parent = n, _this13.source = r, _this13.scopes = o, $l(t, function (s) {
          return _this13.processProvider(s);
        }), _this13.records.set(gm, oo(void 0, _assertThisInitialized(_this13))), o.has("environment") && _this13.records.set(at, oo(void 0, _assertThisInitialized(_this13)));
        var i = _this13.records.get(Bl);
        null != i && "string" == typeof i.value && _this13.scopes.add(i.value), _this13.injectorDefTypes = new Set(_this13.get(Fl, K, $.Self));
        return _this13;
      }
      _inherits(vr, _at);
      return _createClass(vr, [{
        key: "destroyed",
        get: function get() {
          return this._destroyed;
        }
      }, {
        key: "retrieve",
        value: function retrieve(t, n) {
          return this.get(t, n.optional ? cl : hr, n);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          Ci(this), this._destroyed = !0;
          var t = B(null);
          try {
            var _iterator7 = _createForOfIteratorHelper(this._ngOnDestroyHooks),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var r = _step7.value;
                r.ngOnDestroy();
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            var n = this._onDestroyHooks;
            this._onDestroyHooks = [];
            var _iterator8 = _createForOfIteratorHelper(n),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _r4 = _step8.value;
                _r4();
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          } finally {
            this.records.clear(), this._ngOnDestroyHooks.clear(), this.injectorDefTypes.clear(), B(t);
          }
        }
      }, {
        key: "onDestroy",
        value: function onDestroy(t) {
          var _this14 = this;
          return Ci(this), this._onDestroyHooks.push(t), function () {
            return _this14.removeOnDestroy(t);
          };
        }
      }, {
        key: "runInContext",
        value: function runInContext(t) {
          Ci(this);
          var n = Vn(this),
            r = it(void 0);
          try {
            return t();
          } finally {
            Vn(n), it(r);
          }
        }
      }, {
        key: "get",
        value: function get(t) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : hr;
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $.Default;
          if (Ci(this), t.hasOwnProperty(im)) return t[im](this);
          r = _a(r);
          var i = Vn(this),
            s = it(void 0);
          try {
            if (!(r & $.SkipSelf)) {
              var u = this.records.get(t);
              if (void 0 === u) {
                var c = function WS(e) {
                  return "function" == typeof e || "object" == _typeof(e) && e instanceof I;
                }(t) && ya(t);
                u = c && this.injectableDefInScope(c) ? oo(Hl(t), Na) : null, this.records.set(t, u);
              }
              if (null != u) return this.hydrate(t, u, r);
            }
            return (r & $.Self ? Ra() : this.parent).get(t, n = r & $.Optional && n === hr ? null : n);
          } catch (a) {
            if ("NullInjectorError" === a.name) {
              if ((a[Ia] = a[Ia] || []).unshift(Te(t)), i) throw a;
              return function kS(e, t, n, r) {
                var o = e[Ia];
                throw t[lm] && o.unshift(t[lm]), e.message = function OS(e, t, n) {
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  e = e && "\n" === e.charAt(0) && "\u0275" == e.charAt(1) ? e.slice(2) : e;
                  var o = Te(t);
                  if (Array.isArray(t)) o = t.map(Te).join(" -> ");else if ("object" == _typeof(t)) {
                    var _i2 = [];
                    for (var _s in t) if (t.hasOwnProperty(_s)) {
                      var _a2 = t[_s];
                      _i2.push(_s + ":" + ("string" == typeof _a2 ? JSON.stringify(_a2) : Te(_a2)));
                    }
                    o = "{".concat(_i2.join(", "), "}");
                  }
                  return "".concat(n).concat(r ? "(" + r + ")" : "", "[").concat(o, "]: ").concat(e.replace(NS, "\n  "));
                }("\n" + e.message, o, n, r), e.ngTokenPath = o, e[Ia] = null, e;
              }(a, t, "R3InjectorError", this.source);
            }
            throw a;
          } finally {
            it(s), Vn(i);
          }
        }
      }, {
        key: "resolveInjectorInitializers",
        value: function resolveInjectorInitializers() {
          var t = B(null),
            n = Vn(this),
            r = it(void 0);
          try {
            var i = this.get(bt, K, $.Self);
            var _iterator9 = _createForOfIteratorHelper(i),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var s = _step9.value;
                s();
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          } finally {
            Vn(n), it(r), B(t);
          }
        }
      }, {
        key: "toString",
        value: function toString() {
          var t = [],
            n = this.records;
          var _iterator0 = _createForOfIteratorHelper(n.keys()),
            _step0;
          try {
            for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
              var r = _step0.value;
              t.push(Te(r));
            }
          } catch (err) {
            _iterator0.e(err);
          } finally {
            _iterator0.f();
          }
          return "R3Injector[".concat(t.join(", "), "]");
        }
      }, {
        key: "processProvider",
        value: function processProvider(t) {
          var n = mr(t = P(t)) ? t : P(t && t.provide);
          var r = function zS(e) {
            return Vl(e) ? oo(void 0, e.useValue) : oo(function wm(e, t, n) {
              var r;
              if (mr(e)) {
                var o = P(e);
                return pr(o) || Hl(o);
              }
              if (Vl(e)) r = function r() {
                return P(e.useValue);
              };else if (function ym(e) {
                return !(!e || !e.useFactory);
              }(e)) r = function r() {
                return e.useFactory.apply(e, _toConsumableArray(xl(e.deps || [])));
              };else if (function vm(e) {
                return !(!e || !e.useExisting);
              }(e)) r = function r(o, i) {
                return T(P(e.useExisting), void 0 !== i && i & $.Optional ? $.Optional : void 0);
              };else {
                var _o2 = P(e && (e.useClass || e.provide));
                if (!function qS(e) {
                  return !!e.deps;
                }(e)) return pr(_o2) || Hl(_o2);
                r = function r() {
                  return _construct(_o2, _toConsumableArray(xl(e.deps)));
                };
              }
              return r;
            }(e), Na);
          }(t);
          if (!mr(t) && !0 === t.multi) {
            var o = this.records.get(n);
            o || (o = oo(void 0, Na, !0), o.factory = function () {
              return xl(o.multi);
            }, this.records.set(n, o)), n = t, o.multi.push(t);
          }
          this.records.set(n, r);
        }
      }, {
        key: "hydrate",
        value: function hydrate(t, n, r) {
          var o = B(null);
          try {
            return n.value === Dm ? sm(Te(t)) : n.value === Na && (n.value = Dm, n.value = n.factory(void 0, r)), "object" == _typeof(n.value) && n.value && function GS(e) {
              return null !== e && "object" == _typeof(e) && "function" == typeof e.ngOnDestroy;
            }(n.value) && this._ngOnDestroyHooks.add(n.value), n.value;
          } finally {
            B(o);
          }
        }
      }, {
        key: "injectableDefInScope",
        value: function injectableDefInScope(t) {
          if (!t.providedIn) return !1;
          var n = P(t.providedIn);
          return "string" == typeof n ? "any" === n || this.scopes.has(n) : this.injectorDefTypes.has(n);
        }
      }, {
        key: "removeOnDestroy",
        value: function removeOnDestroy(t) {
          var n = this._onDestroyHooks.indexOf(t);
          -1 !== n && this._onDestroyHooks.splice(n, 1);
        }
      }]);
    }(at);
    function Hl(e) {
      var t = ya(e),
        n = null !== t ? t.factory : pr(e);
      if (null !== n) return n;
      if (e instanceof I) throw new E(204, !1);
      if (e instanceof Function) return function $S(e) {
        if (e.length > 0) throw new E(204, !1);
        var n = function IS(e) {
          return e && (e[wa] || e[nm]) || null;
        }(e);
        return null !== n ? function () {
          return n.factory(e);
        } : function () {
          return new e();
        };
      }(e);
      throw new E(204, !1);
    }
    function Ci(e) {
      if (e.destroyed) throw new E(205, !1);
    }
    function oo(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return {
        factory: e,
        value: t,
        multi: n ? [] : void 0
      };
    }
    function $l(e, t) {
      var _iterator1 = _createForOfIteratorHelper(e),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var n = _step1.value;
          Array.isArray(n) ? $l(n, t) : n && Ml(n) ? $l(n.ɵproviders, t) : t(n);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
    }
    function Ft(e, t) {
      var n;
      e instanceof vr ? (Ci(e), n = e) : n = new cm(e);
      var o = Vn(n),
        i = it(void 0);
      try {
        return t();
      } finally {
        Vn(o), it(i);
      }
    }
    function Em() {
      return void 0 !== am() || null != da();
    }
    function yr(e) {
      if (!Em()) throw new E(-203, !1);
    }
    var x = 11,
      M = 26;
    function De(e) {
      return Array.isArray(e) && "object" == _typeof(e[1]);
    }
    function Re(e) {
      return Array.isArray(e) && !0 === e[1];
    }
    function Gl(e) {
      return !!(4 & e.flags);
    }
    function jt(e) {
      return e.componentOffset > -1;
    }
    function Pa(e) {
      return !(1 & ~e.flags);
    }
    function Dt(e) {
      return !!e.template;
    }
    function Cn(e) {
      return !!(512 & e[2]);
    }
    function In(e) {
      return !(256 & ~e[2]);
    }
    var iT = /*#__PURE__*/function () {
      function iT(t, n, r) {
        _classCallCheck(this, iT);
        _defineProperty(this, "previousValue", void 0);
        _defineProperty(this, "currentValue", void 0);
        _defineProperty(this, "firstChange", void 0);
        this.previousValue = t, this.currentValue = n, this.firstChange = r;
      }
      return _createClass(iT, [{
        key: "isFirstChange",
        value: function isFirstChange() {
          return this.firstChange;
        }
      }]);
    }();
    function Nm(e, t, n, r) {
      null !== t ? t.applyValueToInputSignal(t, r) : e[n] = r;
    }
    var fo = function () {
      var e = function e() {
        return Rm;
      };
      return e.ngInherit = !0, e;
    }();
    function Rm(e) {
      return e.type.prototype.ngOnChanges && (e.setInput = aT), sT;
    }
    function sT() {
      var e = xm(this),
        t = e === null || e === void 0 ? void 0 : e.current;
      if (t) {
        var n = e.previous;
        if (n === Pt) e.previous = t;else for (var r in t) n[r] = t[r];
        e.current = null, this.ngOnChanges(t);
      }
    }
    function aT(e, t, n, r, o) {
      var i = this.declaredInputs[r],
        s = xm(e) || function uT(e, t) {
          return e[Am] = t;
        }(e, {
          previous: Pt,
          current: null
        }),
        a = s.current || (s.current = {}),
        u = s.previous,
        c = u[i];
      a[i] = new iT(c && c.currentValue, n, u === Pt), Nm(e, t, o, n);
    }
    var Am = "__ngSimpleChanges__";
    function xm(e) {
      return e[Am] || null;
    }
    function Q(e) {
      for (; Array.isArray(e);) e = e[0];
      return e;
    }
    function ho(e, t) {
      return Q(t[e]);
    }
    function Ze(e, t) {
      return Q(t[e.index]);
    }
    function Cr(e, t) {
      return e.data[t];
    }
    function Qe(e, t) {
      var n = t[e];
      return De(n) ? n : n[0];
    }
    function Ql(e) {
      return !(128 & ~e[2]);
    }
    function Mt(e, t) {
      return null == t ? null : e[t];
    }
    function Pm(e) {
      e[17] = 0;
    }
    function Yl(e) {
      1024 & e[2] || (e[2] |= 1024, Ql(e) && po(e));
    }
    function bi(e) {
      var _e$;
      return !!(9216 & e[2] || (_e$ = e[24]) !== null && _e$ !== void 0 && _e$.dirty);
    }
    function Jl(e) {
      var _e$10$changeDetection;
      (_e$10$changeDetection = e[10].changeDetectionScheduler) !== null && _e$10$changeDetection !== void 0 && _e$10$changeDetection.notify(8), 64 & e[2] && (e[2] |= 1024), bi(e) && po(e);
    }
    function po(e) {
      var _e$10$changeDetection2;
      (_e$10$changeDetection2 = e[10].changeDetectionScheduler) === null || _e$10$changeDetection2 === void 0 || _e$10$changeDetection2.notify(0);
      var t = _n(e);
      for (; null !== t && !(8192 & t[2]) && (t[2] |= 8192, Ql(t));) t = _n(t);
    }
    function La(e, t) {
      if (In(e)) throw new E(911, !1);
      null === e[21] && (e[21] = []), e[21].push(t);
    }
    function _n(e) {
      var t = e[3];
      return Re(t) ? t[3] : t;
    }
    function Xl(e) {
      var _3, _e$_;
      return (_e$_ = e[_3 = 7]) !== null && _e$_ !== void 0 ? _e$_ : e[_3] = [];
    }
    function ed(e) {
      var _e$cleanup;
      return (_e$cleanup = e.cleanup) !== null && _e$cleanup !== void 0 ? _e$cleanup : e.cleanup = [];
    }
    var F = {
      lFrame: Wm(null),
      bindingsEnabled: !0,
      skipHydrationRootTNode: null
    };
    var nd = !1;
    function rd() {
      return F.bindingsEnabled;
    }
    function v() {
      return F.lFrame.lView;
    }
    function k() {
      return F.lFrame.tView;
    }
    function z() {
      var e = Vm();
      for (; null !== e && 64 === e.type;) e = e.parent;
      return e;
    }
    function Vm() {
      return F.lFrame.currentTNode;
    }
    function Vt(e, t) {
      var n = F.lFrame;
      n.currentTNode = e, n.isParent = t;
    }
    function od() {
      return F.lFrame.isParent;
    }
    function id() {
      F.lFrame.isParent = !1;
    }
    function Hm() {
      return nd;
    }
    function Va(e) {
      var t = nd;
      return nd = e, t;
    }
    function Ye() {
      var e = F.lFrame;
      var t = e.bindingRootIndex;
      return -1 === t && (t = e.bindingRootIndex = e.tView.bindingStartIndex), t;
    }
    function St() {
      return F.lFrame.bindingIndex++;
    }
    function IT(e, t) {
      var n = F.lFrame;
      n.bindingIndex = n.bindingRootIndex = e, sd(t);
    }
    function sd(e) {
      F.lFrame.currentDirectiveIndex = e;
    }
    function ud() {
      return F.lFrame.currentQueryIndex;
    }
    function Ba(e) {
      F.lFrame.currentQueryIndex = e;
    }
    function bT(e) {
      var t = e[1];
      return 2 === t.type ? t.declTNode : 1 === t.type ? e[5] : null;
    }
    function qm(e, t, n) {
      if (n & $.SkipSelf) {
        var o = t,
          i = e;
        for (; !(o = o.parent, null !== o || n & $.Host || (o = bT(i), null === o || (i = i[14], 10 & o.type))););
        if (null === o) return !1;
        t = o, e = i;
      }
      var r = F.lFrame = Gm();
      return r.currentTNode = t, r.lView = e, !0;
    }
    function cd(e) {
      var t = Gm(),
        n = e[1];
      F.lFrame = t, t.currentTNode = n.firstChild, t.lView = e, t.tView = n, t.contextLView = e, t.bindingIndex = n.bindingStartIndex, t.inI18n = !1;
    }
    function Gm() {
      var e = F.lFrame,
        t = null === e ? null : e.child;
      return null === t ? Wm(e) : t;
    }
    function Wm(e) {
      var t = {
        currentTNode: null,
        isParent: !0,
        lView: null,
        tView: null,
        selectedIndex: -1,
        contextLView: null,
        elementDepthCount: 0,
        currentNamespace: null,
        currentDirectiveIndex: -1,
        bindingRootIndex: -1,
        bindingIndex: -1,
        currentQueryIndex: 0,
        parent: e,
        child: null,
        inI18n: !1
      };
      return null !== e && (e.child = t), t;
    }
    function Zm() {
      var e = F.lFrame;
      return F.lFrame = e.parent, e.currentTNode = null, e.lView = null, e;
    }
    var Qm = Zm;
    function ld() {
      var e = Zm();
      e.isParent = !0, e.tView = null, e.selectedIndex = -1, e.contextLView = null, e.elementDepthCount = 0, e.currentDirectiveIndex = -1, e.currentNamespace = null, e.bindingRootIndex = -1, e.bindingIndex = -1, e.currentQueryIndex = 0;
    }
    function Ve() {
      return F.lFrame.selectedIndex;
    }
    function br(e) {
      F.lFrame.selectedIndex = e;
    }
    function ie() {
      var e = F.lFrame;
      return Cr(e.tView, e.selectedIndex);
    }
    var Jm = !0;
    function Si() {
      return Jm;
    }
    function nn(e) {
      Jm = e;
    }
    function dd(e, t) {
      for (var n = t.directiveStart, r = t.directiveEnd; n < r; n++) {
        var _e$contentHooks, _e$contentHooks2, _e$contentCheckHooks, _e$viewHooks, _e$viewHooks2, _e$viewCheckHooks, _e$destroyHooks;
        var i = e.data[n].type.prototype,
          s = i.ngAfterContentInit,
          a = i.ngAfterContentChecked,
          u = i.ngAfterViewInit,
          c = i.ngAfterViewChecked,
          l = i.ngOnDestroy;
        s && ((_e$contentHooks = e.contentHooks) !== null && _e$contentHooks !== void 0 ? _e$contentHooks : e.contentHooks = []).push(-n, s), a && (((_e$contentHooks2 = e.contentHooks) !== null && _e$contentHooks2 !== void 0 ? _e$contentHooks2 : e.contentHooks = []).push(n, a), ((_e$contentCheckHooks = e.contentCheckHooks) !== null && _e$contentCheckHooks !== void 0 ? _e$contentCheckHooks : e.contentCheckHooks = []).push(n, a)), u && ((_e$viewHooks = e.viewHooks) !== null && _e$viewHooks !== void 0 ? _e$viewHooks : e.viewHooks = []).push(-n, u), c && (((_e$viewHooks2 = e.viewHooks) !== null && _e$viewHooks2 !== void 0 ? _e$viewHooks2 : e.viewHooks = []).push(n, c), ((_e$viewCheckHooks = e.viewCheckHooks) !== null && _e$viewCheckHooks !== void 0 ? _e$viewCheckHooks : e.viewCheckHooks = []).push(n, c)), null != l && ((_e$destroyHooks = e.destroyHooks) !== null && _e$destroyHooks !== void 0 ? _e$destroyHooks : e.destroyHooks = []).push(n, l);
      }
    }
    function Ua(e, t, n) {
      Km(e, t, 3, n);
    }
    function Ha(e, t, n, r) {
      (3 & e[2]) === n && Km(e, t, n, r);
    }
    function fd(e, t) {
      var n = e[2];
      (3 & n) === t && (n &= 16383, n += 1, e[2] = n);
    }
    function Km(e, t, n, r) {
      var i = r !== null && r !== void 0 ? r : -1,
        s = t.length - 1;
      var a = 0;
      for (var u = void 0 !== r ? 65535 & e[17] : 0; u < s; u++) if ("number" == typeof t[u + 1]) {
        if (a = t[u], null != r && a >= r) break;
      } else t[u] < 0 && (e[17] += 65536), (a < i || -1 == i) && (xT(e, n, t, u), e[17] = (4294901760 & e[17]) + u + 2), u++;
    }
    function Xm(e, t) {
      var n = B(null);
      try {
        t.call(e);
      } finally {
        B(n);
      }
    }
    function xT(e, t, n, r) {
      var o = n[r] < 0,
        i = n[r + 1],
        a = e[o ? -n[r] : n[r]];
      o ? e[2] >> 14 < e[17] >> 16 && (3 & e[2]) === t && (e[2] += 16384, Xm(a, i)) : Xm(a, i);
    }
    var Ti = /*#__PURE__*/_createClass(function Ti(t, n, r) {
      _classCallCheck(this, Ti);
      _defineProperty(this, "factory", void 0);
      _defineProperty(this, "injectImpl", void 0);
      _defineProperty(this, "resolving", !1);
      _defineProperty(this, "canSeeViewProviders", void 0);
      _defineProperty(this, "multi", void 0);
      _defineProperty(this, "componentProviders", void 0);
      _defineProperty(this, "index", void 0);
      _defineProperty(this, "providerFactory", void 0);
      this.factory = t, this.canSeeViewProviders = n, this.injectImpl = r;
    });
    function ev(e) {
      return 3 === e || 4 === e || 6 === e;
    }
    function tv(e) {
      return 64 === e.charCodeAt(0);
    }
    function mo(e, t) {
      if (null !== t && 0 !== t.length) if (null === e || 0 === e.length) e = t.slice();else {
        var n = -1;
        for (var r = 0; r < t.length; r++) {
          var o = t[r];
          "number" == typeof o ? n = o : 0 === n || nv(e, n, o, 0, -1 === n || 2 === n ? t[++r] : null);
        }
      }
      return e;
    }
    function nv(e, t, n, r, o) {
      var i = 0,
        s = e.length;
      if (-1 === t) s = -1;else for (; i < e.length;) {
        var a = e[i++];
        if ("number" == typeof a) {
          if (a === t) {
            s = -1;
            break;
          }
          if (a > t) {
            s = i - 1;
            break;
          }
        }
      }
      for (; i < e.length;) {
        var _a3 = e[i];
        if ("number" == typeof _a3) break;
        if (_a3 === n) return void (null !== o && (e[i + 1] = o));
        i++, null !== o && i++;
      }
      -1 !== s && (e.splice(s, 0, t), i = s + 1), e.splice(i++, 0, n), null !== o && e.splice(i++, 0, o);
    }
    function gd(e) {
      return -1 !== e;
    }
    function Ni(e) {
      return 32767 & e;
    }
    function Ri(e, t) {
      var n = function LT(e) {
          return e >> 16;
        }(e),
        r = t;
      for (; n > 0;) r = r[14], n--;
      return r;
    }
    var md = !0;
    function $a(e) {
      var t = md;
      return md = e, t;
    }
    var jT = 0;
    var rn = {};
    function za(e, t) {
      var n = iv(e, t);
      if (-1 !== n) return n;
      var r = t[1];
      r.firstCreatePass && (e.injectorIndex = t.length, vd(r.data, e), vd(t, null), vd(r.blueprint, null));
      var o = qa(e, t),
        i = e.injectorIndex;
      if (gd(o)) {
        var s = Ni(o),
          a = Ri(o, t),
          u = a[1].data;
        for (var c = 0; c < 8; c++) t[i + c] = a[s + c] | u[s + c];
      }
      return t[i + 8] = o, i;
    }
    function vd(e, t) {
      e.push(0, 0, 0, 0, 0, 0, 0, 0, t);
    }
    function iv(e, t) {
      return -1 === e.injectorIndex || e.parent && e.parent.injectorIndex === e.injectorIndex || null === t[e.injectorIndex + 8] ? -1 : e.injectorIndex;
    }
    function qa(e, t) {
      if (e.parent && -1 !== e.parent.injectorIndex) return e.parent.injectorIndex;
      var n = 0,
        r = null,
        o = t;
      for (; null !== o;) {
        if (r = fv(o), null === r) return -1;
        if (n++, o = o[14], -1 !== r.injectorIndex) return r.injectorIndex | n << 16;
      }
      return -1;
    }
    function yd(e, t, n) {
      !function VT(e, t, n) {
        var r;
        "string" == typeof n ? r = n.charCodeAt(0) || 0 : n.hasOwnProperty(Di) && (r = n[Di]), null == r && (r = n[Di] = jT++);
        var o = 255 & r;
        t.data[e + (o >> 5)] |= 1 << o;
      }(e, t, n);
    }
    function sv(e, t, n) {
      if (n & $.Optional || void 0 !== e) return e;
      Nl();
    }
    function av(e, t, n, r) {
      if (n & $.Optional && void 0 === r && (r = null), !(n & ($.Self | $.Host))) {
        var o = e[9],
          i = it(void 0);
        try {
          return o ? o.get(t, r, n & $.Optional) : um(t, r, n & $.Optional);
        } finally {
          it(i);
        }
      }
      return sv(r, 0, n);
    }
    function uv(e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $.Default;
      var o = arguments.length > 4 ? arguments[4] : undefined;
      if (null !== e) {
        if (2048 & t[2] && !(r & $.Self)) {
          var s = function zT(e, t, n, r, o) {
            var i = e,
              s = t;
            for (; null !== i && null !== s && 2048 & s[2] && !Cn(s);) {
              var a = cv(i, s, n, r | $.Self, rn);
              if (a !== rn) return a;
              var u = i.parent;
              if (!u) {
                var c = s[20];
                if (c) {
                  var l = c.get(n, rn, r);
                  if (l !== rn) return l;
                }
                u = fv(s), s = s[14];
              }
              i = u;
            }
            return o;
          }(e, t, n, r, rn);
          if (s !== rn) return s;
        }
        var i = cv(e, t, n, r, rn);
        if (i !== rn) return i;
      }
      return av(t, n, r, o);
    }
    function cv(e, t, n, r, o) {
      var i = function HT(e) {
        if ("string" == typeof e) return e.charCodeAt(0) || 0;
        var t = e.hasOwnProperty(Di) ? e[Di] : void 0;
        return "number" == typeof t ? t >= 0 ? 255 & t : $T : t;
      }(n);
      if ("function" == typeof i) {
        if (!qm(t, e, r)) return r & $.Host ? sv(o, 0, r) : av(t, n, r, o);
        try {
          var s;
          if (s = i(r), null != s || r & $.Optional) return s;
          Nl();
        } finally {
          Qm();
        }
      } else if ("number" == typeof i) {
        var _s2 = null,
          a = iv(e, t),
          u = -1,
          c = r & $.Host ? t[15][5] : null;
        for ((-1 === a || r & $.SkipSelf) && (u = -1 === a ? qa(e, t) : t[a + 8], -1 !== u && dv(r, !1) ? (_s2 = t[1], a = Ni(u), t = Ri(u, t)) : a = -1); -1 !== a;) {
          var l = t[1];
          if (lv(i, a, l.data)) {
            var d = UT(a, t, n, _s2, r, c);
            if (d !== rn) return d;
          }
          u = t[a + 8], -1 !== u && dv(r, t[1].data[a + 8] === c) && lv(i, a, t) ? (_s2 = l, a = Ni(u), t = Ri(u, t)) : a = -1;
        }
      }
      return o;
    }
    function UT(e, t, n, r, o, i) {
      var s = t[1],
        a = s.data[e + 8],
        l = Ga(a, s, n, null == r ? jt(a) && md : r != s && !!(3 & a.type), o & $.Host && i === a);
      return null !== l ? Ai(t, s, l, a, o) : rn;
    }
    function Ga(e, t, n, r, o) {
      var i = e.providerIndexes,
        s = t.data,
        a = 1048575 & i,
        u = e.directiveStart,
        l = i >> 20,
        h = o ? a + l : e.directiveEnd;
      for (var f = r ? a : a + l; f < h; f++) {
        var p = s[f];
        if (f < u && n === p || f >= u && p.type === n) return f;
      }
      if (o) {
        var _f2 = s[u];
        if (_f2 && Dt(_f2) && _f2.type === n) return u;
      }
      return null;
    }
    function Ai(e, t, n, r, o) {
      var i = e[n];
      var s = t.data;
      if (i instanceof Ti) {
        var a = i;
        a.resolving && sm(function X(e) {
          return "function" == typeof e ? e.name || e.toString() : "object" == _typeof(e) && null != e && "function" == typeof e.type ? e.type.name || e.type.toString() : L(e);
        }(s[n]));
        var u = $a(a.canSeeViewProviders);
        a.resolving = !0;
        var l = a.injectImpl ? it(a.injectImpl) : null;
        qm(e, r, $.Default);
        try {
          i = e[n] = a.factory(void 0, o, s, e, r), t.firstCreatePass && n >= r.directiveStart && function AT(e, t, n, _n$preOrderHooks2, _n$preOrderHooks3, _n$preOrderCheckHooks2) {
            var _t$type$prototype = t.type.prototype,
              r = _t$type$prototype.ngOnChanges,
              o = _t$type$prototype.ngOnInit,
              i = _t$type$prototype.ngDoCheck;
            if (r) {
              var _n$preOrderHooks, _n$preOrderCheckHooks;
              var _s3 = Rm(t);
              ((_n$preOrderHooks = n.preOrderHooks) !== null && _n$preOrderHooks !== void 0 ? _n$preOrderHooks : n.preOrderHooks = []).push(e, _s3), ((_n$preOrderCheckHooks = n.preOrderCheckHooks) !== null && _n$preOrderCheckHooks !== void 0 ? _n$preOrderCheckHooks : n.preOrderCheckHooks = []).push(e, _s3);
            }
            o && ((_n$preOrderHooks2 = n.preOrderHooks) !== null && _n$preOrderHooks2 !== void 0 ? _n$preOrderHooks2 : n.preOrderHooks = []).push(0 - e, o), i && (((_n$preOrderHooks3 = n.preOrderHooks) !== null && _n$preOrderHooks3 !== void 0 ? _n$preOrderHooks3 : n.preOrderHooks = []).push(e, i), ((_n$preOrderCheckHooks2 = n.preOrderCheckHooks) !== null && _n$preOrderCheckHooks2 !== void 0 ? _n$preOrderCheckHooks2 : n.preOrderCheckHooks = []).push(e, i));
          }(n, s[n], t);
        } finally {
          null !== l && it(l), $a(u), a.resolving = !1, Qm();
        }
      }
      return i;
    }
    function lv(e, t, n) {
      return !!(n[t + (e >> 5)] & 1 << e);
    }
    function dv(e, t) {
      return !(e & $.Self || e & $.Host && t);
    }
    var we = /*#__PURE__*/function () {
      function we(t, n) {
        _classCallCheck(this, we);
        _defineProperty(this, "_tNode", void 0);
        _defineProperty(this, "_lView", void 0);
        this._tNode = t, this._lView = n;
      }
      return _createClass(we, [{
        key: "get",
        value: function get(t, n, r) {
          return uv(this._tNode, this._lView, t, _a(r), n);
        }
      }]);
    }();
    function $T() {
      return new we(z(), v());
    }
    function Dd(e) {
      return yn(function () {
        var t = e.prototype.constructor,
          n = t[Dn] || wd(t),
          r = Object.prototype;
        var o = Object.getPrototypeOf(e.prototype).constructor;
        for (; o && o !== r;) {
          var i = o[Dn] || wd(o);
          if (i && i !== n) return i;
          o = Object.getPrototypeOf(o);
        }
        return function (i) {
          return new i();
        };
      });
    }
    function wd(e) {
      return ma(e) ? function () {
        var t = wd(P(e));
        return t && t();
      } : pr(e);
    }
    function fv(e) {
      var t = e[1],
        n = t.type;
      return 2 === n ? t.declTNode : 1 === n ? e[5] : null;
    }
    function vv(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var r = arguments.length > 3 ? arguments[3] : undefined;
      var o = yv(e, t, n, r);
      return o.resolveInjectorInitializers(), o;
    }
    function yv(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var r = arguments.length > 3 ? arguments[3] : undefined;
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Set();
      var i = [n || K, BS(e)];
      return r = r || ("object" == _typeof(e) ? void 0 : Te(e)), new vr(i, t || Ra(), r || null, o);
    }
    var Be = /*#__PURE__*/function () {
      function Be() {
        _classCallCheck(this, Be);
      }
      return _createClass(Be, null, [{
        key: "create",
        value: function create(t, n) {
          if (Array.isArray(t)) return vv({
            name: ""
          }, n, t, "");
          {
            var _t$name;
            var r = (_t$name = t.name) !== null && _t$name !== void 0 ? _t$name : "";
            return vv({
              name: r
            }, t.parent, t.providers, r);
          }
        }
      }]);
    }();
    _Be = Be;
    _defineProperty(Be, "THROW_IF_NOT_FOUND", hr);
    _defineProperty(Be, "NULL", new Sa());
    _defineProperty(Be, "\u0275prov", b({
      token: _Be,
      providedIn: "any",
      factory: function factory() {
        return T(gm);
      }
    }));
    _defineProperty(Be, "__NG_ELEMENT_ID__", -1);
    new I("").__NG_ELEMENT_ID__ = function (e) {
      var t = z();
      if (null === t) throw new E(204, !1);
      if (2 & t.type) return t.value;
      if (e & $.Optional) return null;
      throw new E(204, !1);
    };
    var Dv = !1;
    var Bt = function (_e3) {
      return _e3 = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      }), _defineProperty(_e3, "__NG_ELEMENT_ID__", XT), _defineProperty(_e3, "__NG_ENV_ID__", function (n) {
        return n;
      }), _e3;
    }();
    var wv = /*#__PURE__*/function (_Bt) {
      function wv(t) {
        var _this15;
        _classCallCheck(this, wv);
        _this15 = _callSuper(this, wv), _defineProperty(_assertThisInitialized(_this15), "_lView", void 0), _this15._lView = t;
        return _this15;
      }
      _inherits(wv, _Bt);
      return _createClass(wv, [{
        key: "onDestroy",
        value: function onDestroy(t) {
          var n = this._lView;
          return In(n) ? (t(), function () {}) : (La(n, t), function () {
            return function Kl(e, t) {
              if (null === e[21]) return;
              var n = e[21].indexOf(t);
              -1 !== n && e[21].splice(n, 1);
            }(n, t);
          });
        }
      }]);
    }(Bt);
    function XT() {
      return new wv(v());
    }
    var Sn = /*#__PURE__*/_createClass(function Sn() {
      _classCallCheck(this, Sn);
    });
    var ki = new I("", {
        providedIn: "root",
        factory: function factory() {
          return !1;
        }
      }),
      Ev = new I(""),
      Cd = new I("");
    var Hn = function (_e4) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
          _defineProperty(this, "taskId", 0);
          _defineProperty(this, "pendingTasks", new Set());
          _defineProperty(this, "hasPendingTasks", new _t(!1));
        }
        return _createClass(e, [{
          key: "_hasPendingTasks",
          get: function get() {
            return this.hasPendingTasks.value;
          }
        }, {
          key: "add",
          value: function add() {
            this._hasPendingTasks || this.hasPendingTasks.next(!0);
            var n = this.taskId++;
            return this.pendingTasks.add(n), n;
          }
        }, {
          key: "has",
          value: function has(n) {
            return this.pendingTasks.has(n);
          }
        }, {
          key: "remove",
          value: function remove(n) {
            this.pendingTasks.delete(n), 0 === this.pendingTasks.size && this._hasPendingTasks && this.hasPendingTasks.next(!1);
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            this.pendingTasks.clear(), this._hasPendingTasks && this.hasPendingTasks.next(!1);
          }
        }]);
      }();
      _e4 = e;
      _defineProperty(e, "\u0275prov", b({
        token: _e4,
        providedIn: "root",
        factory: function factory() {
          return new _e4();
        }
      }));
      return e;
    }();
    var ut = /*#__PURE__*/function (_$e3) {
      function e0() {
        var _w2, _w3;
        var _this16;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        _classCallCheck(this, e0);
        _this16 = _callSuper(this, e0), _defineProperty(_assertThisInitialized(_this16), "__isAsync", void 0), _defineProperty(_assertThisInitialized(_this16), "destroyRef", void 0), _defineProperty(_assertThisInitialized(_this16), "pendingTasks", void 0), _this16.__isAsync = t, Em() && (_this16.destroyRef = (_w2 = w(Bt, {
          optional: !0
        })) !== null && _w2 !== void 0 ? _w2 : void 0, _this16.pendingTasks = (_w3 = w(Hn, {
          optional: !0
        })) !== null && _w3 !== void 0 ? _w3 : void 0);
        return _this16;
      }
      _inherits(e0, _$e3);
      return _createClass(e0, [{
        key: "emit",
        value: function emit(t) {
          var n = B(null);
          try {
            _superPropGet(e0, "next", this, 3)([t]);
          } finally {
            B(n);
          }
        }
      }, {
        key: "subscribe",
        value: function subscribe(t, n, r) {
          var o = t,
            i = n || function () {
              return null;
            },
            s = r;
          if (t && "object" == _typeof(t)) {
            var _u$next, _u$error, _u$complete;
            var u = t;
            o = (_u$next = u.next) === null || _u$next === void 0 ? void 0 : _u$next.bind(u), i = (_u$error = u.error) === null || _u$error === void 0 ? void 0 : _u$error.bind(u), s = (_u$complete = u.complete) === null || _u$complete === void 0 ? void 0 : _u$complete.bind(u);
          }
          this.__isAsync && (i = this.wrapInTimeout(i), o && (o = this.wrapInTimeout(o)), s && (s = this.wrapInTimeout(s)));
          var a = _superPropGet(e0, "subscribe", this, 3)([{
            next: o,
            error: i,
            complete: s
          }]);
          return t instanceof He && t.add(a), a;
        }
      }, {
        key: "wrapInTimeout",
        value: function wrapInTimeout(t) {
          var _this17 = this;
          return function (n) {
            var _this17$pendingTasks;
            var r = (_this17$pendingTasks = _this17.pendingTasks) === null || _this17$pendingTasks === void 0 ? void 0 : _this17$pendingTasks.add();
            setTimeout(function () {
              try {
                t(n);
              } finally {
                var _this17$pendingTasks2;
                void 0 !== r && ((_this17$pendingTasks2 = _this17.pendingTasks) === null || _this17$pendingTasks2 === void 0 ? void 0 : _this17$pendingTasks2.remove(r));
              }
            });
          };
        }
      }]);
    }($e);
    function Oi() {}
    function Iv(e) {
      var t, n;
      function r() {
        e = Oi;
        try {
          void 0 !== n && "function" == typeof cancelAnimationFrame && cancelAnimationFrame(n), void 0 !== t && clearTimeout(t);
        } catch (_unused) {}
      }
      return t = setTimeout(function () {
        e(), r();
      }), "function" == typeof requestAnimationFrame && (n = requestAnimationFrame(function () {
        e(), r();
      })), function () {
        return r();
      };
    }
    function _v(e) {
      return queueMicrotask(function () {
        return e();
      }), function () {
        e = Oi;
      };
    }
    var Id = "isAngularZone",
      Za = Id + "_ID";
    var t0 = 0;
    var ee = /*#__PURE__*/function () {
      function ee(t) {
        _classCallCheck(this, ee);
        _defineProperty(this, "hasPendingMacrotasks", !1);
        _defineProperty(this, "hasPendingMicrotasks", !1);
        _defineProperty(this, "isStable", !0);
        _defineProperty(this, "onUnstable", new ut(!1));
        _defineProperty(this, "onMicrotaskEmpty", new ut(!1));
        _defineProperty(this, "onStable", new ut(!1));
        _defineProperty(this, "onError", new ut(!1));
        var _t$enableLongStackTra = t.enableLongStackTrace,
          n = _t$enableLongStackTra === void 0 ? !1 : _t$enableLongStackTra,
          _t$shouldCoalesceEven = t.shouldCoalesceEventChangeDetection,
          r = _t$shouldCoalesceEven === void 0 ? !1 : _t$shouldCoalesceEven,
          _t$shouldCoalesceRunC = t.shouldCoalesceRunChangeDetection,
          o = _t$shouldCoalesceRunC === void 0 ? !1 : _t$shouldCoalesceRunC,
          _t$scheduleInRootZone = t.scheduleInRootZone,
          i = _t$scheduleInRootZone === void 0 ? Dv : _t$scheduleInRootZone;
        if ((typeof Zone === "undefined" ? "undefined" : _typeof(Zone)) > "u") throw new E(908, !1);
        Zone.assertZonePatched();
        var s = this;
        s._nesting = 0, s._outer = s._inner = Zone.current, Zone.TaskTrackingZoneSpec && (s._inner = s._inner.fork(new Zone.TaskTrackingZoneSpec())), n && Zone.longStackTraceZoneSpec && (s._inner = s._inner.fork(Zone.longStackTraceZoneSpec)), s.shouldCoalesceEventChangeDetection = !o && r, s.shouldCoalesceRunChangeDetection = o, s.callbackScheduled = !1, s.scheduleInRootZone = i, function o0(e) {
          var t = function t() {
              !function r0(e) {
                function t() {
                  Iv(function () {
                    e.callbackScheduled = !1, bd(e), e.isCheckStableRunning = !0, _d(e), e.isCheckStableRunning = !1;
                  });
                }
                e.isCheckStableRunning || e.callbackScheduled || (e.callbackScheduled = !0, e.scheduleInRootZone ? Zone.root.run(function () {
                  t();
                }) : e._outer.run(function () {
                  t();
                }), bd(e));
              }(e);
            },
            n = t0++;
          e._inner = e._inner.fork({
            name: "angular",
            properties: _defineProperty(_defineProperty(_defineProperty({}, Id, !0), Za, n), Za + n, !0),
            onInvokeTask: function onInvokeTask(r, o, i, s, a, u) {
              if (function s0(e) {
                return Sv(e, "__ignore_ng_zone__");
              }(u)) return r.invokeTask(i, s, a, u);
              try {
                return bv(e), r.invokeTask(i, s, a, u);
              } finally {
                (e.shouldCoalesceEventChangeDetection && "eventTask" === s.type || e.shouldCoalesceRunChangeDetection) && t(), Mv(e);
              }
            },
            onInvoke: function onInvoke(r, o, i, s, a, u, c) {
              try {
                return bv(e), r.invoke(i, s, a, u, c);
              } finally {
                e.shouldCoalesceRunChangeDetection && !e.callbackScheduled && !function a0(e) {
                  return Sv(e, "__scheduler_tick__");
                }(u) && t(), Mv(e);
              }
            },
            onHasTask: function onHasTask(r, o, i, s) {
              r.hasTask(i, s), o === i && ("microTask" == s.change ? (e._hasPendingMicrotasks = s.microTask, bd(e), _d(e)) : "macroTask" == s.change && (e.hasPendingMacrotasks = s.macroTask));
            },
            onHandleError: function onHandleError(r, o, i, s) {
              return r.handleError(i, s), e.runOutsideAngular(function () {
                return e.onError.emit(s);
              }), !1;
            }
          });
        }(s);
      }
      return _createClass(ee, [{
        key: "run",
        value: function run(t, n, r) {
          return this._inner.run(t, n, r);
        }
      }, {
        key: "runTask",
        value: function runTask(t, n, r, o) {
          var i = this._inner,
            s = i.scheduleEventTask("NgZoneEvent: " + o, t, n0, Oi, Oi);
          try {
            return i.runTask(s, n, r);
          } finally {
            i.cancelTask(s);
          }
        }
      }, {
        key: "runGuarded",
        value: function runGuarded(t, n, r) {
          return this._inner.runGuarded(t, n, r);
        }
      }, {
        key: "runOutsideAngular",
        value: function runOutsideAngular(t) {
          return this._outer.run(t);
        }
      }], [{
        key: "isInAngularZone",
        value: function isInAngularZone() {
          return (typeof Zone === "undefined" ? "undefined" : _typeof(Zone)) < "u" && !0 === Zone.current.get(Id);
        }
      }, {
        key: "assertInAngularZone",
        value: function assertInAngularZone() {
          if (!ee.isInAngularZone()) throw new E(909, !1);
        }
      }, {
        key: "assertNotInAngularZone",
        value: function assertNotInAngularZone() {
          if (ee.isInAngularZone()) throw new E(909, !1);
        }
      }]);
    }();
    var n0 = {};
    function _d(e) {
      if (0 == e._nesting && !e.hasPendingMicrotasks && !e.isStable) try {
        e._nesting++, e.onMicrotaskEmpty.emit(null);
      } finally {
        if (e._nesting--, !e.hasPendingMicrotasks) try {
          e.runOutsideAngular(function () {
            return e.onStable.emit(null);
          });
        } finally {
          e.isStable = !0;
        }
      }
    }
    function bd(e) {
      e.hasPendingMicrotasks = !!(e._hasPendingMicrotasks || (e.shouldCoalesceEventChangeDetection || e.shouldCoalesceRunChangeDetection) && !0 === e.callbackScheduled);
    }
    function bv(e) {
      e._nesting++, e.isStable && (e.isStable = !1, e.onUnstable.emit(null));
    }
    function Mv(e) {
      e._nesting--, _d(e);
    }
    var Md = /*#__PURE__*/function () {
      function Md() {
        _classCallCheck(this, Md);
        _defineProperty(this, "hasPendingMicrotasks", !1);
        _defineProperty(this, "hasPendingMacrotasks", !1);
        _defineProperty(this, "isStable", !0);
        _defineProperty(this, "onUnstable", new ut());
        _defineProperty(this, "onMicrotaskEmpty", new ut());
        _defineProperty(this, "onStable", new ut());
        _defineProperty(this, "onError", new ut());
      }
      return _createClass(Md, [{
        key: "run",
        value: function run(t, n, r) {
          return t.apply(n, r);
        }
      }, {
        key: "runGuarded",
        value: function runGuarded(t, n, r) {
          return t.apply(n, r);
        }
      }, {
        key: "runOutsideAngular",
        value: function runOutsideAngular(t) {
          return t();
        }
      }, {
        key: "runTask",
        value: function runTask(t, n, r, o) {
          return t.apply(n, r);
        }
      }]);
    }();
    function Sv(e, t) {
      var _e$2;
      return !(!Array.isArray(e) || 1 !== e.length) && !0 === ((_e$2 = e[0]) === null || _e$2 === void 0 || (_e$2 = _e$2.data) === null || _e$2 === void 0 ? void 0 : _e$2[t]);
    }
    var Ut = /*#__PURE__*/function () {
      function Ut() {
        _classCallCheck(this, Ut);
        _defineProperty(this, "_console", console);
      }
      return _createClass(Ut, [{
        key: "handleError",
        value: function handleError(t) {
          this._console.error("ERROR", t);
        }
      }]);
    }();
    var c0 = new I("", {
      providedIn: "root",
      factory: function factory() {
        var e = w(ee),
          t = w(Ut);
        return function (n) {
          return e.runOutsideAngular(function () {
            return t.handleError(n);
          });
        };
      }
    });
    function Nv(e, t) {
      return Xg(e, t);
    }
    var d0 = (Nv.required = function l0(e) {
      return Xg(ga, e);
    }, Nv);
    function f0() {
      return vo(z(), v());
    }
    function vo(e, t) {
      return new $n(Ze(e, t));
    }
    var $n = function (_e6) {
      return _e6 = /*#__PURE__*/_createClass(function e(n) {
        _classCallCheck(this, e);
        _defineProperty(this, "nativeElement", void 0);
        this.nativeElement = n;
      }), _defineProperty(_e6, "__NG_ELEMENT_ID__", f0), _e6;
    }();
    function Rv(e) {
      return e instanceof $n ? e.nativeElement : e;
    }
    function Ue(e, t) {
      var n = function YM(e, t) {
          var n = Object.create(al);
          n.value = e, void 0 !== t && (n.equal = t);
          var r = function r() {
            return gi(n), n.value;
          };
          return r[Fe] = n, r;
        }(e, t === null || t === void 0 ? void 0 : t.equal),
        r = n[Fe];
      return n.set = function (o) {
        return la(r, o);
      }, n.update = function (o) {
        return function Ug(e, t) {
          Pg() || Bg(e), la(e, t(e.value));
        }(r, o);
      }, n.asReadonly = Qa.bind(n), n;
    }
    function Qa() {
      var _this18 = this;
      var e = this[Fe];
      if (void 0 === e.readonlyFn) {
        var t = function t() {
          return _this18();
        };
        t[Fe] = e, e.readonlyFn = t;
      }
      return e.readonlyFn;
    }
    function h0() {
      return this._results[Symbol.iterator]();
    }
    var p0 = /*#__PURE__*/function () {
      function p0() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        _classCallCheck(this, p0);
        _defineProperty(this, "_emitDistinctChangesOnly", void 0);
        _defineProperty(this, "dirty", !0);
        _defineProperty(this, "_onDirty", void 0);
        _defineProperty(this, "_results", []);
        _defineProperty(this, "_changesDetected", !1);
        _defineProperty(this, "_changes", void 0);
        _defineProperty(this, "length", 0);
        _defineProperty(this, "first", void 0);
        _defineProperty(this, "last", void 0);
        _defineProperty(this, Symbol.iterator, h0);
        this._emitDistinctChangesOnly = t;
      }
      return _createClass(p0, [{
        key: "changes",
        get: function get() {
          var _this$_changes;
          return (_this$_changes = this._changes) !== null && _this$_changes !== void 0 ? _this$_changes : this._changes = new $e();
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._results[t];
        }
      }, {
        key: "map",
        value: function map(t) {
          return this._results.map(t);
        }
      }, {
        key: "filter",
        value: function filter(t) {
          return this._results.filter(t);
        }
      }, {
        key: "find",
        value: function find(t) {
          return this._results.find(t);
        }
      }, {
        key: "reduce",
        value: function reduce(t, n) {
          return this._results.reduce(t, n);
        }
      }, {
        key: "forEach",
        value: function forEach(t) {
          this._results.forEach(t);
        }
      }, {
        key: "some",
        value: function some(t) {
          return this._results.some(t);
        }
      }, {
        key: "toArray",
        value: function toArray() {
          return this._results.slice();
        }
      }, {
        key: "toString",
        value: function toString() {
          return this._results.toString();
        }
      }, {
        key: "reset",
        value: function reset(t, n) {
          this.dirty = !1;
          var r = function st(e) {
            return e.flat(Number.POSITIVE_INFINITY);
          }(t);
          (this._changesDetected = !function jS(e, t, n) {
            if (e.length !== t.length) return !1;
            for (var _r5 = 0; _r5 < e.length; _r5++) {
              var o = e[_r5],
                i = t[_r5];
              if (n && (o = n(o), i = n(i)), i !== o) return !1;
            }
            return !0;
          }(this._results, r, n)) && (this._results = r, this.length = r.length, this.last = r[this.length - 1], this.first = r[0]);
        }
      }, {
        key: "notifyOnChanges",
        value: function notifyOnChanges() {
          void 0 !== this._changes && (this._changesDetected || !this._emitDistinctChangesOnly) && this._changes.next(this);
        }
      }, {
        key: "onDirty",
        value: function onDirty(t) {
          this._onDirty = t;
        }
      }, {
        key: "setDirty",
        value: function setDirty() {
          var _this$_onDirty;
          this.dirty = !0, (_this$_onDirty = this._onDirty) === null || _this$_onDirty === void 0 ? void 0 : _this$_onDirty.call(this);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          void 0 !== this._changes && (this._changes.complete(), this._changes.unsubscribe());
        }
      }]);
    }();
    function Fi(e) {
      return !(128 & ~e.flags);
    }
    var Ya = function (e) {
      return e[e.OnPush = 0] = "OnPush", e[e.Default = 1] = "Default", e;
    }(Ya || {});
    var Ja = new Map();
    var m0 = 0;
    function Td(e) {
      Ja.delete(e[19]);
    }
    var Rd = "__ngContext__";
    function lt(e, t) {
      De(t) ? (e[Rd] = t[19], function y0(e) {
        Ja.set(e[19], e);
      }(t)) : e[Rd] = t;
    }
    function Uv(e) {
      return $v(e[12]);
    }
    function Hv(e) {
      return $v(e[4]);
    }
    function $v(e) {
      for (; null !== e && !Re(e);) e = e[4];
      return e;
    }
    var xd;
    var Tn = new I("", {
        providedIn: "root",
        factory: function factory() {
          return L0;
        }
      }),
      L0 = "ng",
      kd = new I(""),
      Od = new I("", {
        providedIn: "platform",
        factory: function factory() {
          return "unknown";
        }
      }),
      Yv = new I("", {
        providedIn: "root",
        factory: function factory() {
          var _on$body;
          return ((_on$body = function on() {
            if (void 0 !== xd) return xd;
            if ((typeof document === "undefined" ? "undefined" : _typeof(document)) < "u") return document;
            throw new E(210, !1);
          }().body) === null || _on$body === void 0 || (_on$body = _on$body.querySelector("[ngCspNonce]")) === null || _on$body === void 0 ? void 0 : _on$body.getAttribute("ngCspNonce")) || null;
        }
      }),
      ey = new I("", {
        providedIn: "root",
        factory: function factory() {
          return !1;
        }
      });
    var qd = function (e) {
      return e[e.CHANGE_DETECTION = 0] = "CHANGE_DETECTION", e[e.AFTER_NEXT_RENDER = 1] = "AFTER_NEXT_RENDER", e;
    }(qd || {});
    var Do = new I(""),
      oy = new Set();
    function wt(e) {
      var _performance, _performance$mark;
      oy.has(e) || (oy.add(e), (_performance = performance) === null || _performance === void 0 || (_performance$mark = _performance.mark) === null || _performance$mark === void 0 ? void 0 : _performance$mark.call(_performance, "mark_feature_usage", {
        detail: {
          feature: e
        }
      }));
    }
    var ru = function (_e7) {
      return _e7 = /*#__PURE__*/_createClass(function e(n, r) {
        _classCallCheck(this, e);
        _defineProperty(this, "view", void 0);
        _defineProperty(this, "node", void 0);
        this.view = n, this.node = r;
      }), _defineProperty(_e7, "__NG_ELEMENT_ID__", H0), _e7;
    }();
    function H0() {
      return new ru(v(), z());
    }
    var Gd = function (_e8) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
          _defineProperty(this, "impl", null);
        }
        return _createClass(e, [{
          key: "execute",
          value: function execute() {
            var _this$impl;
            (_this$impl = this.impl) === null || _this$impl === void 0 || _this$impl.execute();
          }
        }]);
      }();
      _e8 = e;
      _defineProperty(e, "\u0275prov", b({
        token: _e8,
        providedIn: "root",
        factory: function factory() {
          return new _e8();
        }
      }));
      return e;
    }();
    function Oy(e, t) {
      var n = e.contentQueries;
      if (null !== n) {
        var r = B(null);
        try {
          for (var o = 0; o < n.length; o += 2) {
            var s = n[o + 1];
            if (-1 !== s) {
              var a = e.data[s];
              Ba(n[o]), a.contentQueries(2, t[s], s);
            }
          }
        } finally {
          B(r);
        }
      }
    }
    function af(e, t, n) {
      Ba(0);
      var r = B(null);
      try {
        t(e, n);
      } finally {
        B(r);
      }
    }
    function uf(e, t, n) {
      if (Gl(t)) {
        var r = B(null);
        try {
          var i = t.directiveEnd;
          for (var s = t.directiveStart; s < i; s++) {
            var a = e.data[s];
            a.contentQueries && a.contentQueries(1, n[s], s);
          }
        } finally {
          B(r);
        }
      }
    }
    var Tt = function (e) {
      return e[e.Emulated = 0] = "Emulated", e[e.None = 2] = "None", e[e.ShadowDom = 3] = "ShadowDom", e;
    }(Tt || {});
    var Vy = /*#__PURE__*/function () {
      function Vy(t) {
        _classCallCheck(this, Vy);
        _defineProperty(this, "changingThisBreaksApplicationSecurity", void 0);
        this.changingThisBreaksApplicationSecurity = t;
      }
      return _createClass(Vy, [{
        key: "toString",
        value: function toString() {
          return "SafeValue must use [property]=binding: ".concat(this.changingThisBreaksApplicationSecurity, " (see ").concat(Jg, ")");
        }
      }]);
    }();
    function qn(e) {
      return e instanceof Vy ? e.changingThisBreaksApplicationSecurity : e;
    }
    var ON = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:\/?#]*(?:[\/?#]|$))/i;
    var No = function (e) {
      return e[e.NONE = 0] = "NONE", e[e.HTML = 1] = "HTML", e[e.STYLE = 2] = "STYLE", e[e.SCRIPT = 3] = "SCRIPT", e[e.URL = 4] = "URL", e[e.RESOURCE_URL = 5] = "RESOURCE_URL", e;
    }(No || {});
    function Ji(e) {
      var t = function Ki() {
        var e = v();
        return e && e[10].sanitizer;
      }();
      return t ? t.sanitize(No.URL, e) || "" : function Qi(e, t) {
        var n = function RN(e) {
          return e instanceof Vy && e.getTypeName() || null;
        }(e);
        if (null != n && n !== t) {
          if ("ResourceURL" === n && "URL" === t) return !0;
          throw new Error("Required a safe ".concat(t, ", got a ").concat(n, " (see ").concat(Jg, ")"));
        }
        return n === t;
      }(e, "URL") ? qn(e) : function lf(e) {
        return (e = String(e)).match(ON) ? e : "unsafe:" + e;
      }(L(e));
    }
    var YN = /^>|^->|<!--|-->|--!>|<!-$/g,
      JN = /(<|>)/g;
    function sn(e) {
      return e instanceof Function ? e() : e;
    }
    function cR(e, t, n) {
      var r = e.length;
      for (;;) {
        var o = e.indexOf(t, n);
        if (-1 === o) return o;
        if (0 === o || e.charCodeAt(o - 1) <= 32) {
          var i = t.length;
          if (o + i === r || e.charCodeAt(o + i) <= 32) return o;
        }
        n = o + 1;
      }
    }
    var oD = "ng-template";
    function lR(e, t, n, r) {
      var o = 0;
      if (r) {
        for (; o < t.length && "string" == typeof t[o]; o += 2) if ("class" === t[o] && -1 !== cR(t[o + 1].toLowerCase(), n, 0)) return !0;
      } else if (mf(e)) return !1;
      if (o = t.indexOf(1, o), o > -1) {
        var i;
        for (; ++o < t.length && "string" == typeof (i = t[o]);) if (i.toLowerCase() === n) return !0;
      }
      return !1;
    }
    function mf(e) {
      return 4 === e.type && e.value !== oD;
    }
    function dR(e, t, n) {
      return t === (4 !== e.type || n ? e.value : oD);
    }
    function fR(e, t, n) {
      var r = 4;
      var o = e.attrs,
        i = null !== o ? function gR(e) {
          for (var _t2 = 0; _t2 < e.length; _t2++) if (ev(e[_t2])) return _t2;
          return e.length;
        }(o) : 0;
      var s = !1;
      for (var a = 0; a < t.length; a++) {
        var u = t[a];
        if ("number" != typeof u) {
          if (!s) if (4 & r) {
            if (r = 2 | 1 & r, "" !== u && !dR(e, u, n) || "" === u && 1 === t.length) {
              if (Ht(r)) return !1;
              s = !0;
            }
          } else if (8 & r) {
            if (null === o || !lR(e, o, u, n)) {
              if (Ht(r)) return !1;
              s = !0;
            }
          } else {
            var c = t[++a],
              l = hR(u, o, mf(e), n);
            if (-1 === l) {
              if (Ht(r)) return !1;
              s = !0;
              continue;
            }
            if ("" !== c) {
              var d = void 0;
              if (d = l > i ? "" : o[l + 1].toLowerCase(), 2 & r && c !== d) {
                if (Ht(r)) return !1;
                s = !0;
              }
            }
          }
        } else {
          if (!s && !Ht(r) && !Ht(u)) return !1;
          if (s && Ht(u)) continue;
          s = !1, r = u | 1 & r;
        }
      }
      return Ht(r) || s;
    }
    function Ht(e) {
      return !(1 & e);
    }
    function hR(e, t, n, r) {
      if (null === t) return -1;
      var o = 0;
      if (r || !n) {
        var i = !1;
        for (; o < t.length;) {
          var s = t[o];
          if (s === e) return o;
          if (3 === s || 6 === s) i = !0;else {
            if (1 === s || 2 === s) {
              var a = t[++o];
              for (; "string" == typeof a;) a = t[++o];
              continue;
            }
            if (4 === s) break;
            if (0 === s) {
              o += 4;
              continue;
            }
          }
          o += i ? 1 : 2;
        }
        return -1;
      }
      return function mR(e, t) {
        var n = e.indexOf(4);
        if (n > -1) for (n++; n < e.length;) {
          var _r6 = e[n];
          if ("number" == typeof _r6) return -1;
          if (_r6 === t) return n;
          n++;
        }
        return -1;
      }(t, e);
    }
    function iD(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      for (var r = 0; r < t.length; r++) if (fR(e, t[r], n)) return !0;
      return !1;
    }
    function sD(e, t) {
      return e ? ":not(" + t.trim() + ")" : t;
    }
    function yR(e) {
      var t = e[0],
        n = 1,
        r = 2,
        o = "",
        i = !1;
      for (; n < e.length;) {
        var s = e[n];
        if ("string" == typeof s) {
          if (2 & r) {
            var a = e[++n];
            o += "[" + s + (a.length > 0 ? '="' + a + '"' : "") + "]";
          } else 8 & r ? o += "." + s : 4 & r && (o += " " + s);
        } else "" !== o && !Ht(s) && (t += sD(i, o), o = ""), r = s, i = i || !Ht(r);
        n++;
      }
      return "" !== o && (t += sD(i, o)), t;
    }
    var j = {};
    function yf(e, t) {
      return e.createComment(function Yy(e) {
        return e.replace(YN, function (t) {
          return t.replace(JN, "\u200B$1\u200B");
        });
      }(t));
    }
    function vu(e, t, n) {
      return e.createElement(t, n);
    }
    function Nr(e, t, n, r, o) {
      e.insertBefore(t, n, r, o);
    }
    function uD(e, t, n) {
      e.appendChild(t, n);
    }
    function cD(e, t, n, r, o) {
      null !== r ? Nr(e, t, n, r, o) : uD(e, t, n);
    }
    function dD(e, t, n) {
      var r = n.mergedAttrs,
        o = n.classes,
        i = n.styles;
      null !== r && function FT(e, t, n) {
        var r = 0;
        for (; r < n.length;) {
          var _o3 = n[r];
          if ("number" == typeof _o3) {
            if (0 !== _o3) break;
            r++;
            var _i3 = n[r++],
              s = n[r++],
              a = n[r++];
            e.setAttribute(t, s, a, _i3);
          } else {
            var _i4 = _o3,
              _s4 = n[++r];
            tv(_i4) ? e.setProperty(t, _i4, _s4) : e.setAttribute(t, _i4, _s4), r++;
          }
        }
      }(e, t, r), null !== o && function CR(e, t, n) {
        "" === n ? e.removeAttribute(t, "class") : e.setAttribute(t, "class", n);
      }(e, t, o), null !== i && function ER(e, t, n) {
        e.setAttribute(t, "style", n);
      }(e, t, i);
    }
    function Df(e, t, n, r, o, i, s, a, u, c, l) {
      var d = M + r,
        h = d + o,
        f = function IR(e, t) {
          var n = [];
          for (var _r7 = 0; _r7 < t; _r7++) n.push(_r7 < e ? null : j);
          return n;
        }(d, h),
        p = "function" == typeof c ? c() : c;
      return f[1] = {
        type: e,
        blueprint: f,
        template: n,
        queries: null,
        viewQuery: a,
        declTNode: t,
        data: f.slice().fill(null, d),
        bindingStartIndex: d,
        expandoStartIndex: h,
        hostBindingOpCodes: null,
        firstCreatePass: !0,
        firstUpdatePass: !0,
        staticViewQueries: !1,
        staticContentQueries: !1,
        preOrderHooks: null,
        preOrderCheckHooks: null,
        contentHooks: null,
        contentCheckHooks: null,
        viewHooks: null,
        viewCheckHooks: null,
        destroyHooks: null,
        cleanup: null,
        contentQueries: null,
        components: null,
        directiveRegistry: "function" == typeof i ? i() : i,
        pipeRegistry: "function" == typeof s ? s() : s,
        firstChild: null,
        schemas: u,
        consts: p,
        incompleteFirstPass: !1,
        ssrId: l
      };
    }
    function yu(e, t, n, r, o, i, s, a, u, c, l) {
      var d = t.blueprint.slice();
      return d[0] = o, d[2] = 1228 | r, (null !== c || e && 2048 & e[2]) && (d[2] |= 2048), Pm(d), d[3] = d[14] = e, d[8] = n, d[10] = s || e && e[10], d[x] = a || e && e[x], d[9] = u || e && e[9] || null, d[5] = i, d[19] = function v0() {
        return m0++;
      }(), d[6] = l, d[20] = c, d[15] = 2 == t.type ? e[15] : d, d;
    }
    function wf(e) {
      var t = 16;
      return e.signals ? t = 4096 : e.onPush && (t = 64), t;
    }
    function es(e, t, n, r) {
      if (0 === n) return -1;
      var o = t.length;
      for (var i = 0; i < n; i++) t.push(r), e.blueprint.push(r), e.data.push(null);
      return o;
    }
    function Ef(e, t) {
      return e[12] ? e[13][4] = t : e[12] = t, e[13] = t, t;
    }
    function ae() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      hD(k(), v(), Ve() + e, !1);
    }
    function hD(e, t, n, r) {
      if (!r) if (3 & ~t[2]) {
        var i = e.preOrderHooks;
        null !== i && Ha(t, i, 0, n);
      } else {
        var _i5 = e.preOrderCheckHooks;
        null !== _i5 && Ua(t, _i5, n);
      }
      br(n);
    }
    var Du = function (e) {
      return e[e.None = 0] = "None", e[e.SignalBased = 1] = "SignalBased", e[e.HasDecoratorInputTransform = 2] = "HasDecoratorInputTransform", e;
    }(Du || {});
    function Cf(e, t, n, r) {
      var o = B(null);
      try {
        var _e$inputs$n = _slicedToArray(e.inputs[n], 3),
          i = _e$inputs$n[0],
          s = _e$inputs$n[1],
          a = _e$inputs$n[2];
        var u = null;
        !!(s & Du.SignalBased) && (u = t[i][Fe]), null !== u && void 0 !== u.transformFn ? r = u.transformFn(r) : null !== a && (r = a.call(t, r)), null !== e.setInput ? e.setInput(t, u, r, n, i) : Nm(t, u, i, r);
      } finally {
        B(o);
      }
    }
    function pD(e, t, n, r, o) {
      var i = Ve(),
        s = 2 & r;
      try {
        br(-1), s && t.length > M && hD(e, t, M, !1), n(r, o);
      } finally {
        br(i);
      }
    }
    function wu(e, t, n) {
      (function AR(e, t, n) {
        var r = n.directiveStart,
          o = n.directiveEnd;
        jt(n) && function _R(e, t, n) {
          var r = Ze(t, e),
            o = function fD(e) {
              var t = e.tView;
              return null === t || t.incompleteFirstPass ? e.tView = Df(1, null, e.template, e.decls, e.vars, e.directiveDefs, e.pipeDefs, e.viewQuery, e.schemas, e.consts, e.id) : t;
            }(n),
            i = e[10].rendererFactory,
            s = Ef(e, yu(e, o, null, wf(n), r, t, null, i.createRenderer(r, n), null, null, null));
          e[t.index] = s;
        }(t, n, e.data[r + n.componentOffset]), e.firstCreatePass || za(n, t);
        var i = n.initialInputs;
        for (var s = r; s < o; s++) {
          var a = e.data[s],
            u = Ai(t, e, s, n);
          lt(u, t), null !== i && OR(0, s - r, u, a, 0, i), Dt(a) && (Qe(n.index, t)[8] = Ai(t, e, s, n));
        }
      })(e, t, n), !(64 & ~n.flags) && function xR(e, t, n) {
        var r = n.directiveStart,
          o = n.directiveEnd,
          i = n.index,
          s = function _T() {
            return F.lFrame.currentDirectiveIndex;
          }();
        try {
          br(i);
          for (var a = r; a < o; a++) {
            var u = e.data[a],
              c = t[a];
            sd(a), (null !== u.hostBindings || 0 !== u.hostVars || null !== u.hostAttrs) && kR(u, c);
          }
        } finally {
          br(-1), sd(s);
        }
      }(e, t, n);
    }
    function If(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Ze;
      var r = t.localNames;
      if (null !== r) {
        var o = t.index + 1;
        for (var i = 0; i < r.length; i += 2) {
          var s = r[i + 1],
            a = -1 === s ? n(t, e) : e[s];
          e[o++] = a;
        }
      }
    }
    var gD = function gD() {
      return null;
    };
    function dt(e, t, n, r, o, i, s, a) {
      if (a || !Sf(t, e, n, r, o)) {
        if (3 & t.type) {
          var u = Ze(t, n);
          r = function NR(e) {
            return "class" === e ? "className" : "for" === e ? "htmlFor" : "formaction" === e ? "formAction" : "innerHtml" === e ? "innerHTML" : "readonly" === e ? "readOnly" : "tabindex" === e ? "tabIndex" : e;
          }(r), o = null != s ? s(o, t.value || "", r) : o, i.setProperty(u, r, o);
        }
      } else jt(t) && function RR(e, t) {
        var n = Qe(t, e);
        16 & n[2] || (n[2] |= 64);
      }(n, t.index);
    }
    function kR(e, t) {
      null !== e.hostBindings && e.hostBindings(1, t);
    }
    function _f(e, t) {
      var n = e.directiveRegistry;
      var r = null;
      if (n) for (var o = 0; o < n.length; o++) {
        var i = n[o];
        iD(t, i.selectors, !1) && (r !== null && r !== void 0 ? r : r = [], Dt(i) ? r.unshift(i) : r.push(i));
      }
      return r;
    }
    function OR(e, t, n, r, o, i) {
      var s = i[t];
      if (null !== s) for (var a = 0; a < s.length; a += 2) Cf(r, n, s[a], s[a + 1]);
    }
    function Sf(e, t, n, r, o) {
      var _e$inputs, _e$hostDirectiveInput;
      var i = (_e$inputs = e.inputs) === null || _e$inputs === void 0 ? void 0 : _e$inputs[r],
        s = (_e$hostDirectiveInput = e.hostDirectiveInputs) === null || _e$hostDirectiveInput === void 0 ? void 0 : _e$hostDirectiveInput[r];
      var a = !1;
      if (s) for (var u = 0; u < s.length; u += 2) {
        var c = s[u];
        Cf(t.data[c], n[c], s[u + 1], o), a = !0;
      }
      if (i) {
        var _iterator10 = _createForOfIteratorHelper(i),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _u4 = _step10.value;
            Cf(t.data[_u4], n[_u4], r, o), a = !0;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      return a;
    }
    function PR(e, t) {
      var n = Qe(t, e),
        r = n[1];
      !function FR(e, t) {
        for (var _n2 = t.length; _n2 < e.blueprint.length; _n2++) t.push(e.blueprint[_n2]);
      }(r, n);
      var o = n[0];
      null !== o && null === n[6] && (n[6] = null), Eu(r, n, n[8]);
    }
    function Eu(e, t, n) {
      cd(t);
      try {
        var _t$;
        var r = e.viewQuery;
        null !== r && af(1, r, n);
        var o = e.template;
        null !== o && pD(e, t, o, 1, n), e.firstCreatePass && (e.firstCreatePass = !1), (_t$ = t[18]) !== null && _t$ !== void 0 && _t$.finishViewCreation(e), e.staticContentQueries && Oy(e, t), e.staticViewQueries && af(2, e.viewQuery, n);
        var i = e.components;
        null !== i && function LR(e, t) {
          for (var _n3 = 0; _n3 < t.length; _n3++) PR(e, t[_n3]);
        }(t, i);
      } catch (r) {
        throw e.firstCreatePass && (e.incompleteFirstPass = !0, e.firstCreatePass = !1), r;
      } finally {
        t[2] &= -5, ld();
      }
    }
    function Rr(e, t) {
      return !t || null === t.firstChild || Fi(e);
    }
    function Nf(e, t) {
      return undefined(e, t);
    }
    var Gn = function (e) {
      return e[e.Important = 1] = "Important", e[e.DashCase = 2] = "DashCase", e;
    }(Gn || {});
    function Wn(e) {
      return !(32 & ~e.flags);
    }
    function xo(e, t, n, r, o) {
      if (null != r) {
        var i,
          s = !1;
        Re(r) ? i = r : De(r) && (s = !0, r = r[0]);
        var a = Q(r);
        0 === e && null !== n ? null == o ? uD(t, n, a) : Nr(t, n, a, o || null, !0) : 1 === e && null !== n ? Nr(t, n, a, o || null, !0) : 2 === e ? function Xi(e, t, n) {
          e.removeChild(null, t, n);
        }(t, a, s) : 3 === e && t.destroyNode(a), null != i && function zR(e, t, n, r, o) {
          var i = n[7];
          i !== Q(n) && xo(t, e, r, i, o);
          for (var _a4 = 10; _a4 < n.length; _a4++) {
            var u = n[_a4];
            Iu(u[1], u, e, t, r, i);
          }
        }(t, e, i, n, o);
      }
    }
    function DD(e, t) {
      var _t$10$changeDetection;
      (_t$10$changeDetection = t[10].changeDetectionScheduler) !== null && _t$10$changeDetection !== void 0 && _t$10$changeDetection.notify(9), Iu(e, t, t[x], 2, null, null);
    }
    function Rf(e, t) {
      var n = e[9],
        r = n.indexOf(t);
      n.splice(r, 1);
    }
    function ts(e, t) {
      if (In(t)) return;
      var n = t[x];
      n.destroyNode && Iu(e, t, n, 3, null, null), function BR(e) {
        var t = e[12];
        if (!t) return Af(e[1], e);
        for (; t;) {
          var _n4 = null;
          if (De(t)) _n4 = t[12];else {
            var r = t[10];
            r && (_n4 = r);
          }
          if (!_n4) {
            for (; t && !t[4] && t !== e;) De(t) && Af(t[1], t), t = t[3];
            null === t && (t = e), De(t) && Af(t[1], t), _n4 = t && t[4];
          }
          t = _n4;
        }
      }(t);
    }
    function Af(e, t) {
      if (In(t)) return;
      var n = B(null);
      try {
        t[2] &= -129, t[2] |= 256, t[24] && sa(t[24]), function HR(e, t) {
          var n;
          if (null != e && null != (n = e.destroyHooks)) for (var _r8 = 0; _r8 < n.length; _r8 += 2) {
            var o = t[n[_r8]];
            if (!(o instanceof Ti)) {
              var i = n[_r8 + 1];
              if (Array.isArray(i)) for (var s = 0; s < i.length; s += 2) {
                var a = o[i[s]],
                  u = i[s + 1];
                try {
                  u.call(a);
                } finally {}
              } else try {
                i.call(o);
              } finally {}
            }
          }
        }(e, t), function UR(e, t) {
          var n = e.cleanup,
            r = t[7];
          if (null !== n) for (var s = 0; s < n.length - 1; s += 2) if ("string" == typeof n[s]) {
            var a = n[s + 3];
            a >= 0 ? r[a]() : r[-a].unsubscribe(), s += 2;
          } else n[s].call(r[n[s + 1]]);
          null !== r && (t[7] = null);
          var o = t[21];
          if (null !== o) {
            t[21] = null;
            for (var _s5 = 0; _s5 < o.length; _s5++) (0, o[_s5])();
          }
          var i = t[23];
          if (null !== i) {
            t[23] = null;
            var _iterator11 = _createForOfIteratorHelper(i),
              _step11;
            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var _s6 = _step11.value;
                _s6.destroy();
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }
          }
        }(e, t), 1 === t[1].type && t[x].destroy();
        var r = t[16];
        if (null !== r && Re(t[3])) {
          r !== t[3] && Rf(r, t);
          var o = t[18];
          null !== o && o.detachView(e);
        }
        Td(t);
      } finally {
        B(n);
      }
    }
    function xf(e, t, n) {
      return function wD(e, t, n) {
        var r = t;
        for (; null !== r && 168 & r.type;) r = (t = r).parent;
        if (null === r) return n[0];
        if (jt(r)) {
          var o = e.data[r.directiveStart + r.componentOffset].encapsulation;
          if (o === Tt.None || o === Tt.Emulated) return null;
        }
        return Ze(r, n);
      }(e, t.parent, n);
    }
    var ID = function CD(e, t, n) {
      return 40 & e.type ? Ze(e, n) : null;
    };
    function Cu(e, t, n, r) {
      var o = xf(e, r, t),
        i = t[x],
        a = function ED(e, t, n) {
          return ID(e, t, n);
        }(r.parent || t[5], r, t);
      if (null != o) if (Array.isArray(n)) for (var u = 0; u < n.length; u++) cD(i, o, n[u], a, !1);else cD(i, o, n, a, !1);
    }
    function Ar(e, t) {
      if (null !== t) {
        var n = t.type;
        if (3 & n) return Ze(t, e);
        if (4 & n) return Of(-1, e[t.index]);
        if (8 & n) {
          var r = t.child;
          if (null !== r) return Ar(e, r);
          {
            var o = e[t.index];
            return Re(o) ? Of(-1, o) : Q(o);
          }
        }
        if (128 & n) return Ar(e, t.next);
        if (32 & n) return Nf(t, e)() || Q(e[t.index]);
        {
          var _r9 = bD(e, t);
          return null !== _r9 ? Array.isArray(_r9) ? _r9[0] : Ar(_n(e[15]), _r9) : Ar(e, t.next);
        }
      }
      return null;
    }
    function bD(e, t) {
      return null !== t ? e[15][5].projection[t.projection] : null;
    }
    function Of(e, t) {
      var n = 10 + e + 1;
      if (n < t.length) {
        var r = t[n],
          o = r[1].firstChild;
        if (null !== o) return Ar(r, o);
      }
      return t[7];
    }
    function Pf(e, t, n, r, o, i, s) {
      for (; null != n;) {
        if (128 === n.type) {
          n = n.next;
          continue;
        }
        var a = r[n.index],
          u = n.type;
        if (s && 0 === t && (a && lt(Q(a), r), n.flags |= 2), !Wn(n)) if (8 & u) Pf(e, t, n.child, r, o, i, !1), xo(t, e, o, a, i);else if (32 & u) {
          var c = Nf(n, r);
          var l = void 0;
          for (; l = c();) xo(t, e, o, l, i);
          xo(t, e, o, a, i);
        } else 16 & u ? MD(e, t, r, n, o, i) : xo(t, e, o, a, i);
        n = s ? n.projectionNext : n.next;
      }
    }
    function Iu(e, t, n, r, o, i) {
      Pf(n, r, e.firstChild, t, o, i, !1);
    }
    function MD(e, t, n, r, o, i) {
      var s = n[15],
        u = s[5].projection[r.projection];
      if (Array.isArray(u)) for (var c = 0; c < u.length; c++) xo(t, e, o, u[c], i);else {
        var _c5 = u;
        var l = s[3];
        Fi(r) && (_c5.flags |= 128), Pf(e, t, _c5, l, o, i, !0);
      }
    }
    function ko(e, t, n, r) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      for (; null !== n;) {
        if (128 === n.type) {
          n = o ? n.projectionNext : n.next;
          continue;
        }
        var i = t[n.index];
        null !== i && r.push(Q(i)), Re(i) && Ff(i, r);
        var s = n.type;
        if (8 & s) ko(e, t, n.child, r);else if (32 & s) {
          var a = Nf(n, t);
          var u = void 0;
          for (; u = a();) r.push(u);
        } else if (16 & s) {
          var _a5 = bD(t, n);
          if (Array.isArray(_a5)) r.push.apply(r, _toConsumableArray(_a5));else {
            var _u5 = _n(t[15]);
            ko(_u5[1], _u5, _a5, r, !0);
          }
        }
        n = o ? n.projectionNext : n.next;
      }
      return r;
    }
    function Ff(e, t) {
      for (var n = 10; n < e.length; n++) {
        var r = e[n],
          o = r[1].firstChild;
        null !== o && ko(r[1], r, o, t);
      }
      e[7] !== e[0] && t.push(e[7]);
    }
    function SD(e) {
      if (null !== e[25]) {
        var _iterator12 = _createForOfIteratorHelper(e[25]),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var t = _step12.value;
            t.impl.addSequence(t);
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        e[25].length = 0;
      }
    }
    var TD = [];
    var QR = _objectSpread(_objectSpread({}, Qr), {}, {
        consumerIsAlwaysLive: !0,
        kind: "template",
        consumerMarkedDirty: function consumerMarkedDirty(e) {
          po(e.lView);
        },
        consumerOnSignalRead: function consumerOnSignalRead() {
          this.lView[24] = this;
        }
      }),
      JR = _objectSpread(_objectSpread({}, Qr), {}, {
        consumerIsAlwaysLive: !0,
        kind: "template",
        consumerMarkedDirty: function consumerMarkedDirty(e) {
          var t = _n(e.lView);
          for (; t && !ND(t[1]);) t = _n(t);
          t && Yl(t);
        },
        consumerOnSignalRead: function consumerOnSignalRead() {
          this.lView[24] = this;
        }
      });
    function ND(e) {
      return 2 !== e.type;
    }
    function RD(e) {
      if (null === e[23]) return;
      var t = !0;
      for (; t;) {
        var n = !1;
        var _iterator13 = _createForOfIteratorHelper(e[23]),
          _step13;
        try {
          var _loop2 = function _loop2() {
            var r = _step13.value;
            r.dirty && (n = !0, null === r.zone || Zone.current === r.zone ? r.run() : r.zone.run(function () {
              return r.run();
            }));
          };
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
        t = n && !!(8192 & e[2]);
      }
    }
    function _u(e) {
      var _o$begin;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var o = e[10].rendererFactory;
      (_o$begin = o.begin) === null || _o$begin === void 0 || _o$begin.call(o);
      try {
        !function XR(e, t) {
          var n = Hm();
          try {
            Va(!0), Lf(e, t);
            var r = 0;
            for (; bi(e);) {
              if (100 === r) throw new E(103, !1);
              r++, Lf(e, 1);
            }
          } finally {
            Va(n);
          }
        }(e, n);
      } catch (s) {
        throw t && function Mf(e, t) {
          var n = e[9],
            r = n ? n.get(Ut, null) : null;
          r && r.handleError(t);
        }(e, s), s;
      } finally {
        var _o$end;
        (_o$end = o.end) === null || _o$end === void 0 || _o$end.call(o);
      }
    }
    function xD(e, t, n, r) {
      if (In(t)) return;
      var o = t[2];
      cd(t);
      var a = !0,
        u = null,
        c = null;
      ND(e) ? (c = function GR(e, _e$3) {
        return (_e$3 = e[24]) !== null && _e$3 !== void 0 ? _e$3 : function WR(e, _TD$pop) {
          var t = (_TD$pop = TD.pop()) !== null && _TD$pop !== void 0 ? _TD$pop : Object.create(QR);
          return t.lView = e, t;
        }(e);
      }(t), u = Yr(c)) : null === function sl() {
        return Se;
      }() ? (a = !1, c = function YR(e, _e$4) {
        var t = (_e$4 = e[24]) !== null && _e$4 !== void 0 ? _e$4 : Object.create(JR);
        return t.lView = e, t;
      }(t), u = Yr(c)) : t[24] && (sa(t[24]), t[24] = null);
      try {
        Pm(t), function $m(e) {
          return F.lFrame.bindingIndex = e;
        }(e.bindingStartIndex), null !== n && pD(e, t, n, 2, r);
        var l = !(3 & ~o);
        if (l) {
          var f = e.preOrderCheckHooks;
          null !== f && Ua(t, f, null);
        } else {
          var _f3 = e.preOrderHooks;
          null !== _f3 && Ha(t, _f3, 0, null), fd(t, 0);
        }
        if (function eA(e) {
          for (var _t3 = Uv(e); null !== _t3; _t3 = Hv(_t3)) {
            if (!(2 & _t3[2])) continue;
            var _n5 = _t3[9];
            for (var _r0 = 0; _r0 < _n5.length; _r0++) Yl(_n5[_r0]);
          }
        }(t), RD(t), kD(t, 0), null !== e.contentQueries && Oy(e, t), l) {
          var _f4 = e.contentCheckHooks;
          null !== _f4 && Ua(t, _f4);
        } else {
          var _f5 = e.contentHooks;
          null !== _f5 && Ha(t, _f5, 1), fd(t, 1);
        }
        !function nA(e, t) {
          var n = e.hostBindingOpCodes;
          if (null !== n) try {
            for (var _r1 = 0; _r1 < n.length; _r1++) {
              var _o4 = n[_r1];
              if (_o4 < 0) br(~_o4);else {
                var i = _o4,
                  s = n[++_r1],
                  _a6 = n[++_r1];
                IT(s, i);
                var _u6 = t[i];
                _a6(2, _u6);
              }
            }
          } finally {
            br(-1);
          }
        }(e, t);
        var d = e.components;
        null !== d && PD(t, d, 0);
        var h = e.viewQuery;
        if (null !== h && af(2, h, r), l) {
          var _f6 = e.viewCheckHooks;
          null !== _f6 && Ua(t, _f6);
        } else {
          var _f7 = e.viewHooks;
          null !== _f7 && Ha(t, _f7, 2), fd(t, 2);
        }
        if (!0 === e.firstUpdatePass && (e.firstUpdatePass = !1), t[22]) {
          var _iterator14 = _createForOfIteratorHelper(t[22]),
            _step14;
          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _f8 = _step14.value;
              _f8();
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
          t[22] = null;
        }
        SD(t), t[2] &= -73;
      } catch (l) {
        throw po(t), l;
      } finally {
        null !== c && (vi(c, u), a && function ZR(e) {
          e.lView[24] !== e && (e.lView = null, TD.push(e));
        }(c)), ld();
      }
    }
    function kD(e, t) {
      for (var n = Uv(e); null !== n; n = Hv(n)) for (var r = 10; r < n.length; r++) OD(n[r], t);
    }
    function tA(e, t, n) {
      var r = Qe(t, e);
      OD(r, n);
    }
    function OD(e, t) {
      Ql(e) && Lf(e, t);
    }
    function Lf(e, t) {
      var r = e[1],
        o = e[2],
        i = e[24];
      var s = !!(0 === t && 16 & o);
      if (s || (s = !!(64 & o && 0 === t)), s || (s = !!(1024 & o)), s || (s = !(!(i !== null && i !== void 0 && i.dirty) || !ia(i))), s || (s = !1), i && (i.dirty = !1), e[2] &= -9217, s) xD(r, e, r.template, e[8]);else if (8192 & o) {
        RD(e), kD(e, 1);
        var a = r.components;
        null !== a && PD(e, a, 1), SD(e);
      }
    }
    function PD(e, t, n) {
      for (var r = 0; r < t.length; r++) tA(e, t[r], n);
    }
    function ns(e, t) {
      var n = Hm() ? 64 : 1088;
      for ((_e$10$changeDetection3 = e[10].changeDetectionScheduler) === null || _e$10$changeDetection3 === void 0 ? void 0 : _e$10$changeDetection3.notify(t); e;) {
        var _e$10$changeDetection3;
        e[2] |= n;
        var r = _n(e);
        if (Cn(e) && !r) return e;
        e = r;
      }
      return null;
    }
    function FD(e, t, n, r) {
      return [e, !0, 0, t, null, r, null, n, null, null];
    }
    function rs(e, t) {
      if (e.length <= 10) return;
      var n = 10 + t,
        r = e[n];
      if (r) {
        var o = r[16];
        null !== o && o !== e && Rf(o, r), t > 0 && (e[n - 1][4] = r[4]);
        var i = ba(e, 10 + t);
        !function yD(e, t) {
          DD(e, t), t[0] = null, t[5] = null;
        }(r[1], r);
        var s = i[18];
        null !== s && s.detachView(i[1]), r[3] = null, r[4] = null, r[2] &= -129;
      }
      return r;
    }
    function jD(e, t) {
      var n = e[9],
        r = t[3];
      (De(r) || t[15] !== r[3][15]) && (e[2] |= 2), null === n ? e[9] = [t] : n.push(t);
    }
    var os = /*#__PURE__*/function () {
        function os(t, n) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          _classCallCheck(this, os);
          _defineProperty(this, "_lView", void 0);
          _defineProperty(this, "_cdRefInjectingView", void 0);
          _defineProperty(this, "notifyErrorHandler", void 0);
          _defineProperty(this, "_appRef", null);
          _defineProperty(this, "_attachedToViewContainer", !1);
          this._lView = t, this._cdRefInjectingView = n, this.notifyErrorHandler = r;
        }
        return _createClass(os, [{
          key: "rootNodes",
          get: function get() {
            var t = this._lView,
              n = t[1];
            return ko(n, t, n.firstChild, []);
          }
        }, {
          key: "context",
          get: function get() {
            return this._lView[8];
          },
          set: function set(t) {
            this._lView[8] = t;
          }
        }, {
          key: "destroyed",
          get: function get() {
            return In(this._lView);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            if (this._appRef) this._appRef.detachView(this);else if (this._attachedToViewContainer) {
              var t = this._lView[3];
              if (Re(t)) {
                var n = t[8],
                  r = n ? n.indexOf(this) : -1;
                r > -1 && (rs(t, r), ba(n, r));
              }
              this._attachedToViewContainer = !1;
            }
            ts(this._lView[1], this._lView);
          }
        }, {
          key: "onDestroy",
          value: function onDestroy(t) {
            La(this._lView, t);
          }
        }, {
          key: "markForCheck",
          value: function markForCheck() {
            ns(this._cdRefInjectingView || this._lView, 4);
          }
        }, {
          key: "detach",
          value: function detach() {
            this._lView[2] &= -129;
          }
        }, {
          key: "reattach",
          value: function reattach() {
            Jl(this._lView), this._lView[2] |= 128;
          }
        }, {
          key: "detectChanges",
          value: function detectChanges() {
            this._lView[2] |= 1024, _u(this._lView, this.notifyErrorHandler);
          }
        }, {
          key: "checkNoChanges",
          value: function checkNoChanges() {}
        }, {
          key: "attachToViewContainerRef",
          value: function attachToViewContainerRef() {
            if (this._appRef) throw new E(902, !1);
            this._attachedToViewContainer = !0;
          }
        }, {
          key: "detachFromAppRef",
          value: function detachFromAppRef() {
            this._appRef = null;
            var t = Cn(this._lView),
              n = this._lView[16];
            null !== n && !t && Rf(n, this._lView), DD(this._lView[1], this._lView);
          }
        }, {
          key: "attachToAppRef",
          value: function attachToAppRef(t) {
            if (this._attachedToViewContainer) throw new E(902, !1);
            this._appRef = t;
            var n = Cn(this._lView),
              r = this._lView[16];
            null !== r && !n && jD(r, this._lView), Jl(this._lView);
          }
        }]);
      }(),
      xn = function (_e9) {
        return _e9 = /*#__PURE__*/_createClass(function e() {
          _classCallCheck(this, e);
        }), _defineProperty(_e9, "__NG_ELEMENT_ID__", sA), _e9;
      }();
    var oA = xn,
      iA = /*#__PURE__*/function (_oA) {
        function iA(t, n, r) {
          var _this19;
          _classCallCheck(this, iA);
          _this19 = _callSuper(this, iA), _defineProperty(_assertThisInitialized(_this19), "_declarationLView", void 0), _defineProperty(_assertThisInitialized(_this19), "_declarationTContainer", void 0), _defineProperty(_assertThisInitialized(_this19), "elementRef", void 0), _this19._declarationLView = t, _this19._declarationTContainer = n, _this19.elementRef = r;
          return _this19;
        }
        _inherits(iA, _oA);
        return _createClass(iA, [{
          key: "ssrId",
          get: function get() {
            var _this$_declarationTCo;
            return ((_this$_declarationTCo = this._declarationTContainer.tView) === null || _this$_declarationTCo === void 0 ? void 0 : _this$_declarationTCo.ssrId) || null;
          }
        }, {
          key: "createEmbeddedView",
          value: function createEmbeddedView(t, n) {
            return this.createEmbeddedViewImpl(t, n);
          }
        }, {
          key: "createEmbeddedViewImpl",
          value: function createEmbeddedViewImpl(t, n, r) {
            var o = function Ao(e, t, n, r) {
              var o = B(null);
              try {
                var _r$injector, _r$embeddedViewInject, _r$dehydratedView;
                var i = t.tView,
                  u = yu(e, i, n, 4096 & e[2] ? 4096 : 16, null, t, null, null, (_r$injector = r === null || r === void 0 ? void 0 : r.injector) !== null && _r$injector !== void 0 ? _r$injector : null, (_r$embeddedViewInject = r === null || r === void 0 ? void 0 : r.embeddedViewInjector) !== null && _r$embeddedViewInject !== void 0 ? _r$embeddedViewInject : null, (_r$dehydratedView = r === null || r === void 0 ? void 0 : r.dehydratedView) !== null && _r$dehydratedView !== void 0 ? _r$dehydratedView : null);
                u[16] = e[t.index];
                var l = e[18];
                return null !== l && (u[18] = l.createEmbeddedView(i)), Eu(i, u, n), u;
              } finally {
                B(o);
              }
            }(this._declarationLView, this._declarationTContainer, t, {
              embeddedViewInjector: n,
              dehydratedView: r
            });
            return new os(o);
          }
        }]);
      }(oA);
    function sA() {
      return bu(z(), v());
    }
    function bu(e, t) {
      return 4 & e.type ? new iA(t, e, vo(e, t)) : null;
    }
    function Po(e, t, n, r, o) {
      var i = e.data[t];
      if (null === i) i = function Hf(e, t, n, r, o) {
        var i = Vm(),
          s = od(),
          u = e.data[t] = function mA(e, t, n, r, o, i) {
            var s = t ? t.injectorIndex : -1,
              a = 0;
            return function _r() {
              return null !== F.skipHydrationRootTNode;
            }() && (a |= 128), {
              type: n,
              index: r,
              insertBeforeIndex: null,
              injectorIndex: s,
              directiveStart: -1,
              directiveEnd: -1,
              directiveStylingLast: -1,
              componentOffset: -1,
              propertyBindings: null,
              flags: a,
              providerIndexes: 0,
              value: o,
              attrs: i,
              mergedAttrs: null,
              localNames: null,
              initialInputs: null,
              inputs: null,
              hostDirectiveInputs: null,
              outputs: null,
              hostDirectiveOutputs: null,
              directiveToIndex: null,
              tView: null,
              next: null,
              prev: null,
              projectionNext: null,
              child: null,
              parent: t,
              projection: null,
              styles: null,
              stylesWithoutHost: null,
              residualStyles: void 0,
              classes: null,
              classesWithoutHost: null,
              residualClasses: void 0,
              classBindings: 0,
              styleBindings: 0
            };
          }(0, s ? i : i && i.parent, n, t, r, o);
        return function gA(e, t, n, r) {
          null === e.firstChild && (e.firstChild = t), null !== n && (r ? null == n.child && null !== t.parent && (n.child = t) : null === n.next && (n.next = t, t.prev = n));
        }(e, u, i, s), u;
      }(e, t, n, r, o), function CT() {
        return F.lFrame.inI18n;
      }() && (i.flags |= 32);else if (64 & i.type) {
        i.type = n, i.value = r, i.attrs = o;
        var s = function Mi() {
          var e = F.lFrame,
            t = e.currentTNode;
          return e.isParent ? t : t.parent;
        }();
        i.injectorIndex = null === s ? -1 : s.injectorIndex;
      }
      return Vt(i, !0), i;
    }
    var nx = /*#__PURE__*/_createClass(function nx() {
        _classCallCheck(this, nx);
      }),
      aw = /*#__PURE__*/_createClass(function aw() {
        _classCallCheck(this, aw);
      });
    var rx = /*#__PURE__*/function () {
      function rx() {
        _classCallCheck(this, rx);
      }
      return _createClass(rx, [{
        key: "resolveComponentFactory",
        value: function resolveComponentFactory(t) {
          throw Error("No component factory found for ".concat(Te(t), "."));
        }
      }]);
    }();
    var xu = (_Class3 = /*#__PURE__*/_createClass(function xu() {
      _classCallCheck(this, xu);
    }), _defineProperty(_Class3, "NULL", new rx()), _Class3);
    var Yf = /*#__PURE__*/_createClass(function Yf() {
      _classCallCheck(this, Yf);
    });
    var ku = function (_e0) {
        return _e0 = /*#__PURE__*/_createClass(function e() {
          _classCallCheck(this, e);
          _defineProperty(this, "destroyNode", null);
        }), _defineProperty(_e0, "__NG_ELEMENT_ID__", function () {
          return function ox() {
            var e = v(),
              n = Qe(z().index, e);
            return (De(n) ? n : e)[x];
          }();
        }), _e0;
      }(),
      ix = function (_e1) {
        var e = /*#__PURE__*/_createClass(function e() {
          _classCallCheck(this, e);
        });
        _e1 = e;
        _defineProperty(e, "\u0275prov", b({
          token: _e1,
          providedIn: "root",
          factory: function factory() {
            return null;
          }
        }));
        return e;
      }();
    var Kf = {};
    var jo = /*#__PURE__*/function () {
      function jo(t, n) {
        _classCallCheck(this, jo);
        _defineProperty(this, "injector", void 0);
        _defineProperty(this, "parentInjector", void 0);
        this.injector = t, this.parentInjector = n;
      }
      return _createClass(jo, [{
        key: "get",
        value: function get(t, n, r) {
          r = _a(r);
          var o = this.injector.get(t, Kf, r);
          return o !== Kf || n === Kf ? o : this.parentInjector.get(t, n, r);
        }
      }]);
    }();
    function Xf(e, t, n) {
      var r = n ? e.styles : null,
        o = n ? e.classes : null,
        i = 0;
      if (null !== t) for (var s = 0; s < t.length; s++) {
        var a = t[s];
        "number" == typeof a ? i = a : 1 == i ? o = El(o, a) : 2 == i && (r = El(r, a + ": " + t[++s] + ";"));
      }
      n ? e.styles = r : e.stylesWithoutHost = r, n ? e.classes = o : e.classesWithoutHost = o;
    }
    function S(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $.Default;
      var n = v();
      return null === n ? T(e, t) : uv(z(), n, P(e), t);
    }
    function eh(e, t, n, r, o) {
      var i = null === r ? null : {
          "": -1
        },
        s = o(e, n);
      if (null !== s) {
        var _l, _l2;
        var a,
          u = null,
          c = null;
        var l = function dx(e, _r10) {
          var t = null,
            n = !1;
          for (var _s7 = 0; _s7 < e.length; _s7++) {
            var _a7 = e[_s7];
            if (0 === _s7 && Dt(_a7) && (t = _a7), null !== _a7.findHostDirectiveDefs) {
              n = !0;
              break;
            }
          }
          if (!n) return null;
          var r = null,
            o = null,
            i = null;
          var _iterator15 = _createForOfIteratorHelper(e),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _s8 = _step15.value;
              null !== _s8.findHostDirectiveDefs && (r !== null && r !== void 0 ? r : r = [], o !== null && o !== void 0 ? o : o = new Map(), i !== null && i !== void 0 ? i : i = new Map(), fx(_s8, r, i, o)), _s8 === t && (r !== null && r !== void 0 ? r : r = [], r.push(_s8));
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
          return null !== r ? ((_r10 = r).push.apply(_r10, _toConsumableArray(null === t ? e : e.slice(1))), [r, o, i]) : null;
        }(s);
        null === l ? a = s : (_l = l, _l2 = _slicedToArray(_l, 3), a = _l2[0], u = _l2[1], c = _l2[2], _l), function px(e, t, n, r, o, i, s) {
          var a = r.length;
          var u = !1;
          for (var h = 0; h < a; h++) {
            var f = r[h];
            !u && Dt(f) && (u = !0, hx(e, n, h)), yd(za(n, t), e, f.type);
          }
          !function wx(e, t, n) {
            e.flags |= 1, e.directiveStart = t, e.directiveEnd = t + n, e.providerIndexes = t;
          }(n, e.data.length, a);
          for (var _h = 0; _h < a; _h++) {
            var _f9 = r[_h];
            _f9.providersResolver && _f9.providersResolver(_f9);
          }
          var c = !1,
            l = !1,
            d = es(e, t, a, null);
          a > 0 && (n.directiveToIndex = new Map());
          for (var _h2 = 0; _h2 < a; _h2++) {
            var _e$preOrderHooks, _e$preOrderCheckHooks;
            var _f0 = r[_h2];
            if (n.mergedAttrs = mo(n.mergedAttrs, _f0.hostAttrs), mx(e, n, t, d, _f0), Dx(d, _f0, o), null !== s && s.has(_f0)) {
              var _s$get = s.get(_f0),
                _s$get2 = _slicedToArray(_s$get, 2),
                g = _s$get2[0],
                m = _s$get2[1];
              n.directiveToIndex.set(_f0.type, [d, g + n.directiveStart, m + n.directiveStart]);
            } else (null === i || !i.has(_f0)) && n.directiveToIndex.set(_f0.type, d);
            null !== _f0.contentQueries && (n.flags |= 4), (null !== _f0.hostBindings || null !== _f0.hostAttrs || 0 !== _f0.hostVars) && (n.flags |= 64);
            var p = _f0.type.prototype;
            !c && (p.ngOnChanges || p.ngOnInit || p.ngDoCheck) && (((_e$preOrderHooks = e.preOrderHooks) !== null && _e$preOrderHooks !== void 0 ? _e$preOrderHooks : e.preOrderHooks = []).push(n.index), c = !0), !l && (p.ngOnChanges || p.ngDoCheck) && (((_e$preOrderCheckHooks = e.preOrderCheckHooks) !== null && _e$preOrderCheckHooks !== void 0 ? _e$preOrderCheckHooks : e.preOrderCheckHooks = []).push(n.index), l = !0), d++;
          }
          !function gx(e, t, n) {
            for (var _r11 = t.directiveStart; _r11 < t.directiveEnd; _r11++) {
              var _o5 = e.data[_r11];
              if (null !== n && n.has(_o5)) {
                var _i6 = n.get(_o5);
                lw(0, t, _i6, _r11), lw(1, t, _i6, _r11), fw(t, _r11, !0);
              } else cw(0, t, _o5, _r11), cw(1, t, _o5, _r11), fw(t, _r11, !1);
            }
          }(e, n, i);
        }(e, t, n, a, i, u, c);
      }
      null !== i && null !== r && function lx(e, t, n) {
        var r = e.localNames = [];
        for (var _o6 = 0; _o6 < t.length; _o6 += 2) {
          var _i7 = n[t[_o6 + 1]];
          if (null == _i7) throw new E(-301, !1);
          r.push(t[_o6], _i7);
        }
      }(n, r, i);
    }
    function fx(e, t, n, r) {
      var o = t.length;
      e.findHostDirectiveDefs(e, t, r), n.set(e, [o, t.length - 1]);
    }
    function hx(e, t, n) {
      var _e$components;
      t.componentOffset = n, ((_e$components = e.components) !== null && _e$components !== void 0 ? _e$components : e.components = []).push(t.index);
    }
    function cw(e, t, n, r) {
      var o = 0 === e ? n.inputs : n.outputs;
      for (var i in o) if (o.hasOwnProperty(i)) {
        var _t$inputs, _t$outputs, _s9, _s9$i;
        var s = void 0;
        s = 0 === e ? (_t$inputs = t.inputs) !== null && _t$inputs !== void 0 ? _t$inputs : t.inputs = {} : (_t$outputs = t.outputs) !== null && _t$outputs !== void 0 ? _t$outputs : t.outputs = {}, (_s9$i = (_s9 = s)[i]) !== null && _s9$i !== void 0 ? _s9$i : _s9[i] = [], s[i].push(r), dw(t, i);
      }
    }
    function lw(e, t, n, r) {
      var o = 0 === e ? n.inputs : n.outputs;
      for (var i in o) if (o.hasOwnProperty(i)) {
        var _t$hostDirectiveInput, _t$hostDirectiveOutpu, _a8, _a8$s;
        var s = o[i];
        var a = void 0;
        a = 0 === e ? (_t$hostDirectiveInput = t.hostDirectiveInputs) !== null && _t$hostDirectiveInput !== void 0 ? _t$hostDirectiveInput : t.hostDirectiveInputs = {} : (_t$hostDirectiveOutpu = t.hostDirectiveOutputs) !== null && _t$hostDirectiveOutpu !== void 0 ? _t$hostDirectiveOutpu : t.hostDirectiveOutputs = {}, (_a8$s = (_a8 = a)[s]) !== null && _a8$s !== void 0 ? _a8$s : _a8[s] = [], a[s].push(r, i), dw(t, s);
      }
    }
    function dw(e, t) {
      "class" === t ? e.flags |= 8 : "style" === t && (e.flags |= 16);
    }
    function fw(e, t, n) {
      var _e$initialInputs, _e$initialInputs2;
      var r = e.attrs,
        o = e.inputs,
        i = e.hostDirectiveInputs;
      if (null === r || !n && null === o || n && null === i || mf(e)) return (_e$initialInputs = e.initialInputs) !== null && _e$initialInputs !== void 0 ? _e$initialInputs : e.initialInputs = [], void e.initialInputs.push(null);
      var s = null,
        a = 0;
      for (; a < r.length;) {
        var u = r[a];
        if (0 !== u) {
          if (5 !== u) {
            if ("number" == typeof u) break;
            if (!n && o.hasOwnProperty(u)) {
              var c = o[u];
              var _iterator16 = _createForOfIteratorHelper(c),
                _step16;
              try {
                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  var l = _step16.value;
                  if (l === t) {
                    s !== null && s !== void 0 ? s : s = [], s.push(u, r[a + 1]);
                    break;
                  }
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }
            } else if (n && i.hasOwnProperty(u)) {
              var _c6 = i[u];
              for (var _l3 = 0; _l3 < _c6.length; _l3 += 2) if (_c6[_l3] === t) {
                s !== null && s !== void 0 ? s : s = [], s.push(_c6[_l3 + 1], r[a + 1]);
                break;
              }
            }
            a += 2;
          } else a += 2;
        } else a += 4;
      }
      (_e$initialInputs2 = e.initialInputs) !== null && _e$initialInputs2 !== void 0 ? _e$initialInputs2 : e.initialInputs = [], e.initialInputs.push(s);
    }
    function mx(e, t, n, r, o) {
      e.data[r] = o;
      var i = o.factory || (o.factory = pr(o.type)),
        s = new Ti(i, Dt(o), S);
      e.blueprint[r] = s, n[r] = s, function vx(e, t, n, r, o) {
        var i = o.hostBindings;
        if (i) {
          var _s0 = e.hostBindingOpCodes;
          null === _s0 && (_s0 = e.hostBindingOpCodes = []);
          var a = ~t.index;
          (function yx(e) {
            var t = e.length;
            for (; t > 0;) {
              var _n6 = e[--t];
              if ("number" == typeof _n6 && _n6 < 0) return _n6;
            }
            return 0;
          })(_s0) != a && _s0.push(a), _s0.push(n, r, i);
        }
      }(e, t, r, es(e, n, o.hostVars, j), o);
    }
    function Dx(e, t, n) {
      if (n) {
        if (t.exportAs) for (var r = 0; r < t.exportAs.length; r++) n[t.exportAs[r]] = e;
        Dt(t) && (n[""] = e);
      }
    }
    function hw(e, t, n, r, o, i, s, a) {
      var u = t.consts,
        l = Po(t, e, 2, r, Mt(u, s));
      return i && eh(t, n, l, Mt(u, a), o), l.mergedAttrs = mo(l.mergedAttrs, l.attrs), null !== l.attrs && Xf(l, l.attrs, !1), null !== l.mergedAttrs && Xf(l, l.mergedAttrs, !0), null !== t.queries && t.queries.elementStart(t, l), l;
    }
    function pw(e, t) {
      dd(e, t), Gl(t) && e.queries.elementEnd(t);
    }
    var gw = /*#__PURE__*/function (_xu) {
      function gw(t) {
        var _this20;
        _classCallCheck(this, gw);
        _this20 = _callSuper(this, gw), _defineProperty(_assertThisInitialized(_this20), "ngModule", void 0), _this20.ngModule = t;
        return _this20;
      }
      _inherits(gw, _xu);
      return _createClass(gw, [{
        key: "resolveComponentFactory",
        value: function resolveComponentFactory(t) {
          var n = G(t);
          return new ps(n, this.ngModule);
        }
      }]);
    }(xu);
    var ps = /*#__PURE__*/function (_aw) {
      function ps(t, n) {
        var _t$ngContentSelectors;
        var _this21;
        _classCallCheck(this, ps);
        _this21 = _callSuper(this, ps), _defineProperty(_assertThisInitialized(_this21), "componentDef", void 0), _defineProperty(_assertThisInitialized(_this21), "ngModule", void 0), _defineProperty(_assertThisInitialized(_this21), "selector", void 0), _defineProperty(_assertThisInitialized(_this21), "componentType", void 0), _defineProperty(_assertThisInitialized(_this21), "ngContentSelectors", void 0), _defineProperty(_assertThisInitialized(_this21), "isBoundToModule", void 0), _defineProperty(_assertThisInitialized(_this21), "cachedInputs", null), _defineProperty(_assertThisInitialized(_this21), "cachedOutputs", null), _this21.componentDef = t, _this21.ngModule = n, _this21.componentType = t.type, _this21.selector = function DR(e) {
          return e.map(yR).join(",");
        }(t.selectors), _this21.ngContentSelectors = (_t$ngContentSelectors = t.ngContentSelectors) !== null && _t$ngContentSelectors !== void 0 ? _t$ngContentSelectors : [], _this21.isBoundToModule = !!n;
        return _this21;
      }
      _inherits(ps, _aw);
      return _createClass(ps, [{
        key: "inputs",
        get: function get() {
          var _this$cachedInputs;
          return (_this$cachedInputs = this.cachedInputs) !== null && _this$cachedInputs !== void 0 ? _this$cachedInputs : this.cachedInputs = function Ex(e) {
            return Object.keys(e).map(function (t) {
              var _e$t = _slicedToArray(e[t], 3),
                n = _e$t[0],
                r = _e$t[1],
                o = _e$t[2],
                i = {
                  propName: n,
                  templateName: t,
                  isSignal: !!(r & Du.SignalBased)
                };
              return o && (i.transform = o), i;
            });
          }(this.componentDef.inputs), this.cachedInputs;
        }
      }, {
        key: "outputs",
        get: function get() {
          var _this$cachedOutputs;
          return (_this$cachedOutputs = this.cachedOutputs) !== null && _this$cachedOutputs !== void 0 ? _this$cachedOutputs : this.cachedOutputs = function Cx(e) {
            return Object.keys(e).map(function (t) {
              return {
                propName: e[t],
                templateName: t
              };
            });
          }(this.componentDef.outputs), this.cachedOutputs;
        }
      }, {
        key: "create",
        value: function create(t, n, r, o) {
          var _this22 = this;
          var i = B(null);
          try {
            var s = this.componentDef,
              a = r ? ["ng-version", "19.2.11"] : function wR(e) {
                var t = [],
                  n = [];
                var r = 1,
                  o = 2;
                for (; r < e.length;) {
                  var _i8 = e[r];
                  if ("string" == typeof _i8) 2 === o ? "" !== _i8 && t.push(_i8, e[++r]) : 8 === o && n.push(_i8);else {
                    if (!Ht(o)) break;
                    o = _i8;
                  }
                  r++;
                }
                return n.length && t.push.apply(t, [1].concat(n)), t;
              }(this.componentDef.selectors[0]),
              u = Df(0, null, null, 1, 0, null, null, null, null, [a], null),
              c = function Ix(e, t, n) {
                var r = t instanceof at ? t : t === null || t === void 0 ? void 0 : t.injector;
                return r && null !== e.getStandaloneInjector && (r = e.getStandaloneInjector(r) || r), r ? new jo(n, r) : n;
              }(s, o || this.ngModule, t),
              l = function _x(e) {
                var t = e.get(Yf, null);
                if (null === t) throw new E(407, !1);
                return {
                  rendererFactory: t,
                  sanitizer: e.get(ix, null),
                  changeDetectionScheduler: e.get(Sn, null)
                };
              }(c),
              d = l.rendererFactory.createRenderer(null, s),
              h = r ? function bR(e, t, n, r) {
                var i = r.get(ey, !1) || n === Tt.ShadowDom,
                  s = e.selectRootElement(t, i);
                return function MR(e) {
                  gD(e);
                }(s), s;
              }(d, r, s.encapsulation, c) : function bx(e, t) {
                var n = (e.selectors[0][0] || "div").toLowerCase();
                return vu(t, n, "svg" === n ? "svg" : "math" === n ? "math" : null);
              }(s, d),
              f = yu(null, u, null, 512 | wf(s), null, null, l, d, c, null, null);
            f[M] = h, cd(f);
            var p = null;
            try {
              var g = hw(M, u, f, "#host", function () {
                return [_this22.componentDef];
              }, !0, 0);
              h && (dD(d, h, g), lt(h, f)), wu(u, f, g), uf(u, g, f), pw(u, g), void 0 !== n && function Sx(e, t, n) {
                var r = e.projection = [];
                for (var _o7 = 0; _o7 < t.length; _o7++) {
                  var _i9 = n[_o7];
                  r.push(null != _i9 && _i9.length ? Array.from(_i9) : null);
                }
              }(g, this.ngContentSelectors, n), p = Qe(g.index, f), f[8] = p[8], Eu(u, f, null);
            } catch (g) {
              throw null !== p && Td(p), Td(f), g;
            } finally {
              ld();
            }
            return new Mx(this.componentType, f);
          } finally {
            B(i);
          }
        }
      }]);
    }(aw);
    var Mx = /*#__PURE__*/function (_nx) {
      function Mx(t, n) {
        var _this23;
        _classCallCheck(this, Mx);
        _this23 = _callSuper(this, Mx), _defineProperty(_assertThisInitialized(_this23), "_rootLView", void 0), _defineProperty(_assertThisInitialized(_this23), "instance", void 0), _defineProperty(_assertThisInitialized(_this23), "hostView", void 0), _defineProperty(_assertThisInitialized(_this23), "changeDetectorRef", void 0), _defineProperty(_assertThisInitialized(_this23), "componentType", void 0), _defineProperty(_assertThisInitialized(_this23), "location", void 0), _defineProperty(_assertThisInitialized(_this23), "previousInputValues", null), _defineProperty(_assertThisInitialized(_this23), "_tNode", void 0), _this23._rootLView = n, _this23._tNode = Cr(n[1], M), _this23.location = vo(_this23._tNode, n), _this23.instance = Qe(_this23._tNode.index, n)[8], _this23.hostView = _this23.changeDetectorRef = new os(n, void 0, !1), _this23.componentType = t;
        return _this23;
      }
      _inherits(Mx, _nx);
      return _createClass(Mx, [{
        key: "setInput",
        value: function setInput(t, n) {
          var _this$previousInputVa;
          var r = this._tNode;
          if ((_this$previousInputVa = this.previousInputValues) !== null && _this$previousInputVa !== void 0 ? _this$previousInputVa : this.previousInputValues = new Map(), this.previousInputValues.has(t) && Object.is(this.previousInputValues.get(t), n)) return;
          var o = this._rootLView;
          Sf(r, o[1], o, t, n), this.previousInputValues.set(t, n), ns(Qe(r.index, o), 1);
        }
      }, {
        key: "injector",
        get: function get() {
          return new we(this._tNode, this._rootLView);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.hostView.destroy();
        }
      }, {
        key: "onDestroy",
        value: function onDestroy(t) {
          this.hostView.onDestroy(t);
        }
      }]);
    }(nx);
    var $t = function (_e10) {
      return _e10 = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      }), _defineProperty(_e10, "__NG_ELEMENT_ID__", Tx), _e10;
    }();
    function Tx() {
      return yw(z(), v());
    }
    var Nx = $t,
      _mw = /*#__PURE__*/function (_Nx) {
        function mw(t, n, r) {
          var _this24;
          _classCallCheck(this, mw);
          _this24 = _callSuper(this, mw), _defineProperty(_assertThisInitialized(_this24), "_lContainer", void 0), _defineProperty(_assertThisInitialized(_this24), "_hostTNode", void 0), _defineProperty(_assertThisInitialized(_this24), "_hostLView", void 0), _this24._lContainer = t, _this24._hostTNode = n, _this24._hostLView = r;
          return _this24;
        }
        _inherits(mw, _Nx);
        return _createClass(mw, [{
          key: "element",
          get: function get() {
            return vo(this._hostTNode, this._hostLView);
          }
        }, {
          key: "injector",
          get: function get() {
            return new we(this._hostTNode, this._hostLView);
          }
        }, {
          key: "parentInjector",
          get: function get() {
            var t = qa(this._hostTNode, this._hostLView);
            if (gd(t)) {
              var n = Ri(t, this._hostLView),
                r = Ni(t);
              return new we(n[1].data[r + 8], n);
            }
            return new we(null, this._hostLView);
          }
        }, {
          key: "clear",
          value: function clear() {
            for (; this.length > 0;) this.remove(this.length - 1);
          }
        }, {
          key: "get",
          value: function get(t) {
            var n = vw(this._lContainer);
            return null !== n && n[t] || null;
          }
        }, {
          key: "length",
          get: function get() {
            return this._lContainer.length - 10;
          }
        }, {
          key: "createEmbeddedView",
          value: function createEmbeddedView(t, n, r) {
            var o, i;
            "number" == typeof r ? o = r : null != r && (o = r.index, i = r.injector);
            var a = t.createEmbeddedViewImpl(n || {}, i, null);
            return this.insertImpl(a, o, Rr(this._hostTNode, null)), a;
          }
        }, {
          key: "createComponent",
          value: function createComponent(t, n, r, o, i) {
            var _u$componentType;
            var s = t && !function Ii(e) {
              return "function" == typeof e;
            }(t);
            var a;
            if (s) a = n;else {
              var p = n || {};
              a = p.index, r = p.injector, o = p.projectableNodes, i = p.environmentInjector || p.ngModuleRef;
            }
            var u = s ? t : new ps(G(t)),
              c = r || this.parentInjector;
            if (!i && null == u.ngModule) {
              var g = (s ? c : this.parentInjector).get(at, null);
              g && (i = g);
            }
            G((_u$componentType = u.componentType) !== null && _u$componentType !== void 0 ? _u$componentType : {});
            var f = u.create(c, o, null, i);
            return this.insertImpl(f.hostView, a, Rr(this._hostTNode, null)), f;
          }
        }, {
          key: "insert",
          value: function insert(t, n) {
            return this.insertImpl(t, n, !0);
          }
        }, {
          key: "insertImpl",
          value: function insertImpl(t, n, r) {
            var o = t._lView;
            if (function fT(e) {
              return Re(e[3]);
            }(o)) {
              var a = this.indexOf(t);
              if (-1 !== a) this.detach(a);else {
                var u = o[3],
                  c = new _mw(u, u[5], u[3]);
                c.detach(c.indexOf(t));
              }
            }
            var i = this._adjustIndex(n),
              s = this._lContainer;
            return function Oo(e, t, n) {
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
              var o = t[1];
              if (function rA(e, t, n, r) {
                var o = 10 + r,
                  i = n.length;
                r > 0 && (n[o - 1][4] = t), r < i - 10 ? (t[4] = n[o], fm(n, 10 + r, t)) : (n.push(t), t[4] = null), t[3] = n;
                var s = t[16];
                null !== s && n !== s && jD(s, t);
                var a = t[18];
                null !== a && a.insertView(e), Jl(t), t[2] |= 128;
              }(o, t, e, n), r) {
                var _s1 = Of(n, e),
                  _a9 = t[x],
                  _u7 = _a9.parentNode(e[7]);
                null !== _u7 && function VR(e, t, n, r, o, i) {
                  r[0] = o, r[5] = t, Iu(e, r, n, 1, o, i);
                }(o, e[5], _a9, t, _u7, _s1);
              }
              var i = t[6];
              null !== i && null !== i.firstChild && (i.firstChild = null);
            }(s, o, i, r), t.attachToViewContainerRef(), fm(th(s), i, t), t;
          }
        }, {
          key: "move",
          value: function move(t, n) {
            return this.insert(t, n);
          }
        }, {
          key: "indexOf",
          value: function indexOf(t) {
            var n = vw(this._lContainer);
            return null !== n ? n.indexOf(t) : -1;
          }
        }, {
          key: "remove",
          value: function remove(t) {
            var n = this._adjustIndex(t, -1),
              r = rs(this._lContainer, n);
            r && (ba(th(this._lContainer), n), ts(r[1], r));
          }
        }, {
          key: "detach",
          value: function detach(t) {
            var n = this._adjustIndex(t, -1),
              r = rs(this._lContainer, n);
            return r && null != ba(th(this._lContainer), n) ? new os(r) : null;
          }
        }, {
          key: "_adjustIndex",
          value: function _adjustIndex(t) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return t !== null && t !== void 0 ? t : this.length + n;
          }
        }]);
      }(Nx);
    function vw(e) {
      return e[8];
    }
    function th(e) {
      return e[8] || (e[8] = []);
    }
    function yw(e, t) {
      var n;
      var r = t[e.index];
      return Re(r) ? n = r : (n = FD(r, t, null, e), t[e.index] = n, Ef(t, n)), Dw(n, t, e, r), new _mw(n, e, t);
    }
    var Dw = function Ew(e, t, n, r) {
      if (e[7]) return;
      var o;
      o = 8 & n.type ? Q(r) : function Rx(e, t) {
        var n = e[x],
          r = n.createComment(""),
          o = Ze(t, e),
          i = n.parentNode(o);
        return Nr(n, i, r, n.nextSibling(o), !1), r;
      }(t, n), e[7] = o;
    };
    var rh = /*#__PURE__*/function () {
      function rh(t) {
        _classCallCheck(this, rh);
        _defineProperty(this, "queryList", void 0);
        _defineProperty(this, "matches", null);
        this.queryList = t;
      }
      return _createClass(rh, [{
        key: "clone",
        value: function clone() {
          return new rh(this.queryList);
        }
      }, {
        key: "setDirty",
        value: function setDirty() {
          this.queryList.setDirty();
        }
      }]);
    }();
    var oh = /*#__PURE__*/function () {
      function oh() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, oh);
        _defineProperty(this, "queries", void 0);
        this.queries = t;
      }
      return _createClass(oh, [{
        key: "createEmbeddedView",
        value: function createEmbeddedView(t) {
          var n = t.queries;
          if (null !== n) {
            var r = null !== t.contentQueries ? t.contentQueries[0] : n.length,
              o = [];
            for (var i = 0; i < r; i++) {
              var s = n.getByIndex(i);
              o.push(this.queries[s.indexInDeclarationView].clone());
            }
            return new oh(o);
          }
          return null;
        }
      }, {
        key: "insertView",
        value: function insertView(t) {
          this.dirtyQueriesWithMatches(t);
        }
      }, {
        key: "detachView",
        value: function detachView(t) {
          this.dirtyQueriesWithMatches(t);
        }
      }, {
        key: "finishViewCreation",
        value: function finishViewCreation(t) {
          this.dirtyQueriesWithMatches(t);
        }
      }, {
        key: "dirtyQueriesWithMatches",
        value: function dirtyQueriesWithMatches(t) {
          for (var n = 0; n < this.queries.length; n++) null !== ch(t, n).matches && this.queries[n].setDirty();
        }
      }]);
    }();
    var Cw = /*#__PURE__*/_createClass(function Cw(t, n) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      _classCallCheck(this, Cw);
      _defineProperty(this, "flags", void 0);
      _defineProperty(this, "read", void 0);
      _defineProperty(this, "predicate", void 0);
      this.flags = n, this.read = r, this.predicate = "string" == typeof t ? function jx(e) {
        return e.split(",").map(function (t) {
          return t.trim();
        });
      }(t) : t;
    });
    var ih = /*#__PURE__*/function () {
      function ih() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, ih);
        _defineProperty(this, "queries", void 0);
        this.queries = t;
      }
      return _createClass(ih, [{
        key: "elementStart",
        value: function elementStart(t, n) {
          for (var r = 0; r < this.queries.length; r++) this.queries[r].elementStart(t, n);
        }
      }, {
        key: "elementEnd",
        value: function elementEnd(t) {
          for (var n = 0; n < this.queries.length; n++) this.queries[n].elementEnd(t);
        }
      }, {
        key: "embeddedTView",
        value: function embeddedTView(t) {
          var n = null;
          for (var r = 0; r < this.length; r++) {
            var o = null !== n ? n.length : 0,
              i = this.getByIndex(r).embeddedTView(t, o);
            i && (i.indexInDeclarationView = r, null !== n ? n.push(i) : n = [i]);
          }
          return null !== n ? new ih(n) : null;
        }
      }, {
        key: "template",
        value: function template(t, n) {
          for (var r = 0; r < this.queries.length; r++) this.queries[r].template(t, n);
        }
      }, {
        key: "getByIndex",
        value: function getByIndex(t) {
          return this.queries[t];
        }
      }, {
        key: "length",
        get: function get() {
          return this.queries.length;
        }
      }, {
        key: "track",
        value: function track(t) {
          this.queries.push(t);
        }
      }]);
    }();
    var sh = /*#__PURE__*/function () {
      function sh(t) {
        var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        _classCallCheck(this, sh);
        _defineProperty(this, "metadata", void 0);
        _defineProperty(this, "matches", null);
        _defineProperty(this, "indexInDeclarationView", -1);
        _defineProperty(this, "crossesNgTemplate", !1);
        _defineProperty(this, "_declarationNodeIndex", void 0);
        _defineProperty(this, "_appliesToNextNode", !0);
        this.metadata = t, this._declarationNodeIndex = n;
      }
      return _createClass(sh, [{
        key: "elementStart",
        value: function elementStart(t, n) {
          this.isApplyingToNode(n) && this.matchTNode(t, n);
        }
      }, {
        key: "elementEnd",
        value: function elementEnd(t) {
          this._declarationNodeIndex === t.index && (this._appliesToNextNode = !1);
        }
      }, {
        key: "template",
        value: function template(t, n) {
          this.elementStart(t, n);
        }
      }, {
        key: "embeddedTView",
        value: function embeddedTView(t, n) {
          return this.isApplyingToNode(t) ? (this.crossesNgTemplate = !0, this.addMatch(-t.index, n), new sh(this.metadata)) : null;
        }
      }, {
        key: "isApplyingToNode",
        value: function isApplyingToNode(t) {
          if (this._appliesToNextNode && 1 & ~this.metadata.flags) {
            var n = this._declarationNodeIndex;
            var r = t.parent;
            for (; null !== r && 8 & r.type && r.index !== n;) r = r.parent;
            return n === (null !== r ? r.index : -1);
          }
          return this._appliesToNextNode;
        }
      }, {
        key: "matchTNode",
        value: function matchTNode(t, n) {
          var r = this.metadata.predicate;
          if (Array.isArray(r)) for (var o = 0; o < r.length; o++) {
            var i = r[o];
            this.matchTNodeWithReadOption(t, n, Ox(n, i)), this.matchTNodeWithReadOption(t, n, Ga(n, t, i, !1, !1));
          } else r === xn ? 4 & n.type && this.matchTNodeWithReadOption(t, n, -1) : this.matchTNodeWithReadOption(t, n, Ga(n, t, r, !1, !1));
        }
      }, {
        key: "matchTNodeWithReadOption",
        value: function matchTNodeWithReadOption(t, n, r) {
          if (null !== r) {
            var o = this.metadata.read;
            if (null !== o) {
              if (o === $n || o === $t || o === xn && 4 & n.type) this.addMatch(n.index, -2);else {
                var i = Ga(n, t, o, !1, !1);
                null !== i && this.addMatch(n.index, i);
              }
            } else this.addMatch(n.index, r);
          }
        }
      }, {
        key: "addMatch",
        value: function addMatch(t, n) {
          null === this.matches ? this.matches = [t, n] : this.matches.push(t, n);
        }
      }]);
    }();
    function Ox(e, t) {
      var n = e.localNames;
      if (null !== n) for (var r = 0; r < n.length; r += 2) if (n[r] === t) return n[r + 1];
      return null;
    }
    function Fx(e, t, n, r) {
      return -1 === n ? function Px(e, t) {
        return 11 & e.type ? vo(e, t) : 4 & e.type ? bu(e, t) : null;
      }(t, e) : -2 === n ? function Lx(e, t, n) {
        return n === $n ? vo(t, e) : n === xn ? bu(t, e) : n === $t ? yw(t, e) : void 0;
      }(e, t, r) : Ai(e, e[1], n, t);
    }
    function Iw(e, t, n, r) {
      var o = t[18].queries[r];
      if (null === o.matches) {
        var i = e.data,
          s = n.matches,
          a = [];
        for (var u = 0; null !== s && u < s.length; u += 2) {
          var c = s[u];
          a.push(c < 0 ? null : Fx(t, i[c], s[u + 1], n.metadata.read));
        }
        o.matches = a;
      }
      return o.matches;
    }
    function ah(e, t, n, r) {
      var o = e.queries.getByIndex(n),
        i = o.matches;
      if (null !== i) {
        var s = Iw(e, t, o, n);
        for (var a = 0; a < i.length; a += 2) {
          var u = i[a];
          if (u > 0) r.push(s[a / 2]);else {
            var c = i[a + 1],
              l = t[-u];
            for (var d = 10; d < l.length; d++) {
              var h = l[d];
              h[16] === h[3] && ah(h[1], h, c, r);
            }
            if (null !== l[9]) {
              var _d2 = l[9];
              for (var _h3 = 0; _h3 < _d2.length; _h3++) {
                var f = _d2[_h3];
                ah(f[1], f, c, r);
              }
            }
          }
        }
      }
      return r;
    }
    function bw(e, t, n) {
      var r = k();
      return r.firstCreatePass && (function Sw(e, t, n) {
        null === e.queries && (e.queries = new ih()), e.queries.track(new sh(t, n));
      }(r, new Cw(e, t, n), -1), !(2 & ~t) && (r.staticViewQueries = !0)), function _w(e, t, n, _4, _t$_) {
        var r = new p0(!(4 & ~n));
        return function hT(e, t, n, r) {
          var o = Xl(t);
          o.push(n), e.firstCreatePass && ed(e).push(r, o.length - 1);
        }(e, t, r, r.destroy), ((_t$_ = t[_4 = 18]) !== null && _t$_ !== void 0 ? _t$_ : t[_4] = new oh()).queries.push(new rh(r)) - 1;
      }(r, v(), t);
    }
    function ch(e, t) {
      return e.queries.getByIndex(t);
    }
    function Tw(e, t) {
      var n = e[1],
        r = ch(n, t);
      return r.crossesNgTemplate ? ah(n, e, t, []) : Iw(n, e, r, t);
    }
    var Or = /*#__PURE__*/_createClass(function Or() {
        _classCallCheck(this, Or);
      }),
      Vw = /*#__PURE__*/_createClass(function Vw() {
        _classCallCheck(this, Vw);
      });
    var fh = /*#__PURE__*/function (_Or) {
      function fh(t, n, r) {
        var _this25;
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
        _classCallCheck(this, fh);
        _this25 = _callSuper(this, fh), _defineProperty(_assertThisInitialized(_this25), "ngModuleType", void 0), _defineProperty(_assertThisInitialized(_this25), "_parent", void 0), _defineProperty(_assertThisInitialized(_this25), "_bootstrapComponents", []), _defineProperty(_assertThisInitialized(_this25), "_r3Injector", void 0), _defineProperty(_assertThisInitialized(_this25), "instance", void 0), _defineProperty(_assertThisInitialized(_this25), "destroyCbs", []), _defineProperty(_assertThisInitialized(_this25), "componentFactoryResolver", new gw(_assertThisInitialized(_this25))), _this25.ngModuleType = t, _this25._parent = n;
        var i = mt(t);
        _this25._bootstrapComponents = sn(i.bootstrap), _this25._r3Injector = yv(t, n, [{
          provide: Or,
          useValue: _this25
        }, {
          provide: xu,
          useValue: _this25.componentFactoryResolver
        }].concat(_toConsumableArray(r)), Te(t), new Set(["environment"])), o && _this25.resolveInjectorInitializers();
        return _this25;
      }
      _inherits(fh, _Or);
      return _createClass(fh, [{
        key: "resolveInjectorInitializers",
        value: function resolveInjectorInitializers() {
          this._r3Injector.resolveInjectorInitializers(), this.instance = this._r3Injector.get(this.ngModuleType);
        }
      }, {
        key: "injector",
        get: function get() {
          return this._r3Injector;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this._r3Injector;
          !t.destroyed && t.destroy(), this.destroyCbs.forEach(function (n) {
            return n();
          }), this.destroyCbs = null;
        }
      }, {
        key: "onDestroy",
        value: function onDestroy(t) {
          this.destroyCbs.push(t);
        }
      }]);
    }(Or);
    var hh = /*#__PURE__*/function (_Vw) {
      function hh(t) {
        var _this26;
        _classCallCheck(this, hh);
        _this26 = _callSuper(this, hh), _defineProperty(_assertThisInitialized(_this26), "moduleType", void 0), _this26.moduleType = t;
        return _this26;
      }
      _inherits(hh, _Vw);
      return _createClass(hh, [{
        key: "create",
        value: function create(t) {
          return new fh(this.moduleType, t, []);
        }
      }]);
    }(Vw);
    var Bw = /*#__PURE__*/function (_Or2) {
      function Bw(t) {
        var _this27;
        _classCallCheck(this, Bw);
        _this27 = _callSuper(this, Bw);
        _defineProperty(_this27, "injector", void 0);
        _defineProperty(_this27, "componentFactoryResolver", new gw(_this27));
        _defineProperty(_this27, "instance", null);
        var n = new vr([].concat(_toConsumableArray(t.providers), [{
          provide: Or,
          useValue: _this27
        }, {
          provide: xu,
          useValue: _this27.componentFactoryResolver
        }]), t.parent || Ra(), t.debugName, new Set(["environment"]));
        _this27.injector = n, t.runEnvironmentInitializers && n.resolveInjectorInitializers();
        return _this27;
      }
      _inherits(Bw, _Or2);
      return _createClass(Bw, [{
        key: "destroy",
        value: function destroy() {
          this.injector.destroy();
        }
      }, {
        key: "onDestroy",
        value: function onDestroy(t) {
          this.injector.onDestroy(t);
        }
      }]);
    }(Or);
    function ph(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new Bw({
        providers: e,
        parent: t,
        debugName: n,
        runEnvironmentInitializers: !0
      }).injector;
    }
    var Jx = function (_e11) {
      var e = /*#__PURE__*/function () {
        function e(n) {
          _classCallCheck(this, e);
          _defineProperty(this, "_injector", void 0);
          _defineProperty(this, "cachedInjectors", new Map());
          this._injector = n;
        }
        return _createClass(e, [{
          key: "getOrCreateStandaloneInjector",
          value: function getOrCreateStandaloneInjector(n) {
            if (!n.standalone) return null;
            if (!this.cachedInjectors.has(n)) {
              var r = Ll(0, n.type),
                o = r.length > 0 ? ph([r], this._injector, "Standalone[".concat(n.type.name, "]")) : null;
              this.cachedInjectors.set(n, o);
            }
            return this.cachedInjectors.get(n);
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            try {
              var _iterator17 = _createForOfIteratorHelper(this.cachedInjectors.values()),
                _step17;
              try {
                for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                  var n = _step17.value;
                  null !== n && n.destroy();
                }
              } catch (err) {
                _iterator17.e(err);
              } finally {
                _iterator17.f();
              }
            } finally {
              this.cachedInjectors.clear();
            }
          }
        }]);
      }();
      _e11 = e;
      _defineProperty(e, "\u0275prov", b({
        token: _e11,
        providedIn: "environment",
        factory: function factory() {
          return new _e11(T(at));
        }
      }));
      return e;
    }();
    function Nt(e) {
      return yn(function () {
        var _e$signals;
        var t = Uw(e),
          n = _objectSpread(_objectSpread({}, t), {}, {
            decls: e.decls,
            vars: e.vars,
            template: e.template,
            consts: e.consts || null,
            ngContentSelectors: e.ngContentSelectors,
            onPush: e.changeDetection === Ya.OnPush,
            directiveDefs: null,
            pipeDefs: null,
            dependencies: t.standalone && e.dependencies || null,
            getStandaloneInjector: t.standalone ? function (o) {
              return o.get(Jx).getOrCreateStandaloneInjector(n);
            } : null,
            getExternalStyles: null,
            signals: (_e$signals = e.signals) !== null && _e$signals !== void 0 ? _e$signals : !1,
            data: e.data || {},
            encapsulation: e.encapsulation || Tt.Emulated,
            styles: e.styles || K,
            _: null,
            schemas: e.schemas || null,
            tView: null,
            id: ""
          });
        t.standalone && wt("NgStandalone"), Hw(n);
        var r = e.dependencies;
        return n.directiveDefs = Pu(r, !1), n.pipeDefs = Pu(r, !0), n.id = function rk(e) {
          var t = 0;
          var r = [e.selectors, e.ngContentSelectors, e.hostVars, e.hostAttrs, "function" == typeof e.consts ? "" : e.consts, e.vars, e.decls, e.encapsulation, e.standalone, e.signals, e.exportAs, JSON.stringify(e.inputs), JSON.stringify(e.outputs), Object.getOwnPropertyNames(e.type.prototype), !!e.contentQueries, !!e.viewQuery];
          var _iterator18 = _createForOfIteratorHelper(r.join("|")),
            _step18;
          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var i = _step18.value;
              t = Math.imul(31, t) + i.charCodeAt(0) | 0;
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
          return t += 2147483648, "c" + t;
        }(n), n;
      });
    }
    function Kx(e) {
      return G(e) || function je(e) {
        return e[Sl] || null;
      }(e);
    }
    function Xx(e) {
      return null !== e;
    }
    function gh(e) {
      return yn(function () {
        return {
          type: e.type,
          bootstrap: e.bootstrap || K,
          declarations: e.declarations || K,
          imports: e.imports || K,
          exports: e.exports || K,
          transitiveCompileScopes: null,
          schemas: e.schemas || null,
          id: e.id || null
        };
      });
    }
    function ek(e, t) {
      if (null == e) return Pt;
      var n = {};
      for (var r in e) if (e.hasOwnProperty(r)) {
        var _o$;
        var o = e[r];
        var i = void 0,
          s = void 0,
          a = void 0,
          u = void 0;
        Array.isArray(o) ? (a = o[0], i = o[1], s = (_o$ = o[2]) !== null && _o$ !== void 0 ? _o$ : i, u = o[3] || null) : (i = o, s = o, a = Du.None, u = null), n[i] = [r, a, u], t[i] = s;
      }
      return n;
    }
    function tk(e) {
      if (null == e) return Pt;
      var t = {};
      for (var n in e) e.hasOwnProperty(n) && (t[e[n]] = n);
      return t;
    }
    function Ke(e) {
      return yn(function () {
        var t = Uw(e);
        return Hw(t), t;
      });
    }
    function Uw(e) {
      var _e$standalone;
      var t = {};
      return {
        type: e.type,
        providersResolver: null,
        factory: null,
        hostBindings: e.hostBindings || null,
        hostVars: e.hostVars || 0,
        hostAttrs: e.hostAttrs || null,
        contentQueries: e.contentQueries || null,
        declaredInputs: t,
        inputConfig: e.inputs || Pt,
        exportAs: e.exportAs || null,
        standalone: (_e$standalone = e.standalone) !== null && _e$standalone !== void 0 ? _e$standalone : !0,
        signals: !0 === e.signals,
        selectors: e.selectors || K,
        viewQuery: e.viewQuery || null,
        features: e.features || null,
        setInput: null,
        findHostDirectiveDefs: null,
        hostDirectives: null,
        inputs: ek(e.inputs, t),
        outputs: tk(e.outputs),
        debugInfo: null
      };
    }
    function Hw(e) {
      var _e$features;
      (_e$features = e.features) === null || _e$features === void 0 || _e$features.forEach(function (t) {
        return t(e);
      });
    }
    function Pu(e, t) {
      if (!e) return null;
      var n = t ? vt : Kx;
      return function () {
        return ("function" == typeof e ? e() : e).map(function (r) {
          return n(r);
        }).filter(Xx);
      };
    }
    function Fu(e) {
      return !!function yh(e) {
        return null !== e && ("function" == typeof e || "object" == _typeof(e));
      }(e) && (Array.isArray(e) || !(e instanceof Map) && Symbol.iterator in e);
    }
    function un(e, t, n) {
      return e[t] = n;
    }
    function Ee(e, t, n) {
      return !Object.is(e[t], n) && (e[t] = n, !0);
    }
    function Pr(e, t, n, r) {
      var o = Ee(e, t, n);
      return Ee(e, t + 1, r) || o;
    }
    function kn(e, t, n, r, o, i, s, a) {
      var u = v(),
        c = k();
      return function vs(e, t, n, r, o, i, s, a, u, c) {
        var l = n + M,
          d = t.firstCreatePass ? function vk(e, t, n, r, o, i, s, a, u) {
            var c = t.consts,
              l = Po(t, e, 4, s || null, a || null);
            rd() && eh(t, n, l, Mt(c, u), _f), l.mergedAttrs = mo(l.mergedAttrs, l.attrs), dd(t, l);
            var d = l.tView = Df(2, l, r, o, i, t.directiveRegistry, t.pipeRegistry, null, t.schemas, c, null);
            return null !== t.queries && (t.queries.template(t, l), d.queries = t.queries.embeddedTView(l)), l;
          }(l, t, e, r, o, i, s, a, u) : t.data[l];
        Vt(d, !1);
        var h = Qw(t, e, d, n);
        Si() && Cu(t, e, h, d), lt(h, e);
        var f = FD(h, e, h, d);
        return e[l] = f, Ef(e, f), Pa(d) && wu(t, e, d), null != u && If(e, d, c), d;
      }(u, c, e, t, n, r, o, Mt(c.consts, i), s, a), kn;
    }
    var Qw = function Yw(e, t, n, r) {
      return nn(!0), t[x].createComment("");
    };
    var Eh = function (_e12) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
        }
        return _createClass(e, [{
          key: "log",
          value: function log(n) {
            console.log(n);
          }
        }, {
          key: "warn",
          value: function warn(n) {
            console.warn(n);
          }
        }]);
      }();
      _e12 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e12)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e12,
        factory: _e12.ɵfac,
        providedIn: "platform"
      }));
      return e;
    }();
    var cE = new I("");
    var lE = function (_e13) {
      var e = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      });
      _e13 = e;
      _defineProperty(e, "\u0275prov", b({
        token: _e13,
        providedIn: "root",
        factory: function factory() {
          return new mO();
        }
      }));
      return e;
    }();
    var mO = /*#__PURE__*/function () {
      function mO() {
        _classCallCheck(this, mO);
        _defineProperty(this, "queuedEffectCount", 0);
        _defineProperty(this, "queues", new Map());
      }
      return _createClass(mO, [{
        key: "schedule",
        value: function schedule(t) {
          this.enqueue(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var r = this.queues.get(t.zone);
          r.has(t) && (r.delete(t), this.queuedEffectCount--);
        }
      }, {
        key: "enqueue",
        value: function enqueue(t) {
          var n = t.zone;
          this.queues.has(n) || this.queues.set(n, new Set());
          var r = this.queues.get(n);
          r.has(t) || (this.queuedEffectCount++, r.add(t));
        }
      }, {
        key: "flush",
        value: function flush() {
          var _this28 = this;
          for (; this.queuedEffectCount > 0;) {
            var _iterator19 = _createForOfIteratorHelper(this.queues),
              _step19;
            try {
              var _loop3 = function _loop3() {
                var _step19$value = _slicedToArray(_step19.value, 2),
                  t = _step19$value[0],
                  n = _step19$value[1];
                null === t ? _this28.flushQueue(n) : t.run(function () {
                  return _this28.flushQueue(n);
                });
              };
              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                _loop3();
              }
            } catch (err) {
              _iterator19.e(err);
            } finally {
              _iterator19.f();
            }
          }
        }
      }, {
        key: "flushQueue",
        value: function flushQueue(t) {
          var _iterator20 = _createForOfIteratorHelper(t),
            _step20;
          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var n = _step20.value;
              t.delete(n), this.queuedEffectCount--, n.run();
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        }
      }]);
    }();
    function Hu(e) {
      return !!e && "function" == typeof e.then;
    }
    function dE(e) {
      return !!e && "function" == typeof e.subscribe;
    }
    var fE = new I("");
    var hE = function (_e14) {
      var e = /*#__PURE__*/function () {
        function e() {
          var _this29 = this,
            _w4;
          _classCallCheck(this, e);
          _defineProperty(this, "resolve", void 0);
          _defineProperty(this, "reject", void 0);
          _defineProperty(this, "initialized", !1);
          _defineProperty(this, "done", !1);
          _defineProperty(this, "donePromise", new Promise(function (n, r) {
            _this29.resolve = n, _this29.reject = r;
          }));
          _defineProperty(this, "appInits", (_w4 = w(fE, {
            optional: !0
          })) !== null && _w4 !== void 0 ? _w4 : []);
          _defineProperty(this, "injector", w(Be));
        }
        return _createClass(e, [{
          key: "runInitializers",
          value: function runInitializers() {
            var _this30 = this;
            if (this.initialized) return;
            var n = [];
            var _iterator21 = _createForOfIteratorHelper(this.appInits),
              _step21;
            try {
              var _loop4 = function _loop4() {
                var o = _step21.value;
                var i = Ft(_this30.injector, o);
                if (Hu(i)) n.push(i);else if (dE(i)) {
                  var s = new Promise(function (a, u) {
                    i.subscribe({
                      complete: a,
                      error: u
                    });
                  });
                  n.push(s);
                }
              };
              for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                _loop4();
              }
            } catch (err) {
              _iterator21.e(err);
            } finally {
              _iterator21.f();
            }
            var r = function r() {
              _this30.done = !0, _this30.resolve();
            };
            Promise.all(n).then(function () {
              r();
            }).catch(function (o) {
              _this30.reject(o);
            }), 0 === n.length && r(), this.initialized = !0;
          }
        }]);
      }();
      _e14 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e14)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e14,
        factory: _e14.ɵfac,
        providedIn: "root"
      }));
      return e;
    }();
    var Ds = new I("");
    var Et = function (_e15) {
      var e = /*#__PURE__*/function () {
        function e() {
          var _this31 = this;
          _classCallCheck(this, e);
          _defineProperty(this, "_runningTick", !1);
          _defineProperty(this, "_destroyed", !1);
          _defineProperty(this, "_destroyListeners", []);
          _defineProperty(this, "_views", []);
          _defineProperty(this, "internalErrorHandler", w(c0));
          _defineProperty(this, "afterRenderManager", w(Gd));
          _defineProperty(this, "zonelessEnabled", w(ki));
          _defineProperty(this, "rootEffectScheduler", w(lE));
          _defineProperty(this, "dirtyFlags", 0);
          _defineProperty(this, "tracingSnapshot", null);
          _defineProperty(this, "externalTestViews", new Set());
          _defineProperty(this, "afterTick", new $e());
          _defineProperty(this, "componentTypes", []);
          _defineProperty(this, "components", []);
          _defineProperty(this, "isStable", w(Hn).hasPendingTasks.pipe(Y(function (n) {
            return !n;
          })));
          _defineProperty(this, "_injector", w(at));
          _defineProperty(this, "_rendererFactory", null);
          _defineProperty(this, "tickImpl", function () {
            if (_this31._runningTick) throw new E(101, !1);
            var n = B(null);
            try {
              _this31._runningTick = !0, _this31.synchronize();
            } catch (r) {
              _this31.internalErrorHandler(r);
            } finally {
              var _this31$tracingSnapsh;
              _this31._runningTick = !1, (_this31$tracingSnapsh = _this31.tracingSnapshot) !== null && _this31$tracingSnapsh !== void 0 && _this31$tracingSnapsh.dispose(), _this31.tracingSnapshot = null, B(n), _this31.afterTick.next();
            }
          });
          w(Do, {
            optional: !0
          });
        }
        return _createClass(e, [{
          key: "allViews",
          get: function get() {
            return [].concat(_toConsumableArray(this.externalTestViews.keys()), _toConsumableArray(this._views));
          }
        }, {
          key: "destroyed",
          get: function get() {
            return this._destroyed;
          }
        }, {
          key: "whenStable",
          value: function whenStable() {
            var _this32 = this;
            var n;
            return new Promise(function (r) {
              n = _this32.isStable.subscribe({
                next: function next(o) {
                  o && r();
                }
              });
            }).finally(function () {
              n.unsubscribe();
            });
          }
        }, {
          key: "injector",
          get: function get() {
            return this._injector;
          }
        }, {
          key: "bootstrap",
          value: function bootstrap(n, r) {
            return this.bootstrapImpl(n, r);
          }
        }, {
          key: "bootstrapImpl",
          value: function bootstrapImpl(n, r) {
            var _this33 = this;
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Be.NULL;
            var i = n instanceof aw;
            if (!this._injector.get(hE).done) throw new E(405, "");
            var a;
            a = i ? n : this._injector.get(xu).resolveComponentFactory(n), this.componentTypes.push(a.componentType);
            var u = function vO(e) {
                return e.isBoundToModule;
              }(a) ? void 0 : this._injector.get(Or),
              l = a.create(o, [], r || a.selector, u),
              d = l.location.nativeElement,
              h = l.injector.get(cE, null);
            return h !== null && h !== void 0 && h.registerApplication(d), l.onDestroy(function () {
              _this33.detachView(l.hostView), $u(_this33.components, l), h === null || h === void 0 ? void 0 : h.unregisterApplication(d);
            }), this._loadComponent(l), l;
          }
        }, {
          key: "tick",
          value: function tick() {
            this.zonelessEnabled || (this.dirtyFlags |= 1), this._tick();
          }
        }, {
          key: "_tick",
          value: function _tick() {
            null !== this.tracingSnapshot ? this.tracingSnapshot.run(qd.CHANGE_DETECTION, this.tickImpl) : this.tickImpl();
          }
        }, {
          key: "synchronize",
          value: function synchronize() {
            null === this._rendererFactory && !this._injector.destroyed && (this._rendererFactory = this._injector.get(Yf, null, {
              optional: !0
            }));
            var n = 0;
            for (; 0 !== this.dirtyFlags && n++ < 10;) this.synchronizeOnce();
          }
        }, {
          key: "synchronizeOnce",
          value: function synchronizeOnce() {
            var _this$_rendererFactor, _this$_rendererFactor2, _this$_rendererFactor3, _this$_rendererFactor4;
            if (16 & this.dirtyFlags && (this.dirtyFlags &= -17, this.rootEffectScheduler.flush()), 7 & this.dirtyFlags) {
              var n = !!(1 & this.dirtyFlags);
              this.dirtyFlags &= -8, this.dirtyFlags |= 8;
              var _iterator22 = _createForOfIteratorHelper(this.allViews),
                _step22;
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  var _step22$value = _step22.value,
                    r = _step22$value._lView,
                    o = _step22$value.notifyErrorHandler;
                  DO(r, o, n, this.zonelessEnabled);
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              if (this.dirtyFlags &= -5, this.syncDirtyFlagsWithViews(), 23 & this.dirtyFlags) return;
            } else (_this$_rendererFactor = this._rendererFactory) !== null && _this$_rendererFactor !== void 0 && (_this$_rendererFactor2 = _this$_rendererFactor.begin) !== null && _this$_rendererFactor2 !== void 0 && _this$_rendererFactor2.call(_this$_rendererFactor), (_this$_rendererFactor3 = this._rendererFactory) === null || _this$_rendererFactor3 === void 0 || (_this$_rendererFactor4 = _this$_rendererFactor3.end) === null || _this$_rendererFactor4 === void 0 ? void 0 : _this$_rendererFactor4.call(_this$_rendererFactor3);
            8 & this.dirtyFlags && (this.dirtyFlags &= -9, this.afterRenderManager.execute()), this.syncDirtyFlagsWithViews();
          }
        }, {
          key: "syncDirtyFlagsWithViews",
          value: function syncDirtyFlagsWithViews() {
            this.allViews.some(function (_ref) {
              var n = _ref._lView;
              return bi(n);
            }) ? this.dirtyFlags |= 2 : this.dirtyFlags &= -8;
          }
        }, {
          key: "attachView",
          value: function attachView(n) {
            var r = n;
            this._views.push(r), r.attachToAppRef(this);
          }
        }, {
          key: "detachView",
          value: function detachView(n) {
            var r = n;
            $u(this._views, r), r.detachFromAppRef();
          }
        }, {
          key: "_loadComponent",
          value: function _loadComponent(n) {
            this.attachView(n.hostView), this.tick(), this.components.push(n), this._injector.get(Ds, []).forEach(function (o) {
              return o(n);
            });
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            if (!this._destroyed) try {
              this._destroyListeners.forEach(function (n) {
                return n();
              }), this._views.slice().forEach(function (n) {
                return n.destroy();
              });
            } finally {
              this._destroyed = !0, this._views = [], this._destroyListeners = [];
            }
          }
        }, {
          key: "onDestroy",
          value: function onDestroy(n) {
            var _this34 = this;
            return this._destroyListeners.push(n), function () {
              return $u(_this34._destroyListeners, n);
            };
          }
        }, {
          key: "destroy",
          value: function destroy() {
            if (this._destroyed) throw new E(406, !1);
            var n = this._injector;
            n.destroy && !n.destroyed && n.destroy();
          }
        }, {
          key: "viewCount",
          get: function get() {
            return this._views.length;
          }
        }]);
      }();
      _e15 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e15)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e15,
        factory: _e15.ɵfac,
        providedIn: "root"
      }));
      return e;
    }();
    function $u(e, t) {
      var n = e.indexOf(t);
      n > -1 && e.splice(n, 1);
    }
    function DO(e, t, n, r) {
      (n || bi(e)) && _u(e, t, n && !r ? 0 : 1);
    }
    function $o(e, t, n, r) {
      return Ee(e, St(), n) ? t + L(n) + r : j;
    }
    function zu(e, t) {
      return e << 17 | t << 2;
    }
    function Lr(e) {
      return e >> 17 & 32767;
    }
    function kh(e) {
      return 2 | e;
    }
    function Jo(e) {
      return (131068 & e) >> 2;
    }
    function Oh(e, t) {
      return -131069 & e | t << 2;
    }
    function Ph(e) {
      return 1 | e;
    }
    function kE(e, t, n, r) {
      var o = e[n + 1],
        i = null === t;
      var s = r ? Lr(o) : Jo(o),
        a = !1;
      for (; 0 !== s && (!1 === a || i);) {
        var c = e[s + 1];
        i1(e[s], t) && (a = !0, e[s + 1] = r ? Ph(c) : kh(c)), s = r ? Lr(c) : Jo(c);
      }
      a && (e[n + 1] = r ? kh(o) : Ph(o));
    }
    function i1(e, t) {
      return null === e || null == t || (Array.isArray(e) ? e[1] : e) === t || !(!Array.isArray(e) || "string" != typeof t) && Ei(e, t) >= 0;
    }
    function xe(e, t, n) {
      var r = v();
      return Ee(r, St(), t) && dt(k(), ie(), r, e, t, r[x], n, !1), xe;
    }
    function Fh(e, t, n, r, o) {
      Sf(t, e, n, o ? "class" : "style", r);
    }
    function qu(e, t, n) {
      return function zt(e, t, n, r) {
        var o = v(),
          i = k(),
          s = function Mn(e) {
            var t = F.lFrame,
              n = t.bindingIndex;
            return t.bindingIndex = t.bindingIndex + e, n;
          }(2);
        i.firstUpdatePass && function HE(e, t, n, r) {
          var o = e.data;
          if (null === o[n + 1]) {
            var _i0 = o[Ve()],
              _s10 = function UE(e, t) {
                return t >= e.expandoStartIndex;
              }(e, n);
            (function GE(e, t) {
              return !!(e.flags & (t ? 8 : 16));
            })(_i0, r) && null === t && !_s10 && (t = !1), t = function p1(e, t, n, r) {
              var o = function ad(e) {
                var t = F.lFrame.currentDirectiveIndex;
                return -1 === t ? null : e[t];
              }(e);
              var i = r ? t.residualClasses : t.residualStyles;
              if (null === o) 0 === (r ? t.classBindings : t.styleBindings) && (n = Es(n = Lh(null, e, t, n, r), t.attrs, r), i = null);else {
                var _s11 = t.directiveStylingLast;
                if (-1 === _s11 || e[_s11] !== o) if (n = Lh(o, e, t, n, r), null === i) {
                  var u = function g1(e, t, n) {
                    var r = n ? t.classBindings : t.styleBindings;
                    if (0 !== Jo(r)) return e[Lr(r)];
                  }(e, t, r);
                  void 0 !== u && Array.isArray(u) && (u = Lh(null, e, t, u[1], r), u = Es(u, t.attrs, r), function m1(e, t, n, r) {
                    e[Lr(n ? t.classBindings : t.styleBindings)] = r;
                  }(e, t, r, u));
                } else i = function v1(e, t, n) {
                  var r;
                  var o = t.directiveEnd;
                  for (var _i1 = 1 + t.directiveStylingLast; _i1 < o; _i1++) r = Es(r, e[_i1].hostAttrs, n);
                  return Es(r, t.attrs, n);
                }(e, t, r);
              }
              return void 0 !== i && (r ? t.residualClasses = i : t.residualStyles = i), n;
            }(o, _i0, t, r), function r1(e, t, n, r, o, i) {
              var s = i ? t.classBindings : t.styleBindings,
                a = Lr(s),
                u = Jo(s);
              e[r] = n;
              var l,
                c = !1;
              if (Array.isArray(n) ? (l = n[1], (null === l || Ei(n, l) > 0) && (c = !0)) : l = n, o) {
                if (0 !== u) {
                  var h = Lr(e[a + 1]);
                  e[r + 1] = zu(h, a), 0 !== h && (e[h + 1] = Oh(e[h + 1], r)), e[a + 1] = function t1(e, t) {
                    return 131071 & e | t << 17;
                  }(e[a + 1], r);
                } else e[r + 1] = zu(a, 0), 0 !== a && (e[a + 1] = Oh(e[a + 1], r)), a = r;
              } else e[r + 1] = zu(u, 0), 0 === a ? a = r : e[u + 1] = Oh(e[u + 1], r), u = r;
              c && (e[r + 1] = kh(e[r + 1])), kE(e, l, r, !0), kE(e, l, r, !1), function o1(e, t, n, r, o) {
                var i = o ? e.residualClasses : e.residualStyles;
                null != i && "string" == typeof t && Ei(i, t) >= 0 && (n[r + 1] = Ph(n[r + 1]));
              }(t, l, e, r, i), s = zu(a, u), i ? t.classBindings = s : t.styleBindings = s;
            }(o, _i0, t, n, _s10, r);
          }
        }(i, e, s, r), t !== j && Ee(o, s, t) && function zE(e, t, n, r, o, i, s, a) {
          if (!(3 & t.type)) return;
          var u = e.data,
            c = u[a + 1],
            l = function n1(e) {
              return !(1 & ~e);
            }(c) ? qE(u, t, n, o, Jo(c), s) : void 0;
          Gu(l) || (Gu(i) || function e1(e) {
            return !(2 & ~e);
          }(c) && (i = qE(u, null, n, o, a, s)), function qR(e, t, n, r, o) {
            if (t) o ? e.addClass(n, r) : e.removeClass(n, r);else {
              var _i10 = -1 === r.indexOf("-") ? void 0 : Gn.DashCase;
              null == o ? e.removeStyle(n, r, _i10) : ("string" == typeof o && o.endsWith("!important") && (o = o.slice(0, -10), _i10 |= Gn.Important), e.setStyle(n, r, o, _i10));
            }
          }(r, s, ho(Ve(), n), o, i));
        }(i, i.data[Ve()], o, o[x], e, o[s + 1] = function E1(e, t) {
          return null == e || "" === e || ("string" == typeof t ? e += t : "object" == _typeof(e) && (e = Te(qn(e)))), e;
        }(t, n), r, s);
      }(e, t, n, !1), qu;
    }
    function Lh(e, t, n, r, o) {
      var i = null;
      var s = n.directiveEnd;
      var a = n.directiveStylingLast;
      for (-1 === a ? a = n.directiveStart : a++; a < s && (i = t[a], r = Es(r, i.hostAttrs, o), i !== e);) a++;
      return null !== e && (n.directiveStylingLast = a), r;
    }
    function Es(e, t, n) {
      var r = n ? 1 : 2;
      var o = -1;
      if (null !== t) for (var i = 0; i < t.length; i++) {
        var s = t[i];
        "number" == typeof s ? o = s : o === r && (Array.isArray(e) || (e = void 0 === e ? [] : ["", e]), gt(e, s, !!n || t[++i]));
      }
      return void 0 === e ? null : e;
    }
    function qE(e, t, n, r, o, i) {
      var s = null === t;
      var a;
      for (; o > 0;) {
        var u = e[o],
          c = Array.isArray(u),
          l = c ? u[1] : u,
          d = null === l;
        var h = n[o + 1];
        h === j && (h = d ? K : void 0);
        var f = d ? Pl(h, r) : l === r ? h : void 0;
        if (c && !Gu(f) && (f = Pl(u, r)), Gu(f) && (a = f, s)) return a;
        var p = e[o + 1];
        o = s ? Lr(p) : Jo(p);
      }
      if (null !== t) {
        var _u8 = i ? t.residualClasses : t.residualStyles;
        null != _u8 && (a = Pl(_u8, r));
      }
      return a;
    }
    function Gu(e) {
      return void 0 !== e;
    }
    function O(e, t, n, r) {
      var o = v(),
        i = k(),
        s = M + e,
        a = o[x],
        u = i.firstCreatePass ? hw(s, i, o, t, _f, rd(), n, r) : i.data[s],
        c = YE(i, o, u, a, t, e);
      o[s] = c;
      var l = Pa(u);
      return Vt(u, !0), dD(a, c, u), !Wn(u) && Si() && Cu(i, o, c, u), (0 === function pT() {
        return F.lFrame.elementDepthCount;
      }() || l) && lt(c, o), function gT() {
        F.lFrame.elementDepthCount++;
      }(), l && (wu(i, o, u), uf(i, u, o)), null !== r && If(o, u), O;
    }
    function N() {
      var e = z();
      od() ? id() : (e = e.parent, Vt(e, !1));
      var t = e;
      (function vT(e) {
        return F.skipHydrationRootTNode === e;
      })(t) && function ET() {
        F.skipHydrationRootTNode = null;
      }(), function mT() {
        F.lFrame.elementDepthCount--;
      }();
      var n = k();
      return n.firstCreatePass && pw(n, t), null != t.classesWithoutHost && function OT(e) {
        return !!(8 & e.flags);
      }(t) && Fh(n, t, v(), t.classesWithoutHost, !0), null != t.stylesWithoutHost && function PT(e) {
        return !!(16 & e.flags);
      }(t) && Fh(n, t, v(), t.stylesWithoutHost, !1), N;
    }
    function pe(e, t, n, r) {
      return O(e, t, n, r), N(), pe;
    }
    var YE = function YE(e, t, n, r, o, i) {
      return nn(!0), vu(r, o, function Ym() {
        return F.lFrame.currentNamespace;
      }());
    };
    function Zu(e, t, n) {
      var r = v(),
        o = k(),
        i = e + M,
        s = o.firstCreatePass ? function G1(e, t, n, r, o) {
          var i = t.consts,
            s = Mt(i, r),
            a = Po(t, e, 8, "ng-container", s);
          null !== s && Xf(a, s, !0);
          var u = Mt(i, o);
          return rd() && eh(t, n, a, u, _f), a.mergedAttrs = mo(a.mergedAttrs, a.attrs), null !== t.queries && t.queries.elementStart(t, a), a;
        }(i, o, r, t, n) : o.data[i];
      Vt(s, !0);
      var a = KE(o, r, s, e);
      return r[i] = a, Si() && Cu(o, r, a, s), lt(a, r), Pa(s) && (wu(o, r, s), uf(o, s, r)), null != n && If(r, s), Zu;
    }
    function Qu() {
      var e = z();
      var t = k();
      return od() ? id() : (e = e.parent, Vt(e, !1)), t.firstCreatePass && (dd(t, e), Gl(e) && t.queries.elementEnd(e)), Qu;
    }
    var KE = function KE(e, t, n, r) {
      return nn(!0), yf(t[x], "");
    };
    var Yu = "en-US";
    var oC = Yu;
    function CC(e, t, n) {
      return function r(o) {
        if (o === Function) return n;
        ns(jt(e) ? Qe(e.index, t) : t, 5);
        var s = t[8];
        var a = IC(t, s, n, o),
          u = r.__ngNextListenerFn__;
        for (; u;) a = IC(t, s, u, o) && a, u = u.__ngNextListenerFn__;
        return a;
      };
    }
    function IC(e, t, n, r) {
      var o = B(null);
      try {
        return !1 !== n(r);
      } catch (i) {
        return function VP(e, t) {
          var n = e[9],
            r = n ? n.get(Ut, null) : null;
          r && r.handleError(t);
        }(e, i), !1;
      } finally {
        B(o);
      }
    }
    function _C(e, t, n, r, o, i) {
      var a = t[1],
        l = t[n][a.data[n].outputs[r]],
        d = a.firstCreatePass ? ed(a) : null,
        h = Xl(t),
        f = l.subscribe(i),
        p = h.length;
      h.push(i, f), d && d.push(o, e.index, p, -(p + 1));
    }
    var $h = new Map();
    function Ss(e, t, n, r) {
      var o = v(),
        i = k(),
        s = z();
      return function zh(e, t, n, r, o, i, s) {
        var a = Pa(r),
          c = e.firstCreatePass ? ed(e) : null,
          l = Xl(t);
        var d = !0;
        if (3 & r.type || s) {
          var h = Ze(r, t),
            f = s ? s(h) : h,
            p = l.length,
            g = s ? function (D) {
              return s(Q(D[r.index]));
            } : r.index;
          var m = null;
          if (!s && a && (m = function HP(e, t, n, r) {
            var o = e.cleanup;
            if (null != o) for (var _i11 = 0; _i11 < o.length - 1; _i11 += 2) {
              var _s12 = o[_i11];
              if (_s12 === n && o[_i11 + 1] === r) {
                var _a0 = t[7],
                  u = o[_i11 + 2];
                return _a0.length > u ? _a0[u] : null;
              }
              "string" == typeof _s12 && (_i11 += 2);
            }
            return null;
          }(e, t, o, r.index)), null !== m) (m.__ngLastListenerFn__ || m).__ngNextListenerFn__ = i, m.__ngLastListenerFn__ = i, d = !1;else {
            var _$h$get;
            i = CC(r, t, i);
            var D = t[9].get(Tn);
            (_$h$get = $h.get(D)) === null || _$h$get === void 0 || _$h$get(f, o, i);
            var _ = n.listen(f, o, i);
            l.push(i, _), c && c.push(o, g, p, p + 1);
          }
        } else i = CC(r, t, i);
        if (d) {
          var _r$outputs, _r$hostDirectiveOutpu;
          var _h4 = (_r$outputs = r.outputs) === null || _r$outputs === void 0 ? void 0 : _r$outputs[o],
            _f1 = (_r$hostDirectiveOutpu = r.hostDirectiveOutputs) === null || _r$hostDirectiveOutpu === void 0 ? void 0 : _r$hostDirectiveOutpu[o];
          if (_f1 && _f1.length) for (var _p2 = 0; _p2 < _f1.length; _p2 += 2) _C(r, t, _f1[_p2], _f1[_p2 + 1], o, i);
          if (_h4 && _h4.length) {
            var _iterator23 = _createForOfIteratorHelper(_h4),
              _step23;
            try {
              for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                var _p3 = _step23.value;
                _C(r, t, _p3, o, o, i);
              }
            } catch (err) {
              _iterator23.e(err);
            } finally {
              _iterator23.f();
            }
          }
        }
      }(i, o, o[x], s, e, t, r), Ss;
    }
    function ei() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return function MT(e) {
        return (F.lFrame.contextLView = function Fm(e, t) {
          for (; e > 0;) t = t[14], e--;
          return t;
        }(e, F.lFrame.contextLView))[8];
      }(e);
    }
    function ec(e, t, n) {
      return qh(e, "", t, "", n), ec;
    }
    function qh(e, t, n, r, o) {
      var i = v(),
        s = $o(i, t, n, r);
      return s !== j && dt(k(), ie(), i, e, s, i[x], o, !1), qh;
    }
    function Gh(e, t, n) {
      bw(e, t, n);
    }
    function tc(e) {
      var t = v(),
        n = k(),
        r = ud();
      Ba(r + 1);
      var o = ch(n, r);
      if (e.dirty && function dT(e) {
        return !(4 & ~e[2]);
      }(t) === !(2 & ~o.metadata.flags)) {
        if (null === o.matches) e.reset([]);else {
          var i = Tw(t, r);
          e.reset(i, Rv), e.notifyOnChanges();
        }
        return !0;
      }
      return !1;
    }
    function nc() {
      return function uh(e, t) {
        return e[18].queries[t].queryList;
      }(v(), ud());
    }
    function W(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var n = v(),
        r = k(),
        o = e + M,
        i = r.firstCreatePass ? Po(r, o, 1, t, null) : r.data[o],
        s = zC(r, n, i, t, e);
      n[o] = s, Si() && Cu(r, n, s, i), Vt(i, !1);
    }
    var zC = function zC(e, t, n, r, o) {
      return nn(!0), function vf(e, t) {
        return e.createText(t);
      }(t[x], r);
    };
    function Zh(e) {
      return At("", e, ""), Zh;
    }
    function At(e, t, n) {
      var r = v(),
        o = $o(r, e, t, n);
      return o !== j && function On(e, t, n) {
        var r = ho(t, e);
        !function aD(e, t, n) {
          e.setValue(t, n);
        }(e[x], r, n);
      }(r, Ve(), o), At;
    }
    function iI(e, t, n, r, o) {
      return function uI(e, t, n, r, o, i, s) {
        var a = t + n;
        return Pr(e, a, o, i) ? un(e, a + 2, s ? r.call(s, o, i) : r(o, i)) : Ts(e, a + 2);
      }(v(), Ye(), e, t, n, r, o);
    }
    function sI(e, t, n, r, o, i) {
      return function cI(e, t, n, r, o, i, s, a) {
        var u = t + n;
        return function Lu(e, t, n, r, o) {
          var i = Pr(e, t, n, r);
          return Ee(e, t + 2, o) || i;
        }(e, u, o, i, s) ? un(e, u + 3, a ? r.call(a, o, i, s) : r(o, i, s)) : Ts(e, u + 3);
      }(v(), Ye(), e, t, n, r, o, i);
    }
    function Ts(e, t) {
      var n = e[t];
      return n === j ? void 0 : n;
    }
    var uL = /*#__PURE__*/_createClass(function uL(t, n) {
      _classCallCheck(this, uL);
      _defineProperty(this, "ngModuleFactory", void 0);
      _defineProperty(this, "componentFactories", void 0);
      this.ngModuleFactory = t, this.componentFactories = n;
    });
    var cL = function (_e16) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
          }
          return _createClass(e, [{
            key: "compileModuleSync",
            value: function compileModuleSync(n) {
              return new hh(n);
            }
          }, {
            key: "compileModuleAsync",
            value: function compileModuleAsync(n) {
              return Promise.resolve(this.compileModuleSync(n));
            }
          }, {
            key: "compileModuleAndAllComponentsSync",
            value: function compileModuleAndAllComponentsSync(n) {
              var r = this.compileModuleSync(n),
                i = sn(mt(n).declarations).reduce(function (s, a) {
                  var u = G(a);
                  return u && s.push(new ps(u)), s;
                }, []);
              return new uL(r, i);
            }
          }, {
            key: "compileModuleAndAllComponentsAsync",
            value: function compileModuleAndAllComponentsAsync(n) {
              return Promise.resolve(this.compileModuleAndAllComponentsSync(n));
            }
          }, {
            key: "clearCache",
            value: function clearCache() {}
          }, {
            key: "clearCacheFor",
            value: function clearCacheFor(n) {}
          }, {
            key: "getModuleId",
            value: function getModuleId(n) {}
          }]);
        }();
        _e16 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e16)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e16,
          factory: _e16.ɵfac,
          providedIn: "root"
        }));
        return e;
      }(),
      fL = function (_e17) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
            _defineProperty(this, "zone", w(ee));
            _defineProperty(this, "changeDetectionScheduler", w(Sn));
            _defineProperty(this, "applicationRef", w(Et));
            _defineProperty(this, "_onMicrotaskEmptySubscription", void 0);
          }
          return _createClass(e, [{
            key: "initialize",
            value: function initialize() {
              var _this35 = this;
              this._onMicrotaskEmptySubscription || (this._onMicrotaskEmptySubscription = this.zone.onMicrotaskEmpty.subscribe({
                next: function next() {
                  _this35.changeDetectionScheduler.runningTick || _this35.zone.run(function () {
                    _this35.applicationRef.tick();
                  });
                }
              }));
            }
          }, {
            key: "ngOnDestroy",
            value: function ngOnDestroy() {
              var _this$_onMicrotaskEmp;
              (_this$_onMicrotaskEmp = this._onMicrotaskEmptySubscription) === null || _this$_onMicrotaskEmp === void 0 || _this$_onMicrotaskEmp.unsubscribe();
            }
          }]);
        }();
        _e17 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e17)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e17,
          factory: _e17.ɵfac,
          providedIn: "root"
        }));
        return e;
      }();
    var hL = new I("", {
      factory: function factory() {
        return !1;
      }
    });
    function rp(_ref2) {
      var e = _ref2.ngZoneFactory,
        t = _ref2.ignoreChangesOutsideZone,
        n = _ref2.scheduleInRootZone;
      return e !== null && e !== void 0 ? e : e = function e() {
        return new ee(_objectSpread(_objectSpread({}, op()), {}, {
          scheduleInRootZone: n
        }));
      }, [{
        provide: ee,
        useFactory: e
      }, {
        provide: bt,
        multi: !0,
        useFactory: function useFactory() {
          var r = w(fL, {
            optional: !0
          });
          return function () {
            return r.initialize();
          };
        }
      }, {
        provide: bt,
        multi: !0,
        useFactory: function useFactory() {
          var r = w(gL);
          return function () {
            r.initialize();
          };
        }
      }, !0 === t ? {
        provide: Ev,
        useValue: !0
      } : [], {
        provide: Cd,
        useValue: n !== null && n !== void 0 ? n : Dv
      }];
    }
    function op(e) {
      var _e$eventCoalescing, _e$runCoalescing;
      return {
        enableLongStackTrace: !1,
        shouldCoalesceEventChangeDetection: (_e$eventCoalescing = e === null || e === void 0 ? void 0 : e.eventCoalescing) !== null && _e$eventCoalescing !== void 0 ? _e$eventCoalescing : !1,
        shouldCoalesceRunChangeDetection: (_e$runCoalescing = e === null || e === void 0 ? void 0 : e.runCoalescing) !== null && _e$runCoalescing !== void 0 ? _e$runCoalescing : !1
      };
    }
    var gL = function (_e18) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
            _defineProperty(this, "subscription", new He());
            _defineProperty(this, "initialized", !1);
            _defineProperty(this, "zone", w(ee));
            _defineProperty(this, "pendingTasks", w(Hn));
          }
          return _createClass(e, [{
            key: "initialize",
            value: function initialize() {
              var _this36 = this;
              if (this.initialized) return;
              this.initialized = !0;
              var n = null;
              !this.zone.isStable && !this.zone.hasPendingMacrotasks && !this.zone.hasPendingMicrotasks && (n = this.pendingTasks.add()), this.zone.runOutsideAngular(function () {
                _this36.subscription.add(_this36.zone.onStable.subscribe(function () {
                  ee.assertNotInAngularZone(), queueMicrotask(function () {
                    null !== n && !_this36.zone.hasPendingMacrotasks && !_this36.zone.hasPendingMicrotasks && (_this36.pendingTasks.remove(n), n = null);
                  });
                }));
              }), this.subscription.add(this.zone.onUnstable.subscribe(function () {
                ee.assertInAngularZone(), n !== null && n !== void 0 ? n : n = _this36.pendingTasks.add();
              }));
            }
          }, {
            key: "ngOnDestroy",
            value: function ngOnDestroy() {
              this.subscription.unsubscribe();
            }
          }]);
        }();
        _e18 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e18)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e18,
          factory: _e18.ɵfac,
          providedIn: "root"
        }));
        return e;
      }(),
      As = function (_e19) {
        var e = /*#__PURE__*/function () {
          function e() {
            var _w5,
              _this$ngZone$_inner,
              _w6,
              _this37 = this;
            _classCallCheck(this, e);
            _defineProperty(this, "appRef", w(Et));
            _defineProperty(this, "taskService", w(Hn));
            _defineProperty(this, "ngZone", w(ee));
            _defineProperty(this, "zonelessEnabled", w(ki));
            _defineProperty(this, "tracing", w(Do, {
              optional: !0
            }));
            _defineProperty(this, "disableScheduling", (_w5 = w(Ev, {
              optional: !0
            })) !== null && _w5 !== void 0 ? _w5 : !1);
            _defineProperty(this, "zoneIsDefined", (typeof Zone === "undefined" ? "undefined" : _typeof(Zone)) < "u" && !!Zone.root.run);
            _defineProperty(this, "schedulerTickApplyArgs", [{
              data: {
                __scheduler_tick__: !0
              }
            }]);
            _defineProperty(this, "subscriptions", new He());
            _defineProperty(this, "angularZoneId", this.zoneIsDefined ? (_this$ngZone$_inner = this.ngZone._inner) === null || _this$ngZone$_inner === void 0 ? void 0 : _this$ngZone$_inner.get(Za) : null);
            _defineProperty(this, "scheduleInRootZone", !this.zonelessEnabled && this.zoneIsDefined && ((_w6 = w(Cd, {
              optional: !0
            })) !== null && _w6 !== void 0 ? _w6 : !1));
            _defineProperty(this, "cancelScheduledCallback", null);
            _defineProperty(this, "useMicrotaskScheduler", !1);
            _defineProperty(this, "runningTick", !1);
            _defineProperty(this, "pendingRenderTaskId", null);
            this.subscriptions.add(this.appRef.afterTick.subscribe(function () {
              _this37.runningTick || _this37.cleanup();
            })), this.subscriptions.add(this.ngZone.onUnstable.subscribe(function () {
              _this37.runningTick || _this37.cleanup();
            })), this.disableScheduling || (this.disableScheduling = !this.zonelessEnabled && (this.ngZone instanceof Md || !this.zoneIsDefined));
          }
          return _createClass(e, [{
            key: "notify",
            value: function notify(n) {
              var _this$tracing$snapsho,
                _this$tracing,
                _this38 = this;
              if (!this.zonelessEnabled && 5 === n) return;
              var r = !1;
              switch (n) {
                case 0:
                  this.appRef.dirtyFlags |= 2;
                  break;
                case 3:
                case 2:
                case 4:
                case 5:
                case 1:
                  this.appRef.dirtyFlags |= 4;
                  break;
                case 6:
                case 13:
                  this.appRef.dirtyFlags |= 2, r = !0;
                  break;
                case 12:
                  this.appRef.dirtyFlags |= 16, r = !0;
                  break;
                case 11:
                  r = !0;
                  break;
                default:
                  this.appRef.dirtyFlags |= 8;
              }
              if (this.appRef.tracingSnapshot = (_this$tracing$snapsho = (_this$tracing = this.tracing) === null || _this$tracing === void 0 ? void 0 : _this$tracing.snapshot(this.appRef.tracingSnapshot)) !== null && _this$tracing$snapsho !== void 0 ? _this$tracing$snapsho : null, !this.shouldScheduleTick(r)) return;
              var o = this.useMicrotaskScheduler ? _v : Iv;
              this.pendingRenderTaskId = this.taskService.add(), this.cancelScheduledCallback = this.scheduleInRootZone ? Zone.root.run(function () {
                return o(function () {
                  return _this38.tick();
                });
              }) : this.ngZone.runOutsideAngular(function () {
                return o(function () {
                  return _this38.tick();
                });
              });
            }
          }, {
            key: "shouldScheduleTick",
            value: function shouldScheduleTick(n) {
              return !(this.disableScheduling && !n || this.appRef.destroyed || null !== this.pendingRenderTaskId || this.runningTick || this.appRef._runningTick || !this.zonelessEnabled && this.zoneIsDefined && Zone.current.get(Za + this.angularZoneId));
            }
          }, {
            key: "tick",
            value: function tick() {
              var _this39 = this;
              if (this.runningTick || this.appRef.destroyed) return;
              if (0 === this.appRef.dirtyFlags) return void this.cleanup();
              !this.zonelessEnabled && 7 & this.appRef.dirtyFlags && (this.appRef.dirtyFlags |= 1);
              var n = this.taskService.add();
              try {
                this.ngZone.run(function () {
                  _this39.runningTick = !0, _this39.appRef._tick();
                }, void 0, this.schedulerTickApplyArgs);
              } catch (r) {
                throw this.taskService.remove(n), r;
              } finally {
                this.cleanup();
              }
              this.useMicrotaskScheduler = !0, _v(function () {
                _this39.useMicrotaskScheduler = !1, _this39.taskService.remove(n);
              });
            }
          }, {
            key: "ngOnDestroy",
            value: function ngOnDestroy() {
              this.subscriptions.unsubscribe(), this.cleanup();
            }
          }, {
            key: "cleanup",
            value: function cleanup() {
              var _this$cancelScheduled;
              if (this.runningTick = !1, (_this$cancelScheduled = this.cancelScheduledCallback) !== null && _this$cancelScheduled !== void 0 && _this$cancelScheduled.call(this), this.cancelScheduledCallback = null, null !== this.pendingRenderTaskId) {
                var n = this.pendingRenderTaskId;
                this.pendingRenderTaskId = null, this.taskService.remove(n);
              }
            }
          }]);
        }();
        _e19 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e19)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e19,
          factory: _e19.ɵfac,
          providedIn: "root"
        }));
        return e;
      }();
    var Kn = new I("", {
        providedIn: "root",
        factory: function factory() {
          return w(Kn, $.Optional | $.SkipSelf) || function mL() {
            return (typeof $localize === "undefined" ? "undefined" : _typeof($localize)) < "u" && $localize.locale || Yu;
          }();
        }
      }),
      sc = new I(""),
      CL = new I("");
    function xs(e) {
      return !e.moduleRef;
    }
    var Xn = null;
    var ac = function (_e20) {
      return _e20 = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      }), _defineProperty(_e20, "__NG_ELEMENT_ID__", TL), _e20;
    }();
    function TL(e) {
      return function NL(e, t, n) {
        if (jt(e) && !n) {
          var r = Qe(e.index, t);
          return new os(r, r);
        }
        return 175 & e.type ? new os(t[15], t) : null;
      }(z(), v(), !(16 & ~e));
    }
    var $I = /*#__PURE__*/function () {
      function $I() {
        _classCallCheck(this, $I);
      }
      return _createClass($I, [{
        key: "supports",
        value: function supports(t) {
          return Fu(t);
        }
      }, {
        key: "create",
        value: function create(t) {
          return new OL(t);
        }
      }]);
    }();
    var kL = function kL(e, t) {
      return t;
    };
    var OL = /*#__PURE__*/function () {
      function OL(t) {
        _classCallCheck(this, OL);
        _defineProperty(this, "length", 0);
        _defineProperty(this, "collection", void 0);
        _defineProperty(this, "_linkedRecords", null);
        _defineProperty(this, "_unlinkedRecords", null);
        _defineProperty(this, "_previousItHead", null);
        _defineProperty(this, "_itHead", null);
        _defineProperty(this, "_itTail", null);
        _defineProperty(this, "_additionsHead", null);
        _defineProperty(this, "_additionsTail", null);
        _defineProperty(this, "_movesHead", null);
        _defineProperty(this, "_movesTail", null);
        _defineProperty(this, "_removalsHead", null);
        _defineProperty(this, "_removalsTail", null);
        _defineProperty(this, "_identityChangesHead", null);
        _defineProperty(this, "_identityChangesTail", null);
        _defineProperty(this, "_trackByFn", void 0);
        this._trackByFn = t || kL;
      }
      return _createClass(OL, [{
        key: "forEachItem",
        value: function forEachItem(t) {
          var n;
          for (n = this._itHead; null !== n; n = n._next) t(n);
        }
      }, {
        key: "forEachOperation",
        value: function forEachOperation(t) {
          var n = this._itHead,
            r = this._removalsHead,
            o = 0,
            i = null;
          for (; n || r;) {
            var s = !r || n && n.currentIndex < qI(r, o, i) ? n : r,
              a = qI(s, o, i),
              u = s.currentIndex;
            if (s === r) o--, r = r._nextRemoved;else if (n = n._next, null == s.previousIndex) o++;else {
              i || (i = []);
              var c = a - o,
                l = u - o;
              if (c != l) {
                for (var h = 0; h < c; h++) {
                  var f = h < i.length ? i[h] : i[h] = 0,
                    p = f + h;
                  l <= p && p < c && (i[h] = f + 1);
                }
                i[s.previousIndex] = l - c;
              }
            }
            a !== u && t(s, a, u);
          }
        }
      }, {
        key: "forEachPreviousItem",
        value: function forEachPreviousItem(t) {
          var n;
          for (n = this._previousItHead; null !== n; n = n._nextPrevious) t(n);
        }
      }, {
        key: "forEachAddedItem",
        value: function forEachAddedItem(t) {
          var n;
          for (n = this._additionsHead; null !== n; n = n._nextAdded) t(n);
        }
      }, {
        key: "forEachMovedItem",
        value: function forEachMovedItem(t) {
          var n;
          for (n = this._movesHead; null !== n; n = n._nextMoved) t(n);
        }
      }, {
        key: "forEachRemovedItem",
        value: function forEachRemovedItem(t) {
          var n;
          for (n = this._removalsHead; null !== n; n = n._nextRemoved) t(n);
        }
      }, {
        key: "forEachIdentityChange",
        value: function forEachIdentityChange(t) {
          var n;
          for (n = this._identityChangesHead; null !== n; n = n._nextIdentityChange) t(n);
        }
      }, {
        key: "diff",
        value: function diff(t) {
          if (null == t && (t = []), !Fu(t)) throw new E(900, !1);
          return this.check(t) ? this : null;
        }
      }, {
        key: "onDestroy",
        value: function onDestroy() {}
      }, {
        key: "check",
        value: function check(t) {
          var _this40 = this;
          this._reset();
          var o,
            i,
            s,
            n = this._itHead,
            r = !1;
          if (Array.isArray(t)) {
            this.length = t.length;
            for (var a = 0; a < this.length; a++) i = t[a], s = this._trackByFn(a, i), null !== n && Object.is(n.trackById, s) ? (r && (n = this._verifyReinsertion(n, i, s, a)), Object.is(n.item, i) || this._addIdentityChange(n, i)) : (n = this._mismatch(n, i, s, a), r = !0), n = n._next;
          } else o = 0, function gk(e, t) {
            if (Array.isArray(e)) for (var _n7 = 0; _n7 < e.length; _n7++) t(e[_n7]);else {
              var _n8 = e[Symbol.iterator]();
              var _r12;
              for (; !(_r12 = _n8.next()).done;) t(_r12.value);
            }
          }(t, function (a) {
            s = _this40._trackByFn(o, a), null !== n && Object.is(n.trackById, s) ? (r && (n = _this40._verifyReinsertion(n, a, s, o)), Object.is(n.item, a) || _this40._addIdentityChange(n, a)) : (n = _this40._mismatch(n, a, s, o), r = !0), n = n._next, o++;
          }), this.length = o;
          return this._truncate(n), this.collection = t, this.isDirty;
        }
      }, {
        key: "isDirty",
        get: function get() {
          return null !== this._additionsHead || null !== this._movesHead || null !== this._removalsHead || null !== this._identityChangesHead;
        }
      }, {
        key: "_reset",
        value: function _reset() {
          if (this.isDirty) {
            var t;
            for (t = this._previousItHead = this._itHead; null !== t; t = t._next) t._nextPrevious = t._next;
            for (t = this._additionsHead; null !== t; t = t._nextAdded) t.previousIndex = t.currentIndex;
            for (this._additionsHead = this._additionsTail = null, t = this._movesHead; null !== t; t = t._nextMoved) t.previousIndex = t.currentIndex;
            this._movesHead = this._movesTail = null, this._removalsHead = this._removalsTail = null, this._identityChangesHead = this._identityChangesTail = null;
          }
        }
      }, {
        key: "_mismatch",
        value: function _mismatch(t, n, r, o) {
          var i;
          return null === t ? i = this._itTail : (i = t._prev, this._remove(t)), null !== (t = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(r, null)) ? (Object.is(t.item, n) || this._addIdentityChange(t, n), this._reinsertAfter(t, i, o)) : null !== (t = null === this._linkedRecords ? null : this._linkedRecords.get(r, o)) ? (Object.is(t.item, n) || this._addIdentityChange(t, n), this._moveAfter(t, i, o)) : t = this._addAfter(new PL(n, r), i, o), t;
        }
      }, {
        key: "_verifyReinsertion",
        value: function _verifyReinsertion(t, n, r, o) {
          var i = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(r, null);
          return null !== i ? t = this._reinsertAfter(i, t._prev, o) : t.currentIndex != o && (t.currentIndex = o, this._addToMoves(t, o)), t;
        }
      }, {
        key: "_truncate",
        value: function _truncate(t) {
          for (; null !== t;) {
            var n = t._next;
            this._addToRemovals(this._unlink(t)), t = n;
          }
          null !== this._unlinkedRecords && this._unlinkedRecords.clear(), null !== this._additionsTail && (this._additionsTail._nextAdded = null), null !== this._movesTail && (this._movesTail._nextMoved = null), null !== this._itTail && (this._itTail._next = null), null !== this._removalsTail && (this._removalsTail._nextRemoved = null), null !== this._identityChangesTail && (this._identityChangesTail._nextIdentityChange = null);
        }
      }, {
        key: "_reinsertAfter",
        value: function _reinsertAfter(t, n, r) {
          null !== this._unlinkedRecords && this._unlinkedRecords.remove(t);
          var o = t._prevRemoved,
            i = t._nextRemoved;
          return null === o ? this._removalsHead = i : o._nextRemoved = i, null === i ? this._removalsTail = o : i._prevRemoved = o, this._insertAfter(t, n, r), this._addToMoves(t, r), t;
        }
      }, {
        key: "_moveAfter",
        value: function _moveAfter(t, n, r) {
          return this._unlink(t), this._insertAfter(t, n, r), this._addToMoves(t, r), t;
        }
      }, {
        key: "_addAfter",
        value: function _addAfter(t, n, r) {
          return this._insertAfter(t, n, r), this._additionsTail = null === this._additionsTail ? this._additionsHead = t : this._additionsTail._nextAdded = t, t;
        }
      }, {
        key: "_insertAfter",
        value: function _insertAfter(t, n, r) {
          var o = null === n ? this._itHead : n._next;
          return t._next = o, t._prev = n, null === o ? this._itTail = t : o._prev = t, null === n ? this._itHead = t : n._next = t, null === this._linkedRecords && (this._linkedRecords = new zI()), this._linkedRecords.put(t), t.currentIndex = r, t;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          return this._addToRemovals(this._unlink(t));
        }
      }, {
        key: "_unlink",
        value: function _unlink(t) {
          null !== this._linkedRecords && this._linkedRecords.remove(t);
          var n = t._prev,
            r = t._next;
          return null === n ? this._itHead = r : n._next = r, null === r ? this._itTail = n : r._prev = n, t;
        }
      }, {
        key: "_addToMoves",
        value: function _addToMoves(t, n) {
          return t.previousIndex === n || (this._movesTail = null === this._movesTail ? this._movesHead = t : this._movesTail._nextMoved = t), t;
        }
      }, {
        key: "_addToRemovals",
        value: function _addToRemovals(t) {
          return null === this._unlinkedRecords && (this._unlinkedRecords = new zI()), this._unlinkedRecords.put(t), t.currentIndex = null, t._nextRemoved = null, null === this._removalsTail ? (this._removalsTail = this._removalsHead = t, t._prevRemoved = null) : (t._prevRemoved = this._removalsTail, this._removalsTail = this._removalsTail._nextRemoved = t), t;
        }
      }, {
        key: "_addIdentityChange",
        value: function _addIdentityChange(t, n) {
          return t.item = n, this._identityChangesTail = null === this._identityChangesTail ? this._identityChangesHead = t : this._identityChangesTail._nextIdentityChange = t, t;
        }
      }]);
    }();
    var PL = /*#__PURE__*/_createClass(function PL(t, n) {
      _classCallCheck(this, PL);
      _defineProperty(this, "item", void 0);
      _defineProperty(this, "trackById", void 0);
      _defineProperty(this, "currentIndex", null);
      _defineProperty(this, "previousIndex", null);
      _defineProperty(this, "_nextPrevious", null);
      _defineProperty(this, "_prev", null);
      _defineProperty(this, "_next", null);
      _defineProperty(this, "_prevDup", null);
      _defineProperty(this, "_nextDup", null);
      _defineProperty(this, "_prevRemoved", null);
      _defineProperty(this, "_nextRemoved", null);
      _defineProperty(this, "_nextAdded", null);
      _defineProperty(this, "_nextMoved", null);
      _defineProperty(this, "_nextIdentityChange", null);
      this.item = t, this.trackById = n;
    });
    var FL = /*#__PURE__*/function () {
      function FL() {
        _classCallCheck(this, FL);
        _defineProperty(this, "_head", null);
        _defineProperty(this, "_tail", null);
      }
      return _createClass(FL, [{
        key: "add",
        value: function add(t) {
          null === this._head ? (this._head = this._tail = t, t._nextDup = null, t._prevDup = null) : (this._tail._nextDup = t, t._prevDup = this._tail, t._nextDup = null, this._tail = t);
        }
      }, {
        key: "get",
        value: function get(t, n) {
          var r;
          for (r = this._head; null !== r; r = r._nextDup) if ((null === n || n <= r.currentIndex) && Object.is(r.trackById, t)) return r;
          return null;
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var n = t._prevDup,
            r = t._nextDup;
          return null === n ? this._head = r : n._nextDup = r, null === r ? this._tail = n : r._prevDup = n, null === this._head;
        }
      }]);
    }();
    var zI = /*#__PURE__*/function () {
      function zI() {
        _classCallCheck(this, zI);
        _defineProperty(this, "map", new Map());
      }
      return _createClass(zI, [{
        key: "put",
        value: function put(t) {
          var n = t.trackById;
          var r = this.map.get(n);
          r || (r = new FL(), this.map.set(n, r)), r.add(t);
        }
      }, {
        key: "get",
        value: function get(t, n) {
          var o = this.map.get(t);
          return o ? o.get(t, n) : null;
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var n = t.trackById;
          return this.map.get(n).remove(t) && this.map.delete(n), t;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.map.size;
        }
      }, {
        key: "clear",
        value: function clear() {
          this.map.clear();
        }
      }]);
    }();
    function qI(e, t, n) {
      var r = e.previousIndex;
      if (null === r) return r;
      var o = 0;
      return n && r < n.length && (o = n[r]), r + t + o;
    }
    function WI() {
      return new lp([new $I()]);
    }
    var lp = function (_e21) {
      var e = /*#__PURE__*/function () {
        function e(n) {
          _classCallCheck(this, e);
          _defineProperty(this, "factories", void 0);
          this.factories = n;
        }
        return _createClass(e, [{
          key: "find",
          value: function find(n) {
            var r = this.factories.find(function (o) {
              return o.supports(n);
            });
            if (null != r) return r;
            throw new E(901, !1);
          }
        }], [{
          key: "create",
          value: function create(n, r) {
            if (null != r) {
              var o = r.factories.slice();
              n = n.concat(o);
            }
            return new e(n);
          }
        }, {
          key: "extend",
          value: function extend(n) {
            return {
              provide: e,
              useFactory: function useFactory(r) {
                return e.create(n, r || WI());
              },
              deps: [[e, new Ol(), new kl()]]
            };
          }
        }]);
      }();
      _e21 = e;
      _defineProperty(e, "\u0275prov", b({
        token: _e21,
        providedIn: "root",
        factory: WI
      }));
      return e;
    }();
    function UL(e) {
      try {
        var t = e.rootComponent,
          n = e.appProviders,
          r = e.platformProviders,
          o = function SL() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            if (Xn) return Xn;
            var t = function LI() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var t = arguments.length > 1 ? arguments[1] : undefined;
              return Be.create({
                name: t,
                providers: [{
                  provide: Bl,
                  useValue: "platform"
                }, {
                  provide: sc,
                  useValue: new Set([function () {
                    return Xn = null;
                  }])
                }].concat(_toConsumableArray(e))
              });
            }(e);
            return Xn = t, function pE() {
              !function QM(e) {
                Vg = e;
              }(function () {
                throw new E(600, !1);
              });
            }(), function jI(e) {
              var t = e.get(kd, null);
              Ft(e, function () {
                t === null || t === void 0 || t.forEach(function (n) {
                  return n();
                });
              });
            }(t), t;
          }(r),
          i = [rp({}), {
            provide: Sn,
            useExisting: As
          }].concat(_toConsumableArray(n || []));
        return function OI(e) {
          var t = xs(e) ? e.r3Injector : e.moduleRef.injector,
            n = t.get(ee);
          return n.run(function () {
            xs(e) ? e.r3Injector.resolveInjectorInitializers() : e.moduleRef.resolveInjectorInitializers();
            var r = t.get(Ut, null);
            var o;
            if (n.runOutsideAngular(function () {
              o = n.onError.subscribe({
                next: function next(i) {
                  r.handleError(i);
                }
              });
            }), xs(e)) {
              var _i12 = function _i12() {
                  return t.destroy();
                },
                s = e.platformInjector.get(sc);
              s.add(_i12), t.onDestroy(function () {
                o.unsubscribe(), s.delete(_i12);
              });
            } else {
              var _i13 = function _i13() {
                  return e.moduleRef.destroy();
                },
                _s13 = e.platformInjector.get(sc);
              _s13.add(_i13), e.moduleRef.onDestroy(function () {
                $u(e.allPlatformModules, e.moduleRef), o.unsubscribe(), _s13.delete(_i13);
              });
            }
            return function _L(e, t, n) {
              try {
                var _r13 = n();
                return Hu(_r13) ? _r13.catch(function (o) {
                  throw t.runOutsideAngular(function () {
                    return e.handleError(o);
                  }), o;
                }) : _r13;
              } catch (r) {
                throw t.runOutsideAngular(function () {
                  return e.handleError(r);
                }), r;
              }
            }(r, n, function () {
              var i = t.get(hE);
              return i.runInitializers(), i.donePromise.then(function () {
                if (function tP(e) {
                  "string" == typeof e && (oC = e.toLowerCase().replace(/_/g, "-"));
                }(t.get(Kn, Yu) || Yu), !t.get(CL, !0)) return xs(e) ? t.get(Et) : (e.allPlatformModules.push(e.moduleRef), e.moduleRef);
                if (xs(e)) {
                  var u = t.get(Et);
                  return void 0 !== e.rootComponent && u.bootstrap(e.rootComponent), u;
                }
                return function IL(e, t) {
                  var n = e.injector.get(Et);
                  if (e._bootstrapComponents.length > 0) e._bootstrapComponents.forEach(function (r) {
                    return n.bootstrap(r);
                  });else {
                    if (!e.instance.ngDoBootstrap) throw new E(-403, !1);
                    e.instance.ngDoBootstrap(n);
                  }
                  t.push(e);
                }(e.moduleRef, e.allPlatformModules), e.moduleRef;
              });
            });
          });
        }({
          r3Injector: new Bw({
            providers: i,
            parent: o,
            debugName: "",
            runEnvironmentInitializers: !1
          }).injector,
          platformInjector: o,
          rootComponent: t
        });
      } catch (t) {
        return Promise.reject(t);
      }
    }
    function Pn(e, t) {
      return function GM(e, t) {
        var n = Object.create(WM);
        n.computation = e, void 0 !== t && (n.equal = t);
        var r = function r() {
          if (mi(n), gi(n), n.value === jn) throw n.error;
          return n.value;
        };
        return r[Fe] = n, r;
      }(e, t === null || t === void 0 ? void 0 : t.equal);
    }
    var hj = /*#__PURE__*/function () {
      function hj(t) {
        _classCallCheck(this, hj);
        _defineProperty(this, Fe, void 0);
        this[Fe] = t;
      }
      return _createClass(hj, [{
        key: "destroy",
        value: function destroy() {
          this[Fe].destroy();
        }
      }]);
    }();
    var u_ = _objectSpread(_objectSpread({}, Qr), {}, {
        consumerIsAlwaysLive: !0,
        consumerAllowSignalWrites: !0,
        dirty: !0,
        hasRun: !1,
        cleanupFns: void 0,
        zone: null,
        kind: "effect",
        onDestroyFn: Oi,
        run: function run() {
          var _this41 = this;
          if (this.dirty = !1, this.hasRun && !ia(this)) return;
          this.hasRun = !0;
          var e = function e(r) {
              var _this41$cleanupFns;
              return ((_this41$cleanupFns = _this41.cleanupFns) !== null && _this41$cleanupFns !== void 0 ? _this41$cleanupFns : _this41.cleanupFns = []).push(r);
            },
            t = Yr(this),
            n = Va(!1);
          try {
            this.maybeCleanup(), this.fn(e);
          } finally {
            Va(n), vi(this, t);
          }
        },
        maybeCleanup: function maybeCleanup() {
          var _this$cleanupFns;
          if ((_this$cleanupFns = this.cleanupFns) !== null && _this$cleanupFns !== void 0 && _this$cleanupFns.length) try {
            for (; this.cleanupFns.length;) this.cleanupFns.pop()();
          } finally {
            this.cleanupFns = [];
          }
        }
      }),
      pj = _objectSpread(_objectSpread({}, u_), {}, {
        consumerMarkedDirty: function consumerMarkedDirty() {
          this.scheduler.schedule(this), this.notifier.notify(12);
        },
        destroy: function destroy() {
          sa(this), this.onDestroyFn(), this.maybeCleanup(), this.scheduler.remove(this);
        }
      }),
      gj = _objectSpread(_objectSpread({}, u_), {}, {
        consumerMarkedDirty: function consumerMarkedDirty() {
          this.view[2] |= 8192, po(this.view), this.notifier.notify(13);
        },
        destroy: function destroy() {
          var _this$view$;
          sa(this), this.onDestroyFn(), this.maybeCleanup(), (_this$view$ = this.view[23]) === null || _this$view$ === void 0 ? void 0 : _this$view$.delete(this);
        }
      }),
      Gt = new I("");
    var h_ = null;
    function ni() {
      return h_;
    }
    var Rj = /*#__PURE__*/_createClass(function Rj() {
      _classCallCheck(this, Rj);
    });
    var p_ = function (_e22) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
          }
          return _createClass(e, [{
            key: "historyGo",
            value: function historyGo(n) {
              throw new Error("");
            }
          }]);
        }();
        _e22 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e22)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e22,
          factory: function factory() {
            return w(Aj);
          },
          providedIn: "platform"
        }));
        return e;
      }(),
      Aj = function (_e23) {
        var e = /*#__PURE__*/function (_p_) {
          function e() {
            var _this42;
            _classCallCheck(this, e);
            _this42 = _callSuper(this, e), _defineProperty(_assertThisInitialized(_this42), "_location", void 0), _defineProperty(_assertThisInitialized(_this42), "_history", void 0), _defineProperty(_assertThisInitialized(_this42), "_doc", w(Gt)), _assertThisInitialized(_this42), _this42._location = window.location, _this42._history = window.history;
            return _this42;
          }
          _inherits(e, _p_);
          return _createClass(e, [{
            key: "getBaseHrefFromDOM",
            value: function getBaseHrefFromDOM() {
              return ni().getBaseHref(this._doc);
            }
          }, {
            key: "onPopState",
            value: function onPopState(n) {
              var r = ni().getGlobalEventTarget(this._doc, "window");
              return r.addEventListener("popstate", n, !1), function () {
                return r.removeEventListener("popstate", n);
              };
            }
          }, {
            key: "onHashChange",
            value: function onHashChange(n) {
              var r = ni().getGlobalEventTarget(this._doc, "window");
              return r.addEventListener("hashchange", n, !1), function () {
                return r.removeEventListener("hashchange", n);
              };
            }
          }, {
            key: "href",
            get: function get() {
              return this._location.href;
            }
          }, {
            key: "protocol",
            get: function get() {
              return this._location.protocol;
            }
          }, {
            key: "hostname",
            get: function get() {
              return this._location.hostname;
            }
          }, {
            key: "port",
            get: function get() {
              return this._location.port;
            }
          }, {
            key: "pathname",
            get: function get() {
              return this._location.pathname;
            },
            set: function set(n) {
              this._location.pathname = n;
            }
          }, {
            key: "search",
            get: function get() {
              return this._location.search;
            }
          }, {
            key: "hash",
            get: function get() {
              return this._location.hash;
            }
          }, {
            key: "pushState",
            value: function pushState(n, r, o) {
              this._history.pushState(n, r, o);
            }
          }, {
            key: "replaceState",
            value: function replaceState(n, r, o) {
              this._history.replaceState(n, r, o);
            }
          }, {
            key: "forward",
            value: function forward() {
              this._history.forward();
            }
          }, {
            key: "back",
            value: function back() {
              this._history.back();
            }
          }, {
            key: "historyGo",
            value: function historyGo() {
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              this._history.go(n);
            }
          }, {
            key: "getState",
            value: function getState() {
              return this._history.state;
            }
          }]);
        }(p_);
        _e23 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e23)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e23,
          factory: function factory() {
            return new _e23();
          },
          providedIn: "platform"
        }));
        return e;
      }();
    function g_(e, t) {
      return e ? t ? e.endsWith("/") ? t.startsWith("/") ? e + t.slice(1) : e + t : t.startsWith("/") ? e + t : "".concat(e, "/").concat(t) : e : t;
    }
    function m_(e) {
      var t = e.search(/#|\?|$/);
      return "/" === e[t - 1] ? e.slice(0, t - 1) + e.slice(t) : e;
    }
    function Br(e) {
      return e && "?" !== e[0] ? "?".concat(e) : e;
    }
    var gc = function (_e24) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
        }
        return _createClass(e, [{
          key: "historyGo",
          value: function historyGo(n) {
            throw new Error("");
          }
        }]);
      }();
      _e24 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e24)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e24,
        factory: function factory() {
          return w(kj);
        },
        providedIn: "root"
      }));
      return e;
    }();
    var xj = new I("");
    var kj = function (_e25) {
        var e = /*#__PURE__*/function (_gc) {
          function e(n, r) {
            var _ref3, _ref4, _w$location;
            var _this43;
            _classCallCheck(this, e);
            _this43 = _callSuper(this, e), _defineProperty(_assertThisInitialized(_this43), "_platformLocation", void 0), _defineProperty(_assertThisInitialized(_this43), "_baseHref", void 0), _defineProperty(_assertThisInitialized(_this43), "_removeListenerFns", []), _assertThisInitialized(_this43), _this43._platformLocation = n, _this43._baseHref = (_ref3 = (_ref4 = r !== null && r !== void 0 ? r : _this43._platformLocation.getBaseHrefFromDOM()) !== null && _ref4 !== void 0 ? _ref4 : (_w$location = w(Gt).location) === null || _w$location === void 0 ? void 0 : _w$location.origin) !== null && _ref3 !== void 0 ? _ref3 : "";
            return _this43;
          }
          _inherits(e, _gc);
          return _createClass(e, [{
            key: "ngOnDestroy",
            value: function ngOnDestroy() {
              for (; this._removeListenerFns.length;) this._removeListenerFns.pop()();
            }
          }, {
            key: "onPopState",
            value: function onPopState(n) {
              this._removeListenerFns.push(this._platformLocation.onPopState(n), this._platformLocation.onHashChange(n));
            }
          }, {
            key: "getBaseHref",
            value: function getBaseHref() {
              return this._baseHref;
            }
          }, {
            key: "prepareExternalUrl",
            value: function prepareExternalUrl(n) {
              return g_(this._baseHref, n);
            }
          }, {
            key: "path",
            value: function path() {
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var r = this._platformLocation.pathname + Br(this._platformLocation.search),
                o = this._platformLocation.hash;
              return o && n ? "".concat(r).concat(o) : r;
            }
          }, {
            key: "pushState",
            value: function pushState(n, r, o, i) {
              var s = this.prepareExternalUrl(o + Br(i));
              this._platformLocation.pushState(n, r, s);
            }
          }, {
            key: "replaceState",
            value: function replaceState(n, r, o, i) {
              var s = this.prepareExternalUrl(o + Br(i));
              this._platformLocation.replaceState(n, r, s);
            }
          }, {
            key: "forward",
            value: function forward() {
              this._platformLocation.forward();
            }
          }, {
            key: "back",
            value: function back() {
              this._platformLocation.back();
            }
          }, {
            key: "getState",
            value: function getState() {
              return this._platformLocation.getState();
            }
          }, {
            key: "historyGo",
            value: function historyGo() {
              var _this$_platformLocati, _this$_platformLocati2;
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              (_this$_platformLocati = (_this$_platformLocati2 = this._platformLocation).historyGo) === null || _this$_platformLocati === void 0 || _this$_platformLocati.call(_this$_platformLocati2, n);
            }
          }]);
        }(gc);
        _e25 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e25)(T(p_), T(xj, 8));
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e25,
          factory: _e25.ɵfac,
          providedIn: "root"
        }));
        return e;
      }(),
      Os = function (_e26) {
        var e = /*#__PURE__*/function () {
          function e(n) {
            var _this44 = this;
            _classCallCheck(this, e);
            _defineProperty(this, "_subject", new $e());
            _defineProperty(this, "_basePath", void 0);
            _defineProperty(this, "_locationStrategy", void 0);
            _defineProperty(this, "_urlChangeListeners", []);
            _defineProperty(this, "_urlChangeSubscription", null);
            this._locationStrategy = n;
            var r = this._locationStrategy.getBaseHref();
            this._basePath = function Fj(e) {
              if (new RegExp("^(https?:)?//").test(e)) {
                var _e$split = e.split(/\/\/[^\/]+/),
                  _e$split2 = _slicedToArray(_e$split, 2),
                  _n9 = _e$split2[1];
                return _n9;
              }
              return e;
            }(m_(v_(r))), this._locationStrategy.onPopState(function (o) {
              _this44._subject.next({
                url: _this44.path(!0),
                pop: !0,
                state: o.state,
                type: o.type
              });
            });
          }
          return _createClass(e, [{
            key: "ngOnDestroy",
            value: function ngOnDestroy() {
              var _this$_urlChangeSubsc;
              (_this$_urlChangeSubsc = this._urlChangeSubscription) !== null && _this$_urlChangeSubsc !== void 0 && _this$_urlChangeSubsc.unsubscribe(), this._urlChangeListeners = [];
            }
          }, {
            key: "path",
            value: function path() {
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              return this.normalize(this._locationStrategy.path(n));
            }
          }, {
            key: "getState",
            value: function getState() {
              return this._locationStrategy.getState();
            }
          }, {
            key: "isCurrentPathEqualTo",
            value: function isCurrentPathEqualTo(n) {
              var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              return this.path() == this.normalize(n + Br(r));
            }
          }, {
            key: "normalize",
            value: function normalize(n) {
              return e.stripTrailingSlash(function Pj(e, t) {
                if (!e || !t.startsWith(e)) return t;
                var n = t.substring(e.length);
                return "" === n || ["/", ";", "?", "#"].includes(n[0]) ? n : t;
              }(this._basePath, v_(n)));
            }
          }, {
            key: "prepareExternalUrl",
            value: function prepareExternalUrl(n) {
              return n && "/" !== n[0] && (n = "/" + n), this._locationStrategy.prepareExternalUrl(n);
            }
          }, {
            key: "go",
            value: function go(n) {
              var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              this._locationStrategy.pushState(o, "", n, r), this._notifyUrlChangeListeners(this.prepareExternalUrl(n + Br(r)), o);
            }
          }, {
            key: "replaceState",
            value: function replaceState(n) {
              var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              this._locationStrategy.replaceState(o, "", n, r), this._notifyUrlChangeListeners(this.prepareExternalUrl(n + Br(r)), o);
            }
          }, {
            key: "forward",
            value: function forward() {
              this._locationStrategy.forward();
            }
          }, {
            key: "back",
            value: function back() {
              this._locationStrategy.back();
            }
          }, {
            key: "historyGo",
            value: function historyGo() {
              var _this$_locationStrate, _this$_locationStrate2;
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              (_this$_locationStrate = (_this$_locationStrate2 = this._locationStrategy).historyGo) === null || _this$_locationStrate === void 0 || _this$_locationStrate.call(_this$_locationStrate2, n);
            }
          }, {
            key: "onUrlChange",
            value: function onUrlChange(n) {
              var _this$_urlChangeSubsc2,
                _this45 = this;
              return this._urlChangeListeners.push(n), (_this$_urlChangeSubsc2 = this._urlChangeSubscription) !== null && _this$_urlChangeSubsc2 !== void 0 ? _this$_urlChangeSubsc2 : this._urlChangeSubscription = this.subscribe(function (r) {
                _this45._notifyUrlChangeListeners(r.url, r.state);
              }), function () {
                var _this45$_urlChangeSub;
                var r = _this45._urlChangeListeners.indexOf(n);
                _this45._urlChangeListeners.splice(r, 1), 0 === _this45._urlChangeListeners.length && ((_this45$_urlChangeSub = _this45._urlChangeSubscription) !== null && _this45$_urlChangeSub !== void 0 && _this45$_urlChangeSub.unsubscribe(), _this45._urlChangeSubscription = null);
              };
            }
          }, {
            key: "_notifyUrlChangeListeners",
            value: function _notifyUrlChangeListeners() {
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              var r = arguments.length > 1 ? arguments[1] : undefined;
              this._urlChangeListeners.forEach(function (o) {
                return o(n, r);
              });
            }
          }, {
            key: "subscribe",
            value: function subscribe(n, r, o) {
              return this._subject.subscribe({
                next: n,
                error: r !== null && r !== void 0 ? r : void 0,
                complete: o !== null && o !== void 0 ? o : void 0
              });
            }
          }]);
        }();
        _e26 = e;
        _defineProperty(e, "normalizeQueryParams", Br);
        _defineProperty(e, "joinWithSlash", g_);
        _defineProperty(e, "stripTrailingSlash", m_);
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e26)(T(gc));
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e26,
          factory: function factory() {
            return function Oj() {
              return new Os(T(gc));
            }();
          },
          providedIn: "root"
        }));
        return e;
      }();
    function v_(e) {
      return e.replace(/\/index.html$/, "");
    }
    function y_(e, t) {
      t = encodeURIComponent(t);
      var _iterator24 = _createForOfIteratorHelper(e.split(";")),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var n = _step24.value;
          var r = n.indexOf("="),
            _ref5 = -1 == r ? [n, ""] : [n.slice(0, r), n.slice(r + 1)],
            _ref6 = _slicedToArray(_ref5, 2),
            o = _ref6[0],
            i = _ref6[1];
          if (o.trim() === t) return decodeURIComponent(i);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      return null;
    }
    function w_(e) {
      return "server" === e;
    }
    var E_ = /*#__PURE__*/_createClass(function E_() {
      _classCallCheck(this, E_);
    });
    var mp = new I("");
    var C_ = function (_e27) {
      var e = /*#__PURE__*/function () {
        function e(n, r) {
          var _this46 = this;
          _classCallCheck(this, e);
          _defineProperty(this, "_zone", void 0);
          _defineProperty(this, "_plugins", void 0);
          _defineProperty(this, "_eventNameToPlugin", new Map());
          this._zone = r, n.forEach(function (o) {
            o.manager = _this46;
          }), this._plugins = n.slice().reverse();
        }
        return _createClass(e, [{
          key: "addEventListener",
          value: function addEventListener(n, r, o, i) {
            return this._findPluginFor(r).addEventListener(n, r, o, i);
          }
        }, {
          key: "getZone",
          value: function getZone() {
            return this._zone;
          }
        }, {
          key: "_findPluginFor",
          value: function _findPluginFor(n) {
            var r = this._eventNameToPlugin.get(n);
            if (r) return r;
            if (r = this._plugins.find(function (i) {
              return i.supports(n);
            }), !r) throw new E(5101, !1);
            return this._eventNameToPlugin.set(n, r), r;
          }
        }]);
      }();
      _e27 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e27)(T(mp), T(ee));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e27,
        factory: _e27.ɵfac
      }));
      return e;
    }();
    var I_ = /*#__PURE__*/_createClass(function I_(t) {
      _classCallCheck(this, I_);
      _defineProperty(this, "_doc", void 0);
      _defineProperty(this, "manager", void 0);
      this._doc = t;
    });
    var mc = "ng-app-id";
    function __(e) {
      var _iterator25 = _createForOfIteratorHelper(e),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var t = _step25.value;
          t.remove();
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }
    function b_(e, t) {
      var n = t.createElement("style");
      return n.textContent = e, n;
    }
    function vp(e, t) {
      var n = t.createElement("link");
      return n.setAttribute("rel", "stylesheet"), n.setAttribute("href", e), n;
    }
    var M_ = function (_e28) {
      var e = /*#__PURE__*/function () {
        function e(n, r, o) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          _classCallCheck(this, e);
          _defineProperty(this, "doc", void 0);
          _defineProperty(this, "appId", void 0);
          _defineProperty(this, "nonce", void 0);
          _defineProperty(this, "inline", new Map());
          _defineProperty(this, "external", new Map());
          _defineProperty(this, "hosts", new Set());
          _defineProperty(this, "isServer", void 0);
          this.doc = n, this.appId = r, this.nonce = o, this.isServer = w_(i), function jj(e, t, n, r, _e$head) {
            var o = (_e$head = e.head) === null || _e$head === void 0 ? void 0 : _e$head.querySelectorAll("style[".concat(mc, "=\"").concat(t, "\"],link[").concat(mc, "=\"").concat(t, "\"]"));
            if (o) {
              var _iterator26 = _createForOfIteratorHelper(o),
                _step26;
              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  var _i14 = _step26.value;
                  _i14.removeAttribute(mc), _i14 instanceof HTMLLinkElement ? r.set(_i14.href.slice(_i14.href.lastIndexOf("/") + 1), {
                    usage: 0,
                    elements: [_i14]
                  }) : _i14.textContent && n.set(_i14.textContent, {
                    usage: 0,
                    elements: [_i14]
                  });
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }
            }
          }(n, r, this.inline, this.external), this.hosts.add(n.head);
        }
        return _createClass(e, [{
          key: "addStyles",
          value: function addStyles(n, r) {
            var _this47 = this;
            var _iterator27 = _createForOfIteratorHelper(n),
              _step27;
            try {
              for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                var o = _step27.value;
                this.addUsage(o, this.inline, b_);
              }
            } catch (err) {
              _iterator27.e(err);
            } finally {
              _iterator27.f();
            }
            r === null || r === void 0 || r.forEach(function (o) {
              return _this47.addUsage(o, _this47.external, vp);
            });
          }
        }, {
          key: "removeStyles",
          value: function removeStyles(n, r) {
            var _this48 = this;
            var _iterator28 = _createForOfIteratorHelper(n),
              _step28;
            try {
              for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                var o = _step28.value;
                this.removeUsage(o, this.inline);
              }
            } catch (err) {
              _iterator28.e(err);
            } finally {
              _iterator28.f();
            }
            r === null || r === void 0 || r.forEach(function (o) {
              return _this48.removeUsage(o, _this48.external);
            });
          }
        }, {
          key: "addUsage",
          value: function addUsage(n, r, o) {
            var _this49 = this;
            var i = r.get(n);
            i ? i.usage++ : r.set(n, {
              usage: 1,
              elements: _toConsumableArray(this.hosts).map(function (s) {
                return _this49.addElement(s, o(n, _this49.doc));
              })
            });
          }
        }, {
          key: "removeUsage",
          value: function removeUsage(n, r) {
            var o = r.get(n);
            o && (o.usage--, o.usage <= 0 && (__(o.elements), r.delete(n)));
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            for (var _i15 = 0, _arr = [].concat(_toConsumableArray(this.inline), _toConsumableArray(this.external)); _i15 < _arr.length; _i15++) {
              var _arr$_i = _slicedToArray(_arr[_i15], 2),
                n = _arr$_i[1].elements;
              __(n);
            }
            this.hosts.clear();
          }
        }, {
          key: "addHost",
          value: function addHost(n) {
            this.hosts.add(n);
            var _iterator29 = _createForOfIteratorHelper(this.inline),
              _step29;
            try {
              for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                var _step29$value = _slicedToArray(_step29.value, 2),
                  r = _step29$value[0],
                  o = _step29$value[1].elements;
                o.push(this.addElement(n, b_(r, this.doc)));
              }
            } catch (err) {
              _iterator29.e(err);
            } finally {
              _iterator29.f();
            }
            var _iterator30 = _createForOfIteratorHelper(this.external),
              _step30;
            try {
              for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                var _step30$value = _slicedToArray(_step30.value, 2),
                  _r14 = _step30$value[0],
                  _o8 = _step30$value[1].elements;
                _o8.push(this.addElement(n, vp(_r14, this.doc)));
              }
            } catch (err) {
              _iterator30.e(err);
            } finally {
              _iterator30.f();
            }
          }
        }, {
          key: "removeHost",
          value: function removeHost(n) {
            this.hosts.delete(n);
          }
        }, {
          key: "addElement",
          value: function addElement(n, r) {
            return this.nonce && r.setAttribute("nonce", this.nonce), this.isServer && r.setAttribute(mc, this.appId), n.appendChild(r);
          }
        }]);
      }();
      _e28 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e28)(T(Gt), T(Tn), T(Yv, 8), T(Od));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e28,
        factory: _e28.ɵfac
      }));
      return e;
    }();
    var yp = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: "http://www.w3.org/1999/xhtml",
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/",
        math: "http://www.w3.org/1998/Math/MathML"
      },
      Dp = /%COMP%/g,
      zj = new I("", {
        providedIn: "root",
        factory: function factory() {
          return !0;
        }
      });
    function T_(e, t) {
      return t.map(function (n) {
        return n.replace(Dp, e);
      });
    }
    var N_ = function (_e29) {
      var e = /*#__PURE__*/function () {
        function e(n, r, o, i, s, a, u) {
          var c = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
          var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
          _classCallCheck(this, e);
          _defineProperty(this, "eventManager", void 0);
          _defineProperty(this, "sharedStylesHost", void 0);
          _defineProperty(this, "appId", void 0);
          _defineProperty(this, "removeStylesOnCompDestroy", void 0);
          _defineProperty(this, "doc", void 0);
          _defineProperty(this, "platformId", void 0);
          _defineProperty(this, "ngZone", void 0);
          _defineProperty(this, "nonce", void 0);
          _defineProperty(this, "tracingService", void 0);
          _defineProperty(this, "rendererByCompId", new Map());
          _defineProperty(this, "defaultRenderer", void 0);
          _defineProperty(this, "platformIsServer", void 0);
          this.eventManager = n, this.sharedStylesHost = r, this.appId = o, this.removeStylesOnCompDestroy = i, this.doc = s, this.platformId = a, this.ngZone = u, this.nonce = c, this.tracingService = l, this.platformIsServer = w_(a), this.defaultRenderer = new wp(n, s, u, this.platformIsServer, this.tracingService);
        }
        return _createClass(e, [{
          key: "createRenderer",
          value: function createRenderer(n, r) {
            if (!n || !r) return this.defaultRenderer;
            this.platformIsServer && r.encapsulation === Tt.ShadowDom && (r = _objectSpread(_objectSpread({}, r), {}, {
              encapsulation: Tt.Emulated
            }));
            var o = this.getOrCreateRenderer(n, r);
            return o instanceof A_ ? o.applyToHost(n) : o instanceof Ep && o.applyStyles(), o;
          }
        }, {
          key: "getOrCreateRenderer",
          value: function getOrCreateRenderer(n, r) {
            var o = this.rendererByCompId;
            var i = o.get(r.id);
            if (!i) {
              var s = this.doc,
                a = this.ngZone,
                u = this.eventManager,
                c = this.sharedStylesHost,
                l = this.removeStylesOnCompDestroy,
                d = this.platformIsServer,
                h = this.tracingService;
              switch (r.encapsulation) {
                case Tt.Emulated:
                  i = new A_(u, c, r, this.appId, l, s, a, d, h);
                  break;
                case Tt.ShadowDom:
                  return new Zj(u, c, n, r, s, a, this.nonce, d, h);
                default:
                  i = new Ep(u, c, r, l, s, a, d, h);
              }
              o.set(r.id, i);
            }
            return i;
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            this.rendererByCompId.clear();
          }
        }, {
          key: "componentReplaced",
          value: function componentReplaced(n) {
            this.rendererByCompId.delete(n);
          }
        }]);
      }();
      _e29 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e29)(T(C_), T(M_), T(Tn), T(zj), T(Gt), T(Od), T(ee), T(Yv), T(Do, 8));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e29,
        factory: _e29.ɵfac
      }));
      return e;
    }();
    var wp = /*#__PURE__*/function () {
      function wp(t, n, r, o, i) {
        _classCallCheck(this, wp);
        _defineProperty(this, "eventManager", void 0);
        _defineProperty(this, "doc", void 0);
        _defineProperty(this, "ngZone", void 0);
        _defineProperty(this, "platformIsServer", void 0);
        _defineProperty(this, "tracingService", void 0);
        _defineProperty(this, "data", Object.create(null));
        _defineProperty(this, "throwOnSyntheticProps", !0);
        _defineProperty(this, "destroyNode", null);
        this.eventManager = t, this.doc = n, this.ngZone = r, this.platformIsServer = o, this.tracingService = i;
      }
      return _createClass(wp, [{
        key: "destroy",
        value: function destroy() {}
      }, {
        key: "createElement",
        value: function createElement(t, n) {
          return n ? this.doc.createElementNS(yp[n] || n, t) : this.doc.createElement(t);
        }
      }, {
        key: "createComment",
        value: function createComment(t) {
          return this.doc.createComment(t);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return this.doc.createTextNode(t);
        }
      }, {
        key: "appendChild",
        value: function appendChild(t, n) {
          (R_(t) ? t.content : t).appendChild(n);
        }
      }, {
        key: "insertBefore",
        value: function insertBefore(t, n, r) {
          t && (R_(t) ? t.content : t).insertBefore(n, r);
        }
      }, {
        key: "removeChild",
        value: function removeChild(t, n) {
          n.remove();
        }
      }, {
        key: "selectRootElement",
        value: function selectRootElement(t, n) {
          var r = "string" == typeof t ? this.doc.querySelector(t) : t;
          if (!r) throw new E(-5104, !1);
          return n || (r.textContent = ""), r;
        }
      }, {
        key: "parentNode",
        value: function parentNode(t) {
          return t.parentNode;
        }
      }, {
        key: "nextSibling",
        value: function nextSibling(t) {
          return t.nextSibling;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, n, r, o) {
          if (o) {
            n = o + ":" + n;
            var i = yp[o];
            i ? t.setAttributeNS(i, n, r) : t.setAttribute(n, r);
          } else t.setAttribute(n, r);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, n, r) {
          if (r) {
            var o = yp[r];
            o ? t.removeAttributeNS(o, n) : t.removeAttribute("".concat(r, ":").concat(n));
          } else t.removeAttribute(n);
        }
      }, {
        key: "addClass",
        value: function addClass(t, n) {
          t.classList.add(n);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, n) {
          t.classList.remove(n);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, n, r, o) {
          o & (Gn.DashCase | Gn.Important) ? t.style.setProperty(n, r, o & Gn.Important ? "important" : "") : t.style[n] = r;
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, n, r) {
          r & Gn.DashCase ? t.style.removeProperty(n) : t.style[n] = "";
        }
      }, {
        key: "setProperty",
        value: function setProperty(t, n, r) {
          null != t && (t[n] = r);
        }
      }, {
        key: "setValue",
        value: function setValue(t, n) {
          t.nodeValue = n;
        }
      }, {
        key: "listen",
        value: function listen(t, n, r, o) {
          var _this$tracingService;
          if ("string" == typeof t && !(t = ni().getGlobalEventTarget(this.doc, t))) throw new E(5102, !1);
          var i = this.decoratePreventDefault(r);
          return (_this$tracingService = this.tracingService) !== null && _this$tracingService !== void 0 && _this$tracingService.wrapEventListener && (i = this.tracingService.wrapEventListener(t, n, i)), this.eventManager.addEventListener(t, n, i, o);
        }
      }, {
        key: "decoratePreventDefault",
        value: function decoratePreventDefault(t) {
          var _this50 = this;
          return function (n) {
            if ("__ngUnwrap__" === n) return t;
            !1 === (_this50.platformIsServer ? _this50.ngZone.runGuarded(function () {
              return t(n);
            }) : t(n)) && n.preventDefault();
          };
        }
      }]);
    }();
    function R_(e) {
      return "TEMPLATE" === e.tagName && void 0 !== e.content;
    }
    var Zj = /*#__PURE__*/function (_wp2) {
      function Zj(t, n, r, o, i, s, a, u, c) {
        var _o$getExternalStyles;
        var _this51;
        _classCallCheck(this, Zj);
        _this51 = _callSuper(this, Zj, [t, i, s, u, c]), _defineProperty(_assertThisInitialized(_this51), "sharedStylesHost", void 0), _defineProperty(_assertThisInitialized(_this51), "hostEl", void 0), _defineProperty(_assertThisInitialized(_this51), "shadowRoot", void 0), _this51.sharedStylesHost = n, _this51.hostEl = r, _this51.shadowRoot = r.attachShadow({
          mode: "open"
        }), _this51.sharedStylesHost.addHost(_this51.shadowRoot);
        var l = o.styles;
        l = T_(o.id, l);
        var _iterator31 = _createForOfIteratorHelper(l),
          _step31;
        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var _h5 = _step31.value;
            var _f10 = document.createElement("style");
            a && _f10.setAttribute("nonce", a), _f10.textContent = _h5, _this51.shadowRoot.appendChild(_f10);
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }
        var d = (_o$getExternalStyles = o.getExternalStyles) === null || _o$getExternalStyles === void 0 ? void 0 : _o$getExternalStyles.call(o);
        if (d) {
          var _iterator32 = _createForOfIteratorHelper(d),
            _step32;
          try {
            for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
              var h = _step32.value;
              var f = vp(h, i);
              a && f.setAttribute("nonce", a), _this51.shadowRoot.appendChild(f);
            }
          } catch (err) {
            _iterator32.e(err);
          } finally {
            _iterator32.f();
          }
        }
        return _this51;
      }
      _inherits(Zj, _wp2);
      return _createClass(Zj, [{
        key: "nodeOrShadowRoot",
        value: function nodeOrShadowRoot(t) {
          return t === this.hostEl ? this.shadowRoot : t;
        }
      }, {
        key: "appendChild",
        value: function appendChild(t, n) {
          return _superPropGet(Zj, "appendChild", this, 3)([this.nodeOrShadowRoot(t), n]);
        }
      }, {
        key: "insertBefore",
        value: function insertBefore(t, n, r) {
          return _superPropGet(Zj, "insertBefore", this, 3)([this.nodeOrShadowRoot(t), n, r]);
        }
      }, {
        key: "removeChild",
        value: function removeChild(t, n) {
          return _superPropGet(Zj, "removeChild", this, 3)([null, n]);
        }
      }, {
        key: "parentNode",
        value: function parentNode(t) {
          return this.nodeOrShadowRoot(_superPropGet(Zj, "parentNode", this, 3)([this.nodeOrShadowRoot(t)]));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.sharedStylesHost.removeHost(this.shadowRoot);
        }
      }]);
    }(wp);
    var Ep = /*#__PURE__*/function (_wp3) {
      function Ep(t, n, r, o, i, s, a, u, c) {
        var _r$getExternalStyles;
        var _this52;
        _classCallCheck(this, Ep);
        _this52 = _callSuper(this, Ep, [t, i, s, a, u]), _defineProperty(_assertThisInitialized(_this52), "sharedStylesHost", void 0), _defineProperty(_assertThisInitialized(_this52), "removeStylesOnCompDestroy", void 0), _defineProperty(_assertThisInitialized(_this52), "styles", void 0), _defineProperty(_assertThisInitialized(_this52), "styleUrls", void 0), _this52.sharedStylesHost = n, _this52.removeStylesOnCompDestroy = o;
        var l = r.styles;
        _this52.styles = c ? T_(c, l) : l, _this52.styleUrls = (_r$getExternalStyles = r.getExternalStyles) === null || _r$getExternalStyles === void 0 ? void 0 : _r$getExternalStyles.call(r, c);
        return _this52;
      }
      _inherits(Ep, _wp3);
      return _createClass(Ep, [{
        key: "applyStyles",
        value: function applyStyles() {
          this.sharedStylesHost.addStyles(this.styles, this.styleUrls);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.removeStylesOnCompDestroy && this.sharedStylesHost.removeStyles(this.styles, this.styleUrls);
        }
      }]);
    }(wp);
    var A_ = /*#__PURE__*/function (_Ep2) {
      function A_(t, n, r, o, i, s, a, u, c) {
        var _this53;
        _classCallCheck(this, A_);
        var l = o + "-" + r.id;
        _this53 = _callSuper(this, A_, [t, n, r, i, s, a, u, c, l]), _defineProperty(_assertThisInitialized(_this53), "contentAttr", void 0), _defineProperty(_assertThisInitialized(_this53), "hostAttr", void 0), _this53.contentAttr = function qj(e) {
          return "_ngcontent-%COMP%".replace(Dp, e);
        }(l), _this53.hostAttr = function Gj(e) {
          return "_nghost-%COMP%".replace(Dp, e);
        }(l);
        return _this53;
      }
      _inherits(A_, _Ep2);
      return _createClass(A_, [{
        key: "applyToHost",
        value: function applyToHost(t) {
          this.applyStyles(), this.setAttribute(t, this.hostAttr, "");
        }
      }, {
        key: "createElement",
        value: function createElement(t, n) {
          var r = _superPropGet(A_, "createElement", this, 3)([t, n]);
          return _superPropGet(A_, "setAttribute", this, 3)([r, this.contentAttr, ""]), r;
        }
      }]);
    }(Ep);
    var Cp = /*#__PURE__*/function (_Rj) {
      function Cp() {
        var _this54;
        _classCallCheck(this, Cp);
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }
        _this54 = _callSuper(this, Cp, [].concat(args));
        _defineProperty(_this54, "supportsDOMEvents", !0);
        return _this54;
      }
      _inherits(Cp, _Rj);
      return _createClass(Cp, [{
        key: "onAndCancel",
        value: function onAndCancel(t, n, r, o) {
          return t.addEventListener(n, r, o), function () {
            t.removeEventListener(n, r, o);
          };
        }
      }, {
        key: "dispatchEvent",
        value: function dispatchEvent(t, n) {
          t.dispatchEvent(n);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          t.remove();
        }
      }, {
        key: "createElement",
        value: function createElement(t, n) {
          return (n = n || this.getDefaultDocument()).createElement(t);
        }
      }, {
        key: "createHtmlDocument",
        value: function createHtmlDocument() {
          return document.implementation.createHTMLDocument("fakeTitle");
        }
      }, {
        key: "getDefaultDocument",
        value: function getDefaultDocument() {
          return document;
        }
      }, {
        key: "isElementNode",
        value: function isElementNode(t) {
          return t.nodeType === Node.ELEMENT_NODE;
        }
      }, {
        key: "isShadowRoot",
        value: function isShadowRoot(t) {
          return t instanceof DocumentFragment;
        }
      }, {
        key: "getGlobalEventTarget",
        value: function getGlobalEventTarget(t, n) {
          return "window" === n ? window : "document" === n ? t : "body" === n ? t.body : null;
        }
      }, {
        key: "getBaseHref",
        value: function getBaseHref(t) {
          var n = function Qj() {
            return Ps = Ps || document.querySelector("base"), Ps ? Ps.getAttribute("href") : null;
          }();
          return null == n ? null : function Yj(e) {
            return new URL(e, document.baseURI).pathname;
          }(n);
        }
      }, {
        key: "resetBaseElement",
        value: function resetBaseElement() {
          Ps = null;
        }
      }, {
        key: "getUserAgent",
        value: function getUserAgent() {
          return window.navigator.userAgent;
        }
      }, {
        key: "getCookie",
        value: function getCookie(t) {
          return y_(document.cookie, t);
        }
      }], [{
        key: "makeCurrent",
        value: function makeCurrent() {
          !function Nj(e) {
            h_ !== null && h_ !== void 0 ? h_ : h_ = e;
          }(new Cp());
        }
      }]);
    }(Rj);
    var Ps = null,
      Kj = function (_e30) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
          }
          return _createClass(e, [{
            key: "build",
            value: function build() {
              return new XMLHttpRequest();
            }
          }]);
        }();
        _e30 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e30)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e30,
          factory: _e30.ɵfac
        }));
        return e;
      }();
    var x_ = ["alt", "control", "meta", "shift"],
      eV = {
        "\b": "Backspace",
        "\t": "Tab",
        "\x7f": "Delete",
        "\x1b": "Escape",
        Del: "Delete",
        Esc: "Escape",
        Left: "ArrowLeft",
        Right: "ArrowRight",
        Up: "ArrowUp",
        Down: "ArrowDown",
        Menu: "ContextMenu",
        Scroll: "ScrollLock",
        Win: "OS"
      },
      tV = {
        alt: function alt(e) {
          return e.altKey;
        },
        control: function control(e) {
          return e.ctrlKey;
        },
        meta: function meta(e) {
          return e.metaKey;
        },
        shift: function shift(e) {
          return e.shiftKey;
        }
      };
    function k_(e) {
      var _e$providers;
      return {
        appProviders: [].concat(cV, _toConsumableArray((_e$providers = e === null || e === void 0 ? void 0 : e.providers) !== null && _e$providers !== void 0 ? _e$providers : [])),
        platformProviders: aV
      };
    }
    var aV = [{
        provide: Od,
        useValue: "browser"
      }, {
        provide: kd,
        useValue: function oV() {
          Cp.makeCurrent();
        },
        multi: !0
      }, {
        provide: Gt,
        useFactory: function sV() {
          return function F0(e) {
            xd = e;
          }(document), document;
        }
      }],
      cV = [{
        provide: Bl,
        useValue: "root"
      }, {
        provide: Ut,
        useFactory: function iV() {
          return new Ut();
        }
      }, {
        provide: mp,
        useClass: function (_e31) {
          var e = /*#__PURE__*/function (_I_2) {
            function e(n) {
              _classCallCheck(this, e);
              return _callSuper(this, e, [n]);
            }
            _inherits(e, _I_2);
            return _createClass(e, [{
              key: "supports",
              value: function supports(n) {
                return !0;
              }
            }, {
              key: "addEventListener",
              value: function addEventListener(n, r, o, i) {
                var _this55 = this;
                return n.addEventListener(r, o, i), function () {
                  return _this55.removeEventListener(n, r, o, i);
                };
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(n, r, o, i) {
                return n.removeEventListener(r, o, i);
              }
            }]);
          }(I_);
          _e31 = e;
          _defineProperty(e, "\u0275fac", function (r) {
            return new (r || _e31)(T(Gt));
          });
          _defineProperty(e, "\u0275prov", b({
            token: _e31,
            factory: _e31.ɵfac
          }));
          return e;
        }(),
        multi: !0,
        deps: [Gt]
      }, {
        provide: mp,
        useClass: function (_e32) {
          var e = /*#__PURE__*/function (_I_3) {
            function e(n) {
              _classCallCheck(this, e);
              return _callSuper(this, e, [n]);
            }
            _inherits(e, _I_3);
            return _createClass(e, [{
              key: "supports",
              value: function supports(n) {
                return null != e.parseEventName(n);
              }
            }, {
              key: "addEventListener",
              value: function addEventListener(n, r, o, i) {
                var s = e.parseEventName(r),
                  a = e.eventCallback(s.fullKey, o, this.manager.getZone());
                return this.manager.getZone().runOutsideAngular(function () {
                  return ni().onAndCancel(n, s.domEventName, a, i);
                });
              }
            }], [{
              key: "parseEventName",
              value: function parseEventName(n) {
                var r = n.toLowerCase().split("."),
                  o = r.shift();
                if (0 === r.length || "keydown" !== o && "keyup" !== o) return null;
                var i = e._normalizeKey(r.pop());
                var s = "",
                  a = r.indexOf("code");
                if (a > -1 && (r.splice(a, 1), s = "code."), x_.forEach(function (c) {
                  var l = r.indexOf(c);
                  l > -1 && (r.splice(l, 1), s += c + ".");
                }), s += i, 0 != r.length || 0 === i.length) return null;
                var u = {};
                return u.domEventName = o, u.fullKey = s, u;
              }
            }, {
              key: "matchEventFullKeyCode",
              value: function matchEventFullKeyCode(n, r) {
                var o = eV[n.key] || n.key,
                  i = "";
                return r.indexOf("code.") > -1 && (o = n.code, i = "code."), !(null == o || !o) && (o = o.toLowerCase(), " " === o ? o = "space" : "." === o && (o = "dot"), x_.forEach(function (s) {
                  s !== o && (0, tV[s])(n) && (i += s + ".");
                }), i += o, i === r);
              }
            }, {
              key: "eventCallback",
              value: function eventCallback(n, r, o) {
                return function (i) {
                  e.matchEventFullKeyCode(i, n) && o.runGuarded(function () {
                    return r(i);
                  });
                };
              }
            }, {
              key: "_normalizeKey",
              value: function _normalizeKey(n) {
                return "esc" === n ? "escape" : n;
              }
            }]);
          }(I_);
          _e32 = e;
          _defineProperty(e, "\u0275fac", function (r) {
            return new (r || _e32)(T(Gt));
          });
          _defineProperty(e, "\u0275prov", b({
            token: _e32,
            factory: _e32.ɵfac
          }));
          return e;
        }(),
        multi: !0,
        deps: [Gt]
      }, N_, M_, C_, {
        provide: Yf,
        useExisting: N_
      }, {
        provide: E_,
        useClass: Kj
      }, []];
    function er(e) {
      return this instanceof er ? (this.v = e, this) : new er(e);
    }
    function L_(e) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var n,
        t = e[Symbol.asyncIterator];
      return t ? t.call(e) : (e = function Mp(e) {
        var t = "function" == typeof Symbol && Symbol.iterator,
          n = t && e[t],
          r = 0;
        if (n) return n.call(e);
        if (e && "number" == typeof e.length) return {
          next: function next() {
            return e && r >= e.length && (e = void 0), {
              value: e && e[r++],
              done: !e
            };
          }
        };
        throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }(e), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function () {
        return this;
      }, n);
      function r(i) {
        n[i] = e[i] && function (s) {
          return new Promise(function (a, u) {
            !function o(i, s, a, u) {
              Promise.resolve(u).then(function (c) {
                i({
                  value: c,
                  done: a
                });
              }, s);
            }(a, u, (s = e[i](s)).done, s.value);
          });
        };
      }
    }
    "function" == typeof SuppressedError && SuppressedError;
    var Tp = function Tp(e) {
      return e && "number" == typeof e.length && "function" != typeof e;
    };
    function j_(e) {
      return J(e === null || e === void 0 ? void 0 : e.then);
    }
    function V_(e) {
      return J(e[Dl]);
    }
    function B_(e) {
      return Symbol.asyncIterator && J(e === null || e === void 0 ? void 0 : e[Symbol.asyncIterator]);
    }
    function U_(e) {
      return new TypeError("You provided ".concat(null !== e && "object" == _typeof(e) ? "an invalid object" : "'".concat(e, "'"), " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable."));
    }
    var H_ = function LV() {
      return "function" == typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator";
    }();
    function $_(e) {
      return J(e === null || e === void 0 ? void 0 : e[H_]);
    }
    function z_(e) {
      return function F_(e, t, n) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var o,
          r = n.apply(e, t || []),
          i = [];
        return o = Object.create(("function" == typeof AsyncIterator ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", function s(f) {
          return function (p) {
            return Promise.resolve(p).then(f, d);
          };
        }), o[Symbol.asyncIterator] = function () {
          return this;
        }, o;
        function a(f, p) {
          r[f] && (o[f] = function (g) {
            return new Promise(function (m, D) {
              i.push([f, g, m, D]) > 1 || u(f, g);
            });
          }, p && (o[f] = p(o[f])));
        }
        function u(f, p) {
          try {
            !function c(f) {
              f.value instanceof er ? Promise.resolve(f.value.v).then(l, d) : h(i[0][2], f);
            }(r[f](p));
          } catch (g) {
            h(i[0][3], g);
          }
        }
        function l(f) {
          u("next", f);
        }
        function d(f) {
          u("throw", f);
        }
        function h(f, p) {
          f(p), i.shift(), i.length && u(i[0][0], i[0][1]);
        }
      }(this, arguments, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var n, _yield$er, r, o;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              n = e.getReader();
              _context.prev = 1;
            case 2:
              _context.next = 4;
              return er(n.read());
            case 4:
              _yield$er = _context.sent;
              r = _yield$er.value;
              o = _yield$er.done;
              if (!o) {
                _context.next = 11;
                break;
              }
              _context.next = 10;
              return er(void 0);
            case 10:
              return _context.abrupt("return", _context.sent);
            case 11:
              _context.next = 13;
              return er(r);
            case 13:
              _context.next = 15;
              return _context.sent;
            case 15:
              _context.next = 2;
              break;
            case 17:
              _context.prev = 17;
              n.releaseLock();
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1,, 17, 20]]);
      }));
    }
    function q_(e) {
      return J(e === null || e === void 0 ? void 0 : e.getReader);
    }
    function dn(e) {
      if (e instanceof _e) return e;
      if (null != e) {
        if (V_(e)) return function jV(e) {
          return new _e(function (t) {
            var n = e[Dl]();
            if (J(n.subscribe)) return n.subscribe(t);
            throw new TypeError("Provided object does not correctly implement Symbol.observable");
          });
        }(e);
        if (Tp(e)) return function VV(e) {
          return new _e(function (t) {
            for (var n = 0; n < e.length && !t.closed; n++) t.next(e[n]);
            t.complete();
          });
        }(e);
        if (j_(e)) return function BV(e) {
          return new _e(function (t) {
            e.then(function (n) {
              t.closed || (t.next(n), t.complete());
            }, function (n) {
              return t.error(n);
            }).then(null, Gg);
          });
        }(e);
        if (B_(e)) return G_(e);
        if ($_(e)) return function UV(e) {
          return new _e(function (t) {
            var _iterator33 = _createForOfIteratorHelper(e),
              _step33;
            try {
              for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                var n = _step33.value;
                if (t.next(n), t.closed) return;
              }
            } catch (err) {
              _iterator33.e(err);
            } finally {
              _iterator33.f();
            }
            t.complete();
          });
        }(e);
        if (q_(e)) return function HV(e) {
          return G_(z_(e));
        }(e);
      }
      throw U_(e);
    }
    function G_(e) {
      return new _e(function (t) {
        (function $V(e, t) {
          var n, r, o, i;
          return function O_(e, t, n, r) {
            return new (n || (n = Promise))(function (i, s) {
              function a(l) {
                try {
                  c(r.next(l));
                } catch (d) {
                  s(d);
                }
              }
              function u(l) {
                try {
                  c(r.throw(l));
                } catch (d) {
                  s(d);
                }
              }
              function c(l) {
                l.done ? i(l.value) : function o(i) {
                  return i instanceof n ? i : new n(function (s) {
                    s(i);
                  });
                }(l.value).then(a, u);
              }
              c((r = r.apply(e, t || [])).next());
            });
          }(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  n = L_(e);
                case 2:
                  _context2.next = 4;
                  return n.next();
                case 4:
                  if ((r = _context2.sent).done) {
                    _context2.next = 9;
                    break;
                  }
                  if (!(t.next(r.value), t.closed)) {
                    _context2.next = 7;
                    break;
                  }
                  return _context2.abrupt("return");
                case 7:
                  _context2.next = 2;
                  break;
                case 9:
                  _context2.next = 14;
                  break;
                case 11:
                  _context2.prev = 11;
                  _context2.t0 = _context2["catch"](0);
                  o = {
                    error: _context2.t0
                  };
                case 14:
                  _context2.prev = 14;
                  _context2.prev = 15;
                  _context2.t1 = r && !r.done && (i = n.return);
                  if (!_context2.t1) {
                    _context2.next = 20;
                    break;
                  }
                  _context2.next = 20;
                  return i.call(n);
                case 20:
                  _context2.prev = 20;
                  if (!o) {
                    _context2.next = 23;
                    break;
                  }
                  throw o.error;
                case 23:
                  return _context2.finish(20);
                case 24:
                  return _context2.finish(14);
                case 25:
                  t.complete();
                case 26:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[0, 11, 14, 25], [15,, 20, 24]]);
          }));
        })(e, t).catch(function (n) {
          return t.error(n);
        });
      });
    }
    function Fn(e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      var i = t.schedule(function () {
        n(), o ? e.add(this.schedule(null, r)) : this.unsubscribe();
      }, r);
      if (e.add(i), !o) return i;
    }
    function W_(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return Le(function (n, r) {
        n.subscribe(ke(r, function (o) {
          return Fn(r, e, function () {
            return r.next(o);
          }, t);
        }, function () {
          return Fn(r, e, function () {
            return r.complete();
          }, t);
        }, function (o) {
          return Fn(r, e, function () {
            return r.error(o);
          }, t);
        }));
      });
    }
    function Z_(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return Le(function (n, r) {
        r.add(e.schedule(function () {
          return n.subscribe(r);
        }, t));
      });
    }
    function Q_(e, t) {
      if (!e) throw new Error("Iterable cannot be null");
      return new _e(function (n) {
        Fn(n, t, function () {
          var r = e[Symbol.asyncIterator]();
          Fn(n, t, function () {
            r.next().then(function (o) {
              o.done ? n.complete() : n.next(o.value);
            });
          }, 0, !0);
        });
      });
    }
    function qe(e, t) {
      return t ? function QV(e, t) {
        if (null != e) {
          if (V_(e)) return function zV(e, t) {
            return dn(e).pipe(Z_(t), W_(t));
          }(e, t);
          if (Tp(e)) return function GV(e, t) {
            return new _e(function (n) {
              var r = 0;
              return t.schedule(function () {
                r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
              });
            });
          }(e, t);
          if (j_(e)) return function qV(e, t) {
            return dn(e).pipe(Z_(t), W_(t));
          }(e, t);
          if (B_(e)) return Q_(e, t);
          if ($_(e)) return function WV(e, t) {
            return new _e(function (n) {
              var r;
              return Fn(n, t, function () {
                r = e[H_](), Fn(n, t, function () {
                  var o, i;
                  try {
                    var _r$next = r.next();
                    o = _r$next.value;
                    i = _r$next.done;
                  } catch (s) {
                    return void n.error(s);
                  }
                  i ? n.complete() : n.next(o);
                }, 0, !0);
              }), function () {
                var _r15;
                return J((_r15 = r) === null || _r15 === void 0 ? void 0 : _r15.return) && r.return();
              };
            });
          }(e, t);
          if (q_(e)) return function ZV(e, t) {
            return Q_(z_(e), t);
          }(e, t);
        }
        throw U_(e);
      }(e, t) : dn(e);
    }
    function Np(e) {
      return e[e.length - 1];
    }
    function vc(e) {
      return function YV(e) {
        return e && J(e.schedule);
      }(Np(e)) ? e.pop() : void 0;
    }
    function V() {
      for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        e[_key7] = arguments[_key7];
      }
      return qe(e, vc(e));
    }
    var yc = ll(function (e) {
        return function () {
          e(this), this.name = "EmptyError", this.message = "no elements in sequence";
        };
      }),
      KV = Array.isArray,
      XV = Object.getPrototypeOf,
      e2 = Object.prototype,
      t2 = Object.keys;
    var o2 = Array.isArray;
    function Y_(e) {
      return Y(function (t) {
        return function i2(e, t) {
          return o2(t) ? e.apply(void 0, _toConsumableArray(t)) : e(t);
        }(e, t);
      });
    }
    function J_() {
      for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        e[_key8] = arguments[_key8];
      }
      var t = vc(e),
        n = function JV(e) {
          return J(Np(e)) ? e.pop() : void 0;
        }(e),
        _n0 = function n2(e) {
          if (1 === e.length) {
            var _t4 = e[0];
            if (KV(_t4)) return {
              args: _t4,
              keys: null
            };
            if (function r2(e) {
              return e && "object" == _typeof(e) && XV(e) === e2;
            }(_t4)) {
              var _n1 = t2(_t4);
              return {
                args: _n1.map(function (r) {
                  return _t4[r];
                }),
                keys: _n1
              };
            }
          }
          return {
            args: e,
            keys: null
          };
        }(e),
        r = _n0.args,
        o = _n0.keys;
      if (0 === r.length) return qe([], t);
      var i = new _e(function a2(e, t) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : dr;
        return function (r) {
          K_(t, function () {
            var o = e.length,
              i = new Array(o);
            var s = o,
              a = o;
            var _loop5 = function _loop5(u) {
              K_(t, function () {
                var c = qe(e[u], t);
                var l = !1;
                c.subscribe(ke(r, function (d) {
                  i[u] = d, l || (l = !0, a--), a || r.next(n(i.slice()));
                }, function () {
                  --s || r.complete();
                }));
              }, r);
            };
            for (var u = 0; u < o; u++) {
              _loop5(u);
            }
          }, r);
        };
      }(r, t, o ? function (s) {
        return function s2(e, t) {
          return e.reduce(function (n, r, o) {
            return n[r] = t[o], n;
          }, {});
        }(o, s);
      } : dr));
      return n ? i.pipe(Y_(n)) : i;
    }
    function K_(e, t, n) {
      e ? Fn(n, e, t) : t();
    }
    function Ge(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1 / 0;
      return J(t) ? Ge(function (r, o) {
        return Y(function (i, s) {
          return t(r, i, o, s);
        })(dn(e(r, o)));
      }, n) : ("number" == typeof t && (n = t), Le(function (r, o) {
        return function u2(e, t, n, r, o, i, s, a) {
          var u = [];
          var c = 0,
            l = 0,
            d = !1;
          var h = function h() {
              d && !u.length && !c && t.complete();
            },
            f = function f(g) {
              return c < r ? _p4(g) : u.push(g);
            },
            _p4 = function p(g) {
              i && t.next(g), c++;
              var m = !1;
              dn(n(g, l++)).subscribe(ke(t, function (D) {
                o !== null && o !== void 0 && o(D), i ? f(D) : t.next(D);
              }, function () {
                m = !0;
              }, void 0, function () {
                if (m) try {
                  var _loop6 = function _loop6() {
                    var D = u.shift();
                    s ? Fn(t, s, function () {
                      return _p4(D);
                    }) : _p4(D);
                  };
                  for (c--; u.length && c < r;) {
                    _loop6();
                  }
                  h();
                } catch (D) {
                  t.error(D);
                }
              }));
            };
          return e.subscribe(ke(t, f, function () {
            d = !0, h();
          })), function () {
            a === null || a === void 0 || a();
          };
        }(r, o, e, n);
      }));
    }
    function Ap() {
      for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        e[_key9] = arguments[_key9];
      }
      return function c2() {
        return function Rp() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1 / 0;
          return Ge(dr, e);
        }(1);
      }()(qe(e, vc(e)));
    }
    function X_(e) {
      return new _e(function (t) {
        dn(e()).subscribe(t);
      });
    }
    function Dc(e, t) {
      var n = J(e) ? e : function () {
          return e;
        },
        r = function r(o) {
          return o.error(n());
        };
      return new _e(t ? function (o) {
        return t.schedule(r, 0, o);
      } : r);
    }
    var Wt = new _e(function (e) {
      return e.complete();
    });
    function xp() {
      return Le(function (e, t) {
        var n = null;
        e._refCount++;
        var r = ke(t, void 0, void 0, void 0, function () {
          if (!e || e._refCount <= 0 || 0 < --e._refCount) return void (n = null);
          var o = e._connection,
            i = n;
          n = null, o && (!i || o === i) && o.unsubscribe(), t.unsubscribe();
        });
        e.subscribe(r), r.closed || (n = e.connect());
      });
    }
    var eb = /*#__PURE__*/function (_e33) {
      function eb(t, n) {
        var _this56;
        _classCallCheck(this, eb);
        _this56 = _callSuper(this, eb), _this56.source = t, _this56.subjectFactory = n, _this56._subject = null, _this56._refCount = 0, _this56._connection = null, Yg(t) && (_this56.lift = t.lift);
        return _this56;
      }
      _inherits(eb, _e33);
      return _createClass(eb, [{
        key: "_subscribe",
        value: function _subscribe(t) {
          return this.getSubject().subscribe(t);
        }
      }, {
        key: "getSubject",
        value: function getSubject() {
          var t = this._subject;
          return (!t || t.isStopped) && (this._subject = this.subjectFactory()), this._subject;
        }
      }, {
        key: "_teardown",
        value: function _teardown() {
          this._refCount = 0;
          var t = this._connection;
          this._subject = this._connection = null, t === null || t === void 0 ? void 0 : t.unsubscribe();
        }
      }, {
        key: "connect",
        value: function connect() {
          var _this57 = this;
          var t = this._connection;
          if (!t) {
            t = this._connection = new He();
            var n = this.getSubject();
            t.add(this.source.subscribe(ke(n, void 0, function () {
              _this57._teardown(), n.complete();
            }, function (r) {
              _this57._teardown(), n.error(r);
            }, function () {
              return _this57._teardown();
            }))), t.closed && (this._connection = null, t = He.EMPTY);
          }
          return t;
        }
      }, {
        key: "refCount",
        value: function refCount() {
          return xp()(this);
        }
      }]);
    }(_e);
    function fn(e, t) {
      return Le(function (n, r) {
        var o = null,
          i = 0,
          s = !1;
        var a = function a() {
          return s && !o && r.complete();
        };
        n.subscribe(ke(r, function (u) {
          var _o9;
          (_o9 = o) === null || _o9 === void 0 || _o9.unsubscribe();
          var c = 0;
          var l = i++;
          dn(e(u, l)).subscribe(o = ke(r, function (d) {
            return r.next(t ? t(u, d, l, c++) : d);
          }, function () {
            o = null, a();
          }));
        }, function () {
          s = !0, a();
        }));
      });
    }
    function ri(e) {
      return e <= 0 ? function () {
        return Wt;
      } : Le(function (t, n) {
        var r = 0;
        t.subscribe(ke(n, function (o) {
          ++r <= e && (n.next(o), e <= r && n.complete());
        }));
      });
    }
    function tr(e, t) {
      return Le(function (n, r) {
        var o = 0;
        n.subscribe(ke(r, function (i) {
          return e.call(t, i, o++) && r.next(i);
        }));
      });
    }
    function wc(e) {
      return Le(function (t, n) {
        var r = !1;
        t.subscribe(ke(n, function (o) {
          r = !0, n.next(o);
        }, function () {
          r || n.next(e), n.complete();
        }));
      });
    }
    function tb() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : f2;
      return Le(function (t, n) {
        var r = !1;
        t.subscribe(ke(n, function (o) {
          r = !0, n.next(o);
        }, function () {
          return r ? n.complete() : n.error(e());
        }));
      });
    }
    function f2() {
      return new yc();
    }
    function Ur(e, t) {
      var n = arguments.length >= 2;
      return function (r) {
        return r.pipe(e ? tr(function (o, i) {
          return e(o, i, r);
        }) : dr, ri(1), n ? wc(t) : tb(function () {
          return new yc();
        }));
      };
    }
    function Fs(e, t) {
      return J(t) ? Ge(e, t, 1) : Ge(e, 1);
    }
    function tt(e, t, n) {
      var r = J(e) || t || n ? {
        next: e,
        error: t,
        complete: n
      } : e;
      return r ? Le(function (o, i) {
        var s;
        null === (s = r.subscribe) || void 0 === s || s.call(r);
        var a = !0;
        o.subscribe(ke(i, function (u) {
          var c;
          null === (c = r.next) || void 0 === c || c.call(r, u), i.next(u);
        }, function () {
          var u;
          a = !1, null === (u = r.complete) || void 0 === u || u.call(r), i.complete();
        }, function (u) {
          var c;
          a = !1, null === (c = r.error) || void 0 === c || c.call(r, u), i.error(u);
        }, function () {
          var u, c;
          a && (null === (u = r.unsubscribe) || void 0 === u || u.call(r)), null === (c = r.finalize) || void 0 === c || c.call(r);
        }));
      }) : dr;
    }
    function oi(e) {
      return Le(function (t, n) {
        var i,
          r = null,
          o = !1;
        r = t.subscribe(ke(n, void 0, void 0, function (s) {
          i = dn(e(s, oi(e)(t))), r ? (r.unsubscribe(), r = null, i.subscribe(n)) : o = !0;
        })), o && (r.unsubscribe(), r = null, i.subscribe(n));
      });
    }
    function kp(e) {
      return e <= 0 ? function () {
        return Wt;
      } : Le(function (t, n) {
        var r = [];
        t.subscribe(ke(n, function (o) {
          r.push(o), e < r.length && r.shift();
        }, function () {
          var _iterator34 = _createForOfIteratorHelper(r),
            _step34;
          try {
            for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
              var o = _step34.value;
              n.next(o);
            }
          } catch (err) {
            _iterator34.e(err);
          } finally {
            _iterator34.f();
          }
          n.complete();
        }, void 0, function () {
          r = null;
        }));
      });
    }
    function Ec(e) {
      return Le(function (t, n) {
        try {
          t.subscribe(n);
        } finally {
          n.add(e);
        }
      });
    }
    var v2 = function (_e34) {
      var e = /*#__PURE__*/function () {
        function e(n) {
          _classCallCheck(this, e);
          _defineProperty(this, "_doc", void 0);
          this._doc = n;
        }
        return _createClass(e, [{
          key: "getTitle",
          value: function getTitle() {
            return this._doc.title;
          }
        }, {
          key: "setTitle",
          value: function setTitle(n) {
            this._doc.title = n || "";
          }
        }]);
      }();
      _e34 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e34)(T(Gt));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e34,
        factory: _e34.ɵfac,
        providedIn: "root"
      }));
      return e;
    }();
    var U = "primary",
      js = Symbol("RouteTitle");
    var E2 = /*#__PURE__*/function () {
      function E2(t) {
        _classCallCheck(this, E2);
        _defineProperty(this, "params", void 0);
        this.params = t || {};
      }
      return _createClass(E2, [{
        key: "has",
        value: function has(t) {
          return Object.prototype.hasOwnProperty.call(this.params, t);
        }
      }, {
        key: "get",
        value: function get(t) {
          if (this.has(t)) {
            var n = this.params[t];
            return Array.isArray(n) ? n[0] : n;
          }
          return null;
        }
      }, {
        key: "getAll",
        value: function getAll(t) {
          if (this.has(t)) {
            var n = this.params[t];
            return Array.isArray(n) ? n : [n];
          }
          return [];
        }
      }, {
        key: "keys",
        get: function get() {
          return Object.keys(this.params);
        }
      }]);
    }();
    function ii(e) {
      return new E2(e);
    }
    function C2(e, t, n) {
      var r = n.path.split("/");
      if (r.length > e.length || "full" === n.pathMatch && (t.hasChildren() || r.length < e.length)) return null;
      var o = {};
      for (var i = 0; i < r.length; i++) {
        var s = r[i],
          a = e[i];
        if (":" === s[0]) o[s.substring(1)] = a;else if (s !== a.path) return null;
      }
      return {
        consumed: e.slice(0, r.length),
        posParams: o
      };
    }
    function hn(e, t) {
      var n = e ? Op(e) : void 0,
        r = t ? Op(t) : void 0;
      if (!n || !r || n.length != r.length) return !1;
      var o;
      for (var i = 0; i < n.length; i++) if (o = n[i], !ob(e[o], t[o])) return !1;
      return !0;
    }
    function Op(e) {
      return [].concat(_toConsumableArray(Object.keys(e)), _toConsumableArray(Object.getOwnPropertySymbols(e)));
    }
    function ob(e, t) {
      if (Array.isArray(e) && Array.isArray(t)) {
        if (e.length !== t.length) return !1;
        var n = _toConsumableArray(e).sort(),
          r = _toConsumableArray(t).sort();
        return n.every(function (o, i) {
          return r[i] === o;
        });
      }
      return e === t;
    }
    function ib(e) {
      return e.length > 0 ? e[e.length - 1] : null;
    }
    function rr(e) {
      return function lV(e) {
        return !!e && (e instanceof _e || J(e.lift) && J(e.subscribe));
      }(e) ? e : Hu(e) ? qe(Promise.resolve(e)) : V(e);
    }
    var _2 = {
        exact: function ub(e, t, n) {
          if (!$r(e.segments, t.segments) || !Cc(e.segments, t.segments, n) || e.numberOfChildren !== t.numberOfChildren) return !1;
          for (var r in t.children) if (!e.children[r] || !ub(e.children[r], t.children[r], n)) return !1;
          return !0;
        },
        subset: cb
      },
      sb = {
        exact: function b2(e, t) {
          return hn(e, t);
        },
        subset: function M2(e, t) {
          return Object.keys(t).length <= Object.keys(e).length && Object.keys(t).every(function (n) {
            return ob(e[n], t[n]);
          });
        },
        ignored: function ignored() {
          return !0;
        }
      };
    function ab(e, t, n) {
      return _2[n.paths](e.root, t.root, n.matrixParams) && sb[n.queryParams](e.queryParams, t.queryParams) && !("exact" === n.fragment && e.fragment !== t.fragment);
    }
    function cb(e, t, n) {
      return lb(e, t, t.segments, n);
    }
    function lb(e, t, n, r) {
      if (e.segments.length > n.length) {
        var o = e.segments.slice(0, n.length);
        return !(!$r(o, n) || t.hasChildren() || !Cc(o, n, r));
      }
      if (e.segments.length === n.length) {
        if (!$r(e.segments, n) || !Cc(e.segments, n, r)) return !1;
        for (var _o0 in t.children) if (!e.children[_o0] || !cb(e.children[_o0], t.children[_o0], r)) return !1;
        return !0;
      }
      {
        var _o1 = n.slice(0, e.segments.length),
          i = n.slice(e.segments.length);
        return !!($r(e.segments, _o1) && Cc(e.segments, _o1, r) && e.children[U]) && lb(e.children[U], t, i, r);
      }
    }
    function Cc(e, t, n) {
      return t.every(function (r, o) {
        return sb[n](e[o].parameters, r.parameters);
      });
    }
    var Hr = /*#__PURE__*/function () {
      function Hr() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ue([], {});
        var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        _classCallCheck(this, Hr);
        _defineProperty(this, "root", void 0);
        _defineProperty(this, "queryParams", void 0);
        _defineProperty(this, "fragment", void 0);
        _defineProperty(this, "_queryParamMap", void 0);
        this.root = t, this.queryParams = n, this.fragment = r;
      }
      return _createClass(Hr, [{
        key: "queryParamMap",
        get: function get() {
          var _this$_queryParamMap;
          return (_this$_queryParamMap = this._queryParamMap) !== null && _this$_queryParamMap !== void 0 ? _this$_queryParamMap : this._queryParamMap = ii(this.queryParams), this._queryParamMap;
        }
      }, {
        key: "toString",
        value: function toString() {
          return N2.serialize(this);
        }
      }]);
    }();
    var ue = /*#__PURE__*/function () {
      function ue(t, n) {
        var _this58 = this;
        _classCallCheck(this, ue);
        _defineProperty(this, "segments", void 0);
        _defineProperty(this, "children", void 0);
        _defineProperty(this, "parent", null);
        this.segments = t, this.children = n, Object.values(n).forEach(function (r) {
          return r.parent = _this58;
        });
      }
      return _createClass(ue, [{
        key: "hasChildren",
        value: function hasChildren() {
          return this.numberOfChildren > 0;
        }
      }, {
        key: "numberOfChildren",
        get: function get() {
          return Object.keys(this.children).length;
        }
      }, {
        key: "toString",
        value: function toString() {
          return bc(this);
        }
      }]);
    }();
    var Vs = /*#__PURE__*/function () {
      function Vs(t, n) {
        _classCallCheck(this, Vs);
        _defineProperty(this, "path", void 0);
        _defineProperty(this, "parameters", void 0);
        _defineProperty(this, "_parameterMap", void 0);
        this.path = t, this.parameters = n;
      }
      return _createClass(Vs, [{
        key: "parameterMap",
        get: function get() {
          var _this$_parameterMap;
          return (_this$_parameterMap = this._parameterMap) !== null && _this$_parameterMap !== void 0 ? _this$_parameterMap : this._parameterMap = ii(this.parameters), this._parameterMap;
        }
      }, {
        key: "toString",
        value: function toString() {
          return hb(this);
        }
      }]);
    }();
    function $r(e, t) {
      return e.length === t.length && e.every(function (n, r) {
        return n.path === t[r].path;
      });
    }
    var Ic = function (_e35) {
      var e = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      });
      _e35 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e35)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e35,
        factory: function factory() {
          return new _c();
        },
        providedIn: "root"
      }));
      return e;
    }();
    var _c = /*#__PURE__*/function () {
      function _c() {
        _classCallCheck(this, _c);
      }
      return _createClass(_c, [{
        key: "parse",
        value: function parse(t) {
          var n = new B2(t);
          return new Hr(n.parseRootSegment(), n.parseQueryParams(), n.parseFragment());
        }
      }, {
        key: "serialize",
        value: function serialize(t) {
          var n = "/".concat(Bs(t.root, !0)),
            r = function x2(e) {
              var t = Object.entries(e).map(function (_ref7) {
                var _ref8 = _slicedToArray(_ref7, 2),
                  n = _ref8[0],
                  r = _ref8[1];
                return Array.isArray(r) ? r.map(function (o) {
                  return "".concat(Mc(n), "=").concat(Mc(o));
                }).join("&") : "".concat(Mc(n), "=").concat(Mc(r));
              }).filter(function (n) {
                return n;
              });
              return t.length ? "?".concat(t.join("&")) : "";
            }(t.queryParams);
          return "".concat(n).concat(r).concat("string" == typeof t.fragment ? "#".concat(function R2(e) {
            return encodeURI(e);
          }(t.fragment)) : "");
        }
      }]);
    }();
    var N2 = new _c();
    function bc(e) {
      return e.segments.map(function (t) {
        return hb(t);
      }).join("/");
    }
    function Bs(e, t) {
      if (!e.hasChildren()) return bc(e);
      if (t) {
        var n = e.children[U] ? Bs(e.children[U], !1) : "",
          r = [];
        return Object.entries(e.children).forEach(function (_ref9) {
          var _ref0 = _slicedToArray(_ref9, 2),
            o = _ref0[0],
            i = _ref0[1];
          o !== U && r.push("".concat(o, ":").concat(Bs(i, !1)));
        }), r.length > 0 ? "".concat(n, "(").concat(r.join("//"), ")") : n;
      }
      {
        var _n10 = function T2(e, t) {
          var n = [];
          return Object.entries(e.children).forEach(function (_ref1) {
            var _ref10 = _slicedToArray(_ref1, 2),
              r = _ref10[0],
              o = _ref10[1];
            r === U && (n = n.concat(t(o, r)));
          }), Object.entries(e.children).forEach(function (_ref11) {
            var _ref12 = _slicedToArray(_ref11, 2),
              r = _ref12[0],
              o = _ref12[1];
            r !== U && (n = n.concat(t(o, r)));
          }), n;
        }(e, function (r, o) {
          return o === U ? [Bs(e.children[U], !1)] : ["".concat(o, ":").concat(Bs(r, !1))];
        });
        return 1 === Object.keys(e.children).length && null != e.children[U] ? "".concat(bc(e), "/").concat(_n10[0]) : "".concat(bc(e), "/(").concat(_n10.join("//"), ")");
      }
    }
    function db(e) {
      return encodeURIComponent(e).replace(/%40/g, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",");
    }
    function Mc(e) {
      return db(e).replace(/%3B/gi, ";");
    }
    function Pp(e) {
      return db(e).replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/%26/gi, "&");
    }
    function Sc(e) {
      return decodeURIComponent(e);
    }
    function fb(e) {
      return Sc(e.replace(/\+/g, "%20"));
    }
    function hb(e) {
      return "".concat(Pp(e.path)).concat(function A2(e) {
        return Object.entries(e).map(function (_ref13) {
          var _ref14 = _slicedToArray(_ref13, 2),
            t = _ref14[0],
            n = _ref14[1];
          return ";".concat(Pp(t), "=").concat(Pp(n));
        }).join("");
      }(e.parameters));
    }
    var k2 = /^[^\/()?;#]+/;
    function Fp(e) {
      var t = e.match(k2);
      return t ? t[0] : "";
    }
    var O2 = /^[^\/()?;=#]+/,
      F2 = /^[^=?&#]+/,
      j2 = /^[^&#]+/;
    var B2 = /*#__PURE__*/function () {
      function B2(t) {
        _classCallCheck(this, B2);
        _defineProperty(this, "url", void 0);
        _defineProperty(this, "remaining", void 0);
        this.url = t, this.remaining = t;
      }
      return _createClass(B2, [{
        key: "parseRootSegment",
        value: function parseRootSegment() {
          return this.consumeOptional("/"), "" === this.remaining || this.peekStartsWith("?") || this.peekStartsWith("#") ? new ue([], {}) : new ue([], this.parseChildren());
        }
      }, {
        key: "parseQueryParams",
        value: function parseQueryParams() {
          var t = {};
          if (this.consumeOptional("?")) do {
            this.parseQueryParam(t);
          } while (this.consumeOptional("&"));
          return t;
        }
      }, {
        key: "parseFragment",
        value: function parseFragment() {
          return this.consumeOptional("#") ? decodeURIComponent(this.remaining) : null;
        }
      }, {
        key: "parseChildren",
        value: function parseChildren() {
          if ("" === this.remaining) return {};
          this.consumeOptional("/");
          var t = [];
          for (this.peekStartsWith("(") || t.push(this.parseSegment()); this.peekStartsWith("/") && !this.peekStartsWith("//") && !this.peekStartsWith("/(");) this.capture("/"), t.push(this.parseSegment());
          var n = {};
          this.peekStartsWith("/(") && (this.capture("/"), n = this.parseParens(!0));
          var r = {};
          return this.peekStartsWith("(") && (r = this.parseParens(!1)), (t.length > 0 || Object.keys(n).length > 0) && (r[U] = new ue(t, n)), r;
        }
      }, {
        key: "parseSegment",
        value: function parseSegment() {
          var t = Fp(this.remaining);
          if ("" === t && this.peekStartsWith(";")) throw new E(4009, !1);
          return this.capture(t), new Vs(Sc(t), this.parseMatrixParams());
        }
      }, {
        key: "parseMatrixParams",
        value: function parseMatrixParams() {
          var t = {};
          for (; this.consumeOptional(";");) this.parseParam(t);
          return t;
        }
      }, {
        key: "parseParam",
        value: function parseParam(t) {
          var n = function P2(e) {
            var t = e.match(O2);
            return t ? t[0] : "";
          }(this.remaining);
          if (!n) return;
          this.capture(n);
          var r = "";
          if (this.consumeOptional("=")) {
            var o = Fp(this.remaining);
            o && (r = o, this.capture(r));
          }
          t[Sc(n)] = Sc(r);
        }
      }, {
        key: "parseQueryParam",
        value: function parseQueryParam(t) {
          var n = function L2(e) {
            var t = e.match(F2);
            return t ? t[0] : "";
          }(this.remaining);
          if (!n) return;
          this.capture(n);
          var r = "";
          if (this.consumeOptional("=")) {
            var s = function V2(e) {
              var t = e.match(j2);
              return t ? t[0] : "";
            }(this.remaining);
            s && (r = s, this.capture(r));
          }
          var o = fb(n),
            i = fb(r);
          if (t.hasOwnProperty(o)) {
            var _s14 = t[o];
            Array.isArray(_s14) || (_s14 = [_s14], t[o] = _s14), _s14.push(i);
          } else t[o] = i;
        }
      }, {
        key: "parseParens",
        value: function parseParens(t) {
          var n = {};
          for (this.capture("("); !this.consumeOptional(")") && this.remaining.length > 0;) {
            var r = Fp(this.remaining),
              o = this.remaining[r.length];
            if ("/" !== o && ")" !== o && ";" !== o) throw new E(4010, !1);
            var i = void 0;
            r.indexOf(":") > -1 ? (i = r.slice(0, r.indexOf(":")), this.capture(i), this.capture(":")) : t && (i = U);
            var s = this.parseChildren();
            n[i] = 1 === Object.keys(s).length ? s[U] : new ue([], s), this.consumeOptional("//");
          }
          return n;
        }
      }, {
        key: "peekStartsWith",
        value: function peekStartsWith(t) {
          return this.remaining.startsWith(t);
        }
      }, {
        key: "consumeOptional",
        value: function consumeOptional(t) {
          return !!this.peekStartsWith(t) && (this.remaining = this.remaining.substring(t.length), !0);
        }
      }, {
        key: "capture",
        value: function capture(t) {
          if (!this.consumeOptional(t)) throw new E(4011, !1);
        }
      }]);
    }();
    function pb(e) {
      return e.segments.length > 0 ? new ue([], _defineProperty({}, U, e)) : e;
    }
    function gb(e) {
      var t = {};
      for (var _i16 = 0, _Object$entries = Object.entries(e.children); _i16 < _Object$entries.length; _i16++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i16], 2),
          r = _Object$entries$_i[0],
          o = _Object$entries$_i[1];
        var i = gb(o);
        if (r === U && 0 === i.segments.length && i.hasChildren()) for (var _i17 = 0, _Object$entries2 = Object.entries(i.children); _i17 < _Object$entries2.length; _i17++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i17], 2),
            s = _Object$entries2$_i[0],
            a = _Object$entries2$_i[1];
          t[s] = a;
        } else (i.segments.length > 0 || i.hasChildren()) && (t[r] = i);
      }
      return function U2(e) {
        if (1 === e.numberOfChildren && e.children[U]) {
          var _t5 = e.children[U];
          return new ue(e.segments.concat(_t5.segments), _t5.children);
        }
        return e;
      }(new ue(e.segments, t));
    }
    function zr(e) {
      return e instanceof Hr;
    }
    function mb(e) {
      var t;
      var o = pb(function n(i) {
        var s = {};
        var _iterator35 = _createForOfIteratorHelper(i.children),
          _step35;
        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var u = _step35.value;
            var c = n(u);
            s[u.outlet] = c;
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
        var a = new ue(i.url, s);
        return i === e && (t = a), a;
      }(e.root));
      return t !== null && t !== void 0 ? t : o;
    }
    function vb(e, t, n, r) {
      var o = e;
      for (; o.parent;) o = o.parent;
      if (0 === t.length) return Lp(o, o, o, n, r);
      var i = function $2(e) {
        if ("string" == typeof e[0] && 1 === e.length && "/" === e[0]) return new Db(!0, 0, e);
        var t = 0,
          n = !1;
        var r = e.reduce(function (o, i, s) {
          if ("object" == _typeof(i) && null != i) {
            if (i.outlets) {
              var _a1 = {};
              return Object.entries(i.outlets).forEach(function (_ref15) {
                var _ref16 = _slicedToArray(_ref15, 2),
                  u = _ref16[0],
                  c = _ref16[1];
                _a1[u] = "string" == typeof c ? c.split("/") : c;
              }), [].concat(_toConsumableArray(o), [{
                outlets: _a1
              }]);
            }
            if (i.segmentPath) return [].concat(_toConsumableArray(o), [i.segmentPath]);
          }
          return "string" != typeof i ? [].concat(_toConsumableArray(o), [i]) : 0 === s ? (i.split("/").forEach(function (a, u) {
            0 == u && "." === a || (0 == u && "" === a ? n = !0 : ".." === a ? t++ : "" != a && o.push(a));
          }), o) : [].concat(_toConsumableArray(o), [i]);
        }, []);
        return new Db(n, t, r);
      }(t);
      if (i.toRoot()) return Lp(o, o, new ue([], {}), n, r);
      var s = function z2(e, t, n) {
          if (e.isAbsolute) return new Nc(t, !0, 0);
          if (!n) return new Nc(t, !1, NaN);
          if (null === n.parent) return new Nc(n, !0, 0);
          var r = Tc(e.commands[0]) ? 0 : 1;
          return function q2(e, t, n) {
            var r = e,
              o = t,
              i = n;
            for (; i > o;) {
              if (i -= o, r = r.parent, !r) throw new E(4005, !1);
              o = r.segments.length;
            }
            return new Nc(r, !1, o - i);
          }(n, n.segments.length - 1 + r, e.numberOfDoubleDots);
        }(i, o, e),
        a = s.processChildren ? Hs(s.segmentGroup, s.index, i.commands) : wb(s.segmentGroup, s.index, i.commands);
      return Lp(o, s.segmentGroup, a, n, r);
    }
    function Tc(e) {
      return "object" == _typeof(e) && null != e && !e.outlets && !e.segmentPath;
    }
    function Us(e) {
      return "object" == _typeof(e) && null != e && e.outlets;
    }
    function Lp(e, t, n, r, o) {
      var s,
        i = {};
      r && Object.entries(r).forEach(function (_ref17) {
        var _ref18 = _slicedToArray(_ref17, 2),
          u = _ref18[0],
          c = _ref18[1];
        i[u] = Array.isArray(c) ? c.map(function (l) {
          return "".concat(l);
        }) : "".concat(c);
      }), s = e === t ? n : yb(e, t, n);
      var a = pb(gb(s));
      return new Hr(a, i, o);
    }
    function yb(e, t, n) {
      var r = {};
      return Object.entries(e.children).forEach(function (_ref19) {
        var _ref20 = _slicedToArray(_ref19, 2),
          o = _ref20[0],
          i = _ref20[1];
        r[o] = i === t ? n : yb(i, t, n);
      }), new ue(e.segments, r);
    }
    var Db = /*#__PURE__*/function () {
      function Db(t, n, r) {
        _classCallCheck(this, Db);
        _defineProperty(this, "isAbsolute", void 0);
        _defineProperty(this, "numberOfDoubleDots", void 0);
        _defineProperty(this, "commands", void 0);
        if (this.isAbsolute = t, this.numberOfDoubleDots = n, this.commands = r, t && r.length > 0 && Tc(r[0])) throw new E(4003, !1);
        var o = r.find(Us);
        if (o && o !== ib(r)) throw new E(4004, !1);
      }
      return _createClass(Db, [{
        key: "toRoot",
        value: function toRoot() {
          return this.isAbsolute && 1 === this.commands.length && "/" == this.commands[0];
        }
      }]);
    }();
    var Nc = /*#__PURE__*/_createClass(function Nc(t, n, r) {
      _classCallCheck(this, Nc);
      _defineProperty(this, "segmentGroup", void 0);
      _defineProperty(this, "processChildren", void 0);
      _defineProperty(this, "index", void 0);
      this.segmentGroup = t, this.processChildren = n, this.index = r;
    });
    function wb(e, t, n) {
      if (e !== null && e !== void 0 ? e : e = new ue([], {}), 0 === e.segments.length && e.hasChildren()) return Hs(e, t, n);
      var r = function W2(e, t, n) {
          var r = 0,
            o = t;
          var i = {
            match: !1,
            pathIndex: 0,
            commandIndex: 0
          };
          for (; o < e.segments.length;) {
            if (r >= n.length) return i;
            var s = e.segments[o],
              a = n[r];
            if (Us(a)) break;
            var u = "".concat(a),
              c = r < n.length - 1 ? n[r + 1] : null;
            if (o > 0 && void 0 === u) break;
            if (u && c && "object" == _typeof(c) && void 0 === c.outlets) {
              if (!Cb(u, c, s)) return i;
              r += 2;
            } else {
              if (!Cb(u, {}, s)) return i;
              r++;
            }
            o++;
          }
          return {
            match: !0,
            pathIndex: o,
            commandIndex: r
          };
        }(e, t, n),
        o = n.slice(r.commandIndex);
      if (r.match && r.pathIndex < e.segments.length) {
        var i = new ue(e.segments.slice(0, r.pathIndex), {});
        return i.children[U] = new ue(e.segments.slice(r.pathIndex), e.children), Hs(i, 0, o);
      }
      return r.match && 0 === o.length ? new ue(e.segments, {}) : r.match && !e.hasChildren() ? jp(e, t, n) : r.match ? Hs(e, 0, o) : jp(e, t, n);
    }
    function Hs(e, t, n) {
      if (0 === n.length) return new ue(e.segments, {});
      {
        var r = function G2(e) {
            return Us(e[0]) ? e[0].outlets : _defineProperty({}, U, e);
          }(n),
          o = {};
        if (Object.keys(r).some(function (i) {
          return i !== U;
        }) && e.children[U] && 1 === e.numberOfChildren && 0 === e.children[U].segments.length) {
          var i = Hs(e.children[U], t, n);
          return new ue(e.segments, i.children);
        }
        return Object.entries(r).forEach(function (_ref22) {
          var _ref23 = _slicedToArray(_ref22, 2),
            i = _ref23[0],
            s = _ref23[1];
          "string" == typeof s && (s = [s]), null !== s && (o[i] = wb(e.children[i], t, s));
        }), Object.entries(e.children).forEach(function (_ref24) {
          var _ref25 = _slicedToArray(_ref24, 2),
            i = _ref25[0],
            s = _ref25[1];
          void 0 === r[i] && (o[i] = s);
        }), new ue(e.segments, o);
      }
    }
    function jp(e, t, n) {
      var r = e.segments.slice(0, t);
      var o = 0;
      for (; o < n.length;) {
        var i = n[o];
        if (Us(i)) {
          var u = Z2(i.outlets);
          return new ue(r, u);
        }
        if (0 === o && Tc(n[0])) {
          r.push(new Vs(e.segments[t].path, Eb(n[0]))), o++;
          continue;
        }
        var s = Us(i) ? i.outlets[U] : "".concat(i),
          a = o < n.length - 1 ? n[o + 1] : null;
        s && a && Tc(a) ? (r.push(new Vs(s, Eb(a))), o += 2) : (r.push(new Vs(s, {})), o++);
      }
      return new ue(r, {});
    }
    function Z2(e) {
      var t = {};
      return Object.entries(e).forEach(function (_ref26) {
        var _ref27 = _slicedToArray(_ref26, 2),
          n = _ref27[0],
          r = _ref27[1];
        "string" == typeof r && (r = [r]), null !== r && (t[n] = jp(new ue([], {}), 0, r));
      }), t;
    }
    function Eb(e) {
      var t = {};
      return Object.entries(e).forEach(function (_ref28) {
        var _ref29 = _slicedToArray(_ref28, 2),
          n = _ref29[0],
          r = _ref29[1];
        return t[n] = "".concat(r);
      }), t;
    }
    function Cb(e, t, n) {
      return e == n.path && hn(t, n.parameters);
    }
    var Rc = "imperative";
    var Z = function (e) {
      return e[e.NavigationStart = 0] = "NavigationStart", e[e.NavigationEnd = 1] = "NavigationEnd", e[e.NavigationCancel = 2] = "NavigationCancel", e[e.NavigationError = 3] = "NavigationError", e[e.RoutesRecognized = 4] = "RoutesRecognized", e[e.ResolveStart = 5] = "ResolveStart", e[e.ResolveEnd = 6] = "ResolveEnd", e[e.GuardsCheckStart = 7] = "GuardsCheckStart", e[e.GuardsCheckEnd = 8] = "GuardsCheckEnd", e[e.RouteConfigLoadStart = 9] = "RouteConfigLoadStart", e[e.RouteConfigLoadEnd = 10] = "RouteConfigLoadEnd", e[e.ChildActivationStart = 11] = "ChildActivationStart", e[e.ChildActivationEnd = 12] = "ChildActivationEnd", e[e.ActivationStart = 13] = "ActivationStart", e[e.ActivationEnd = 14] = "ActivationEnd", e[e.Scroll = 15] = "Scroll", e[e.NavigationSkipped = 16] = "NavigationSkipped", e;
    }(Z || {});
    var pn = /*#__PURE__*/_createClass(function pn(t, n) {
      _classCallCheck(this, pn);
      _defineProperty(this, "id", void 0);
      _defineProperty(this, "url", void 0);
      this.id = t, this.url = n;
    });
    var Vp = /*#__PURE__*/function (_pn2) {
      function Vp(t, n) {
        var _this59;
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "imperative";
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        _classCallCheck(this, Vp);
        _this59 = _callSuper(this, Vp, [t, n]), _defineProperty(_assertThisInitialized(_this59), "type", Z.NavigationStart), _defineProperty(_assertThisInitialized(_this59), "navigationTrigger", void 0), _defineProperty(_assertThisInitialized(_this59), "restoredState", void 0), _this59.navigationTrigger = r, _this59.restoredState = o;
        return _this59;
      }
      _inherits(Vp, _pn2);
      return _createClass(Vp, [{
        key: "toString",
        value: function toString() {
          return "NavigationStart(id: ".concat(this.id, ", url: '").concat(this.url, "')");
        }
      }]);
    }(pn);
    var qr = /*#__PURE__*/function (_pn3) {
      function qr(t, n, r) {
        var _this60;
        _classCallCheck(this, qr);
        _this60 = _callSuper(this, qr, [t, n]), _defineProperty(_assertThisInitialized(_this60), "urlAfterRedirects", void 0), _defineProperty(_assertThisInitialized(_this60), "type", Z.NavigationEnd), _this60.urlAfterRedirects = r;
        return _this60;
      }
      _inherits(qr, _pn3);
      return _createClass(qr, [{
        key: "toString",
        value: function toString() {
          return "NavigationEnd(id: ".concat(this.id, ", url: '").concat(this.url, "', urlAfterRedirects: '").concat(this.urlAfterRedirects, "')");
        }
      }]);
    }(pn);
    var Ct = function (e) {
        return e[e.Redirect = 0] = "Redirect", e[e.SupersededByNewNavigation = 1] = "SupersededByNewNavigation", e[e.NoDataFromResolver = 2] = "NoDataFromResolver", e[e.GuardRejected = 3] = "GuardRejected", e;
      }(Ct || {}),
      Bp = function (e) {
        return e[e.IgnoredSameUrlNavigation = 0] = "IgnoredSameUrlNavigation", e[e.IgnoredByUrlHandlingStrategy = 1] = "IgnoredByUrlHandlingStrategy", e;
      }(Bp || {});
    var Gr = /*#__PURE__*/function (_pn4) {
      function Gr(t, n, r, o) {
        var _this61;
        _classCallCheck(this, Gr);
        _this61 = _callSuper(this, Gr, [t, n]), _defineProperty(_assertThisInitialized(_this61), "reason", void 0), _defineProperty(_assertThisInitialized(_this61), "code", void 0), _defineProperty(_assertThisInitialized(_this61), "type", Z.NavigationCancel), _this61.reason = r, _this61.code = o;
        return _this61;
      }
      _inherits(Gr, _pn4);
      return _createClass(Gr, [{
        key: "toString",
        value: function toString() {
          return "NavigationCancel(id: ".concat(this.id, ", url: '").concat(this.url, "')");
        }
      }]);
    }(pn);
    var $s = /*#__PURE__*/function (_pn5) {
      function $s(t, n, r, o) {
        var _this62;
        _classCallCheck(this, $s);
        _this62 = _callSuper(this, $s, [t, n]), _defineProperty(_assertThisInitialized(_this62), "reason", void 0), _defineProperty(_assertThisInitialized(_this62), "code", void 0), _defineProperty(_assertThisInitialized(_this62), "type", Z.NavigationSkipped), _this62.reason = r, _this62.code = o;
        return _this62;
      }
      _inherits($s, _pn5);
      return _createClass($s);
    }(pn);
    var Up = /*#__PURE__*/function (_pn6) {
      function Up(t, n, r, o) {
        var _this63;
        _classCallCheck(this, Up);
        _this63 = _callSuper(this, Up, [t, n]), _defineProperty(_assertThisInitialized(_this63), "error", void 0), _defineProperty(_assertThisInitialized(_this63), "target", void 0), _defineProperty(_assertThisInitialized(_this63), "type", Z.NavigationError), _this63.error = r, _this63.target = o;
        return _this63;
      }
      _inherits(Up, _pn6);
      return _createClass(Up, [{
        key: "toString",
        value: function toString() {
          return "NavigationError(id: ".concat(this.id, ", url: '").concat(this.url, "', error: ").concat(this.error, ")");
        }
      }]);
    }(pn);
    var Ib = /*#__PURE__*/function (_pn7) {
      function Ib(t, n, r, o) {
        var _this64;
        _classCallCheck(this, Ib);
        _this64 = _callSuper(this, Ib, [t, n]), _defineProperty(_assertThisInitialized(_this64), "urlAfterRedirects", void 0), _defineProperty(_assertThisInitialized(_this64), "state", void 0), _defineProperty(_assertThisInitialized(_this64), "type", Z.RoutesRecognized), _this64.urlAfterRedirects = r, _this64.state = o;
        return _this64;
      }
      _inherits(Ib, _pn7);
      return _createClass(Ib, [{
        key: "toString",
        value: function toString() {
          return "RoutesRecognized(id: ".concat(this.id, ", url: '").concat(this.url, "', urlAfterRedirects: '").concat(this.urlAfterRedirects, "', state: ").concat(this.state, ")");
        }
      }]);
    }(pn);
    var Q2 = /*#__PURE__*/function (_pn8) {
      function Q2(t, n, r, o) {
        var _this65;
        _classCallCheck(this, Q2);
        _this65 = _callSuper(this, Q2, [t, n]), _defineProperty(_assertThisInitialized(_this65), "urlAfterRedirects", void 0), _defineProperty(_assertThisInitialized(_this65), "state", void 0), _defineProperty(_assertThisInitialized(_this65), "type", Z.GuardsCheckStart), _this65.urlAfterRedirects = r, _this65.state = o;
        return _this65;
      }
      _inherits(Q2, _pn8);
      return _createClass(Q2, [{
        key: "toString",
        value: function toString() {
          return "GuardsCheckStart(id: ".concat(this.id, ", url: '").concat(this.url, "', urlAfterRedirects: '").concat(this.urlAfterRedirects, "', state: ").concat(this.state, ")");
        }
      }]);
    }(pn);
    var Y2 = /*#__PURE__*/function (_pn9) {
      function Y2(t, n, r, o, i) {
        var _this66;
        _classCallCheck(this, Y2);
        _this66 = _callSuper(this, Y2, [t, n]), _defineProperty(_assertThisInitialized(_this66), "urlAfterRedirects", void 0), _defineProperty(_assertThisInitialized(_this66), "state", void 0), _defineProperty(_assertThisInitialized(_this66), "shouldActivate", void 0), _defineProperty(_assertThisInitialized(_this66), "type", Z.GuardsCheckEnd), _this66.urlAfterRedirects = r, _this66.state = o, _this66.shouldActivate = i;
        return _this66;
      }
      _inherits(Y2, _pn9);
      return _createClass(Y2, [{
        key: "toString",
        value: function toString() {
          return "GuardsCheckEnd(id: ".concat(this.id, ", url: '").concat(this.url, "', urlAfterRedirects: '").concat(this.urlAfterRedirects, "', state: ").concat(this.state, ", shouldActivate: ").concat(this.shouldActivate, ")");
        }
      }]);
    }(pn);
    var J2 = /*#__PURE__*/function (_pn0) {
      function J2(t, n, r, o) {
        var _this67;
        _classCallCheck(this, J2);
        _this67 = _callSuper(this, J2, [t, n]), _defineProperty(_assertThisInitialized(_this67), "urlAfterRedirects", void 0), _defineProperty(_assertThisInitialized(_this67), "state", void 0), _defineProperty(_assertThisInitialized(_this67), "type", Z.ResolveStart), _this67.urlAfterRedirects = r, _this67.state = o;
        return _this67;
      }
      _inherits(J2, _pn0);
      return _createClass(J2, [{
        key: "toString",
        value: function toString() {
          return "ResolveStart(id: ".concat(this.id, ", url: '").concat(this.url, "', urlAfterRedirects: '").concat(this.urlAfterRedirects, "', state: ").concat(this.state, ")");
        }
      }]);
    }(pn);
    var K2 = /*#__PURE__*/function (_pn1) {
      function K2(t, n, r, o) {
        var _this68;
        _classCallCheck(this, K2);
        _this68 = _callSuper(this, K2, [t, n]), _defineProperty(_assertThisInitialized(_this68), "urlAfterRedirects", void 0), _defineProperty(_assertThisInitialized(_this68), "state", void 0), _defineProperty(_assertThisInitialized(_this68), "type", Z.ResolveEnd), _this68.urlAfterRedirects = r, _this68.state = o;
        return _this68;
      }
      _inherits(K2, _pn1);
      return _createClass(K2, [{
        key: "toString",
        value: function toString() {
          return "ResolveEnd(id: ".concat(this.id, ", url: '").concat(this.url, "', urlAfterRedirects: '").concat(this.urlAfterRedirects, "', state: ").concat(this.state, ")");
        }
      }]);
    }(pn);
    var X2 = /*#__PURE__*/function () {
      function X2(t) {
        _classCallCheck(this, X2);
        _defineProperty(this, "route", void 0);
        _defineProperty(this, "type", Z.RouteConfigLoadStart);
        this.route = t;
      }
      return _createClass(X2, [{
        key: "toString",
        value: function toString() {
          return "RouteConfigLoadStart(path: ".concat(this.route.path, ")");
        }
      }]);
    }();
    var eB = /*#__PURE__*/function () {
      function eB(t) {
        _classCallCheck(this, eB);
        _defineProperty(this, "route", void 0);
        _defineProperty(this, "type", Z.RouteConfigLoadEnd);
        this.route = t;
      }
      return _createClass(eB, [{
        key: "toString",
        value: function toString() {
          return "RouteConfigLoadEnd(path: ".concat(this.route.path, ")");
        }
      }]);
    }();
    var tB = /*#__PURE__*/function () {
      function tB(t) {
        _classCallCheck(this, tB);
        _defineProperty(this, "snapshot", void 0);
        _defineProperty(this, "type", Z.ChildActivationStart);
        this.snapshot = t;
      }
      return _createClass(tB, [{
        key: "toString",
        value: function toString() {
          return "ChildActivationStart(path: '".concat(this.snapshot.routeConfig && this.snapshot.routeConfig.path || "", "')");
        }
      }]);
    }();
    var nB = /*#__PURE__*/function () {
      function nB(t) {
        _classCallCheck(this, nB);
        _defineProperty(this, "snapshot", void 0);
        _defineProperty(this, "type", Z.ChildActivationEnd);
        this.snapshot = t;
      }
      return _createClass(nB, [{
        key: "toString",
        value: function toString() {
          return "ChildActivationEnd(path: '".concat(this.snapshot.routeConfig && this.snapshot.routeConfig.path || "", "')");
        }
      }]);
    }();
    var rB = /*#__PURE__*/function () {
      function rB(t) {
        _classCallCheck(this, rB);
        _defineProperty(this, "snapshot", void 0);
        _defineProperty(this, "type", Z.ActivationStart);
        this.snapshot = t;
      }
      return _createClass(rB, [{
        key: "toString",
        value: function toString() {
          return "ActivationStart(path: '".concat(this.snapshot.routeConfig && this.snapshot.routeConfig.path || "", "')");
        }
      }]);
    }();
    var oB = /*#__PURE__*/function () {
      function oB(t) {
        _classCallCheck(this, oB);
        _defineProperty(this, "snapshot", void 0);
        _defineProperty(this, "type", Z.ActivationEnd);
        this.snapshot = t;
      }
      return _createClass(oB, [{
        key: "toString",
        value: function toString() {
          return "ActivationEnd(path: '".concat(this.snapshot.routeConfig && this.snapshot.routeConfig.path || "", "')");
        }
      }]);
    }();
    var Hp = /*#__PURE__*/_createClass(function Hp() {
      _classCallCheck(this, Hp);
    });
    var Ac = /*#__PURE__*/_createClass(function Ac(t, n) {
      _classCallCheck(this, Ac);
      _defineProperty(this, "url", void 0);
      _defineProperty(this, "navigationBehaviorOptions", void 0);
      this.url = t, this.navigationBehaviorOptions = n;
    });
    function Zt(e) {
      return e.outlet || U;
    }
    function zs(e) {
      var _e$routeConfig;
      if (!e) return null;
      if ((_e$routeConfig = e.routeConfig) !== null && _e$routeConfig !== void 0 && _e$routeConfig._injector) return e.routeConfig._injector;
      for (var t = e.parent; t; t = t.parent) {
        var n = t.routeConfig;
        if (n !== null && n !== void 0 && n._loadedInjector) return n._loadedInjector;
        if (n !== null && n !== void 0 && n._injector) return n._injector;
      }
      return null;
    }
    var lB = /*#__PURE__*/function () {
      function lB(t) {
        _classCallCheck(this, lB);
        _defineProperty(this, "rootInjector", void 0);
        _defineProperty(this, "outlet", null);
        _defineProperty(this, "route", null);
        _defineProperty(this, "children", void 0);
        _defineProperty(this, "attachRef", null);
        this.rootInjector = t, this.children = new qs(this.rootInjector);
      }
      return _createClass(lB, [{
        key: "injector",
        get: function get() {
          var _zs, _this$route;
          return (_zs = zs((_this$route = this.route) === null || _this$route === void 0 ? void 0 : _this$route.snapshot)) !== null && _zs !== void 0 ? _zs : this.rootInjector;
        }
      }]);
    }();
    var qs = function (_e36) {
      var e = /*#__PURE__*/function () {
        function e(n) {
          _classCallCheck(this, e);
          _defineProperty(this, "rootInjector", void 0);
          _defineProperty(this, "contexts", new Map());
          this.rootInjector = n;
        }
        return _createClass(e, [{
          key: "onChildOutletCreated",
          value: function onChildOutletCreated(n, r) {
            var o = this.getOrCreateContext(n);
            o.outlet = r, this.contexts.set(n, o);
          }
        }, {
          key: "onChildOutletDestroyed",
          value: function onChildOutletDestroyed(n) {
            var r = this.getContext(n);
            r && (r.outlet = null, r.attachRef = null);
          }
        }, {
          key: "onOutletDeactivated",
          value: function onOutletDeactivated() {
            var n = this.contexts;
            return this.contexts = new Map(), n;
          }
        }, {
          key: "onOutletReAttached",
          value: function onOutletReAttached(n) {
            this.contexts = n;
          }
        }, {
          key: "getOrCreateContext",
          value: function getOrCreateContext(n) {
            var r = this.getContext(n);
            return r || (r = new lB(this.rootInjector), this.contexts.set(n, r)), r;
          }
        }, {
          key: "getContext",
          value: function getContext(n) {
            return this.contexts.get(n) || null;
          }
        }]);
      }();
      _e36 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e36)(T(at));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e36,
        factory: _e36.ɵfac,
        providedIn: "root"
      }));
      return e;
    }();
    var _b = /*#__PURE__*/function () {
      function _b(t) {
        _classCallCheck(this, _b);
        _defineProperty(this, "_root", void 0);
        this._root = t;
      }
      return _createClass(_b, [{
        key: "root",
        get: function get() {
          return this._root.value;
        }
      }, {
        key: "parent",
        value: function parent(t) {
          var n = this.pathFromRoot(t);
          return n.length > 1 ? n[n.length - 2] : null;
        }
      }, {
        key: "children",
        value: function children(t) {
          var n = $p(t, this._root);
          return n ? n.children.map(function (r) {
            return r.value;
          }) : [];
        }
      }, {
        key: "firstChild",
        value: function firstChild(t) {
          var n = $p(t, this._root);
          return n && n.children.length > 0 ? n.children[0].value : null;
        }
      }, {
        key: "siblings",
        value: function siblings(t) {
          var n = zp(t, this._root);
          return n.length < 2 ? [] : n[n.length - 2].children.map(function (o) {
            return o.value;
          }).filter(function (o) {
            return o !== t;
          });
        }
      }, {
        key: "pathFromRoot",
        value: function pathFromRoot(t) {
          return zp(t, this._root).map(function (n) {
            return n.value;
          });
        }
      }]);
    }();
    function $p(e, t) {
      if (e === t.value) return t;
      var _iterator36 = _createForOfIteratorHelper(t.children),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var n = _step36.value;
          var r = $p(e, n);
          if (r) return r;
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      return null;
    }
    function zp(e, t) {
      if (e === t.value) return [t];
      var _iterator37 = _createForOfIteratorHelper(t.children),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var n = _step37.value;
          var r = zp(e, n);
          if (r.length) return r.unshift(t), r;
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      return [];
    }
    var Qt = /*#__PURE__*/function () {
      function Qt(t, n) {
        _classCallCheck(this, Qt);
        _defineProperty(this, "value", void 0);
        _defineProperty(this, "children", void 0);
        this.value = t, this.children = n;
      }
      return _createClass(Qt, [{
        key: "toString",
        value: function toString() {
          return "TreeNode(".concat(this.value, ")");
        }
      }]);
    }();
    function si(e) {
      var t = {};
      return e && e.children.forEach(function (n) {
        return t[n.value.outlet] = n;
      }), t;
    }
    var bb = /*#__PURE__*/function (_b3) {
      function bb(t, n) {
        var _this69;
        _classCallCheck(this, bb);
        _this69 = _callSuper(this, bb, [t]), _defineProperty(_assertThisInitialized(_this69), "snapshot", void 0), _this69.snapshot = n, qp(_assertThisInitialized(_this69), t);
        return _this69;
      }
      _inherits(bb, _b3);
      return _createClass(bb, [{
        key: "toString",
        value: function toString() {
          return this.snapshot.toString();
        }
      }]);
    }(_b);
    function Mb(e) {
      var t = function dB(e) {
          var i = new kc([], {}, {}, "", {}, U, e, null, {});
          return new Sb("", new Qt(i, []));
        }(e),
        n = new _t([new Vs("", {})]),
        r = new _t({}),
        o = new _t({}),
        i = new _t({}),
        s = new _t(""),
        a = new ai(n, r, i, s, o, U, e, t.root);
      return a.snapshot = t.root, new bb(new Qt(a, []), t);
    }
    var ai = /*#__PURE__*/function () {
      function ai(t, n, r, o, i, s, a, u) {
        var _this$dataSubject$pip, _this$dataSubject;
        _classCallCheck(this, ai);
        _defineProperty(this, "urlSubject", void 0);
        _defineProperty(this, "paramsSubject", void 0);
        _defineProperty(this, "queryParamsSubject", void 0);
        _defineProperty(this, "fragmentSubject", void 0);
        _defineProperty(this, "dataSubject", void 0);
        _defineProperty(this, "outlet", void 0);
        _defineProperty(this, "component", void 0);
        _defineProperty(this, "snapshot", void 0);
        _defineProperty(this, "_futureSnapshot", void 0);
        _defineProperty(this, "_routerState", void 0);
        _defineProperty(this, "_paramMap", void 0);
        _defineProperty(this, "_queryParamMap", void 0);
        _defineProperty(this, "title", void 0);
        _defineProperty(this, "url", void 0);
        _defineProperty(this, "params", void 0);
        _defineProperty(this, "queryParams", void 0);
        _defineProperty(this, "fragment", void 0);
        _defineProperty(this, "data", void 0);
        this.urlSubject = t, this.paramsSubject = n, this.queryParamsSubject = r, this.fragmentSubject = o, this.dataSubject = i, this.outlet = s, this.component = a, this._futureSnapshot = u, this.title = (_this$dataSubject$pip = (_this$dataSubject = this.dataSubject) === null || _this$dataSubject === void 0 ? void 0 : _this$dataSubject.pipe(Y(function (c) {
          return c[js];
        }))) !== null && _this$dataSubject$pip !== void 0 ? _this$dataSubject$pip : V(void 0), this.url = t, this.params = n, this.queryParams = r, this.fragment = o, this.data = i;
      }
      return _createClass(ai, [{
        key: "routeConfig",
        get: function get() {
          return this._futureSnapshot.routeConfig;
        }
      }, {
        key: "root",
        get: function get() {
          return this._routerState.root;
        }
      }, {
        key: "parent",
        get: function get() {
          return this._routerState.parent(this);
        }
      }, {
        key: "firstChild",
        get: function get() {
          return this._routerState.firstChild(this);
        }
      }, {
        key: "children",
        get: function get() {
          return this._routerState.children(this);
        }
      }, {
        key: "pathFromRoot",
        get: function get() {
          return this._routerState.pathFromRoot(this);
        }
      }, {
        key: "paramMap",
        get: function get() {
          var _this$_paramMap;
          return (_this$_paramMap = this._paramMap) !== null && _this$_paramMap !== void 0 ? _this$_paramMap : this._paramMap = this.params.pipe(Y(function (t) {
            return ii(t);
          })), this._paramMap;
        }
      }, {
        key: "queryParamMap",
        get: function get() {
          var _this$_queryParamMap2;
          return (_this$_queryParamMap2 = this._queryParamMap) !== null && _this$_queryParamMap2 !== void 0 ? _this$_queryParamMap2 : this._queryParamMap = this.queryParams.pipe(Y(function (t) {
            return ii(t);
          })), this._queryParamMap;
        }
      }, {
        key: "toString",
        value: function toString() {
          return this.snapshot ? this.snapshot.toString() : "Future(".concat(this._futureSnapshot, ")");
        }
      }]);
    }();
    function xc(e, t) {
      var _t$routeConfig, _e$_resolvedData;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "emptyOnly";
      var r;
      var o = e.routeConfig;
      return r = null === t || "always" !== n && "" !== (o === null || o === void 0 ? void 0 : o.path) && (t.component || (_t$routeConfig = t.routeConfig) !== null && _t$routeConfig !== void 0 && _t$routeConfig.loadComponent) ? {
        params: _objectSpread({}, e.params),
        data: _objectSpread({}, e.data),
        resolve: _objectSpread(_objectSpread({}, e.data), (_e$_resolvedData = e._resolvedData) !== null && _e$_resolvedData !== void 0 ? _e$_resolvedData : {})
      } : {
        params: _objectSpread(_objectSpread({}, t.params), e.params),
        data: _objectSpread(_objectSpread({}, t.data), e.data),
        resolve: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, e.data), t.data), o === null || o === void 0 ? void 0 : o.data), e._resolvedData)
      }, o && Nb(o) && (r.resolve[js] = o.title), r;
    }
    var kc = /*#__PURE__*/function () {
      function kc(t, n, r, o, i, s, a, u, c) {
        _classCallCheck(this, kc);
        _defineProperty(this, "url", void 0);
        _defineProperty(this, "params", void 0);
        _defineProperty(this, "queryParams", void 0);
        _defineProperty(this, "fragment", void 0);
        _defineProperty(this, "data", void 0);
        _defineProperty(this, "outlet", void 0);
        _defineProperty(this, "component", void 0);
        _defineProperty(this, "routeConfig", void 0);
        _defineProperty(this, "_resolve", void 0);
        _defineProperty(this, "_resolvedData", void 0);
        _defineProperty(this, "_routerState", void 0);
        _defineProperty(this, "_paramMap", void 0);
        _defineProperty(this, "_queryParamMap", void 0);
        this.url = t, this.params = n, this.queryParams = r, this.fragment = o, this.data = i, this.outlet = s, this.component = a, this.routeConfig = u, this._resolve = c;
      }
      return _createClass(kc, [{
        key: "title",
        get: function get() {
          var _this$data;
          return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data[js];
        }
      }, {
        key: "root",
        get: function get() {
          return this._routerState.root;
        }
      }, {
        key: "parent",
        get: function get() {
          return this._routerState.parent(this);
        }
      }, {
        key: "firstChild",
        get: function get() {
          return this._routerState.firstChild(this);
        }
      }, {
        key: "children",
        get: function get() {
          return this._routerState.children(this);
        }
      }, {
        key: "pathFromRoot",
        get: function get() {
          return this._routerState.pathFromRoot(this);
        }
      }, {
        key: "paramMap",
        get: function get() {
          var _this$_paramMap2;
          return (_this$_paramMap2 = this._paramMap) !== null && _this$_paramMap2 !== void 0 ? _this$_paramMap2 : this._paramMap = ii(this.params), this._paramMap;
        }
      }, {
        key: "queryParamMap",
        get: function get() {
          var _this$_queryParamMap3;
          return (_this$_queryParamMap3 = this._queryParamMap) !== null && _this$_queryParamMap3 !== void 0 ? _this$_queryParamMap3 : this._queryParamMap = ii(this.queryParams), this._queryParamMap;
        }
      }, {
        key: "toString",
        value: function toString() {
          return "Route(url:'".concat(this.url.map(function (r) {
            return r.toString();
          }).join("/"), "', path:'").concat(this.routeConfig ? this.routeConfig.path : "", "')");
        }
      }]);
    }();
    var Sb = /*#__PURE__*/function (_b4) {
      function Sb(t, n) {
        var _this70;
        _classCallCheck(this, Sb);
        _this70 = _callSuper(this, Sb, [n]), _defineProperty(_assertThisInitialized(_this70), "url", void 0), _this70.url = t, qp(_assertThisInitialized(_this70), n);
        return _this70;
      }
      _inherits(Sb, _b4);
      return _createClass(Sb, [{
        key: "toString",
        value: function toString() {
          return Tb(this._root);
        }
      }]);
    }(_b);
    function qp(e, t) {
      t.value._routerState = e, t.children.forEach(function (n) {
        return qp(e, n);
      });
    }
    function Tb(e) {
      var t = e.children.length > 0 ? " { ".concat(e.children.map(Tb).join(", "), " } ") : "";
      return "".concat(e.value).concat(t);
    }
    function Gp(e) {
      if (e.snapshot) {
        var t = e.snapshot,
          n = e._futureSnapshot;
        e.snapshot = n, hn(t.queryParams, n.queryParams) || e.queryParamsSubject.next(n.queryParams), t.fragment !== n.fragment && e.fragmentSubject.next(n.fragment), hn(t.params, n.params) || e.paramsSubject.next(n.params), function I2(e, t) {
          if (e.length !== t.length) return !1;
          for (var _n11 = 0; _n11 < e.length; ++_n11) if (!hn(e[_n11], t[_n11])) return !1;
          return !0;
        }(t.url, n.url) || e.urlSubject.next(n.url), hn(t.data, n.data) || e.dataSubject.next(n.data);
      } else e.snapshot = e._futureSnapshot, e.dataSubject.next(e._futureSnapshot.data);
    }
    function Wp(e, t) {
      var n = hn(e.params, t.params) && function S2(e, t) {
        return $r(e, t) && e.every(function (n, r) {
          return hn(n.parameters, t[r].parameters);
        });
      }(e.url, t.url);
      return n && !(!e.parent != !t.parent) && (!e.parent || Wp(e.parent, t.parent));
    }
    function Nb(e) {
      return "string" == typeof e.title || null === e.title;
    }
    var fB = new I("");
    var Zp = function (_e37) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
          _defineProperty(this, "activated", null);
          _defineProperty(this, "_activatedRoute", null);
          _defineProperty(this, "name", U);
          _defineProperty(this, "activateEvents", new ut());
          _defineProperty(this, "deactivateEvents", new ut());
          _defineProperty(this, "attachEvents", new ut());
          _defineProperty(this, "detachEvents", new ut());
          _defineProperty(this, "routerOutletData", d0(void 0));
          _defineProperty(this, "parentContexts", w(qs));
          _defineProperty(this, "location", w($t));
          _defineProperty(this, "changeDetector", w(ac));
          _defineProperty(this, "inputBinder", w(Qp, {
            optional: !0
          }));
          _defineProperty(this, "supportsBindingToComponentInputs", !0);
        }
        return _createClass(e, [{
          key: "activatedComponentRef",
          get: function get() {
            return this.activated;
          }
        }, {
          key: "ngOnChanges",
          value: function ngOnChanges(n) {
            if (n.name) {
              var _n$name = n.name,
                r = _n$name.firstChange,
                o = _n$name.previousValue;
              if (r) return;
              this.isTrackedInParentContexts(o) && (this.deactivate(), this.parentContexts.onChildOutletDestroyed(o)), this.initializeOutletWithName();
            }
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            var _this$inputBinder;
            this.isTrackedInParentContexts(this.name) && this.parentContexts.onChildOutletDestroyed(this.name), (_this$inputBinder = this.inputBinder) === null || _this$inputBinder === void 0 ? void 0 : _this$inputBinder.unsubscribeFromRouteData(this);
          }
        }, {
          key: "isTrackedInParentContexts",
          value: function isTrackedInParentContexts(n) {
            var _this$parentContexts$;
            return ((_this$parentContexts$ = this.parentContexts.getContext(n)) === null || _this$parentContexts$ === void 0 ? void 0 : _this$parentContexts$.outlet) === this;
          }
        }, {
          key: "ngOnInit",
          value: function ngOnInit() {
            this.initializeOutletWithName();
          }
        }, {
          key: "initializeOutletWithName",
          value: function initializeOutletWithName() {
            if (this.parentContexts.onChildOutletCreated(this.name, this), this.activated) return;
            var n = this.parentContexts.getContext(this.name);
            (n === null || n === void 0 ? void 0 : n.route) && (n.attachRef ? this.attach(n.attachRef, n.route) : this.activateWith(n.route, n.injector));
          }
        }, {
          key: "isActivated",
          get: function get() {
            return !!this.activated;
          }
        }, {
          key: "component",
          get: function get() {
            if (!this.activated) throw new E(4012, !1);
            return this.activated.instance;
          }
        }, {
          key: "activatedRoute",
          get: function get() {
            if (!this.activated) throw new E(4012, !1);
            return this._activatedRoute;
          }
        }, {
          key: "activatedRouteData",
          get: function get() {
            return this._activatedRoute ? this._activatedRoute.snapshot.data : {};
          }
        }, {
          key: "detach",
          value: function detach() {
            if (!this.activated) throw new E(4012, !1);
            this.location.detach();
            var n = this.activated;
            return this.activated = null, this._activatedRoute = null, this.detachEvents.emit(n.instance), n;
          }
        }, {
          key: "attach",
          value: function attach(n, r) {
            var _this$inputBinder2;
            this.activated = n, this._activatedRoute = r, this.location.insert(n.hostView), (_this$inputBinder2 = this.inputBinder) !== null && _this$inputBinder2 !== void 0 && _this$inputBinder2.bindActivatedRouteToOutletComponent(this), this.attachEvents.emit(n.instance);
          }
        }, {
          key: "deactivate",
          value: function deactivate() {
            if (this.activated) {
              var n = this.component;
              this.activated.destroy(), this.activated = null, this._activatedRoute = null, this.deactivateEvents.emit(n);
            }
          }
        }, {
          key: "activateWith",
          value: function activateWith(n, r) {
            var _this$inputBinder3;
            if (this.isActivated) throw new E(4013, !1);
            this._activatedRoute = n;
            var o = this.location,
              s = n.snapshot.component,
              a = this.parentContexts.getOrCreateContext(this.name).children,
              u = new hB(n, a, o.injector, this.routerOutletData);
            this.activated = o.createComponent(s, {
              index: o.length,
              injector: u,
              environmentInjector: r
            }), this.changeDetector.markForCheck(), (_this$inputBinder3 = this.inputBinder) !== null && _this$inputBinder3 !== void 0 && _this$inputBinder3.bindActivatedRouteToOutletComponent(this), this.activateEvents.emit(this.activated.instance);
          }
        }]);
      }();
      _e37 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e37)();
      });
      _defineProperty(e, "\u0275dir", Ke({
        type: _e37,
        selectors: [["router-outlet"]],
        inputs: {
          name: "name",
          routerOutletData: [1, "routerOutletData"]
        },
        outputs: {
          activateEvents: "activate",
          deactivateEvents: "deactivate",
          attachEvents: "attach",
          detachEvents: "detach"
        },
        exportAs: ["outlet"],
        features: [fo]
      }));
      return e;
    }();
    var hB = /*#__PURE__*/function () {
      function hB(t, n, r, o) {
        _classCallCheck(this, hB);
        _defineProperty(this, "route", void 0);
        _defineProperty(this, "childContexts", void 0);
        _defineProperty(this, "parent", void 0);
        _defineProperty(this, "outletData", void 0);
        this.route = t, this.childContexts = n, this.parent = r, this.outletData = o;
      }
      return _createClass(hB, [{
        key: "get",
        value: function get(t, n) {
          return t === ai ? this.route : t === qs ? this.childContexts : t === fB ? this.outletData : this.parent.get(t, n);
        }
      }]);
    }();
    var Qp = new I("");
    var Rb = function (_e38) {
      var e = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      });
      _e38 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e38)();
      });
      _defineProperty(e, "\u0275cmp", Nt({
        type: _e38,
        selectors: [["ng-component"]],
        exportAs: ["emptyRouterOutlet"],
        decls: 1,
        vars: 0,
        template: function template(r, o) {
          1 & r && pe(0, "router-outlet");
        },
        dependencies: [Zp],
        encapsulation: 2
      }));
      return e;
    }();
    function Yp(e) {
      var t = e.children && e.children.map(Yp),
        n = t ? _objectSpread(_objectSpread({}, e), {}, {
          children: t
        }) : _objectSpread({}, e);
      return !n.component && !n.loadComponent && (t || n.loadChildren) && n.outlet && n.outlet !== U && (n.component = Rb), n;
    }
    function Gs(e, t, n) {
      if (n && e.shouldReuseRoute(t.value, n.value.snapshot)) {
        var r = n.value;
        r._futureSnapshot = t.value;
        var o = function gB(e, t, n) {
          return t.children.map(function (r) {
            var _iterator38 = _createForOfIteratorHelper(n.children),
              _step38;
            try {
              for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                var _o10 = _step38.value;
                if (e.shouldReuseRoute(r.value, _o10.value.snapshot)) return Gs(e, r, _o10);
              }
            } catch (err) {
              _iterator38.e(err);
            } finally {
              _iterator38.f();
            }
            return Gs(e, r);
          });
        }(e, t, n);
        return new Qt(r, o);
      }
      {
        if (e.shouldAttach(t.value)) {
          var i = e.retrieve(t.value);
          if (null !== i) {
            var s = i.route;
            return s.value._futureSnapshot = t.value, s.children = t.children.map(function (a) {
              return Gs(e, a);
            }), s;
          }
        }
        var _r16 = function mB(e) {
            return new ai(new _t(e.url), new _t(e.params), new _t(e.queryParams), new _t(e.fragment), new _t(e.data), e.outlet, e.component, e);
          }(t.value),
          _o11 = t.children.map(function (i) {
            return Gs(e, i);
          });
        return new Qt(_r16, _o11);
      }
    }
    var Jp = /*#__PURE__*/_createClass(function Jp(t, n) {
      _classCallCheck(this, Jp);
      _defineProperty(this, "redirectTo", void 0);
      _defineProperty(this, "navigationBehaviorOptions", void 0);
      this.redirectTo = t, this.navigationBehaviorOptions = n;
    });
    var Ab = "ngNavigationCancelingError";
    function Oc(e, t) {
      var _ref30 = zr(t) ? {
          redirectTo: t,
          navigationBehaviorOptions: void 0
        } : t,
        n = _ref30.redirectTo,
        r = _ref30.navigationBehaviorOptions,
        o = xb(!1, Ct.Redirect);
      return o.url = n, o.navigationBehaviorOptions = r, o;
    }
    function xb(e, t) {
      var n = new Error("NavigationCancelingError: ".concat(e || ""));
      return n[Ab] = !0, n.cancellationCode = t, n;
    }
    function kb(e) {
      return !!e && e[Ab];
    }
    var DB = /*#__PURE__*/function () {
      function DB(t, n, r, o, i) {
        _classCallCheck(this, DB);
        _defineProperty(this, "routeReuseStrategy", void 0);
        _defineProperty(this, "futureState", void 0);
        _defineProperty(this, "currState", void 0);
        _defineProperty(this, "forwardEvent", void 0);
        _defineProperty(this, "inputBindingEnabled", void 0);
        this.routeReuseStrategy = t, this.futureState = n, this.currState = r, this.forwardEvent = o, this.inputBindingEnabled = i;
      }
      return _createClass(DB, [{
        key: "activate",
        value: function activate(t) {
          var n = this.futureState._root,
            r = this.currState ? this.currState._root : null;
          this.deactivateChildRoutes(n, r, t), Gp(this.futureState.root), this.activateChildRoutes(n, r, t);
        }
      }, {
        key: "deactivateChildRoutes",
        value: function deactivateChildRoutes(t, n, r) {
          var _this71 = this;
          var o = si(n);
          t.children.forEach(function (i) {
            var s = i.value.outlet;
            _this71.deactivateRoutes(i, o[s], r), delete o[s];
          }), Object.values(o).forEach(function (i) {
            _this71.deactivateRouteAndItsChildren(i, r);
          });
        }
      }, {
        key: "deactivateRoutes",
        value: function deactivateRoutes(t, n, r) {
          var o = t.value,
            i = n ? n.value : null;
          if (o === i) {
            if (o.component) {
              var s = r.getContext(o.outlet);
              s && this.deactivateChildRoutes(t, n, s.children);
            } else this.deactivateChildRoutes(t, n, r);
          } else i && this.deactivateRouteAndItsChildren(n, r);
        }
      }, {
        key: "deactivateRouteAndItsChildren",
        value: function deactivateRouteAndItsChildren(t, n) {
          t.value.component && this.routeReuseStrategy.shouldDetach(t.value.snapshot) ? this.detachAndStoreRouteSubtree(t, n) : this.deactivateRouteAndOutlet(t, n);
        }
      }, {
        key: "detachAndStoreRouteSubtree",
        value: function detachAndStoreRouteSubtree(t, n) {
          var r = n.getContext(t.value.outlet),
            o = r && t.value.component ? r.children : n,
            i = si(t);
          for (var _i18 = 0, _Object$values = Object.values(i); _i18 < _Object$values.length; _i18++) {
            var s = _Object$values[_i18];
            this.deactivateRouteAndItsChildren(s, o);
          }
          if (r && r.outlet) {
            var _s15 = r.outlet.detach(),
              a = r.children.onOutletDeactivated();
            this.routeReuseStrategy.store(t.value.snapshot, {
              componentRef: _s15,
              route: t,
              contexts: a
            });
          }
        }
      }, {
        key: "deactivateRouteAndOutlet",
        value: function deactivateRouteAndOutlet(t, n) {
          var r = n.getContext(t.value.outlet),
            o = r && t.value.component ? r.children : n,
            i = si(t);
          for (var _i19 = 0, _Object$values2 = Object.values(i); _i19 < _Object$values2.length; _i19++) {
            var s = _Object$values2[_i19];
            this.deactivateRouteAndItsChildren(s, o);
          }
          r && (r.outlet && (r.outlet.deactivate(), r.children.onOutletDeactivated()), r.attachRef = null, r.route = null);
        }
      }, {
        key: "activateChildRoutes",
        value: function activateChildRoutes(t, n, r) {
          var _this72 = this;
          var o = si(n);
          t.children.forEach(function (i) {
            _this72.activateRoutes(i, o[i.value.outlet], r), _this72.forwardEvent(new oB(i.value.snapshot));
          }), t.children.length && this.forwardEvent(new nB(t.value.snapshot));
        }
      }, {
        key: "activateRoutes",
        value: function activateRoutes(t, n, r) {
          var o = t.value,
            i = n ? n.value : null;
          if (Gp(o), o === i) {
            if (o.component) {
              var s = r.getOrCreateContext(o.outlet);
              this.activateChildRoutes(t, n, s.children);
            } else this.activateChildRoutes(t, n, r);
          } else if (o.component) {
            var _s16 = r.getOrCreateContext(o.outlet);
            if (this.routeReuseStrategy.shouldAttach(o.snapshot)) {
              var a = this.routeReuseStrategy.retrieve(o.snapshot);
              this.routeReuseStrategy.store(o.snapshot, null), _s16.children.onOutletReAttached(a.contexts), _s16.attachRef = a.componentRef, _s16.route = a.route.value, _s16.outlet && _s16.outlet.attach(a.componentRef, a.route.value), Gp(a.route.value), this.activateChildRoutes(t, null, _s16.children);
            } else _s16.attachRef = null, _s16.route = o, _s16.outlet && _s16.outlet.activateWith(o, _s16.injector), this.activateChildRoutes(t, null, _s16.children);
          } else this.activateChildRoutes(t, null, r);
        }
      }]);
    }();
    var Ob = /*#__PURE__*/_createClass(function Ob(t) {
      _classCallCheck(this, Ob);
      _defineProperty(this, "path", void 0);
      _defineProperty(this, "route", void 0);
      this.path = t, this.route = this.path[this.path.length - 1];
    });
    var Pc = /*#__PURE__*/_createClass(function Pc(t, n) {
      _classCallCheck(this, Pc);
      _defineProperty(this, "component", void 0);
      _defineProperty(this, "route", void 0);
      this.component = t, this.route = n;
    });
    function wB(e, t, n) {
      var r = e._root;
      return Ws(r, t ? t._root : null, n, [r.value]);
    }
    function ui(e, t) {
      var n = Symbol(),
        r = t.get(e, n);
      return r === n ? "function" != typeof e || function CS(e) {
        return null !== ya(e);
      }(e) ? t.get(e) : e : r;
    }
    function Ws(e, t, n, r) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        canDeactivateChecks: [],
        canActivateChecks: []
      };
      var i = si(t);
      return e.children.forEach(function (s) {
        (function CB(e, t, n, r) {
          var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            canDeactivateChecks: [],
            canActivateChecks: []
          };
          var i = e.value,
            s = t ? t.value : null,
            a = n ? n.getContext(e.value.outlet) : null;
          if (s && i.routeConfig === s.routeConfig) {
            var u = function IB(e, t, n) {
              if ("function" == typeof n) return n(e, t);
              switch (n) {
                case "pathParamsChange":
                  return !$r(e.url, t.url);
                case "pathParamsOrQueryParamsChange":
                  return !$r(e.url, t.url) || !hn(e.queryParams, t.queryParams);
                case "always":
                  return !0;
                case "paramsOrQueryParamsChange":
                  return !Wp(e, t) || !hn(e.queryParams, t.queryParams);
                default:
                  return !Wp(e, t);
              }
            }(s, i, i.routeConfig.runGuardsAndResolvers);
            u ? o.canActivateChecks.push(new Ob(r)) : (i.data = s.data, i._resolvedData = s._resolvedData), Ws(e, t, i.component ? a ? a.children : null : n, r, o), u && a && a.outlet && a.outlet.isActivated && o.canDeactivateChecks.push(new Pc(a.outlet.component, s));
          } else s && Zs(t, a, o), o.canActivateChecks.push(new Ob(r)), Ws(e, null, i.component ? a ? a.children : null : n, r, o);
        })(s, i[s.value.outlet], n, r.concat([s.value]), o), delete i[s.value.outlet];
      }), Object.entries(i).forEach(function (_ref31) {
        var _ref32 = _slicedToArray(_ref31, 2),
          s = _ref32[0],
          a = _ref32[1];
        return Zs(a, n.getContext(s), o);
      }), o;
    }
    function Zs(e, t, n) {
      var r = si(e),
        o = e.value;
      Object.entries(r).forEach(function (_ref33) {
        var _ref34 = _slicedToArray(_ref33, 2),
          i = _ref34[0],
          s = _ref34[1];
        Zs(s, o.component ? t ? t.children.getContext(i) : null : t, n);
      }), n.canDeactivateChecks.push(new Pc(o.component && t && t.outlet && t.outlet.isActivated ? t.outlet.component : null, o));
    }
    function Qs(e) {
      return "function" == typeof e;
    }
    function Pb(e) {
      return e instanceof yc || "EmptyError" === (e === null || e === void 0 ? void 0 : e.name);
    }
    var Fc = Symbol("INITIAL_VALUE");
    function ci() {
      return fn(function (e) {
        return J_(e.map(function (t) {
          return t.pipe(ri(1), function d2() {
            for (var _len0 = arguments.length, e = new Array(_len0), _key0 = 0; _key0 < _len0; _key0++) {
              e[_key0] = arguments[_key0];
            }
            var t = vc(e);
            return Le(function (n, r) {
              (t ? Ap(e, n, t) : Ap(e, n)).subscribe(r);
            });
          }(Fc));
        })).pipe(Y(function (t) {
          var _iterator39 = _createForOfIteratorHelper(t),
            _step39;
          try {
            for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
              var n = _step39.value;
              if (!0 !== n) {
                if (n === Fc) return Fc;
                if (!1 === n || RB(n)) return n;
              }
            }
          } catch (err) {
            _iterator39.e(err);
          } finally {
            _iterator39.f();
          }
          return !0;
        }), tr(function (t) {
          return t !== Fc;
        }), ri(1));
      });
    }
    function RB(e) {
      return zr(e) || e instanceof Jp;
    }
    function Fb(e) {
      return function dS() {
        for (var _len1 = arguments.length, e = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++) {
          e[_key1] = arguments[_key1];
        }
        return Wg(e);
      }(tt(function (t) {
        if ("boolean" != typeof t) throw Oc(0, t);
      }), Y(function (t) {
        return !0 === t;
      }));
    }
    var Kp = /*#__PURE__*/_createClass(function Kp(t) {
      _classCallCheck(this, Kp);
      _defineProperty(this, "segmentGroup", void 0);
      this.segmentGroup = t || null;
    });
    var Xp = /*#__PURE__*/function (_Error2) {
      function Xp(t) {
        var _this73;
        _classCallCheck(this, Xp);
        _this73 = _callSuper(this, Xp), _defineProperty(_assertThisInitialized(_this73), "urlTree", void 0), _this73.urlTree = t;
        return _this73;
      }
      _inherits(Xp, _Error2);
      return _createClass(Xp);
    }(/*#__PURE__*/_wrapNativeSuper(Error));
    function li(e) {
      return Dc(new Kp(e));
    }
    var $B = /*#__PURE__*/function () {
      function $B(t, n) {
        _classCallCheck(this, $B);
        _defineProperty(this, "urlSerializer", void 0);
        _defineProperty(this, "urlTree", void 0);
        this.urlSerializer = t, this.urlTree = n;
      }
      return _createClass($B, [{
        key: "lineralizeSegments",
        value: function lineralizeSegments(t, n) {
          var r = [],
            o = n.root;
          for (;;) {
            if (r = r.concat(o.segments), 0 === o.numberOfChildren) return V(r);
            if (o.numberOfChildren > 1 || !o.children[U]) return Dc(new E(4e3, !1));
            o = o.children[U];
          }
        }
      }, {
        key: "applyRedirectCommands",
        value: function applyRedirectCommands(t, n, r, o, i) {
          if ("string" != typeof n) {
            var a = n,
              u = o.queryParams,
              c = o.fragment,
              l = o.routeConfig,
              d = o.url,
              h = o.outlet,
              f = o.params,
              p = o.data,
              g = o.title,
              m = Ft(i, function () {
                return a({
                  params: f,
                  data: p,
                  queryParams: u,
                  fragment: c,
                  routeConfig: l,
                  url: d,
                  outlet: h,
                  title: g
                });
              });
            if (m instanceof Hr) throw new Xp(m);
            n = m;
          }
          var s = this.applyRedirectCreateUrlTree(n, this.urlSerializer.parse(n), t, r);
          if ("/" === n[0]) throw new Xp(s);
          return s;
        }
      }, {
        key: "applyRedirectCreateUrlTree",
        value: function applyRedirectCreateUrlTree(t, n, r, o) {
          var i = this.createSegmentGroup(t, n.root, r, o);
          return new Hr(i, this.createQueryParams(n.queryParams, this.urlTree.queryParams), n.fragment);
        }
      }, {
        key: "createQueryParams",
        value: function createQueryParams(t, n) {
          var r = {};
          return Object.entries(t).forEach(function (_ref35) {
            var _ref36 = _slicedToArray(_ref35, 2),
              o = _ref36[0],
              i = _ref36[1];
            if ("string" == typeof i && ":" === i[0]) {
              var a = i.substring(1);
              r[o] = n[a];
            } else r[o] = i;
          }), r;
        }
      }, {
        key: "createSegmentGroup",
        value: function createSegmentGroup(t, n, r, o) {
          var _this74 = this;
          var i = this.createSegments(t, n.segments, r, o);
          var s = {};
          return Object.entries(n.children).forEach(function (_ref37) {
            var _ref38 = _slicedToArray(_ref37, 2),
              a = _ref38[0],
              u = _ref38[1];
            s[a] = _this74.createSegmentGroup(t, u, r, o);
          }), new ue(i, s);
        }
      }, {
        key: "createSegments",
        value: function createSegments(t, n, r, o) {
          var _this75 = this;
          return n.map(function (i) {
            return ":" === i.path[0] ? _this75.findPosParam(t, i, o) : _this75.findOrReturn(i, r);
          });
        }
      }, {
        key: "findPosParam",
        value: function findPosParam(t, n, r) {
          var o = r[n.path.substring(1)];
          if (!o) throw new E(4001, !1);
          return o;
        }
      }, {
        key: "findOrReturn",
        value: function findOrReturn(t, n) {
          var r = 0;
          var _iterator40 = _createForOfIteratorHelper(n),
            _step40;
          try {
            for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
              var o = _step40.value;
              if (o.path === t.path) return n.splice(r), o;
              r++;
            }
          } catch (err) {
            _iterator40.e(err);
          } finally {
            _iterator40.f();
          }
          return t;
        }
      }]);
    }();
    var eg = {
      matched: !1,
      consumedSegments: [],
      remainingSegments: [],
      parameters: {},
      positionalParamSegments: {}
    };
    function zB(e, t, n, r, o) {
      var i = Lb(e, t, n);
      return i.matched ? (r = function iB(e, t, _e$_injector) {
        return e.providers && !e._injector && (e._injector = ph(e.providers, t, "Route: ".concat(e.path))), (_e$_injector = e._injector) !== null && _e$_injector !== void 0 ? _e$_injector : t;
      }(t, r), function BB(e, t, n, r) {
        var o = t.canMatch;
        return o && 0 !== o.length ? V(o.map(function (s) {
          var a = ui(s, e);
          return rr(function NB(e) {
            return e && Qs(e.canMatch);
          }(a) ? a.canMatch(t, n) : Ft(e, function () {
            return a(t, n);
          }));
        })).pipe(ci(), Fb()) : V(!0);
      }(r, t, n).pipe(Y(function (s) {
        return !0 === s ? i : _objectSpread({}, eg);
      }))) : V(i);
    }
    function Lb(e, t, n) {
      var _o$posParams, _o$posParams2;
      if ("**" === t.path) return function qB(e) {
        return {
          matched: !0,
          parameters: e.length > 0 ? ib(e).parameters : {},
          consumedSegments: e,
          remainingSegments: [],
          positionalParamSegments: {}
        };
      }(n);
      if ("" === t.path) return "full" === t.pathMatch && (e.hasChildren() || n.length > 0) ? _objectSpread({}, eg) : {
        matched: !0,
        consumedSegments: [],
        remainingSegments: n,
        parameters: {},
        positionalParamSegments: {}
      };
      var o = (t.matcher || C2)(n, e, t);
      if (!o) return _objectSpread({}, eg);
      var i = {};
      Object.entries((_o$posParams = o.posParams) !== null && _o$posParams !== void 0 ? _o$posParams : {}).forEach(function (_ref39) {
        var _ref40 = _slicedToArray(_ref39, 2),
          a = _ref40[0],
          u = _ref40[1];
        i[a] = u.path;
      });
      var s = o.consumed.length > 0 ? _objectSpread(_objectSpread({}, i), o.consumed[o.consumed.length - 1].parameters) : i;
      return {
        matched: !0,
        consumedSegments: o.consumed,
        remainingSegments: n.slice(o.consumed.length),
        parameters: s,
        positionalParamSegments: (_o$posParams2 = o.posParams) !== null && _o$posParams2 !== void 0 ? _o$posParams2 : {}
      };
    }
    function jb(e, t, n, r) {
      return n.length > 0 && function ZB(e, t, n) {
        return n.some(function (r) {
          return Lc(e, t, r) && Zt(r) !== U;
        });
      }(e, n, r) ? {
        segmentGroup: new ue(t, WB(r, new ue(n, e.children))),
        slicedSegments: []
      } : 0 === n.length && function QB(e, t, n) {
        return n.some(function (r) {
          return Lc(e, t, r);
        });
      }(e, n, r) ? {
        segmentGroup: new ue(e.segments, GB(e, n, r, e.children)),
        slicedSegments: n
      } : {
        segmentGroup: new ue(e.segments, e.children),
        slicedSegments: n
      };
    }
    function GB(e, t, n, r) {
      var o = {};
      var _iterator41 = _createForOfIteratorHelper(n),
        _step41;
      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var i = _step41.value;
          if (Lc(e, t, i) && !r[Zt(i)]) {
            var s = new ue([], {});
            o[Zt(i)] = s;
          }
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
      return _objectSpread(_objectSpread({}, r), o);
    }
    function WB(e, t) {
      var n = {};
      n[U] = t;
      var _iterator42 = _createForOfIteratorHelper(e),
        _step42;
      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var r = _step42.value;
          if ("" === r.path && Zt(r) !== U) {
            var o = new ue([], {});
            n[Zt(r)] = o;
          }
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
      return n;
    }
    function Lc(e, t, n) {
      return (!(e.hasChildren() || t.length > 0) || "full" !== n.pathMatch) && "" === n.path;
    }
    var JB = /*#__PURE__*/_createClass(function JB() {
      _classCallCheck(this, JB);
    });
    var eU = /*#__PURE__*/function () {
      function eU(t, n, r, o, i, s, a) {
        _classCallCheck(this, eU);
        _defineProperty(this, "injector", void 0);
        _defineProperty(this, "configLoader", void 0);
        _defineProperty(this, "rootComponentType", void 0);
        _defineProperty(this, "config", void 0);
        _defineProperty(this, "urlTree", void 0);
        _defineProperty(this, "paramsInheritanceStrategy", void 0);
        _defineProperty(this, "urlSerializer", void 0);
        _defineProperty(this, "applyRedirects", void 0);
        _defineProperty(this, "absoluteRedirectCount", 0);
        _defineProperty(this, "allowRedirects", !0);
        this.injector = t, this.configLoader = n, this.rootComponentType = r, this.config = o, this.urlTree = i, this.paramsInheritanceStrategy = s, this.urlSerializer = a, this.applyRedirects = new $B(this.urlSerializer, this.urlTree);
      }
      return _createClass(eU, [{
        key: "noMatchError",
        value: function noMatchError(t) {
          return new E(4002, "'".concat(t.segmentGroup, "'"));
        }
      }, {
        key: "recognize",
        value: function recognize() {
          var _this76 = this;
          var t = jb(this.urlTree.root, [], [], this.config).segmentGroup;
          return this.match(t).pipe(Y(function (_ref41) {
            var n = _ref41.children,
              r = _ref41.rootSnapshot;
            var o = new Qt(r, n),
              i = new Sb("", o),
              s = function H2(e, t) {
                var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                return vb(mb(e), t, n, r);
              }(r, [], _this76.urlTree.queryParams, _this76.urlTree.fragment);
            return s.queryParams = _this76.urlTree.queryParams, i.url = _this76.urlSerializer.serialize(s), {
              state: i,
              tree: s
            };
          }));
        }
      }, {
        key: "match",
        value: function match(t) {
          var _this77 = this;
          var n = new kc([], Object.freeze({}), Object.freeze(_objectSpread({}, this.urlTree.queryParams)), this.urlTree.fragment, Object.freeze({}), U, this.rootComponentType, null, {});
          return this.processSegmentGroup(this.injector, this.config, t, U, n).pipe(Y(function (r) {
            return {
              children: r,
              rootSnapshot: n
            };
          }), oi(function (r) {
            if (r instanceof Xp) return _this77.urlTree = r.urlTree, _this77.match(r.urlTree.root);
            throw r instanceof Kp ? _this77.noMatchError(r) : r;
          }));
        }
      }, {
        key: "processSegmentGroup",
        value: function processSegmentGroup(t, n, r, o, i) {
          return 0 === r.segments.length && r.hasChildren() ? this.processChildren(t, n, r, i) : this.processSegment(t, n, r, r.segments, o, !0, i).pipe(Y(function (s) {
            return s instanceof Qt ? [s] : [];
          }));
        }
      }, {
        key: "processChildren",
        value: function processChildren(t, n, r, o) {
          var _this78 = this;
          var i = [];
          for (var _i20 = 0, _Object$keys = Object.keys(r.children); _i20 < _Object$keys.length; _i20++) {
            var s = _Object$keys[_i20];
            "primary" === s ? i.unshift(s) : i.push(s);
          }
          return qe(i).pipe(Fs(function (s) {
            var a = r.children[s],
              u = function cB(e, t) {
                var n = e.filter(function (r) {
                  return Zt(r) === t;
                });
                return n.push.apply(n, _toConsumableArray(e.filter(function (r) {
                  return Zt(r) !== t;
                }))), n;
              }(n, s);
            return _this78.processSegmentGroup(t, u, a, s, o);
          }), function p2(e, t) {
            return Le(function h2(e, t, n, r, o) {
              return function (i, s) {
                var a = n,
                  u = t,
                  c = 0;
                i.subscribe(ke(s, function (l) {
                  var d = c++;
                  u = a ? e(u, l, d) : (a = !0, l), r && s.next(u);
                }, o && function () {
                  a && s.next(u), s.complete();
                }));
              };
            }(e, t, arguments.length >= 2, !0));
          }(function (s, a) {
            return s.push.apply(s, _toConsumableArray(a)), s;
          }), wc(null), function g2(e, t) {
            var n = arguments.length >= 2;
            return function (r) {
              return r.pipe(e ? tr(function (o, i) {
                return e(o, i, r);
              }) : dr, kp(1), n ? wc(t) : tb(function () {
                return new yc();
              }));
            };
          }(), Ge(function (s) {
            if (null === s) return li(r);
            var a = Vb(s);
            return function tU(e) {
              e.sort(function (t, n) {
                return t.value.outlet === U ? -1 : n.value.outlet === U ? 1 : t.value.outlet.localeCompare(n.value.outlet);
              });
            }(a), V(a);
          }));
        }
      }, {
        key: "processSegment",
        value: function processSegment(t, n, r, o, i, s, a) {
          var _this79 = this;
          return qe(n).pipe(Fs(function (u) {
            var _u$_injector;
            return _this79.processSegmentAgainstRoute((_u$_injector = u._injector) !== null && _u$_injector !== void 0 ? _u$_injector : t, n, u, r, o, i, s, a).pipe(oi(function (c) {
              if (c instanceof Kp) return V(null);
              throw c;
            }));
          }), Ur(function (u) {
            return !!u;
          }), oi(function (u) {
            if (Pb(u)) return function YB(e, t, n) {
              return 0 === t.length && !e.children[n];
            }(r, o, i) ? V(new JB()) : li(r);
            throw u;
          }));
        }
      }, {
        key: "processSegmentAgainstRoute",
        value: function processSegmentAgainstRoute(t, n, r, o, i, s, a, u) {
          return Zt(r) === s || s !== U && Lc(o, i, r) ? void 0 === r.redirectTo ? this.matchSegmentAgainstRoute(t, o, r, i, s, u) : this.allowRedirects && a ? this.expandSegmentAgainstRouteUsingRedirect(t, o, n, r, i, s, u) : li(o) : li(o);
        }
      }, {
        key: "expandSegmentAgainstRouteUsingRedirect",
        value: function expandSegmentAgainstRouteUsingRedirect(t, n, r, o, i, s, a) {
          var _ref42,
            _o$component,
            _this80 = this;
          var _Lb = Lb(n, o, i),
            u = _Lb.matched,
            c = _Lb.parameters,
            l = _Lb.consumedSegments,
            d = _Lb.positionalParamSegments,
            h = _Lb.remainingSegments;
          if (!u) return li(n);
          "string" == typeof o.redirectTo && "/" === o.redirectTo[0] && (this.absoluteRedirectCount++, this.absoluteRedirectCount > 31 && (this.allowRedirects = !1));
          var f = new kc(i, c, Object.freeze(_objectSpread({}, this.urlTree.queryParams)), this.urlTree.fragment, Bb(o), Zt(o), (_ref42 = (_o$component = o.component) !== null && _o$component !== void 0 ? _o$component : o._loadedComponent) !== null && _ref42 !== void 0 ? _ref42 : null, o, Ub(o)),
            p = xc(f, a, this.paramsInheritanceStrategy);
          f.params = Object.freeze(p.params), f.data = Object.freeze(p.data);
          var g = this.applyRedirects.applyRedirectCommands(l, o.redirectTo, d, f, t);
          return this.applyRedirects.lineralizeSegments(o, g).pipe(Ge(function (m) {
            return _this80.processSegment(t, r, n, m.concat(h), s, !1, a);
          }));
        }
      }, {
        key: "matchSegmentAgainstRoute",
        value: function matchSegmentAgainstRoute(t, n, r, o, i, s) {
          var _this81 = this;
          var a = zB(n, r, o, t);
          return "**" === r.path && (n.children = {}), a.pipe(fn(function (u) {
            var _r$_injector;
            return u.matched ? _this81.getChildConfig(t = (_r$_injector = r._injector) !== null && _r$_injector !== void 0 ? _r$_injector : t, r, o).pipe(fn(function (_ref43) {
              var _r$_loadedInjector, _ref44, _r$component;
              var c = _ref43.routes;
              var l = (_r$_loadedInjector = r._loadedInjector) !== null && _r$_loadedInjector !== void 0 ? _r$_loadedInjector : t,
                d = u.parameters,
                h = u.consumedSegments,
                f = u.remainingSegments,
                p = new kc(h, d, Object.freeze(_objectSpread({}, _this81.urlTree.queryParams)), _this81.urlTree.fragment, Bb(r), Zt(r), (_ref44 = (_r$component = r.component) !== null && _r$component !== void 0 ? _r$component : r._loadedComponent) !== null && _ref44 !== void 0 ? _ref44 : null, r, Ub(r)),
                g = xc(p, s, _this81.paramsInheritanceStrategy);
              p.params = Object.freeze(g.params), p.data = Object.freeze(g.data);
              var _jb = jb(n, h, f, c),
                m = _jb.segmentGroup,
                D = _jb.slicedSegments;
              if (0 === D.length && m.hasChildren()) return _this81.processChildren(l, c, m, p).pipe(Y(function (_) {
                return new Qt(p, _);
              }));
              if (0 === c.length && 0 === D.length) return V(new Qt(p, []));
              var y = Zt(r) === i;
              return _this81.processSegment(l, c, m, D, y ? U : i, !0, p).pipe(Y(function (_) {
                return new Qt(p, _ instanceof Qt ? [_] : []);
              }));
            })) : li(n);
          }));
        }
      }, {
        key: "getChildConfig",
        value: function getChildConfig(t, n, r) {
          var _this82 = this;
          return n.children ? V({
            routes: n.children,
            injector: t
          }) : n.loadChildren ? void 0 !== n._loadedRoutes ? V({
            routes: n._loadedRoutes,
            injector: n._loadedInjector
          }) : function VB(e, t, n, r) {
            var o = t.canLoad;
            return void 0 === o || 0 === o.length ? V(!0) : V(o.map(function (s) {
              var a = ui(s, e);
              return rr(function bB(e) {
                return e && Qs(e.canLoad);
              }(a) ? a.canLoad(t, n) : Ft(e, function () {
                return a(t, n);
              }));
            })).pipe(ci(), Fb());
          }(t, n, r).pipe(Ge(function (o) {
            return o ? _this82.configLoader.loadChildren(t, n).pipe(tt(function (i) {
              n._loadedRoutes = i.routes, n._loadedInjector = i.injector;
            })) : function HB() {
              return Dc(xb(!1, Ct.GuardRejected));
            }();
          })) : V({
            routes: [],
            injector: t
          });
        }
      }]);
    }();
    function nU(e) {
      var t = e.value.routeConfig;
      return t && "" === t.path;
    }
    function Vb(e) {
      var t = [],
        n = new Set();
      var _iterator43 = _createForOfIteratorHelper(e),
        _step43;
      try {
        var _loop7 = function _loop7() {
          var _o$children;
          var r = _step43.value;
          if (!nU(r)) {
            t.push(r);
            return 1; // continue
          }
          var o = t.find(function (i) {
            return r.value.routeConfig === i.value.routeConfig;
          });
          void 0 !== o ? ((_o$children = o.children).push.apply(_o$children, _toConsumableArray(r.children)), n.add(o)) : t.push(r);
        };
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          if (_loop7()) continue;
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
      var _iterator44 = _createForOfIteratorHelper(n),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var r = _step44.value;
          var o = Vb(r.children);
          t.push(new Qt(r.value, o));
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      return t.filter(function (r) {
        return !n.has(r);
      });
    }
    function Bb(e) {
      return e.data || {};
    }
    function Ub(e) {
      return e.resolve || {};
    }
    function Hb(e) {
      var t = e.children.map(function (n) {
        return Hb(n);
      }).flat();
      return [e].concat(_toConsumableArray(t));
    }
    function tg(e) {
      return fn(function (t) {
        var n = e(t);
        return n ? qe(n).pipe(Y(function () {
          return t;
        })) : V(t);
      });
    }
    var $b = function (_e39) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
          }
          return _createClass(e, [{
            key: "buildTitle",
            value: function buildTitle(n) {
              var r,
                o = n.root;
              for (; void 0 !== o;) {
                var _this$getResolvedTitl;
                r = (_this$getResolvedTitl = this.getResolvedTitleForRoute(o)) !== null && _this$getResolvedTitl !== void 0 ? _this$getResolvedTitl : r, o = o.children.find(function (i) {
                  return i.outlet === U;
                });
              }
              return r;
            }
          }, {
            key: "getResolvedTitleForRoute",
            value: function getResolvedTitleForRoute(n) {
              return n.data[js];
            }
          }]);
        }();
        _e39 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e39)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e39,
          factory: function factory() {
            return w(uU);
          },
          providedIn: "root"
        }));
        return e;
      }(),
      uU = function (_e40) {
        var e = /*#__PURE__*/function (_$b) {
          function e(n) {
            var _this83;
            _classCallCheck(this, e);
            _this83 = _callSuper(this, e), _defineProperty(_assertThisInitialized(_this83), "title", void 0), _assertThisInitialized(_this83), _this83.title = n;
            return _this83;
          }
          _inherits(e, _$b);
          return _createClass(e, [{
            key: "updateTitle",
            value: function updateTitle(n) {
              var r = this.buildTitle(n);
              void 0 !== r && this.title.setTitle(r);
            }
          }]);
        }($b);
        _e40 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e40)(T(v2));
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e40,
          factory: _e40.ɵfac,
          providedIn: "root"
        }));
        return e;
      }();
    var jc = new I("", {
        providedIn: "root",
        factory: function factory() {
          return {};
        }
      }),
      ng = new I("");
    var zb = function (_e41) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
          _defineProperty(this, "componentLoaders", new WeakMap());
          _defineProperty(this, "childrenLoaders", new WeakMap());
          _defineProperty(this, "onLoadStartListener", void 0);
          _defineProperty(this, "onLoadEndListener", void 0);
          _defineProperty(this, "compiler", w(cL));
        }
        return _createClass(e, [{
          key: "loadComponent",
          value: function loadComponent(n) {
            var _this84 = this;
            if (this.componentLoaders.get(n)) return this.componentLoaders.get(n);
            if (n._loadedComponent) return V(n._loadedComponent);
            this.onLoadStartListener && this.onLoadStartListener(n);
            var r = rr(n.loadComponent()).pipe(Y(qb), tt(function (i) {
                _this84.onLoadEndListener && _this84.onLoadEndListener(n), n._loadedComponent = i;
              }), Ec(function () {
                _this84.componentLoaders.delete(n);
              })),
              o = new eb(r, function () {
                return new $e();
              }).pipe(xp());
            return this.componentLoaders.set(n, o), o;
          }
        }, {
          key: "loadChildren",
          value: function loadChildren(n, r) {
            var _this85 = this;
            if (this.childrenLoaders.get(r)) return this.childrenLoaders.get(r);
            if (r._loadedRoutes) return V({
              routes: r._loadedRoutes,
              injector: r._loadedInjector
            });
            this.onLoadStartListener && this.onLoadStartListener(r);
            var i = function cU(e, t, n, r) {
                return rr(e.loadChildren()).pipe(Y(qb), Ge(function (o) {
                  return o instanceof Vw || Array.isArray(o) ? V(o) : qe(t.compileModuleAsync(o));
                }), Y(function (o) {
                  r && r(e);
                  var i,
                    s,
                    a = !1;
                  return Array.isArray(o) ? (s = o, !0) : (i = o.create(n).injector, s = i.get(ng, [], {
                    optional: !0,
                    self: !0
                  }).flat()), {
                    routes: s.map(Yp),
                    injector: i
                  };
                }));
              }(r, this.compiler, n, this.onLoadEndListener).pipe(Ec(function () {
                _this85.childrenLoaders.delete(r);
              })),
              s = new eb(i, function () {
                return new $e();
              }).pipe(xp());
            return this.childrenLoaders.set(r, s), s;
          }
        }]);
      }();
      _e41 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e41)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e41,
        factory: _e41.ɵfac,
        providedIn: "root"
      }));
      return e;
    }();
    function qb(e) {
      return function lU(e) {
        return e && "object" == _typeof(e) && "default" in e;
      }(e) ? e.default : e;
    }
    var rg = function (_e42) {
        var e = /*#__PURE__*/_createClass(function e() {
          _classCallCheck(this, e);
        });
        _e42 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e42)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e42,
          factory: function factory() {
            return w(dU);
          },
          providedIn: "root"
        }));
        return e;
      }(),
      dU = function (_e43) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
          }
          return _createClass(e, [{
            key: "shouldProcessUrl",
            value: function shouldProcessUrl(n) {
              return !0;
            }
          }, {
            key: "extract",
            value: function extract(n) {
              return n;
            }
          }, {
            key: "merge",
            value: function merge(n, r) {
              return n;
            }
          }]);
        }();
        _e43 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e43)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e43,
          factory: _e43.ɵfac,
          providedIn: "root"
        }));
        return e;
      }();
    var fU = new I(""),
      gU = new I("");
    var mU = function (_e44) {
      var e = /*#__PURE__*/function () {
        function e() {
          var _this86 = this;
          _classCallCheck(this, e);
          _defineProperty(this, "currentNavigation", null);
          _defineProperty(this, "currentTransition", null);
          _defineProperty(this, "lastSuccessfulNavigation", null);
          _defineProperty(this, "events", new $e());
          _defineProperty(this, "transitionAbortSubject", new $e());
          _defineProperty(this, "configLoader", w(zb));
          _defineProperty(this, "environmentInjector", w(at));
          _defineProperty(this, "destroyRef", w(Bt));
          _defineProperty(this, "urlSerializer", w(Ic));
          _defineProperty(this, "rootContexts", w(qs));
          _defineProperty(this, "location", w(Os));
          _defineProperty(this, "inputBindingEnabled", null !== w(Qp, {
            optional: !0
          }));
          _defineProperty(this, "titleStrategy", w($b));
          _defineProperty(this, "options", w(jc, {
            optional: !0
          }) || {});
          _defineProperty(this, "paramsInheritanceStrategy", this.options.paramsInheritanceStrategy || "emptyOnly");
          _defineProperty(this, "urlHandlingStrategy", w(rg));
          _defineProperty(this, "createViewTransition", w(fU, {
            optional: !0
          }));
          _defineProperty(this, "navigationErrorHandler", w(gU, {
            optional: !0
          }));
          _defineProperty(this, "navigationId", 0);
          _defineProperty(this, "transitions", void 0);
          _defineProperty(this, "afterPreactivation", function () {
            return V(void 0);
          });
          _defineProperty(this, "rootComponentType", null);
          _defineProperty(this, "destroyed", !1);
          this.configLoader.onLoadEndListener = function (o) {
            return _this86.events.next(new eB(o));
          }, this.configLoader.onLoadStartListener = function (o) {
            return _this86.events.next(new X2(o));
          }, this.destroyRef.onDestroy(function () {
            _this86.destroyed = !0;
          });
        }
        return _createClass(e, [{
          key: "hasRequestedNavigation",
          get: function get() {
            return 0 !== this.navigationId;
          }
        }, {
          key: "complete",
          value: function complete() {
            var _this$transitions;
            (_this$transitions = this.transitions) === null || _this$transitions === void 0 || _this$transitions.complete();
          }
        }, {
          key: "handleNavigationRequest",
          value: function handleNavigationRequest(n) {
            var _this$transitions2;
            var r = ++this.navigationId;
            (_this$transitions2 = this.transitions) === null || _this$transitions2 === void 0 || _this$transitions2.next(_objectSpread(_objectSpread({}, n), {}, {
              extractedUrl: this.urlHandlingStrategy.extract(n.rawUrl),
              targetSnapshot: null,
              targetRouterState: null,
              guards: {
                canActivateChecks: [],
                canDeactivateChecks: []
              },
              guardsResult: null,
              id: r
            }));
          }
        }, {
          key: "setupNavigations",
          value: function setupNavigations(n) {
            var _this87 = this;
            return this.transitions = new _t(null), this.transitions.pipe(tr(function (r) {
              return null !== r;
            }), fn(function (r) {
              var o = !1,
                i = !1;
              return V(r).pipe(fn(function (s) {
                var _s$extras$onSameUrlNa;
                if (_this87.navigationId > r.id) return _this87.cancelNavigationTransition(r, "", Ct.SupersededByNewNavigation), Wt;
                _this87.currentTransition = r, _this87.currentNavigation = {
                  id: s.id,
                  initialUrl: s.rawUrl,
                  extractedUrl: s.extractedUrl,
                  targetBrowserUrl: "string" == typeof s.extras.browserUrl ? _this87.urlSerializer.parse(s.extras.browserUrl) : s.extras.browserUrl,
                  trigger: s.source,
                  extras: s.extras,
                  previousNavigation: _this87.lastSuccessfulNavigation ? _objectSpread(_objectSpread({}, _this87.lastSuccessfulNavigation), {}, {
                    previousNavigation: null
                  }) : null
                };
                var a = !n.navigated || _this87.isUpdatingInternalState() || _this87.isUpdatedBrowserUrl();
                if (!a && "reload" !== ((_s$extras$onSameUrlNa = s.extras.onSameUrlNavigation) !== null && _s$extras$onSameUrlNa !== void 0 ? _s$extras$onSameUrlNa : n.onSameUrlNavigation)) {
                  var c = "";
                  return _this87.events.next(new $s(s.id, _this87.urlSerializer.serialize(s.rawUrl), c, Bp.IgnoredSameUrlNavigation)), s.resolve(!1), Wt;
                }
                if (_this87.urlHandlingStrategy.shouldProcessUrl(s.rawUrl)) return V(s).pipe(fn(function (c) {
                  return _this87.events.next(new Vp(c.id, _this87.urlSerializer.serialize(c.extractedUrl), c.source, c.restoredState)), c.id !== _this87.navigationId ? Wt : Promise.resolve(c);
                }), function rU(e, t, n, r, o, i) {
                  return Ge(function (s) {
                    return function KB(e, t, n, r, o, i) {
                      var s = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "emptyOnly";
                      return new eU(e, t, n, r, o, s, i).recognize();
                    }(e, t, n, r, s.extractedUrl, o, i).pipe(Y(function (_ref45) {
                      var a = _ref45.state,
                        u = _ref45.tree;
                      return _objectSpread(_objectSpread({}, s), {}, {
                        targetSnapshot: a,
                        urlAfterRedirects: u
                      });
                    }));
                  });
                }(_this87.environmentInjector, _this87.configLoader, _this87.rootComponentType, n.config, _this87.urlSerializer, _this87.paramsInheritanceStrategy), tt(function (c) {
                  r.targetSnapshot = c.targetSnapshot, r.urlAfterRedirects = c.urlAfterRedirects, _this87.currentNavigation = _objectSpread(_objectSpread({}, _this87.currentNavigation), {}, {
                    finalUrl: c.urlAfterRedirects
                  });
                  var l = new Ib(c.id, _this87.urlSerializer.serialize(c.extractedUrl), _this87.urlSerializer.serialize(c.urlAfterRedirects), c.targetSnapshot);
                  _this87.events.next(l);
                }));
                if (a && _this87.urlHandlingStrategy.shouldProcessUrl(s.currentRawUrl)) {
                  var _c7 = s.id,
                    l = s.extractedUrl,
                    d = s.source,
                    h = s.restoredState,
                    f = s.extras,
                    p = new Vp(_c7, _this87.urlSerializer.serialize(l), d, h);
                  _this87.events.next(p);
                  var g = Mb(_this87.rootComponentType).snapshot;
                  return _this87.currentTransition = r = _objectSpread(_objectSpread({}, s), {}, {
                    targetSnapshot: g,
                    urlAfterRedirects: l,
                    extras: _objectSpread(_objectSpread({}, f), {}, {
                      skipLocationChange: !1,
                      replaceUrl: !1
                    })
                  }), _this87.currentNavigation.finalUrl = l, V(r);
                }
                {
                  var _c8 = "";
                  return _this87.events.next(new $s(s.id, _this87.urlSerializer.serialize(s.extractedUrl), _c8, Bp.IgnoredByUrlHandlingStrategy)), s.resolve(!1), Wt;
                }
              }), tt(function (s) {
                var a = new Q2(s.id, _this87.urlSerializer.serialize(s.extractedUrl), _this87.urlSerializer.serialize(s.urlAfterRedirects), s.targetSnapshot);
                _this87.events.next(a);
              }), Y(function (s) {
                return _this87.currentTransition = r = _objectSpread(_objectSpread({}, s), {}, {
                  guards: wB(s.targetSnapshot, s.currentSnapshot, _this87.rootContexts)
                }), r;
              }), function AB(e, t) {
                return Ge(function (n) {
                  var r = n.targetSnapshot,
                    o = n.currentSnapshot,
                    _n$guards = n.guards,
                    i = _n$guards.canActivateChecks,
                    s = _n$guards.canDeactivateChecks;
                  return 0 === s.length && 0 === i.length ? V(_objectSpread(_objectSpread({}, n), {}, {
                    guardsResult: !0
                  })) : function xB(e, t, n, r) {
                    return qe(e).pipe(Ge(function (o) {
                      return function jB(e, t, n, r, o) {
                        var i = t && t.routeConfig ? t.routeConfig.canDeactivate : null;
                        return i && 0 !== i.length ? V(i.map(function (a) {
                          var _zs2;
                          var u = (_zs2 = zs(t)) !== null && _zs2 !== void 0 ? _zs2 : o,
                            c = ui(a, u);
                          return rr(function TB(e) {
                            return e && Qs(e.canDeactivate);
                          }(c) ? c.canDeactivate(e, t, n, r) : Ft(u, function () {
                            return c(e, t, n, r);
                          })).pipe(Ur());
                        })).pipe(ci()) : V(!0);
                      }(o.component, o.route, n, t, r);
                    }), Ur(function (o) {
                      return !0 !== o;
                    }, !0));
                  }(s, r, o, e).pipe(Ge(function (a) {
                    return a && function _B(e) {
                      return "boolean" == typeof e;
                    }(a) ? function kB(e, t, n, r) {
                      return qe(t).pipe(Fs(function (o) {
                        return Ap(function PB(e, t) {
                          return null !== e && t && t(new tB(e)), V(!0);
                        }(o.route.parent, r), function OB(e, t) {
                          return null !== e && t && t(new rB(e)), V(!0);
                        }(o.route, r), function LB(e, t, n) {
                          var r = t[t.length - 1],
                            i = t.slice(0, t.length - 1).reverse().map(function (s) {
                              return function EB(e) {
                                var t = e.routeConfig ? e.routeConfig.canActivateChild : null;
                                return t && 0 !== t.length ? {
                                  node: e,
                                  guards: t
                                } : null;
                              }(s);
                            }).filter(function (s) {
                              return null !== s;
                            }).map(function (s) {
                              return X_(function () {
                                return V(s.guards.map(function (u) {
                                  var _zs3;
                                  var c = (_zs3 = zs(s.node)) !== null && _zs3 !== void 0 ? _zs3 : n,
                                    l = ui(u, c);
                                  return rr(function SB(e) {
                                    return e && Qs(e.canActivateChild);
                                  }(l) ? l.canActivateChild(r, e) : Ft(c, function () {
                                    return l(r, e);
                                  })).pipe(Ur());
                                })).pipe(ci());
                              });
                            });
                          return V(i).pipe(ci());
                        }(e, o.path, n), function FB(e, t, n) {
                          var r = t.routeConfig ? t.routeConfig.canActivate : null;
                          if (!r || 0 === r.length) return V(!0);
                          var o = r.map(function (i) {
                            return X_(function () {
                              var _zs4;
                              var s = (_zs4 = zs(t)) !== null && _zs4 !== void 0 ? _zs4 : n,
                                a = ui(i, s);
                              return rr(function MB(e) {
                                return e && Qs(e.canActivate);
                              }(a) ? a.canActivate(t, e) : Ft(s, function () {
                                return a(t, e);
                              })).pipe(Ur());
                            });
                          });
                          return V(o).pipe(ci());
                        }(e, o.route, n));
                      }), Ur(function (o) {
                        return !0 !== o;
                      }, !0));
                    }(r, i, e, t) : V(a);
                  }), Y(function (a) {
                    return _objectSpread(_objectSpread({}, n), {}, {
                      guardsResult: a
                    });
                  }));
                });
              }(_this87.environmentInjector, function (s) {
                return _this87.events.next(s);
              }), tt(function (s) {
                if (r.guardsResult = s.guardsResult, s.guardsResult && "boolean" != typeof s.guardsResult) throw Oc(0, s.guardsResult);
                var a = new Y2(s.id, _this87.urlSerializer.serialize(s.extractedUrl), _this87.urlSerializer.serialize(s.urlAfterRedirects), s.targetSnapshot, !!s.guardsResult);
                _this87.events.next(a);
              }), tr(function (s) {
                return !!s.guardsResult || (_this87.cancelNavigationTransition(s, "", Ct.GuardRejected), !1);
              }), tg(function (s) {
                if (0 !== s.guards.canActivateChecks.length) return V(s).pipe(tt(function (a) {
                  var u = new J2(a.id, _this87.urlSerializer.serialize(a.extractedUrl), _this87.urlSerializer.serialize(a.urlAfterRedirects), a.targetSnapshot);
                  _this87.events.next(u);
                }), fn(function (a) {
                  var u = !1;
                  return V(a).pipe(function oU(e, t) {
                    return Ge(function (n) {
                      var r = n.targetSnapshot,
                        o = n.guards.canActivateChecks;
                      if (!o.length) return V(n);
                      var i = new Set(o.map(function (u) {
                          return u.route;
                        })),
                        s = new Set();
                      var _iterator45 = _createForOfIteratorHelper(i),
                        _step45;
                      try {
                        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
                          var _u9 = _step45.value;
                          if (!s.has(_u9)) {
                            var _iterator46 = _createForOfIteratorHelper(Hb(_u9)),
                              _step46;
                            try {
                              for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                                var c = _step46.value;
                                s.add(c);
                              }
                            } catch (err) {
                              _iterator46.e(err);
                            } finally {
                              _iterator46.f();
                            }
                          }
                        }
                      } catch (err) {
                        _iterator45.e(err);
                      } finally {
                        _iterator45.f();
                      }
                      var a = 0;
                      return qe(s).pipe(Fs(function (u) {
                        return i.has(u) ? function iU(e, t, n, r) {
                          var o = e.routeConfig,
                            i = e._resolve;
                          return void 0 !== (o === null || o === void 0 ? void 0 : o.title) && !Nb(o) && (i[js] = o.title), function sU(e, t, n, r) {
                            var o = Op(e);
                            if (0 === o.length) return V({});
                            var i = {};
                            return qe(o).pipe(Ge(function (s) {
                              return function aU(e, t, n, r, _zs5) {
                                var o = (_zs5 = zs(t)) !== null && _zs5 !== void 0 ? _zs5 : r,
                                  i = ui(e, o);
                                return rr(i.resolve ? i.resolve(t, n) : Ft(o, function () {
                                  return i(t, n);
                                }));
                              }(e[s], t, n, r).pipe(Ur(), tt(function (a) {
                                if (a instanceof Jp) throw Oc(new _c(), a);
                                i[s] = a;
                              }));
                            }), kp(1), Y(function () {
                              return i;
                            }), oi(function (s) {
                              return Pb(s) ? Wt : Dc(s);
                            }));
                          }(i, e, t, r).pipe(Y(function (s) {
                            return e._resolvedData = s, e.data = xc(e, e.parent, n).resolve, null;
                          }));
                        }(u, r, e, t) : (u.data = xc(u, u.parent, e).resolve, V(void 0));
                      }), tt(function () {
                        return a++;
                      }), kp(1), Ge(function (u) {
                        return a === s.size ? V(n) : Wt;
                      }));
                    });
                  }(_this87.paramsInheritanceStrategy, _this87.environmentInjector), tt({
                    next: function next() {
                      return u = !0;
                    },
                    complete: function complete() {
                      u || _this87.cancelNavigationTransition(a, "", Ct.NoDataFromResolver);
                    }
                  }));
                }), tt(function (a) {
                  var u = new K2(a.id, _this87.urlSerializer.serialize(a.extractedUrl), _this87.urlSerializer.serialize(a.urlAfterRedirects), a.targetSnapshot);
                  _this87.events.next(u);
                }));
              }), tg(function (s) {
                var _a10 = function a(u) {
                  var _u$routeConfig;
                  var c = [];
                  ((_u$routeConfig = u.routeConfig) === null || _u$routeConfig === void 0 ? void 0 : _u$routeConfig.loadComponent) && !u.routeConfig._loadedComponent && c.push(_this87.configLoader.loadComponent(u.routeConfig).pipe(tt(function (l) {
                    u.component = l;
                  }), Y(function () {})));
                  var _iterator47 = _createForOfIteratorHelper(u.children),
                    _step47;
                  try {
                    for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
                      var l = _step47.value;
                      c.push.apply(c, _toConsumableArray(_a10(l)));
                    }
                  } catch (err) {
                    _iterator47.e(err);
                  } finally {
                    _iterator47.f();
                  }
                  return c;
                };
                return J_(_a10(s.targetSnapshot.root)).pipe(wc(null), ri(1));
              }), tg(function () {
                return _this87.afterPreactivation();
              }), fn(function () {
                var _this87$createViewTra;
                var _r17 = r,
                  s = _r17.currentSnapshot,
                  a = _r17.targetSnapshot,
                  u = (_this87$createViewTra = _this87.createViewTransition) === null || _this87$createViewTra === void 0 ? void 0 : _this87$createViewTra.call(_this87, _this87.environmentInjector, s.root, a.root);
                return u ? qe(u).pipe(Y(function () {
                  return r;
                })) : V(r);
              }), Y(function (s) {
                var a = function pB(e, t, n) {
                  var r = Gs(e, t._root, n ? n._root : void 0);
                  return new bb(r, t);
                }(n.routeReuseStrategy, s.targetSnapshot, s.currentRouterState);
                return _this87.currentTransition = r = _objectSpread(_objectSpread({}, s), {}, {
                  targetRouterState: a
                }), _this87.currentNavigation.targetRouterState = a, r;
              }), tt(function () {
                _this87.events.next(new Hp());
              }), function (_e45, t, n, r) {
                return Y(function (o) {
                  return new DB(t, o.targetRouterState, o.currentRouterState, n, r).activate(_e45), o;
                });
              }(_this87.rootContexts, n.routeReuseStrategy, function (s) {
                return _this87.events.next(s);
              }, _this87.inputBindingEnabled), ri(1), tt({
                next: function next(s) {
                  var _this87$titleStrategy;
                  o = !0, _this87.lastSuccessfulNavigation = _this87.currentNavigation, _this87.events.next(new qr(s.id, _this87.urlSerializer.serialize(s.extractedUrl), _this87.urlSerializer.serialize(s.urlAfterRedirects))), (_this87$titleStrategy = _this87.titleStrategy) !== null && _this87$titleStrategy !== void 0 && _this87$titleStrategy.updateTitle(s.targetRouterState.snapshot), s.resolve(!0);
                },
                complete: function complete() {
                  o = !0;
                }
              }), function m2(e) {
                return Le(function (t, n) {
                  dn(e).subscribe(ke(n, function () {
                    return n.complete();
                  }, hl)), !n.closed && t.subscribe(n);
                });
              }(_this87.transitionAbortSubject.pipe(tt(function (s) {
                throw s;
              }))), Ec(function () {
                var _this87$currentTransi;
                !o && !i && _this87.cancelNavigationTransition(r, "", Ct.SupersededByNewNavigation), ((_this87$currentTransi = _this87.currentTransition) === null || _this87$currentTransi === void 0 ? void 0 : _this87$currentTransi.id) === r.id && (_this87.currentNavigation = null, _this87.currentTransition = null);
              }), oi(function (s) {
                if (_this87.destroyed) return r.resolve(!1), Wt;
                if (i = !0, kb(s)) _this87.events.next(new Gr(r.id, _this87.urlSerializer.serialize(r.extractedUrl), s.message, s.cancellationCode)), function vB(e) {
                  return kb(e) && zr(e.url);
                }(s) ? _this87.events.next(new Ac(s.url, s.navigationBehaviorOptions)) : r.resolve(!1);else {
                  var _r$targetSnapshot;
                  var a = new Up(r.id, _this87.urlSerializer.serialize(r.extractedUrl), s, (_r$targetSnapshot = r.targetSnapshot) !== null && _r$targetSnapshot !== void 0 ? _r$targetSnapshot : void 0);
                  try {
                    var u = Ft(_this87.environmentInjector, function () {
                      var _this87$navigationErr;
                      return (_this87$navigationErr = _this87.navigationErrorHandler) === null || _this87$navigationErr === void 0 ? void 0 : _this87$navigationErr.call(_this87, a);
                    });
                    if (!(u instanceof Jp)) throw _this87.events.next(a), s;
                    {
                      var _Oc = Oc(0, u),
                        c = _Oc.message,
                        l = _Oc.cancellationCode;
                      _this87.events.next(new Gr(r.id, _this87.urlSerializer.serialize(r.extractedUrl), c, l)), _this87.events.next(new Ac(u.redirectTo, u.navigationBehaviorOptions));
                    }
                  } catch (u) {
                    _this87.options.resolveNavigationPromiseOnError ? r.resolve(!1) : r.reject(u);
                  }
                }
                return Wt;
              }));
            }));
          }
        }, {
          key: "cancelNavigationTransition",
          value: function cancelNavigationTransition(n, r, o) {
            var i = new Gr(n.id, this.urlSerializer.serialize(n.extractedUrl), r, o);
            this.events.next(i), n.resolve(!1);
          }
        }, {
          key: "isUpdatingInternalState",
          value: function isUpdatingInternalState() {
            var _this$currentTransiti, _this$currentTransiti2;
            return ((_this$currentTransiti = this.currentTransition) === null || _this$currentTransiti === void 0 ? void 0 : _this$currentTransiti.extractedUrl.toString()) !== ((_this$currentTransiti2 = this.currentTransition) === null || _this$currentTransiti2 === void 0 ? void 0 : _this$currentTransiti2.currentUrlTree.toString());
          }
        }, {
          key: "isUpdatedBrowserUrl",
          value: function isUpdatedBrowserUrl() {
            var _this$currentNavigati, _this$currentNavigati2, _this$currentNavigati3, _this$currentNavigati4;
            var n = this.urlHandlingStrategy.extract(this.urlSerializer.parse(this.location.path(!0))),
              r = (_this$currentNavigati = (_this$currentNavigati2 = this.currentNavigation) === null || _this$currentNavigati2 === void 0 ? void 0 : _this$currentNavigati2.targetBrowserUrl) !== null && _this$currentNavigati !== void 0 ? _this$currentNavigati : (_this$currentNavigati3 = this.currentNavigation) === null || _this$currentNavigati3 === void 0 ? void 0 : _this$currentNavigati3.extractedUrl;
            return n.toString() !== (r === null || r === void 0 ? void 0 : r.toString()) && !((_this$currentNavigati4 = this.currentNavigation) !== null && _this$currentNavigati4 !== void 0 && _this$currentNavigati4.extras.skipLocationChange);
          }
        }]);
      }();
      _e44 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e44)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e44,
        factory: _e44.ɵfac,
        providedIn: "root"
      }));
      return e;
    }();
    function vU(e) {
      return e !== Rc;
    }
    var Gb = function (_e46) {
      var e = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      });
      _e46 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e46)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e46,
        factory: function factory() {
          return w(DU);
        },
        providedIn: "root"
      }));
      return e;
    }();
    var yU = /*#__PURE__*/function () {
      function yU() {
        _classCallCheck(this, yU);
      }
      return _createClass(yU, [{
        key: "shouldDetach",
        value: function shouldDetach(t) {
          return !1;
        }
      }, {
        key: "store",
        value: function store(t, n) {}
      }, {
        key: "shouldAttach",
        value: function shouldAttach(t) {
          return !1;
        }
      }, {
        key: "retrieve",
        value: function retrieve(t) {
          return null;
        }
      }, {
        key: "shouldReuseRoute",
        value: function shouldReuseRoute(t, n) {
          return t.routeConfig === n.routeConfig;
        }
      }]);
    }();
    var DU = function (_e47) {
        var e = /*#__PURE__*/function (_yU) {
          function e() {
            _classCallCheck(this, e);
            return _callSuper(this, e, arguments);
          }
          _inherits(e, _yU);
          return _createClass(e);
        }(yU);
        _e47 = e;
        _defineProperty(e, "\u0275fac", function () {
          var n;
          return function (o) {
            return (n || (n = Dd(_e47)))(o || _e47);
          };
        }());
        _defineProperty(e, "\u0275prov", b({
          token: _e47,
          factory: _e47.ɵfac,
          providedIn: "root"
        }));
        return e;
      }(),
      Wb = function (_e48) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
            _defineProperty(this, "urlSerializer", w(Ic));
            _defineProperty(this, "options", w(jc, {
              optional: !0
            }) || {});
            _defineProperty(this, "canceledNavigationResolution", this.options.canceledNavigationResolution || "replace");
            _defineProperty(this, "location", w(Os));
            _defineProperty(this, "urlHandlingStrategy", w(rg));
            _defineProperty(this, "urlUpdateStrategy", this.options.urlUpdateStrategy || "deferred");
            _defineProperty(this, "currentUrlTree", new Hr());
            _defineProperty(this, "rawUrlTree", this.currentUrlTree);
            _defineProperty(this, "routerState", Mb(null));
            _defineProperty(this, "stateMemento", this.createStateMemento());
          }
          return _createClass(e, [{
            key: "getCurrentUrlTree",
            value: function getCurrentUrlTree() {
              return this.currentUrlTree;
            }
          }, {
            key: "getRawUrlTree",
            value: function getRawUrlTree() {
              return this.rawUrlTree;
            }
          }, {
            key: "createBrowserPath",
            value: function createBrowserPath(_ref46) {
              var n = _ref46.finalUrl,
                r = _ref46.initialUrl,
                o = _ref46.targetBrowserUrl;
              var i = void 0 !== n ? this.urlHandlingStrategy.merge(n, r) : r,
                s = o !== null && o !== void 0 ? o : i;
              return s instanceof Hr ? this.urlSerializer.serialize(s) : s;
            }
          }, {
            key: "commitTransition",
            value: function commitTransition(_ref47) {
              var n = _ref47.targetRouterState,
                r = _ref47.finalUrl,
                o = _ref47.initialUrl;
              r && n ? (this.currentUrlTree = r, this.rawUrlTree = this.urlHandlingStrategy.merge(r, o), this.routerState = n) : this.rawUrlTree = o;
            }
          }, {
            key: "getRouterState",
            value: function getRouterState() {
              return this.routerState;
            }
          }, {
            key: "updateStateMemento",
            value: function updateStateMemento() {
              this.stateMemento = this.createStateMemento();
            }
          }, {
            key: "createStateMemento",
            value: function createStateMemento() {
              return {
                rawUrlTree: this.rawUrlTree,
                currentUrlTree: this.currentUrlTree,
                routerState: this.routerState
              };
            }
          }, {
            key: "resetInternalState",
            value: function resetInternalState(_ref48) {
              var n = _ref48.finalUrl;
              this.routerState = this.stateMemento.routerState, this.currentUrlTree = this.stateMemento.currentUrlTree, this.rawUrlTree = this.urlHandlingStrategy.merge(this.currentUrlTree, n !== null && n !== void 0 ? n : this.rawUrlTree);
            }
          }]);
        }();
        _e48 = e;
        _defineProperty(e, "\u0275fac", function (r) {
          return new (r || _e48)();
        });
        _defineProperty(e, "\u0275prov", b({
          token: _e48,
          factory: function factory() {
            return w(wU);
          },
          providedIn: "root"
        }));
        return e;
      }(),
      wU = function (_e49) {
        var e = /*#__PURE__*/function (_Wb) {
          function e() {
            var _this88;
            _classCallCheck(this, e);
            for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
              args[_key10] = arguments[_key10];
            }
            _this88 = _callSuper(this, e, [].concat(args));
            _defineProperty(_this88, "currentPageId", 0);
            _defineProperty(_this88, "lastSuccessfulId", -1);
            return _this88;
          }
          _inherits(e, _Wb);
          return _createClass(e, [{
            key: "restoredState",
            value: function restoredState() {
              return this.location.getState();
            }
          }, {
            key: "browserPageId",
            get: function get() {
              var _this$restoredState$ɵ, _this$restoredState;
              return "computed" !== this.canceledNavigationResolution ? this.currentPageId : (_this$restoredState$ɵ = (_this$restoredState = this.restoredState()) === null || _this$restoredState === void 0 ? void 0 : _this$restoredState.ɵrouterPageId) !== null && _this$restoredState$ɵ !== void 0 ? _this$restoredState$ɵ : this.currentPageId;
            }
          }, {
            key: "registerNonRouterCurrentEntryChangeListener",
            value: function registerNonRouterCurrentEntryChangeListener(n) {
              return this.location.subscribe(function (r) {
                "popstate" === r.type && setTimeout(function () {
                  n(r.url, r.state, "popstate");
                });
              });
            }
          }, {
            key: "handleRouterEvent",
            value: function handleRouterEvent(n, r) {
              n instanceof Vp ? this.updateStateMemento() : n instanceof $s ? this.commitTransition(r) : n instanceof Ib ? "eager" === this.urlUpdateStrategy && (r.extras.skipLocationChange || this.setBrowserUrl(this.createBrowserPath(r), r)) : n instanceof Hp ? (this.commitTransition(r), "deferred" === this.urlUpdateStrategy && !r.extras.skipLocationChange && this.setBrowserUrl(this.createBrowserPath(r), r)) : n instanceof Gr && (n.code === Ct.GuardRejected || n.code === Ct.NoDataFromResolver) ? this.restoreHistory(r) : n instanceof Up ? this.restoreHistory(r, !0) : n instanceof qr && (this.lastSuccessfulId = n.id, this.currentPageId = this.browserPageId);
            }
          }, {
            key: "setBrowserUrl",
            value: function setBrowserUrl(n, _ref49) {
              var r = _ref49.extras,
                o = _ref49.id;
              var i = r.replaceUrl,
                s = r.state;
              if (this.location.isCurrentPathEqualTo(n) || i) {
                var a = this.browserPageId,
                  u = _objectSpread(_objectSpread({}, s), this.generateNgRouterState(o, a));
                this.location.replaceState(n, "", u);
              } else {
                var _a11 = _objectSpread(_objectSpread({}, s), this.generateNgRouterState(o, this.browserPageId + 1));
                this.location.go(n, "", _a11);
              }
            }
          }, {
            key: "restoreHistory",
            value: function restoreHistory(n) {
              var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              if ("computed" === this.canceledNavigationResolution) {
                var i = this.currentPageId - this.browserPageId;
                0 !== i ? this.location.historyGo(i) : this.getCurrentUrlTree() === n.finalUrl && 0 === i && (this.resetInternalState(n), this.resetUrlToCurrentUrlTree());
              } else "replace" === this.canceledNavigationResolution && (r && this.resetInternalState(n), this.resetUrlToCurrentUrlTree());
            }
          }, {
            key: "resetUrlToCurrentUrlTree",
            value: function resetUrlToCurrentUrlTree() {
              this.location.replaceState(this.urlSerializer.serialize(this.getRawUrlTree()), "", this.generateNgRouterState(this.lastSuccessfulId, this.currentPageId));
            }
          }, {
            key: "generateNgRouterState",
            value: function generateNgRouterState(n, r) {
              return "computed" === this.canceledNavigationResolution ? {
                navigationId: n,
                ɵrouterPageId: r
              } : {
                navigationId: n
              };
            }
          }]);
        }(Wb);
        _e49 = e;
        _defineProperty(e, "\u0275fac", function () {
          var n;
          return function (o) {
            return (n || (n = Dd(_e49)))(o || _e49);
          };
        }());
        _defineProperty(e, "\u0275prov", b({
          token: _e49,
          factory: _e49.ɵfac,
          providedIn: "root"
        }));
        return e;
      }();
    var CU = {
        paths: "exact",
        fragment: "ignored",
        matrixParams: "ignored",
        queryParams: "exact"
      },
      IU = {
        paths: "subset",
        fragment: "ignored",
        matrixParams: "ignored",
        queryParams: "subset"
      };
    var or = function (_e50) {
      var e = /*#__PURE__*/function () {
        function e() {
          var _w$flat,
            _w7,
            _this89 = this;
          _classCallCheck(this, e);
          _defineProperty(this, "disposed", !1);
          _defineProperty(this, "nonRouterCurrentEntryChangeSubscription", void 0);
          _defineProperty(this, "console", w(Eh));
          _defineProperty(this, "stateManager", w(Wb));
          _defineProperty(this, "options", w(jc, {
            optional: !0
          }) || {});
          _defineProperty(this, "pendingTasks", w(Hn));
          _defineProperty(this, "urlUpdateStrategy", this.options.urlUpdateStrategy || "deferred");
          _defineProperty(this, "navigationTransitions", w(mU));
          _defineProperty(this, "urlSerializer", w(Ic));
          _defineProperty(this, "location", w(Os));
          _defineProperty(this, "urlHandlingStrategy", w(rg));
          _defineProperty(this, "_events", new $e());
          _defineProperty(this, "navigated", !1);
          _defineProperty(this, "routeReuseStrategy", w(Gb));
          _defineProperty(this, "onSameUrlNavigation", this.options.onSameUrlNavigation || "ignore");
          _defineProperty(this, "config", (_w$flat = (_w7 = w(ng, {
            optional: !0
          })) === null || _w7 === void 0 ? void 0 : _w7.flat()) !== null && _w$flat !== void 0 ? _w$flat : []);
          _defineProperty(this, "componentInputBindingEnabled", !!w(Qp, {
            optional: !0
          }));
          _defineProperty(this, "eventsSubscription", new He());
          this.resetConfig(this.config), this.navigationTransitions.setupNavigations(this).subscribe({
            error: function error(n) {
              _this89.console.warn(n);
            }
          }), this.subscribeToNavigationEvents();
        }
        return _createClass(e, [{
          key: "currentUrlTree",
          get: function get() {
            return this.stateManager.getCurrentUrlTree();
          }
        }, {
          key: "rawUrlTree",
          get: function get() {
            return this.stateManager.getRawUrlTree();
          }
        }, {
          key: "events",
          get: function get() {
            return this._events;
          }
        }, {
          key: "routerState",
          get: function get() {
            return this.stateManager.getRouterState();
          }
        }, {
          key: "subscribeToNavigationEvents",
          value: function subscribeToNavigationEvents() {
            var _this90 = this;
            var n = this.navigationTransitions.events.subscribe(function (r) {
              try {
                var o = _this90.navigationTransitions.currentTransition,
                  i = _this90.navigationTransitions.currentNavigation;
                if (null !== o && null !== i) if (_this90.stateManager.handleRouterEvent(r, i), r instanceof Gr && r.code !== Ct.Redirect && r.code !== Ct.SupersededByNewNavigation) _this90.navigated = !0;else if (r instanceof qr) _this90.navigated = !0;else if (r instanceof Ac) {
                  var s = r.navigationBehaviorOptions,
                    a = _this90.urlHandlingStrategy.merge(r.url, o.currentRawUrl),
                    u = _objectSpread({
                      browserUrl: o.extras.browserUrl,
                      info: o.extras.info,
                      skipLocationChange: o.extras.skipLocationChange,
                      replaceUrl: o.extras.replaceUrl || "eager" === _this90.urlUpdateStrategy || vU(o.source)
                    }, s);
                  _this90.scheduleNavigation(a, Rc, null, u, {
                    resolve: o.resolve,
                    reject: o.reject,
                    promise: o.promise
                  });
                }
                (function bU(e) {
                  return !(e instanceof Hp || e instanceof Ac);
                })(r) && _this90._events.next(r);
              } catch (o) {
                _this90.navigationTransitions.transitionAbortSubject.next(o);
              }
            });
            this.eventsSubscription.add(n);
          }
        }, {
          key: "resetRootComponentType",
          value: function resetRootComponentType(n) {
            this.routerState.root.component = n, this.navigationTransitions.rootComponentType = n;
          }
        }, {
          key: "initialNavigation",
          value: function initialNavigation() {
            this.setUpLocationChangeListener(), this.navigationTransitions.hasRequestedNavigation || this.navigateToSyncWithBrowser(this.location.path(!0), Rc, this.stateManager.restoredState());
          }
        }, {
          key: "setUpLocationChangeListener",
          value: function setUpLocationChangeListener() {
            var _this$nonRouterCurren,
              _this91 = this;
            (_this$nonRouterCurren = this.nonRouterCurrentEntryChangeSubscription) !== null && _this$nonRouterCurren !== void 0 ? _this$nonRouterCurren : this.nonRouterCurrentEntryChangeSubscription = this.stateManager.registerNonRouterCurrentEntryChangeListener(function (n, r, o) {
              _this91.navigateToSyncWithBrowser(n, o, r);
            });
          }
        }, {
          key: "navigateToSyncWithBrowser",
          value: function navigateToSyncWithBrowser(n, r, o) {
            var i = {
                replaceUrl: !0
              },
              s = o !== null && o !== void 0 && o.navigationId ? o : null;
            if (o) {
              var u = _objectSpread({}, o);
              delete u.navigationId, delete u.ɵrouterPageId, 0 !== Object.keys(u).length && (i.state = u);
            }
            var a = this.parseUrl(n);
            this.scheduleNavigation(a, r, s, i);
          }
        }, {
          key: "url",
          get: function get() {
            return this.serializeUrl(this.currentUrlTree);
          }
        }, {
          key: "getCurrentNavigation",
          value: function getCurrentNavigation() {
            return this.navigationTransitions.currentNavigation;
          }
        }, {
          key: "lastSuccessfulNavigation",
          get: function get() {
            return this.navigationTransitions.lastSuccessfulNavigation;
          }
        }, {
          key: "resetConfig",
          value: function resetConfig(n) {
            this.config = n.map(Yp), this.navigated = !1;
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            this.dispose();
          }
        }, {
          key: "dispose",
          value: function dispose() {
            this._events.unsubscribe(), this.navigationTransitions.complete(), this.nonRouterCurrentEntryChangeSubscription && (this.nonRouterCurrentEntryChangeSubscription.unsubscribe(), this.nonRouterCurrentEntryChangeSubscription = void 0), this.disposed = !0, this.eventsSubscription.unsubscribe();
          }
        }, {
          key: "createUrlTree",
          value: function createUrlTree(n) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var o = r.relativeTo,
              i = r.queryParams,
              s = r.fragment,
              a = r.queryParamsHandling,
              u = r.preserveFragment,
              c = u ? this.currentUrlTree.fragment : s;
            var d,
              l = null;
            switch (a !== null && a !== void 0 ? a : this.options.defaultQueryParamsHandling) {
              case "merge":
                l = _objectSpread(_objectSpread({}, this.currentUrlTree.queryParams), i);
                break;
              case "preserve":
                l = this.currentUrlTree.queryParams;
                break;
              default:
                l = i || null;
            }
            null !== l && (l = this.removeEmptyProps(l));
            try {
              d = mb(o ? o.snapshot : this.routerState.snapshot.root);
            } catch (_unused2) {
              ("string" != typeof n[0] || "/" !== n[0][0]) && (n = []), d = this.currentUrlTree.root;
            }
            return vb(d, n, l, c !== null && c !== void 0 ? c : null);
          }
        }, {
          key: "navigateByUrl",
          value: function navigateByUrl(n) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              skipLocationChange: !1
            };
            var o = zr(n) ? n : this.parseUrl(n),
              i = this.urlHandlingStrategy.merge(o, this.rawUrlTree);
            return this.scheduleNavigation(i, Rc, null, r);
          }
        }, {
          key: "navigate",
          value: function navigate(n) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              skipLocationChange: !1
            };
            return function _U(e) {
              for (var t = 0; t < e.length; t++) if (null == e[t]) throw new E(4008, !1);
            }(n), this.navigateByUrl(this.createUrlTree(n, r), r);
          }
        }, {
          key: "serializeUrl",
          value: function serializeUrl(n) {
            return this.urlSerializer.serialize(n);
          }
        }, {
          key: "parseUrl",
          value: function parseUrl(n) {
            try {
              return this.urlSerializer.parse(n);
            } catch (_unused3) {
              return this.urlSerializer.parse("/");
            }
          }
        }, {
          key: "isActive",
          value: function isActive(n, r) {
            var o;
            if (o = !0 === r ? _objectSpread({}, CU) : !1 === r ? _objectSpread({}, IU) : r, zr(n)) return ab(this.currentUrlTree, n, o);
            var i = this.parseUrl(n);
            return ab(this.currentUrlTree, i, o);
          }
        }, {
          key: "removeEmptyProps",
          value: function removeEmptyProps(n) {
            return Object.entries(n).reduce(function (r, _ref50) {
              var _ref51 = _slicedToArray(_ref50, 2),
                o = _ref51[0],
                i = _ref51[1];
              return null != i && (r[o] = i), r;
            }, {});
          }
        }, {
          key: "scheduleNavigation",
          value: function scheduleNavigation(n, r, o, i, s) {
            var _this92 = this;
            if (this.disposed) return Promise.resolve(!1);
            var a, u, c;
            s ? (a = s.resolve, u = s.reject, c = s.promise) : c = new Promise(function (d, h) {
              a = d, u = h;
            });
            var l = this.pendingTasks.add();
            return function EU(e, t) {
              e.events.pipe(tr(function (n) {
                return n instanceof qr || n instanceof Gr || n instanceof Up || n instanceof $s;
              }), Y(function (n) {
                return n instanceof qr || n instanceof $s ? 0 : n instanceof Gr && (n.code === Ct.Redirect || n.code === Ct.SupersededByNewNavigation) ? 2 : 1;
              }), tr(function (n) {
                return 2 !== n;
              }), ri(1)).subscribe(function () {
                t();
              });
            }(this, function () {
              queueMicrotask(function () {
                return _this92.pendingTasks.remove(l);
              });
            }), this.navigationTransitions.handleNavigationRequest({
              source: r,
              restoredState: o,
              currentUrlTree: this.currentUrlTree,
              currentRawUrl: this.currentUrlTree,
              rawUrl: n,
              extras: i,
              resolve: a,
              reject: u,
              promise: c,
              currentSnapshot: this.routerState.snapshot,
              currentRouterState: this.routerState
            }), c.catch(function (d) {
              return Promise.reject(d);
            });
          }
        }]);
      }();
      _e50 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e50)();
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e50,
        factory: _e50.ɵfac,
        providedIn: "root"
      }));
      return e;
    }();
    var ig = new I("");
    function Qb(e) {
      return e.routerState.root;
    }
    function Yb() {
      var e = w(Be);
      return function (t) {
        var _e$get, _e$get2;
        var n = e.get(Et);
        if (t !== n.components[0]) return;
        var r = e.get(or),
          o = e.get(Jb);
        1 === e.get(sg) && r.initialNavigation(), (_e$get = e.get(Kb, null, $.Optional)) !== null && _e$get !== void 0 && _e$get.setUpPreloading(), (_e$get2 = e.get(ig, null, $.Optional)) !== null && _e$get2 !== void 0 && _e$get2.init(), r.resetRootComponentType(n.componentTypes[0]), o.closed || (o.next(), o.complete(), o.unsubscribe());
      };
    }
    var Jb = new I("", {
        factory: function factory() {
          return new $e();
        }
      }),
      sg = new I("", {
        providedIn: "root",
        factory: function factory() {
          return 1;
        }
      }),
      Kb = new I("");
    var Vc = function (_e51) {
      var e = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      });
      _e51 = e;
      _e51.ɵfac = function (r) {
        return new (r || _e51)();
      };
      _e51.ɵcmp = Nt({
        type: _e51,
        selectors: [["app-footer"]],
        decls: 3,
        vars: 0,
        consts: [[1, "absolute", "bottom-0", "w-full", "bg-linear-to-t", "from-black/20"], [1, "mx-auto", "w-[18.5625vh]", "py-[3.25vh]"], ["src", "images/mimms-logo-white.png", "alt", "Mimms Museum of Technology and Art"]],
        template: function template(r, o) {
          1 & r && (O(0, "footer", 0)(1, "div", 1), pe(2, "img", 2), N()());
        },
        encapsulation: 2
      });
      return e;
    }();
    var PU = ["canvas"];
    var eM = function (_e52) {
      var e = /*#__PURE__*/function () {
        function e() {
          var _this93 = this;
          _classCallCheck(this, e);
          this.muted = !1, this.playbackEnded = new ut(), this.animationFrameId = null, this.resizeCanvas = function () {
            var n = _this93.canvasRef.nativeElement;
            n.width = n.offsetWidth, n.height = n.offsetHeight;
          }, this.draw = function () {
            _this93.animationFrameId = requestAnimationFrame(_this93.draw), _this93.analyser.getByteFrequencyData(_this93.dataArray);
            var n = _this93.canvasRef.nativeElement,
              r = n.width,
              o = n.height;
            _this93.ctx.clearRect(0, 0, r, o);
            var i = o / 2,
              s = r / 2,
              a = Math.floor(_this93.dataArray.length / 6),
              c = Math.max(1, (r - 2 * (2 * a - 1)) / (2 * a));
            _this93.ctx.fillStyle = "white";
            for (var l = 0; l < a; l++) {
              var h = _this93.dataArray[l] / 255 * (o / 2),
                f = 2 * h,
                p = 0,
                g = l * (c + 2),
                D = s + 1 + g;
              _this93.drawRoundedRect(s - 1 - g - c, i - h, c, f, p), _this93.drawRoundedRect(D, i - h, c, f, p);
            }
          };
        }
        return _createClass(e, [{
          key: "ngAfterViewInit",
          value: function ngAfterViewInit() {
            this.ctx = this.canvasRef.nativeElement.getContext("2d", {
              alpha: !0
            }), this.resizeCanvas(), window.addEventListener("resize", this.resizeCanvas), this.audioCtx = new AudioContext(), this.analyser = this.audioCtx.createAnalyser(), this.analyser.fftSize = 256, this.dataArray = new Uint8Array(this.analyser.frequencyBinCount), this.loadAndPlay();
          }
        }, {
          key: "loadAndPlay",
          value: function loadAndPlay() {
            var n = this;
            return function mn(e) {
              return function () {
                var t = this,
                  n = arguments;
                return new Promise(function (r, o) {
                  var i = e.apply(t, n);
                  function s(u) {
                    ra(i, r, o, s, a, "next", u);
                  }
                  function a(u) {
                    ra(i, r, o, s, a, "throw", u);
                  }
                  s(void 0);
                });
              };
            }(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              var o, i, s;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return fetch(n.audioUrl);
                  case 2:
                    _context3.next = 4;
                    return _context3.sent.arrayBuffer();
                  case 4:
                    o = _context3.sent;
                    _context3.next = 7;
                    return n.audioCtx.decodeAudioData(o);
                  case 7:
                    i = _context3.sent;
                    if (n.sourceNode = n.audioCtx.createBufferSource(), n.sourceNode.buffer = i, n.sourceNode.connect(n.analyser), n.muted) {
                      s = n.audioCtx.createGain();
                      s.gain.value = 0, n.analyser.connect(s), s.connect(n.audioCtx.destination);
                    } else n.analyser.connect(n.audioCtx.destination);
                    n.sourceNode.start(), n.draw(), n.sourceNode.onended = function () {
                      n.playbackEnded.emit(), n.ngOnDestroy();
                    };
                  case 10:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }))();
          }
        }, {
          key: "drawRoundedRect",
          value: function drawRoundedRect(n, r, o, i, s) {
            var a = this.ctx;
            a.beginPath(), a.moveTo(n + s, r), a.lineTo(n + o - s, r), a.quadraticCurveTo(n + o, r, n + o, r + s), a.lineTo(n + o, r + i - s), a.quadraticCurveTo(n + o, r + i, n + o - s, r + i), a.lineTo(n + s, r + i), a.quadraticCurveTo(n, r + i, n, r + i - s), a.lineTo(n, r + s), a.quadraticCurveTo(n, r, n + s, r), a.closePath(), a.fill();
          }
        }, {
          key: "ngOnDestroy",
          value: function ngOnDestroy() {
            var _this$sourceNode;
            cancelAnimationFrame(this.animationFrameId), (_this$sourceNode = this.sourceNode) !== null && _this$sourceNode !== void 0 && _this$sourceNode.stop(), window.removeEventListener("resize", this.resizeCanvas);
          }
        }]);
      }();
      _e52 = e;
      _e52.ɵfac = function (r) {
        return new (r || _e52)();
      };
      _e52.ɵcmp = Nt({
        type: _e52,
        selectors: [["app-audio-visualizer"]],
        viewQuery: function viewQuery(r, o) {
          if (1 & r && Gh(PU, 7), 2 & r) {
            var i;
            tc(i = nc()) && (o.canvasRef = i.first);
          }
        },
        inputs: {
          audioUrl: "audioUrl",
          muted: "muted"
        },
        outputs: {
          playbackEnded: "playbackEnded"
        },
        decls: 2,
        vars: 0,
        consts: [["canvas", ""], [1, "w-full", "h-full", "pointer-events-none"]],
        template: function template(r, o) {
          1 & r && pe(0, "canvas", 1, 0);
        },
        encapsulation: 2
      });
      return e;
    }();
    var FU = ["addListener", "removeListener"],
      LU = ["addEventListener", "removeEventListener"],
      jU = ["on", "off"];
    function ag(e, t, n, r) {
      if (J(n) && (r = n, n = void 0), r) return ag(e, t, n).pipe(Y_(r));
      var _ref52 = function UU(e) {
          return J(e.addEventListener) && J(e.removeEventListener);
        }(e) ? LU.map(function (s) {
          return function (a) {
            return e[s](t, a, n);
          };
        }) : function VU(e) {
          return J(e.addListener) && J(e.removeListener);
        }(e) ? FU.map(tM(e, t)) : function BU(e) {
          return J(e.on) && J(e.off);
        }(e) ? jU.map(tM(e, t)) : [],
        _ref53 = _slicedToArray(_ref52, 2),
        o = _ref53[0],
        i = _ref53[1];
      if (!o && Tp(e)) return Ge(function (s) {
        return ag(s, t, n);
      })(dn(e));
      if (!o) throw new TypeError("Invalid event target");
      return new _e(function (s) {
        var a = function a() {
          for (var _len11 = arguments.length, u = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            u[_key11] = arguments[_key11];
          }
          return s.next(1 < u.length ? u : u[0]);
        };
        return o(a), function () {
          return i(a);
        };
      });
    }
    function tM(e, t) {
      return function (n) {
        return function (r) {
          return e[n](t, r);
        };
      };
    }
    var nM = function (_e53) {
        var e = /*#__PURE__*/function () {
          function e() {
            var _this94 = this;
            _classCallCheck(this, e);
            this.available = !1, this.controldownSubject = new $e(), this.controlupSubject = new $e(), this.controldown$ = this.controldownSubject.asObservable(), this.controlup$ = this.controlupSubject.asObservable();
            try {
              {
                var n = kg(936);
                this.controlPort = new n("BrightSign"), this.available = !0, [0, 1, 2, 3].forEach(function (r) {
                  _this94.controlPort.ConfigureAsOutput(r), _this94.controlPort.SetPinValue(r, 0);
                }), [4, 5, 6, 7].forEach(function (r) {
                  return _this94.controlPort.ConfigureAsInput(r);
                }), this.controlPort.addEventListener("controldown", function (r) {
                  _this94.controldownSubject.next(r.detail);
                }), this.controlPort.addEventListener("controlup", function (r) {
                  _this94.controlupSubject.next(r.detail);
                });
              }
            } catch (n) {
              console.error("BrightSign GPIO service not available", n);
            }
          }
          return _createClass(e, [{
            key: "isAvailable",
            value: function isAvailable() {
              return !!this.controlPort;
            }
          }, {
            key: "setOutput",
            value: function setOutput(n, r) {
              this.available && this.controlPort.SetPinValue(n, r);
            }
          }]);
        }();
        _e53 = e;
        _e53.ɵfac = function (r) {
          return new (r || _e53)();
        };
        _e53.ɵprov = b({
          token: _e53,
          factory: _e53.ɵfac,
          providedIn: "root"
        });
        return e;
      }(),
      Ys = function (_e54) {
        var e = /*#__PURE__*/function () {
          function e(n, r) {
            _classCallCheck(this, e);
            this.gpioService = n, this.zone = r, this.action$ = new $e(), this.listenToKeyboard(), this.listenToGpio();
          }
          return _createClass(e, [{
            key: "actions$",
            get: function get() {
              return this.action$.asObservable();
            }
          }, {
            key: "listenToKeyboard",
            value: function listenToKeyboard() {
              var _this95 = this;
              ag(document, "keydown").pipe(Y(function (n) {
                return _this95.mapKeyToAction(n);
              })).subscribe(function (n) {
                n && _this95.action$.next(n);
              });
            }
          }, {
            key: "listenToGpio",
            value: function listenToGpio() {
              var _this96 = this;
              this.gpioService.isAvailable() && this.gpioService.controldown$.subscribe(function (n) {
                var r = _this96.mapPinToAction(n);
                r && _this96.zone.run(function () {
                  return _this96.action$.next(r);
                });
              });
            }
          }, {
            key: "mapKeyToAction",
            value: function mapKeyToAction(n) {
              switch (n.code) {
                case "Space":
                  return "play";
                case "Digit1":
                  return "select_a";
                case "Digit2":
                  return "select_b";
                case "Digit3":
                  return "select_c";
                default:
                  return null;
              }
            }
          }, {
            key: "mapPinToAction",
            value: function mapPinToAction(n) {
              switch (n) {
                case 4:
                  return "play";
                case 5:
                  return "select_a";
                case 6:
                  return "select_b";
                case 7:
                  return "select_c";
                default:
                  return null;
              }
            }
          }]);
        }();
        _e54 = e;
        _e54.ɵfac = function (r) {
          return new (r || _e54)(T(nM), T(ee));
        };
        _e54.ɵprov = b({
          token: _e54,
          factory: _e54.ɵfac,
          providedIn: "root"
        });
        return e;
      }(),
      ug = function (_e55) {
        var e = /*#__PURE__*/_createClass(function e() {
          _classCallCheck(this, e);
          this.totalRounds = 5, this.pointsPerInitialCorrectAnswer = 20, this.pointsPerSubsequentCorrectAnswer = 10;
        });
        _e55 = e;
        _e55.ɵfac = function (r) {
          return new (r || _e55)();
        };
        _e55.ɵprov = b({
          token: _e55,
          factory: _e55.ɵfac,
          providedIn: "root"
        });
        return e;
      }(),
      cg = function (_e56) {
        var e = /*#__PURE__*/function () {
          function e() {
            _classCallCheck(this, e);
          }
          return _createClass(e, [{
            key: "play",
            value: function play(n) {
              return new Promise(function (r, o) {
                var i = new Audio(n);
                i.onended = function () {
                  return r();
                }, i.onerror = function (s) {
                  return o(s);
                }, i.play().catch(o);
              });
            }
          }, {
            key: "stop",
            value: function stop() {
              this.currentAudio && (this.currentAudio.pause(), this.currentAudio.currentTime = 0, this.currentAudio = void 0);
            }
          }]);
        }();
        _e56 = e;
        _e56.ɵfac = function (r) {
          return new (r || _e56)();
        };
        _e56.ɵprov = b({
          token: _e56,
          factory: _e56.ɵfac,
          providedIn: "root"
        });
        return e;
      }(),
      Wr = function (_e57) {
        var e = /*#__PURE__*/function () {
          function e(n, r, o) {
            _classCallCheck(this, e);
            this.config = n, this.router = r, this.audio = o, this.previousScore = Ue(0), this.score = Ue(0), this.round = Ue(1), this.guess = Ue(0), this.usedAnswerIds = Ue(new Set()), this.lastAnswerCard = Ue(null);
          }
          return _createClass(e, [{
            key: "startGame",
            value: function startGame() {
              this.audio.play("audio/game-start.wav"), this.previousScore.set(0), this.score.set(0), this.round.set(1), this.router.navigate(["/round"]);
            }
          }, {
            key: "nextRound",
            value: function nextRound() {
              var n = this.round(),
                r = this.score();
              this.previousScore.set(r), n >= this.config.totalRounds ? this.reset() : (this.audio.play("audio/game-start.wav"), this.round.set(n + 1), this.guess.set(0), this.router.navigate(["/round"]));
            }
          }, {
            key: "showResults",
            value: function showResults() {
              this.router.navigate(["/results"]);
            }
          }, {
            key: "end",
            value: function end() {
              this.router.navigate(["/end"]);
            }
          }, {
            key: "reset",
            value: function reset() {
              this.score.set(0), this.round.set(1), this.guess.set(0), this.usedAnswerIds.set(new Set()), this.router.navigate(["/"]);
            }
          }, {
            key: "addUsedAnswerId",
            value: function addUsedAnswerId(n) {
              var r = new Set(this.usedAnswerIds());
              r.add(n), this.usedAnswerIds.set(r);
            }
          }, {
            key: "setLastAnswer",
            value: function setLastAnswer(n) {
              this.lastAnswerCard.set(n);
            }
          }]);
        }();
        _e57 = e;
        _e57.ɵfac = function (r) {
          return new (r || _e57)(T(ug), T(or), T(cg));
        };
        _e57.ɵprov = b({
          token: _e57,
          factory: _e57.ɵfac,
          providedIn: "root"
        });
        return e;
      }(),
      Bc = function (_e58) {
        var e = /*#__PURE__*/function () {
          function e(n) {
            var _this97 = this;
            _classCallCheck(this, e);
            this.gpioService = n, this.isBrightSign = !1, this.gpioSub = new He(), this.currentOutputState = [0, 0, 0, 0], this.savedOutputState = null, this.blinking = !1, this.blinkState = 0, this.isBrightSign = this.gpioService.isAvailable(), this.isBrightSign && (this.applyState(this.currentOutputState), this.gpioSub.add(this.gpioService.controldown$.subscribe(function (r) {
              return _this97.handlePress(r);
            })), this.gpioSub.add(this.gpioService.controlup$.subscribe(function (r) {
              return _this97.handleRelease(r);
            })));
          }
          return _createClass(e, [{
            key: "applyState",
            value: function applyState(n) {
              var _this98 = this;
              n.forEach(function (r, o) {
                _this98.gpioService.setOutput(o, r);
              }), this.currentOutputState = _toConsumableArray(n);
            }
          }, {
            key: "handlePress",
            value: function handlePress(n) {
              [4, 5, 6, 7].includes(n) && this.stopBlinking(), 4 === n ? this.overrideOutputState([1, 0, 0, 0]) : 5 === n ? this.overrideOutputState([0, 1, 0, 0]) : 6 === n ? this.overrideOutputState([0, 0, 1, 0]) : 7 === n && this.overrideOutputState([0, 0, 0, 1]);
            }
          }, {
            key: "handleRelease",
            value: function handleRelease(n) {
              [4, 5, 6, 7].includes(n) && this.restorePreviousState();
            }
          }, {
            key: "overrideOutputState",
            value: function overrideOutputState(n) {
              this.isBrightSign && (this.savedOutputState = _toConsumableArray(this.currentOutputState), this.applyState(n));
            }
          }, {
            key: "restorePreviousState",
            value: function restorePreviousState() {
              !this.isBrightSign || !this.savedOutputState || (this.applyState(this.savedOutputState), this.savedOutputState = null);
            }
          }, {
            key: "startBlinkingPin0",
            value: function startBlinkingPin0() {
              var _this99 = this;
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1375;
              if (this.isBrightSign && !this.blinking) return this.blinking = !0, this.blinkState = 0, this.gpioService.setOutput(0, 0), this.blinkIntervalId = setInterval(function () {
                _this99.blinkState = 0 === _this99.blinkState ? 1 : 0, _this99.gpioService.setOutput(0, _this99.blinkState), _this99.currentOutputState[0] = _this99.blinkState;
              }, n);
            }
          }, {
            key: "stopBlinking",
            value: function stopBlinking() {
              this.blinkIntervalId && (clearInterval(this.blinkIntervalId), this.blinkIntervalId = void 0), this.gpioService.setOutput(0, 0), this.blinking = !1;
            }
          }, {
            key: "setOutputState",
            value: function setOutputState(n) {
              this.isBrightSign && (this.currentOutputState = _toConsumableArray(n), this.applyState(this.currentOutputState));
            }
          }, {
            key: "setPinsToZero",
            value: function setPinsToZero() {
              this.isBrightSign && (this.setOutputState([0, 0, 0, 0]), this.savedOutputState = [0, 0, 0, 0]);
            }
          }]);
        }();
        _e58 = e;
        _e58.ɵfac = function (r) {
          return new (r || _e58)(T(nM));
        };
        _e58.ɵprov = b({
          token: _e58,
          factory: _e58.ɵfac,
          providedIn: "root"
        });
        return e;
      }(),
      HU = function (_e59) {
        var e = /*#__PURE__*/function () {
          function e(n, r, o, i) {
            _classCallCheck(this, e);
            this.inputService = n, this.gameStateService = r, this.outputService = o, this.router = i, this.audioUrl = "audio/dial-up-modem.mp3";
          }
          return _createClass(e, [{
            key: "ngOnInit",
            value: function ngOnInit() {
              var _this100 = this;
              this.outputService.startBlinkingPin0(), this.inputSub = this.inputService.actions$.subscribe(function (n) {
                "play" === n && _this100.gameStateService.startGame();
              });
            }
          }, {
            key: "handlePlaybackEnded",
            value: function handlePlaybackEnded() {
              this.reloadComponent();
            }
          }, {
            key: "reloadComponent",
            value: function reloadComponent() {
              this.router.navigateByUrl(this.router.url);
            }
          }, {
            key: "ngOnDestroy",
            value: function ngOnDestroy() {
              this.inputSub.unsubscribe();
            }
          }]);
        }();
        _e59 = e;
        _e59.ɵfac = function (r) {
          return new (r || _e59)(S(Ys), S(Wr), S(Bc), S(or));
        };
        _e59.ɵcmp = Nt({
          type: _e59,
          selectors: [["app-home"]],
          decls: 31,
          vars: 2,
          consts: [[1, "h-screen", "bg-cover", "bg-center", 2, "background-image", "url('images/technology-on-desk.jpg')"], [1, "absolute", "inset-0", "bg-black/67"], [1, "py-[8vh]"], [1, "text-primary", "uppercase", "text-center", "leading-[1.1]"], [1, "block", "font-bold", "text-[6vh]", "tracking-widest"], [1, "block", "animate-fade", "animate-duration-500", "animate-delay-2500"], [1, "block", "animate-fade", "animate-duration-500", "animate-delay-3000"], [1, "block", "font-8-bit", "text-[12.5vh]", "leading-[0.95]"], [1, "animate-fade-right", "animate-duration-250", "animate-delay-3500"], [1, "animate-fade-right", "animate-duration-250", "animate-delay-3750"], [1, "animate-fade-right", "animate-duration-250", "animate-delay-4000"], [1, "animate-fade-right", "animate-duration-250", "animate-delay-4250"], [1, "animate-fade-right", "animate-duration-250", "animate-delay-4500"], [1, "text-center", "text-white", "text-[3vh]", "uppercase", "leading-[1]", "items-center", "tracking-[0.5vh]"], [1, "animate-fade", "animate-duration-1000", "animate-infinite", "animate-alternate", "animate-delay-4750"], [1, "text-[4vh]"], [1, "mt-[6vh]", "h-[33vh]", "animate-fade", "animate-duration-1000", "animate-delay-4500"], [3, "playbackEnded", "audioUrl", "muted"]],
          template: function template(r, o) {
            1 & r && (O(0, "div", 0)(1, "div", 1)(2, "header", 2)(3, "h1", 3)(4, "span", 4)(5, "span", 5), W(6, "Guess That"), N(), O(7, "span", 6), W(8, "Technology"), N()(), O(9, "span", 7)(10, "span", 8), W(11, "S"), N(), O(12, "span", 9), W(13, "O"), N(), O(14, "span", 10), W(15, "U"), N(), O(16, "span", 11), W(17, "N"), N(), O(18, "span", 12), W(19, "D"), N()()()(), O(20, "main")(21, "div", 13)(22, "div", 14)(23, "span", 15), W(24, "\u203A"), N(), W(25, "Press Play to Start"), O(26, "span", 15), W(27, "\u2039"), N()()(), O(28, "div", 16)(29, "app-audio-visualizer", 17), Ss("playbackEnded", function () {
              return o.handlePlaybackEnded();
            }), N()()(), pe(30, "app-footer"), N()()), 2 & r && (ae(29), xe("audioUrl", o.audioUrl)("muted", !0));
          },
          dependencies: [eM, Vc],
          encapsulation: 2
        });
        return e;
      }();
    var Dg = /\s+/,
      dM = [];
    var fM = function (_e60) {
      var e = /*#__PURE__*/function () {
        function e(n, r) {
          _classCallCheck(this, e);
          _defineProperty(this, "_ngEl", void 0);
          _defineProperty(this, "_renderer", void 0);
          _defineProperty(this, "initialClasses", dM);
          _defineProperty(this, "rawClass", void 0);
          _defineProperty(this, "stateMap", new Map());
          this._ngEl = n, this._renderer = r;
        }
        return _createClass(e, [{
          key: "klass",
          set: function set(n) {
            this.initialClasses = null != n ? n.trim().split(Dg) : dM;
          }
        }, {
          key: "ngClass",
          set: function set(n) {
            this.rawClass = "string" == typeof n ? n.trim().split(Dg) : n;
          }
        }, {
          key: "ngDoCheck",
          value: function ngDoCheck() {
            var _iterator48 = _createForOfIteratorHelper(this.initialClasses),
              _step48;
            try {
              for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
                var _r19 = _step48.value;
                this._updateState(_r19, !0);
              }
            } catch (err) {
              _iterator48.e(err);
            } finally {
              _iterator48.f();
            }
            var n = this.rawClass;
            if (Array.isArray(n) || n instanceof Set) {
              var _iterator49 = _createForOfIteratorHelper(n),
                _step49;
              try {
                for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                  var r = _step49.value;
                  this._updateState(r, !0);
                }
              } catch (err) {
                _iterator49.e(err);
              } finally {
                _iterator49.f();
              }
            } else if (null != n) for (var _i21 = 0, _Object$keys2 = Object.keys(n); _i21 < _Object$keys2.length; _i21++) {
              var _r18 = _Object$keys2[_i21];
              this._updateState(_r18, !!n[_r18]);
            }
            this._applyStateDiff();
          }
        }, {
          key: "_updateState",
          value: function _updateState(n, r) {
            var o = this.stateMap.get(n);
            void 0 !== o ? (o.enabled !== r && (o.changed = !0, o.enabled = r), o.touched = !0) : this.stateMap.set(n, {
              enabled: r,
              changed: !0,
              touched: !0
            });
          }
        }, {
          key: "_applyStateDiff",
          value: function _applyStateDiff() {
            var _iterator50 = _createForOfIteratorHelper(this.stateMap),
              _step50;
            try {
              for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                var n = _step50.value;
                var r = n[0],
                  o = n[1];
                o.changed ? (this._toggleClass(r, o.enabled), o.changed = !1) : o.touched || (o.enabled && this._toggleClass(r, !1), this.stateMap.delete(r)), o.touched = !1;
              }
            } catch (err) {
              _iterator50.e(err);
            } finally {
              _iterator50.f();
            }
          }
        }, {
          key: "_toggleClass",
          value: function _toggleClass(n, r) {
            var _this101 = this;
            (n = n.trim()).length > 0 && n.split(Dg).forEach(function (o) {
              r ? _this101._renderer.addClass(_this101._ngEl.nativeElement, o) : _this101._renderer.removeClass(_this101._ngEl.nativeElement, o);
            });
          }
        }]);
      }();
      _e60 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e60)(S($n), S(ku));
      });
      _defineProperty(e, "\u0275dir", Ke({
        type: _e60,
        selectors: [["", "ngClass", ""]],
        inputs: {
          klass: [0, "class", "klass"],
          ngClass: "ngClass"
        }
      }));
      return e;
    }();
    var SH = /*#__PURE__*/function () {
      function SH(t, n, r, o) {
        _classCallCheck(this, SH);
        _defineProperty(this, "$implicit", void 0);
        _defineProperty(this, "ngForOf", void 0);
        _defineProperty(this, "index", void 0);
        _defineProperty(this, "count", void 0);
        this.$implicit = t, this.ngForOf = n, this.index = r, this.count = o;
      }
      return _createClass(SH, [{
        key: "first",
        get: function get() {
          return 0 === this.index;
        }
      }, {
        key: "last",
        get: function get() {
          return this.index === this.count - 1;
        }
      }, {
        key: "even",
        get: function get() {
          return this.index % 2 == 0;
        }
      }, {
        key: "odd",
        get: function get() {
          return !this.even;
        }
      }]);
    }();
    var wg = function (_e61) {
      var e = /*#__PURE__*/function () {
        function e(n, r, o) {
          _classCallCheck(this, e);
          _defineProperty(this, "_viewContainer", void 0);
          _defineProperty(this, "_template", void 0);
          _defineProperty(this, "_differs", void 0);
          _defineProperty(this, "_ngForOf", null);
          _defineProperty(this, "_ngForOfDirty", !0);
          _defineProperty(this, "_differ", null);
          _defineProperty(this, "_trackByFn", void 0);
          this._viewContainer = n, this._template = r, this._differs = o;
        }
        return _createClass(e, [{
          key: "ngForOf",
          set: function set(n) {
            this._ngForOf = n, this._ngForOfDirty = !0;
          }
        }, {
          key: "ngForTrackBy",
          get: function get() {
            return this._trackByFn;
          },
          set: function set(n) {
            this._trackByFn = n;
          }
        }, {
          key: "ngForTemplate",
          set: function set(n) {
            n && (this._template = n);
          }
        }, {
          key: "ngDoCheck",
          value: function ngDoCheck() {
            if (this._ngForOfDirty) {
              this._ngForOfDirty = !1;
              var n = this._ngForOf;
              !this._differ && n && (this._differ = this._differs.find(n).create(this.ngForTrackBy));
            }
            if (this._differ) {
              var _n12 = this._differ.diff(this._ngForOf);
              _n12 && this._applyChanges(_n12);
            }
          }
        }, {
          key: "_applyChanges",
          value: function _applyChanges(n) {
            var _this102 = this;
            var r = this._viewContainer;
            n.forEachOperation(function (o, i, s) {
              if (null == o.previousIndex) r.createEmbeddedView(_this102._template, new SH(o.item, _this102._ngForOf, -1, -1), null === s ? void 0 : s);else if (null == s) r.remove(null === i ? void 0 : i);else if (null !== i) {
                var a = r.get(i);
                r.move(a, s), pM(a, o);
              }
            });
            for (var o = 0, i = r.length; o < i; o++) {
              var a = r.get(o).context;
              a.index = o, a.count = i, a.ngForOf = this._ngForOf;
            }
            n.forEachIdentityChange(function (o) {
              pM(r.get(o.currentIndex), o);
            });
          }
        }], [{
          key: "ngTemplateContextGuard",
          value: function ngTemplateContextGuard(n, r) {
            return !0;
          }
        }]);
      }();
      _e61 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e61)(S($t), S(xn), S(lp));
      });
      _defineProperty(e, "\u0275dir", Ke({
        type: _e61,
        selectors: [["", "ngFor", "", "ngForOf", ""]],
        inputs: {
          ngForOf: "ngForOf",
          ngForTrackBy: "ngForTrackBy",
          ngForTemplate: "ngForTemplate"
        }
      }));
      return e;
    }();
    function pM(e, t) {
      e.context.$implicit = t.item;
    }
    var Eg = function (_e62) {
      var e = /*#__PURE__*/function () {
        function e(n, r) {
          _classCallCheck(this, e);
          _defineProperty(this, "_viewContainer", void 0);
          _defineProperty(this, "_context", new TH());
          _defineProperty(this, "_thenTemplateRef", null);
          _defineProperty(this, "_elseTemplateRef", null);
          _defineProperty(this, "_thenViewRef", null);
          _defineProperty(this, "_elseViewRef", null);
          this._viewContainer = n, this._thenTemplateRef = r;
        }
        return _createClass(e, [{
          key: "ngIf",
          set: function set(n) {
            this._context.$implicit = this._context.ngIf = n, this._updateView();
          }
        }, {
          key: "ngIfThen",
          set: function set(n) {
            gM(n), this._thenTemplateRef = n, this._thenViewRef = null, this._updateView();
          }
        }, {
          key: "ngIfElse",
          set: function set(n) {
            gM(n), this._elseTemplateRef = n, this._elseViewRef = null, this._updateView();
          }
        }, {
          key: "_updateView",
          value: function _updateView() {
            this._context.$implicit ? this._thenViewRef || (this._viewContainer.clear(), this._elseViewRef = null, this._thenTemplateRef && (this._thenViewRef = this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context))) : this._elseViewRef || (this._viewContainer.clear(), this._thenViewRef = null, this._elseTemplateRef && (this._elseViewRef = this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context)));
          }
        }], [{
          key: "ngTemplateContextGuard",
          value: function ngTemplateContextGuard(n, r) {
            return !0;
          }
        }]);
      }();
      _e62 = e;
      _defineProperty(e, "ngIfUseIfTypeGuard", void 0);
      _defineProperty(e, "ngTemplateGuard_ngIf", void 0);
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e62)(S($t), S(xn));
      });
      _defineProperty(e, "\u0275dir", Ke({
        type: _e62,
        selectors: [["", "ngIf", ""]],
        inputs: {
          ngIf: "ngIf",
          ngIfThen: "ngIfThen",
          ngIfElse: "ngIfElse"
        }
      }));
      return e;
    }();
    var TH = /*#__PURE__*/_createClass(function TH() {
      _classCallCheck(this, TH);
      _defineProperty(this, "$implicit", null);
      _defineProperty(this, "ngIf", null);
    });
    function gM(e, t) {
      if (e && !e.createEmbeddedView) throw new E(2020, !1);
    }
    var yM = function (_e63) {
      var e = /*#__PURE__*/_createClass(function e() {
        _classCallCheck(this, e);
      });
      _e63 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e63)();
      });
      _defineProperty(e, "\u0275mod", gh({
        type: _e63
      }));
      _defineProperty(e, "\u0275inj", va({}));
      return e;
    }();
    var XH = function XH(e, t) {
        return [e, t];
      },
      e$ = function e$(e, t, n) {
        return [e, t, n];
      };
    var t$ = function (_e64) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
          this.image = "", this.title = "", this.buttonColor = "bg-gray-400", this.isReverseLayout = !1, this.imageRotation = "", this.isAnswer = !1, this.cardIndex = 1;
        }
        return _createClass(e, [{
          key: "getZIndexClass",
          value: function getZIndexClass(n) {
            var _n13;
            return (_n13 = ["z-30", "z-20", "z-10"][n]) !== null && _n13 !== void 0 ? _n13 : "z-0";
          }
        }, {
          key: "getAnimationDelayClass",
          value: function getAnimationDelayClass(n) {
            var r = 500 * (n + 1);
            return console.log("Animation delay for index ".concat(n, ": ").concat(r, "ms")), "animate-delay-".concat(r.toString());
          }
        }]);
      }();
      _e64 = e;
      _e64.ɵfac = function (r) {
        return new (r || _e64)();
      };
      _e64.ɵcmp = Nt({
        type: _e64,
        selectors: [["app-tech-sound-card"]],
        inputs: {
          image: "image",
          title: "title",
          buttonColor: "buttonColor",
          isReverseLayout: "isReverseLayout",
          imageRotation: "imageRotation",
          isAnswer: "isAnswer",
          cardIndex: "cardIndex"
        },
        decls: 7,
        vars: 13,
        consts: [[1, "px-[3.375vh]", "flex", "items-center", "relative", "mt-[-1.265625vh]", 3, "ngClass"], [1, "w-2/3"], [1, "border-[0.84375vh]", "border-white", "shadow-[0.75vh_0.75vh_0_0.375vh_rgba(0,0,0,0.20)]", "w-[29.8125vh]", 3, "src", "alt", "ngClass"], [1, "w-1/3", "text-center"], [1, "bg-radial-[at_50%_30%]", "text-white", "w-[4vh]", "h-[4vh]", "scale-y-90", "rounded-[100%]", "shadow-[0.25vh_0.75vh_0_0.375vh_rgba(0,0,0,0.20)]", "font-bold", "text-sm", 3, "ngClass"], [1, "mt-[1.5vh]", "text-white", "text-[2.25vh]", "leading-[1.2]", "tracking-widest", "uppercase"]],
        template: function template(r, o) {
          1 & r && (O(0, "div", 0)(1, "div", 1), pe(2, "img", 2), N(), O(3, "div", 3), pe(4, "button", 4), O(5, "div", 5), W(6), N()()()), 2 & r && (xe("ngClass", iI(6, XH, o.isReverseLayout ? "flex flex-row-reverse" : "flex", o.getZIndexClass(o.cardIndex))), ae(2), xe("src", o.image, Ji)("alt", o.title)("ngClass", sI(9, e$, o.imageRotation, o.isReverseLayout ? "animate-fade-left float-right" : "animate-fade-right", o.getAnimationDelayClass(o.cardIndex))), ae(2), xe("ngClass", o.buttonColor), ae(2), At(" ", o.title, " "));
        },
        dependencies: [fM],
        encapsulation: 2
      });
      return e;
    }();
    var Kc = /*#__PURE__*/_createClass(function Kc() {
      _classCallCheck(this, Kc);
    });
    var Xc = /*#__PURE__*/_createClass(function Xc() {
      _classCallCheck(this, Xc);
    });
    var Kt = /*#__PURE__*/function () {
      function Kt(t) {
        var _this103 = this;
        _classCallCheck(this, Kt);
        _defineProperty(this, "headers", void 0);
        _defineProperty(this, "normalizedNames", new Map());
        _defineProperty(this, "lazyInit", void 0);
        _defineProperty(this, "lazyUpdate", null);
        t ? "string" == typeof t ? this.lazyInit = function () {
          _this103.headers = new Map(), t.split("\n").forEach(function (n) {
            var r = n.indexOf(":");
            if (r > 0) {
              var o = n.slice(0, r),
                i = n.slice(r + 1).trim();
              _this103.addHeaderEntry(o, i);
            }
          });
        } : (typeof Headers === "undefined" ? "undefined" : _typeof(Headers)) < "u" && t instanceof Headers ? (this.headers = new Map(), t.forEach(function (n, r) {
          _this103.addHeaderEntry(r, n);
        })) : this.lazyInit = function () {
          _this103.headers = new Map(), Object.entries(t).forEach(function (_ref54) {
            var _ref55 = _slicedToArray(_ref54, 2),
              n = _ref55[0],
              r = _ref55[1];
            _this103.setHeaderEntries(n, r);
          });
        } : this.headers = new Map();
      }
      return _createClass(Kt, [{
        key: "has",
        value: function has(t) {
          return this.init(), this.headers.has(t.toLowerCase());
        }
      }, {
        key: "get",
        value: function get(t) {
          this.init();
          var n = this.headers.get(t.toLowerCase());
          return n && n.length > 0 ? n[0] : null;
        }
      }, {
        key: "keys",
        value: function keys() {
          return this.init(), Array.from(this.normalizedNames.values());
        }
      }, {
        key: "getAll",
        value: function getAll(t) {
          return this.init(), this.headers.get(t.toLowerCase()) || null;
        }
      }, {
        key: "append",
        value: function append(t, n) {
          return this.clone({
            name: t,
            value: n,
            op: "a"
          });
        }
      }, {
        key: "set",
        value: function set(t, n) {
          return this.clone({
            name: t,
            value: n,
            op: "s"
          });
        }
      }, {
        key: "delete",
        value: function _delete(t, n) {
          return this.clone({
            name: t,
            value: n,
            op: "d"
          });
        }
      }, {
        key: "maybeSetNormalizedName",
        value: function maybeSetNormalizedName(t, n) {
          this.normalizedNames.has(n) || this.normalizedNames.set(n, t);
        }
      }, {
        key: "init",
        value: function init() {
          var _this104 = this;
          this.lazyInit && (this.lazyInit instanceof Kt ? this.copyFrom(this.lazyInit) : this.lazyInit(), this.lazyInit = null, this.lazyUpdate && (this.lazyUpdate.forEach(function (t) {
            return _this104.applyUpdate(t);
          }), this.lazyUpdate = null));
        }
      }, {
        key: "copyFrom",
        value: function copyFrom(t) {
          var _this105 = this;
          t.init(), Array.from(t.headers.keys()).forEach(function (n) {
            _this105.headers.set(n, t.headers.get(n)), _this105.normalizedNames.set(n, t.normalizedNames.get(n));
          });
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var n = new Kt();
          return n.lazyInit = this.lazyInit && this.lazyInit instanceof Kt ? this.lazyInit : this, n.lazyUpdate = (this.lazyUpdate || []).concat([t]), n;
        }
      }, {
        key: "applyUpdate",
        value: function applyUpdate(t) {
          var n = t.name.toLowerCase();
          switch (t.op) {
            case "a":
            case "s":
              var r = t.value;
              if ("string" == typeof r && (r = [r]), 0 === r.length) return;
              this.maybeSetNormalizedName(t.name, n);
              var o = ("a" === t.op ? this.headers.get(n) : void 0) || [];
              o.push.apply(o, _toConsumableArray(r)), this.headers.set(n, o);
              break;
            case "d":
              var i = t.value;
              if (i) {
                var s = this.headers.get(n);
                if (!s) return;
                s = s.filter(function (a) {
                  return -1 === i.indexOf(a);
                }), 0 === s.length ? (this.headers.delete(n), this.normalizedNames.delete(n)) : this.headers.set(n, s);
              } else this.headers.delete(n), this.normalizedNames.delete(n);
          }
        }
      }, {
        key: "addHeaderEntry",
        value: function addHeaderEntry(t, n) {
          var r = t.toLowerCase();
          this.maybeSetNormalizedName(t, r), this.headers.has(r) ? this.headers.get(r).push(n) : this.headers.set(r, [n]);
        }
      }, {
        key: "setHeaderEntries",
        value: function setHeaderEntries(t, n) {
          var r = (Array.isArray(n) ? n : [n]).map(function (i) {
              return i.toString();
            }),
            o = t.toLowerCase();
          this.headers.set(o, r), this.maybeSetNormalizedName(t, o);
        }
      }, {
        key: "forEach",
        value: function forEach(t) {
          var _this106 = this;
          this.init(), Array.from(this.normalizedNames.keys()).forEach(function (n) {
            return t(_this106.normalizedNames.get(n), _this106.headers.get(n));
          });
        }
      }]);
    }();
    var s$ = /*#__PURE__*/function () {
      function s$() {
        _classCallCheck(this, s$);
      }
      return _createClass(s$, [{
        key: "encodeKey",
        value: function encodeKey(t) {
          return CM(t);
        }
      }, {
        key: "encodeValue",
        value: function encodeValue(t) {
          return CM(t);
        }
      }, {
        key: "decodeKey",
        value: function decodeKey(t) {
          return decodeURIComponent(t);
        }
      }, {
        key: "decodeValue",
        value: function decodeValue(t) {
          return decodeURIComponent(t);
        }
      }]);
    }();
    var u$ = /%(\d[a-f0-9])/gi,
      c$ = {
        40: "@",
        "3A": ":",
        24: "$",
        "2C": ",",
        "3B": ";",
        "3D": "=",
        "3F": "?",
        "2F": "/"
      };
    function CM(e) {
      return encodeURIComponent(e).replace(u$, function (t, n) {
        var _c$$n;
        return (_c$$n = c$[n]) !== null && _c$$n !== void 0 ? _c$$n : t;
      });
    }
    function el(e) {
      return "".concat(e);
    }
    var ir = /*#__PURE__*/function () {
      function ir() {
        var _this107 = this;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, ir);
        _defineProperty(this, "map", void 0);
        _defineProperty(this, "encoder", void 0);
        _defineProperty(this, "updates", null);
        _defineProperty(this, "cloneFrom", null);
        if (this.encoder = t.encoder || new s$(), t.fromString) {
          if (t.fromObject) throw new E(2805, !1);
          this.map = function a$(e, t) {
            var n = new Map();
            return e.length > 0 && e.replace(/^\?/, "").split("&").forEach(function (o) {
              var i = o.indexOf("="),
                _ref56 = -1 == i ? [t.decodeKey(o), ""] : [t.decodeKey(o.slice(0, i)), t.decodeValue(o.slice(i + 1))],
                _ref57 = _slicedToArray(_ref56, 2),
                s = _ref57[0],
                a = _ref57[1],
                u = n.get(s) || [];
              u.push(a), n.set(s, u);
            }), n;
          }(t.fromString, this.encoder);
        } else t.fromObject ? (this.map = new Map(), Object.keys(t.fromObject).forEach(function (n) {
          var r = t.fromObject[n],
            o = Array.isArray(r) ? r.map(el) : [el(r)];
          _this107.map.set(n, o);
        })) : this.map = null;
      }
      return _createClass(ir, [{
        key: "has",
        value: function has(t) {
          return this.init(), this.map.has(t);
        }
      }, {
        key: "get",
        value: function get(t) {
          this.init();
          var n = this.map.get(t);
          return n ? n[0] : null;
        }
      }, {
        key: "getAll",
        value: function getAll(t) {
          return this.init(), this.map.get(t) || null;
        }
      }, {
        key: "keys",
        value: function keys() {
          return this.init(), Array.from(this.map.keys());
        }
      }, {
        key: "append",
        value: function append(t, n) {
          return this.clone({
            param: t,
            value: n,
            op: "a"
          });
        }
      }, {
        key: "appendAll",
        value: function appendAll(t) {
          var n = [];
          return Object.keys(t).forEach(function (r) {
            var o = t[r];
            Array.isArray(o) ? o.forEach(function (i) {
              n.push({
                param: r,
                value: i,
                op: "a"
              });
            }) : n.push({
              param: r,
              value: o,
              op: "a"
            });
          }), this.clone(n);
        }
      }, {
        key: "set",
        value: function set(t, n) {
          return this.clone({
            param: t,
            value: n,
            op: "s"
          });
        }
      }, {
        key: "delete",
        value: function _delete(t, n) {
          return this.clone({
            param: t,
            value: n,
            op: "d"
          });
        }
      }, {
        key: "toString",
        value: function toString() {
          var _this108 = this;
          return this.init(), this.keys().map(function (t) {
            var n = _this108.encoder.encodeKey(t);
            return _this108.map.get(t).map(function (r) {
              return n + "=" + _this108.encoder.encodeValue(r);
            }).join("&");
          }).filter(function (t) {
            return "" !== t;
          }).join("&");
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var n = new ir({
            encoder: this.encoder
          });
          return n.cloneFrom = this.cloneFrom || this, n.updates = (this.updates || []).concat(t), n;
        }
      }, {
        key: "init",
        value: function init() {
          var _this109 = this;
          null === this.map && (this.map = new Map()), null !== this.cloneFrom && (this.cloneFrom.init(), this.cloneFrom.keys().forEach(function (t) {
            return _this109.map.set(t, _this109.cloneFrom.map.get(t));
          }), this.updates.forEach(function (t) {
            switch (t.op) {
              case "a":
              case "s":
                var n = ("a" === t.op ? _this109.map.get(t.param) : void 0) || [];
                n.push(el(t.value)), _this109.map.set(t.param, n);
                break;
              case "d":
                if (void 0 === t.value) {
                  _this109.map.delete(t.param);
                  break;
                }
                {
                  var r = _this109.map.get(t.param) || [];
                  var o = r.indexOf(el(t.value));
                  -1 !== o && r.splice(o, 1), r.length > 0 ? _this109.map.set(t.param, r) : _this109.map.delete(t.param);
                }
            }
          }), this.cloneFrom = this.updates = null);
        }
      }]);
    }();
    var l$ = /*#__PURE__*/function () {
      function l$() {
        _classCallCheck(this, l$);
        _defineProperty(this, "map", new Map());
      }
      return _createClass(l$, [{
        key: "set",
        value: function set(t, n) {
          return this.map.set(t, n), this;
        }
      }, {
        key: "get",
        value: function get(t) {
          return this.map.has(t) || this.map.set(t, t.defaultValue()), this.map.get(t);
        }
      }, {
        key: "delete",
        value: function _delete(t) {
          return this.map.delete(t), this;
        }
      }, {
        key: "has",
        value: function has(t) {
          return this.map.has(t);
        }
      }, {
        key: "keys",
        value: function keys() {
          return this.map.keys();
        }
      }]);
    }();
    function IM(e) {
      return (typeof ArrayBuffer === "undefined" ? "undefined" : _typeof(ArrayBuffer)) < "u" && e instanceof ArrayBuffer;
    }
    function _M(e) {
      return (typeof Blob === "undefined" ? "undefined" : _typeof(Blob)) < "u" && e instanceof Blob;
    }
    function bM(e) {
      return (typeof FormData === "undefined" ? "undefined" : _typeof(FormData)) < "u" && e instanceof FormData;
    }
    var Ks = "Content-Type",
      Mg = "X-Request-URL",
      MM = "text/plain",
      SM = "application/json",
      TM = "".concat(SM, ", ").concat(MM, ", */*");
    var Xs = /*#__PURE__*/function () {
      function Xs(t, n, r, o) {
        var _this$headers, _this$context;
        _classCallCheck(this, Xs);
        _defineProperty(this, "url", void 0);
        _defineProperty(this, "body", null);
        _defineProperty(this, "headers", void 0);
        _defineProperty(this, "context", void 0);
        _defineProperty(this, "reportProgress", !1);
        _defineProperty(this, "withCredentials", !1);
        _defineProperty(this, "responseType", "json");
        _defineProperty(this, "method", void 0);
        _defineProperty(this, "params", void 0);
        _defineProperty(this, "urlWithParams", void 0);
        _defineProperty(this, "transferCache", void 0);
        var i;
        if (this.url = n, this.method = t.toUpperCase(), function d$(e) {
          switch (e) {
            case "DELETE":
            case "GET":
            case "HEAD":
            case "OPTIONS":
            case "JSONP":
              return !1;
            default:
              return !0;
          }
        }(this.method) || o ? (this.body = void 0 !== r ? r : null, i = o) : i = r, i && (this.reportProgress = !!i.reportProgress, this.withCredentials = !!i.withCredentials, i.responseType && (this.responseType = i.responseType), i.headers && (this.headers = i.headers), i.context && (this.context = i.context), i.params && (this.params = i.params), this.transferCache = i.transferCache), (_this$headers = this.headers) !== null && _this$headers !== void 0 ? _this$headers : this.headers = new Kt(), (_this$context = this.context) !== null && _this$context !== void 0 ? _this$context : this.context = new l$(), this.params) {
          var s = this.params.toString();
          if (0 === s.length) this.urlWithParams = n;else {
            var a = n.indexOf("?");
            this.urlWithParams = n + (-1 === a ? "?" : a < n.length - 1 ? "&" : "") + s;
          }
        } else this.params = new ir(), this.urlWithParams = n;
      }
      return _createClass(Xs, [{
        key: "serializeBody",
        value: function serializeBody() {
          return null === this.body ? null : "string" == typeof this.body || IM(this.body) || _M(this.body) || bM(this.body) || function f$(e) {
            return (typeof URLSearchParams === "undefined" ? "undefined" : _typeof(URLSearchParams)) < "u" && e instanceof URLSearchParams;
          }(this.body) ? this.body : this.body instanceof ir ? this.body.toString() : "object" == _typeof(this.body) || "boolean" == typeof this.body || Array.isArray(this.body) ? JSON.stringify(this.body) : this.body.toString();
        }
      }, {
        key: "detectContentTypeHeader",
        value: function detectContentTypeHeader() {
          return null === this.body || bM(this.body) ? null : _M(this.body) ? this.body.type || null : IM(this.body) ? null : "string" == typeof this.body ? MM : this.body instanceof ir ? "application/x-www-form-urlencoded;charset=UTF-8" : "object" == _typeof(this.body) || "number" == typeof this.body || "boolean" == typeof this.body ? SM : null;
        }
      }, {
        key: "clone",
        value: function clone() {
          var _t$transferCache, _t$withCredentials, _t$reportProgress, _t$context;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var n = t.method || this.method,
            r = t.url || this.url,
            o = t.responseType || this.responseType,
            i = (_t$transferCache = t.transferCache) !== null && _t$transferCache !== void 0 ? _t$transferCache : this.transferCache,
            s = void 0 !== t.body ? t.body : this.body,
            a = (_t$withCredentials = t.withCredentials) !== null && _t$withCredentials !== void 0 ? _t$withCredentials : this.withCredentials,
            u = (_t$reportProgress = t.reportProgress) !== null && _t$reportProgress !== void 0 ? _t$reportProgress : this.reportProgress;
          var c = t.headers || this.headers,
            l = t.params || this.params;
          var d = (_t$context = t.context) !== null && _t$context !== void 0 ? _t$context : this.context;
          return void 0 !== t.setHeaders && (c = Object.keys(t.setHeaders).reduce(function (h, f) {
            return h.set(f, t.setHeaders[f]);
          }, c)), t.setParams && (l = Object.keys(t.setParams).reduce(function (h, f) {
            return h.set(f, t.setParams[f]);
          }, l)), new Xs(n, r, s, {
            params: l,
            headers: c,
            context: d,
            reportProgress: u,
            responseType: o,
            withCredentials: a,
            transferCache: i
          });
        }
      }]);
    }();
    var sr = function (e) {
      return e[e.Sent = 0] = "Sent", e[e.UploadProgress = 1] = "UploadProgress", e[e.ResponseHeader = 2] = "ResponseHeader", e[e.DownloadProgress = 3] = "DownloadProgress", e[e.Response = 4] = "Response", e[e.User = 5] = "User", e;
    }(sr || {});
    var Sg = /*#__PURE__*/_createClass(function Sg(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "OK";
      _classCallCheck(this, Sg);
      _defineProperty(this, "headers", void 0);
      _defineProperty(this, "status", void 0);
      _defineProperty(this, "statusText", void 0);
      _defineProperty(this, "url", void 0);
      _defineProperty(this, "ok", void 0);
      _defineProperty(this, "type", void 0);
      this.headers = t.headers || new Kt(), this.status = void 0 !== t.status ? t.status : n, this.statusText = t.statusText || r, this.url = t.url || null, this.ok = this.status >= 200 && this.status < 300;
    });
    var nl = /*#__PURE__*/function (_Sg2) {
      function nl() {
        var _this110;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, nl);
        _this110 = _callSuper(this, nl, [t]);
        _defineProperty(_this110, "type", sr.ResponseHeader);
        return _this110;
      }
      _inherits(nl, _Sg2);
      return _createClass(nl, [{
        key: "clone",
        value: function clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return new nl({
            headers: t.headers || this.headers,
            status: void 0 !== t.status ? t.status : this.status,
            statusText: t.statusText || this.statusText,
            url: t.url || this.url || void 0
          });
        }
      }]);
    }(Sg);
    var ea = /*#__PURE__*/function (_Sg3) {
      function ea() {
        var _this111;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, ea);
        _this111 = _callSuper(this, ea, [t]), _defineProperty(_assertThisInitialized(_this111), "body", void 0), _defineProperty(_assertThisInitialized(_this111), "type", sr.Response), _this111.body = void 0 !== t.body ? t.body : null;
        return _this111;
      }
      _inherits(ea, _Sg3);
      return _createClass(ea, [{
        key: "clone",
        value: function clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return new ea({
            body: void 0 !== t.body ? t.body : this.body,
            headers: t.headers || this.headers,
            status: void 0 !== t.status ? t.status : this.status,
            statusText: t.statusText || this.statusText,
            url: t.url || this.url || void 0
          });
        }
      }]);
    }(Sg);
    var fi = /*#__PURE__*/function (_Sg4) {
      function fi(t) {
        var _this112;
        _classCallCheck(this, fi);
        _this112 = _callSuper(this, fi, [t, 0, "Unknown Error"]), _defineProperty(_assertThisInitialized(_this112), "name", "HttpErrorResponse"), _defineProperty(_assertThisInitialized(_this112), "message", void 0), _defineProperty(_assertThisInitialized(_this112), "error", void 0), _defineProperty(_assertThisInitialized(_this112), "ok", !1), _this112.message = _this112.status >= 200 && _this112.status < 300 ? "Http failure during parsing for ".concat(t.url || "(unknown url)") : "Http failure response for ".concat(t.url || "(unknown url)", ": ").concat(t.status, " ").concat(t.statusText), _this112.error = t.error || null;
        return _this112;
      }
      _inherits(fi, _Sg4);
      return _createClass(fi);
    }(Sg);
    function Tg(e, t) {
      return {
        body: t,
        headers: e.headers,
        context: e.context,
        observe: e.observe,
        params: e.params,
        reportProgress: e.reportProgress,
        responseType: e.responseType,
        withCredentials: e.withCredentials,
        transferCache: e.transferCache
      };
    }
    var RM = function (_e65) {
      var e = /*#__PURE__*/function () {
        function e(n) {
          _classCallCheck(this, e);
          _defineProperty(this, "handler", void 0);
          this.handler = n;
        }
        return _createClass(e, [{
          key: "request",
          value: function request(n, r) {
            var _this113 = this;
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i;
            if (n instanceof Xs) i = n;else {
              var u, c;
              u = o.headers instanceof Kt ? o.headers : new Kt(o.headers), o.params && (c = o.params instanceof ir ? o.params : new ir({
                fromObject: o.params
              })), i = new Xs(n, r, void 0 !== o.body ? o.body : null, {
                headers: u,
                context: o.context,
                params: c,
                reportProgress: o.reportProgress,
                responseType: o.responseType || "json",
                withCredentials: o.withCredentials,
                transferCache: o.transferCache
              });
            }
            var s = V(i).pipe(Fs(function (u) {
              return _this113.handler.handle(u);
            }));
            if (n instanceof Xs || "events" === o.observe) return s;
            var a = s.pipe(tr(function (u) {
              return u instanceof ea;
            }));
            switch (o.observe || "body") {
              case "body":
                switch (i.responseType) {
                  case "arraybuffer":
                    return a.pipe(Y(function (u) {
                      if (null !== u.body && !(u.body instanceof ArrayBuffer)) throw new E(2806, !1);
                      return u.body;
                    }));
                  case "blob":
                    return a.pipe(Y(function (u) {
                      if (null !== u.body && !(u.body instanceof Blob)) throw new E(2807, !1);
                      return u.body;
                    }));
                  case "text":
                    return a.pipe(Y(function (u) {
                      if (null !== u.body && "string" != typeof u.body) throw new E(2808, !1);
                      return u.body;
                    }));
                  default:
                    return a.pipe(Y(function (u) {
                      return u.body;
                    }));
                }
              case "response":
                return a;
              default:
                throw new E(2809, !1);
            }
          }
        }, {
          key: "delete",
          value: function _delete(n) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.request("DELETE", n, r);
          }
        }, {
          key: "get",
          value: function get(n) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.request("GET", n, r);
          }
        }, {
          key: "head",
          value: function head(n) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.request("HEAD", n, r);
          }
        }, {
          key: "jsonp",
          value: function jsonp(n, r) {
            return this.request("JSONP", n, {
              params: new ir().append(r, "JSONP_CALLBACK"),
              observe: "body",
              responseType: "json"
            });
          }
        }, {
          key: "options",
          value: function options(n) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.request("OPTIONS", n, r);
          }
        }, {
          key: "patch",
          value: function patch(n, r) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return this.request("PATCH", n, Tg(o, r));
          }
        }, {
          key: "post",
          value: function post(n, r) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return this.request("POST", n, Tg(o, r));
          }
        }, {
          key: "put",
          value: function put(n, r) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return this.request("PUT", n, Tg(o, r));
          }
        }]);
      }();
      _e65 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e65)(T(Kc));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e65,
        factory: _e65.ɵfac
      }));
      return e;
    }();
    var xM = new I("");
    function kM(e, t) {
      return t(e);
    }
    var ta = new I(""),
      E$ = new I(""),
      OM = new I("", {
        providedIn: "root",
        factory: function factory() {
          return !0;
        }
      });
    var PM = function (_e66) {
      var e = /*#__PURE__*/function (_Kc) {
        function e(n, r) {
          var _this114;
          _classCallCheck(this, e);
          _this114 = _callSuper(this, e), _defineProperty(_assertThisInitialized(_this114), "backend", void 0), _defineProperty(_assertThisInitialized(_this114), "injector", void 0), _defineProperty(_assertThisInitialized(_this114), "chain", null), _defineProperty(_assertThisInitialized(_this114), "pendingTasks", w(Hn)), _defineProperty(_assertThisInitialized(_this114), "contributeToStability", w(OM)), _assertThisInitialized(_this114), _this114.backend = n, _this114.injector = r;
          return _this114;
        }
        _inherits(e, _Kc);
        return _createClass(e, [{
          key: "handle",
          value: function handle(n) {
            var _this115 = this;
            if (null === this.chain) {
              var r = Array.from(new Set([].concat(_toConsumableArray(this.injector.get(ta)), _toConsumableArray(this.injector.get(E$, [])))));
              this.chain = r.reduceRight(function (o, i) {
                return function D$(e, t, n) {
                  return function (r, o) {
                    return Ft(n, function () {
                      return t(r, function (i) {
                        return e(i, o);
                      });
                    });
                  };
                }(o, i, _this115.injector);
              }, kM);
            }
            if (this.contributeToStability) {
              var _r20 = this.pendingTasks.add();
              return this.chain(n, function (o) {
                return _this115.backend.handle(o);
              }).pipe(Ec(function () {
                return _this115.pendingTasks.remove(_r20);
              }));
            }
            return this.chain(n, function (r) {
              return _this115.backend.handle(r);
            });
          }
        }]);
      }(Kc);
      _e66 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e66)(T(Xc), T(at));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e66,
        factory: _e66.ɵfac
      }));
      return e;
    }();
    var M$ = /^\)\]\}',?\n/,
      S$ = RegExp("^".concat(Mg, ":"), "m");
    var LM = function (_e67) {
      var e = /*#__PURE__*/function () {
        function e(n) {
          _classCallCheck(this, e);
          _defineProperty(this, "xhrFactory", void 0);
          this.xhrFactory = n;
        }
        return _createClass(e, [{
          key: "handle",
          value: function handle(n) {
            if ("JSONP" === n.method) throw new E(-2800, !1);
            var r = this.xhrFactory;
            return (r.ɵloadImpl ? qe(r.ɵloadImpl()) : V(null)).pipe(fn(function () {
              return new _e(function (i) {
                var s = r.build();
                if (s.open(n.method, n.urlWithParams), n.withCredentials && (s.withCredentials = !0), n.headers.forEach(function (g, m) {
                  return s.setRequestHeader(g, m.join(","));
                }), n.headers.has("Accept") || s.setRequestHeader("Accept", TM), !n.headers.has(Ks)) {
                  var g = n.detectContentTypeHeader();
                  null !== g && s.setRequestHeader(Ks, g);
                }
                if (n.responseType) {
                  var _g = n.responseType.toLowerCase();
                  s.responseType = "json" !== _g ? _g : "text";
                }
                var a = n.serializeBody();
                var u = null;
                var c = function c() {
                    if (null !== u) return u;
                    var g = s.statusText || "OK",
                      m = new Kt(s.getAllResponseHeaders()),
                      D = function T$(e) {
                        return "responseURL" in e && e.responseURL ? e.responseURL : S$.test(e.getAllResponseHeaders()) ? e.getResponseHeader(Mg) : null;
                      }(s) || n.url;
                    return u = new nl({
                      headers: m,
                      status: s.status,
                      statusText: g,
                      url: D
                    }), u;
                  },
                  l = function l() {
                    var _c9 = c(),
                      g = _c9.headers,
                      m = _c9.status,
                      D = _c9.statusText,
                      y = _c9.url,
                      _ = null;
                    204 !== m && (_ = _typeof(s.response) > "u" ? s.responseText : s.response), 0 === m && (m = _ ? 200 : 0);
                    var H = m >= 200 && m < 300;
                    if ("json" === n.responseType && "string" == typeof _) {
                      var q = _;
                      _ = _.replace(M$, "");
                      try {
                        _ = "" !== _ ? JSON.parse(_) : null;
                      } catch (rt) {
                        _ = q, H && (H = !1, _ = {
                          error: rt,
                          text: _
                        });
                      }
                    }
                    H ? (i.next(new ea({
                      body: _,
                      headers: g,
                      status: m,
                      statusText: D,
                      url: y || void 0
                    })), i.complete()) : i.error(new fi({
                      error: _,
                      headers: g,
                      status: m,
                      statusText: D,
                      url: y || void 0
                    }));
                  },
                  d = function d(g) {
                    var _c0 = c(),
                      m = _c0.url,
                      D = new fi({
                        error: g,
                        status: s.status || 0,
                        statusText: s.statusText || "Unknown Error",
                        url: m || void 0
                      });
                    i.error(D);
                  };
                var h = !1;
                var f = function f(g) {
                    h || (i.next(c()), h = !0);
                    var m = {
                      type: sr.DownloadProgress,
                      loaded: g.loaded
                    };
                    g.lengthComputable && (m.total = g.total), "text" === n.responseType && s.responseText && (m.partialText = s.responseText), i.next(m);
                  },
                  p = function p(g) {
                    var m = {
                      type: sr.UploadProgress,
                      loaded: g.loaded
                    };
                    g.lengthComputable && (m.total = g.total), i.next(m);
                  };
                return s.addEventListener("load", l), s.addEventListener("error", d), s.addEventListener("timeout", d), s.addEventListener("abort", d), n.reportProgress && (s.addEventListener("progress", f), null !== a && s.upload && s.upload.addEventListener("progress", p)), s.send(a), i.next({
                  type: sr.Sent
                }), function () {
                  s.removeEventListener("error", d), s.removeEventListener("abort", d), s.removeEventListener("load", l), s.removeEventListener("timeout", d), n.reportProgress && (s.removeEventListener("progress", f), null !== a && s.upload && s.upload.removeEventListener("progress", p)), s.readyState !== s.DONE && s.abort();
                };
              });
            }));
          }
        }]);
      }();
      _e67 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e67)(T(E_));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e67,
        factory: _e67.ɵfac
      }));
      return e;
    }();
    var Ag = new I(""),
      jM = new I("", {
        providedIn: "root",
        factory: function factory() {
          return "XSRF-TOKEN";
        }
      }),
      VM = new I("", {
        providedIn: "root",
        factory: function factory() {
          return "X-XSRF-TOKEN";
        }
      });
    var BM = /*#__PURE__*/_createClass(function BM() {
      _classCallCheck(this, BM);
    });
    var A$ = function (_e68) {
      var e = /*#__PURE__*/function () {
        function e(n, r) {
          _classCallCheck(this, e);
          _defineProperty(this, "doc", void 0);
          _defineProperty(this, "cookieName", void 0);
          _defineProperty(this, "lastCookieString", "");
          _defineProperty(this, "lastToken", null);
          _defineProperty(this, "parseCount", 0);
          this.doc = n, this.cookieName = r;
        }
        return _createClass(e, [{
          key: "getToken",
          value: function getToken() {
            var n = this.doc.cookie || "";
            return n !== this.lastCookieString && (this.parseCount++, this.lastToken = y_(n, this.cookieName), this.lastCookieString = n), this.lastToken;
          }
        }]);
      }();
      _e68 = e;
      _defineProperty(e, "\u0275fac", function (r) {
        return new (r || _e68)(T(Gt), T(jM));
      });
      _defineProperty(e, "\u0275prov", b({
        token: _e68,
        factory: _e68.ɵfac
      }));
      return e;
    }();
    function x$(e, t) {
      var n = e.url.toLowerCase();
      if (!w(Ag) || "GET" === e.method || "HEAD" === e.method || n.startsWith("http://") || n.startsWith("https://")) return t(e);
      var r = w(BM).getToken(),
        o = w(VM);
      return null != r && !e.headers.has(o) && (e = e.clone({
        headers: e.headers.set(o, r)
      })), t(e);
    }
    var O$ = function (_e69) {
      var e = /*#__PURE__*/_createClass(function e(n) {
        var _this116 = this;
        _classCallCheck(this, e);
        this.http = n, this.game = w(Wr), this.allCards = function EM(e, t, _t$injector$get, _t$injector) {
          var n = !(t !== null && t !== void 0 && t.manualCleanup);
          n && !(t !== null && t !== void 0 && t.injector) && yr();
          var r = n ? (_t$injector$get = t === null || t === void 0 || (_t$injector = t.injector) === null || _t$injector === void 0 ? void 0 : _t$injector.get(Bt)) !== null && _t$injector$get !== void 0 ? _t$injector$get : w(Bt) : null,
            o = function r$() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.is;
              return function (t, n) {
                return 1 === t.kind && 1 === n.kind && e(t.value, n.value);
              };
            }(t === null || t === void 0 ? void 0 : t.equal);
          var i;
          i = Ue(t !== null && t !== void 0 && t.requireSync ? {
            kind: 0
          } : {
            kind: 1,
            value: t === null || t === void 0 ? void 0 : t.initialValue
          }, {
            equal: o
          });
          var s = e.subscribe({
            next: function next(a) {
              return i.set({
                kind: 1,
                value: a
              });
            },
            error: function error(a) {
              if (t !== null && t !== void 0 && t.rejectErrors) throw a;
              i.set({
                kind: 2,
                error: a
              });
            }
          });
          if (t !== null && t !== void 0 && t.requireSync && 0 === i().kind) throw new E(601, !1);
          return r !== null && r !== void 0 && r.onDestroy(s.unsubscribe.bind(s)), Pn(function () {
            var a = i();
            switch (a.kind) {
              case 1:
                return a.value;
              case 2:
                throw a.error;
              case 0:
                throw new E(601, !1);
            }
          }, {
            equal: t === null || t === void 0 ? void 0 : t.equal
          });
        }(this.http.get("data/tech-sound-cards.json"), {
          initialValue: []
        }), this.roundCards = Pn(function () {
          var r = _this116.allCards(),
            o = _this116.game.usedAnswerIds();
          if (!r || r.length < 3) return [];
          var i = r.filter(function (c) {
            return !o.has(c.id);
          });
          i.length < 1 && (console.warn("All answers have been used, allowing repeats"), i.push.apply(i, _toConsumableArray(r)));
          var s = i[Math.floor(Math.random() * i.length)],
            a = r.filter(function (c) {
              return c.id !== s.id;
            }).sort(function () {
              return Math.random() - .5;
            }).slice(0, 2);
          return [s].concat(_toConsumableArray(a)).sort(function () {
            return Math.random() - .5;
          }).map(function (c, l) {
            return _objectSpread(_objectSpread({}, c), {}, {
              isAnswer: c.id === s.id,
              buttonColor: 0 === l ? "bg-rose-600" : 1 === l ? "bg-lime-600" : "bg-indigo-600",
              isReverseLayout: 1 === l,
              imageRotation: 1 === l ? "transform rotate-[-5deg]" : "transform rotate-[5deg]"
            });
          });
        });
      });
      _e69 = e;
      _e69.ɵfac = function (r) {
        return new (r || _e69)(T(RM));
      };
      _e69.ɵprov = b({
        token: _e69,
        factory: _e69.ɵfac,
        providedIn: "root"
      });
      return e;
    }();
    var _rl = function rl() {
        return _rl = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }, _rl.apply(this, arguments);
      },
      P$ = function () {
        function e(t, n, r) {
          var o = this;
          this.endVal = n, this.options = r, this.version = "2.9.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
          }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function (i) {
            o.startTime || (o.startTime = i);
            var s = i - o.startTime;
            o.remaining = o.duration - s, o.frameVal = o.useEasing ? o.countDown ? o.startVal - o.easingFn(s, 0, o.startVal - o.endVal, o.duration) : o.easingFn(s, o.startVal, o.endVal - o.startVal, o.duration) : o.startVal + s / o.duration * (o.endVal - o.startVal), o.frameVal = (o.countDown ? o.frameVal < o.endVal : o.frameVal > o.endVal) ? o.endVal : o.frameVal, o.frameVal = Number(o.frameVal.toFixed(o.options.decimalPlaces)), o.printValue(o.frameVal), s < o.duration ? o.rAF = requestAnimationFrame(o.count) : null !== o.finalEndVal ? o.update(o.finalEndVal) : o.options.onCompleteCallback && o.options.onCompleteCallback();
          }, this.formatNumber = function (i) {
            var s,
              a,
              u,
              c,
              l = i < 0 ? "-" : "";
            s = Math.abs(i).toFixed(o.options.decimalPlaces);
            var d = (s += "").split(".");
            if (a = d[0], u = d.length > 1 ? o.options.decimal + d[1] : "", o.options.useGrouping) {
              c = "";
              for (var h = 3, f = 0, p = 0, g = a.length; p < g; ++p) o.options.useIndianSeparators && 4 === p && (h = 2, f = 1), 0 !== p && f % h == 0 && (c = o.options.separator + c), f++, c = a[g - p - 1] + c;
              a = c;
            }
            return o.options.numerals && o.options.numerals.length && (a = a.replace(/[0-9]/g, function (m) {
              return o.options.numerals[+m];
            }), u = u.replace(/[0-9]/g, function (m) {
              return o.options.numerals[+m];
            })), l + o.options.prefix + a + u + o.options.suffix;
          }, this.easeOutExpo = function (i, s, a, u) {
            return a * (1 - Math.pow(2, -10 * i / u)) * 1024 / 1023 + s;
          }, this.options = _rl(_rl({}, this.defaults), r), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = "string" == typeof t ? document.getElementById(t) : t, n = n !== null && n !== void 0 ? n : this.parse(this.el.innerHTML), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function () {
            return o.handleScroll(o);
          }), window.onscroll = function () {
            window.onScrollFns.forEach(function (i) {
              return i();
            });
          }, this.handleScroll(this)));
        }
        return e.prototype.handleScroll = function (t) {
          if (t && window && !t.once) {
            var n = window.innerHeight + window.scrollY,
              r = t.el.getBoundingClientRect(),
              o = r.top + window.pageYOffset,
              i = r.top + r.height + window.pageYOffset;
            i < n && i > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function () {
              return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > i || o > n) && !t.paused && t.reset();
          }
        }, e.prototype.determineDirectionAndSmartEasing = function () {
          var t = this.finalEndVal ? this.finalEndVal : this.endVal;
          this.countDown = this.startVal > t, Math.abs(t - this.startVal) > this.options.smartEasingThreshold && this.options.useEasing ? (this.finalEndVal = t, this.endVal = t + (this.countDown ? 1 : -1) * this.options.smartEasingAmount, this.duration = this.duration / 2) : (this.endVal = t, this.finalEndVal = null), this.useEasing = null === this.finalEndVal && this.options.useEasing;
        }, e.prototype.start = function (t) {
          this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
        }, e.prototype.pauseResume = function () {
          this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
        }, e.prototype.reset = function () {
          cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
        }, e.prototype.update = function (t) {
          cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
        }, e.prototype.printValue = function (t) {
          var n;
          if (this.el) {
            var r = this.formattingFn(t);
            null !== (n = this.options.plugin) && void 0 !== n && n.render ? this.options.plugin.render(this.el, r) : "INPUT" === this.el.tagName ? this.el.value = r : "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = r : this.el.innerHTML = r;
          }
        }, e.prototype.ensureNumber = function (t) {
          return "number" == typeof t && !isNaN(t);
        }, e.prototype.validateValue = function (t) {
          var n = Number(t);
          return this.ensureNumber(n) ? n : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
        }, e.prototype.resetDuration = function () {
          this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
        }, e.prototype.parse = function (t) {
          var n = function n(s) {
              return s.replace(/([.,'\xa0 ])/g, "\\$1");
            },
            r = n(this.options.separator),
            o = n(this.options.decimal),
            i = t.replace(new RegExp(r, "g"), "").replace(new RegExp(o, "g"), ".");
          return parseFloat(i);
        }, e;
      }();
    var F$ = ["scoreContainer"];
    var HM = function (_e70) {
      var e = /*#__PURE__*/function () {
        function e() {
          _classCallCheck(this, e);
          this.game = w(Wr), this.round = this.game.round, this.previousScore = this.game.previousScore, this.score = this.game.score;
        }
        return _createClass(e, [{
          key: "ngAfterViewInit",
          value: function ngAfterViewInit() {
            this.counter = new P$(this.scoreContainer.nativeElement, this.score(), {
              startVal: this.previousScore(),
              duration: 1.2
            }), this.counter.start();
          }
        }]);
      }();
      _e70 = e;
      _e70.ɵfac = function (r) {
        return new (r || _e70)();
      };
      _e70.ɵcmp = Nt({
        type: _e70,
        selectors: [["app-header"]],
        viewQuery: function viewQuery(r, o) {
          if (1 & r && Gh(F$, 7), 2 & r) {
            var i;
            tc(i = nc()) && (o.scoreContainer = i.first);
          }
        },
        decls: 19,
        vars: 1,
        consts: [["scoreContainer", ""], [1, "py-[2vh]", "px-[3.375vh]", "flex", "justify-between"], [1, "text-center"], [1, "text-white", "uppercase", "tracking-widest", "text-[2.25vh]"], [1, "font-8-bit", "text-[4.5vh]", "text-primary", "uppercase", "text-center", "leading-[1.0]"], [1, "text-primary", "uppercase", "text-center", "leading-[1.1]"], [1, "block", "font-bold", "text-[2.25vh]", "tracking-widest"], [1, "block"], [1, "block", "font-8-bit", "text-[4.95vh]", "uppercase", "leading-[0.9]"]],
        template: function template(r, o) {
          1 & r && (O(0, "header", 1)(1, "div", 2)(2, "div", 3), W(3, " Round "), N(), O(4, "div", 4), W(5), N()(), O(6, "h1", 5)(7, "span", 6)(8, "span", 7), W(9, "Guess That"), N(), O(10, "span", 7), W(11, "Technology"), N()(), O(12, "span", 8), W(13, " Sound "), N()(), O(14, "div", 2)(15, "div", 3), W(16, " Score "), N(), pe(17, "div", 4, 0), N()()), 2 & r && (ae(5), At(" ", o.round(), " "));
        },
        encapsulation: 2
      });
      return e;
    }();
    function L$(e, t) {
      1 & e && (O(0, "div"), pe(1, "app-header"), N());
    }
    function j$(e, t) {
      if (1 & e && (O(0, "div", 4)(1, "div", 5)(2, "div", 6)(3, "div", 7), W(4, " Round "), N(), O(5, "div", 8), W(6), N()(), O(7, "p", 9), W(8, "Press play to"), pe(9, "br"), W(10, "play the sound"), N()()()), 2 & e) {
        var n = ei();
        ae(6), At(" ", n.round(), " ");
      }
    }
    function V$(e, t) {
      if (1 & e) {
        var n = function XE() {
          return v();
        }();
        O(0, "app-audio-visualizer", 14), Ss("playbackEnded", function () {
          return function Lm(e) {
            return F.lFrame.contextLView = e, e[8];
          }(n), function jm(e) {
            return F.lFrame.contextLView = null, e;
          }(ei(2).handlePlaybackEnded());
        }), N();
      }
      2 & e && xe("audioUrl", ei(2).answerCardAudioSrc());
    }
    function B$(e, t) {
      if (1 & e && (O(0, "div")(1, "div", 10)(2, "h1", 11), W(3, " What's That Sound? "), N()(), O(4, "div", 12), kn(5, V$, 1, 1, "app-audio-visualizer", 13), N()()), 2 & e) {
        var n = ei();
        ae(5), xe("ngIf", n.isPlayingSound());
      }
    }
    function U$(e, t) {
      1 & e && (O(0, "div", 21), W(1, " Press play to"), pe(2, "br"), W(3, "play the sound again "), N());
    }
    function H$(e, t) {
      1 & e && (O(0, "div", 22), W(1, " Incorrect! Please try again "), N());
    }
    function $$(e, t) {
      if (1 & e && (Zu(0), pe(1, "app-tech-sound-card", 23), Qu()), 2 & e) {
        var n = t.$implicit,
          r = t.index;
        ae(), xe("image", n.image)("title", n.title)("buttonColor", n.buttonColor)("isReverseLayout", !!n.isReverseLayout)("imageRotation", n.imageRotation)("isAnswer", !!n.isAnswer)("cardIndex", r);
      }
    }
    function z$(e, t) {
      if (1 & e && (O(0, "div", 15)(1, "div", 16), kn(2, U$, 4, 0, "div", 17)(3, H$, 2, 0, "div", 18), N(), O(4, "div", 19), kn(5, $$, 2, 7, "ng-container", 20), N()()), 2 & e) {
        var n = ei();
        ae(2), xe("ngIf", !n.isInError()), ae(), xe("ngIf", n.isInError()), ae(2), xe("ngForOf", n.roundCards());
      }
    }
    var q$ = function (_e71) {
        var e = /*#__PURE__*/function () {
          function e() {
            var _this117 = this;
            _classCallCheck(this, e);
            this.game = w(Wr), this.audio = w(cg), this.inputService = w(Ys), this.outputService = w(Bc), this.service = w(O$), this.round = this.game.round, this.guess = this.game.guess, this.score = this.game.score, this.isPlayingSound = Ue(!1), this.hasPlayedSound = Ue(!1), this.isInError = Ue(!1), this.answerCardAudioSrc = Ue(null), this.roundCards = Pn(function () {
              return _this117.service.roundCards();
            }), function hp(e, t, _t$injector2) {
              !(t !== null && t !== void 0 && t.injector) && yr();
              var n = (_t$injector2 = t === null || t === void 0 ? void 0 : t.injector) !== null && _t$injector2 !== void 0 ? _t$injector2 : w(Be);
              var o,
                r = !0 !== (t === null || t === void 0 ? void 0 : t.manualCleanup) ? n.get(Bt) : null;
              var i = n.get(ru, null, {
                  optional: !0
                }),
                s = n.get(Sn);
              return null === i || t !== null && t !== void 0 && t.forceRoot ? o = function vj(e, t, n) {
                var r = Object.create(pj);
                return r.fn = e, r.scheduler = t, r.notifier = n, r.zone = (typeof Zone === "undefined" ? "undefined" : _typeof(Zone)) < "u" ? Zone.current : null, r.scheduler.schedule(r), r.notifier.notify(12), r;
              }(e, n.get(lE), s) : (o = function mj(e, t, n, _5, _e$_2) {
                var r = Object.create(gj);
                return r.view = e, r.zone = (typeof Zone === "undefined" ? "undefined" : _typeof(Zone)) < "u" ? Zone.current : null, r.notifier = t, r.fn = n, (_e$_2 = e[_5 = 23]) !== null && _e$_2 !== void 0 ? _e$_2 : e[_5] = new Set(), e[23].add(r), r.consumerMarkedDirty(r), r;
              }(i.view, s, e), r instanceof wv && r._lView === i.view && (r = null)), o.injector = n, null !== r && (o.onDestroyFn = r.onDestroy(function () {
                return o.destroy();
              })), new hj(o);
            }(function () {
              var n = _this117.isPlayingSound(),
                r = _this117.hasPlayedSound();
              if (_this117.outputService.setPinsToZero(), !n) return !n && r ? (_this117.outputService.stopBlinking(), void _this117.outputService.setOutputState([0, 1, 1, 1])) : void (!n && !r && _this117.outputService.startBlinkingPin0());
              _this117.outputService.stopBlinking();
            });
          }
          return _createClass(e, [{
            key: "ngOnInit",
            value: function ngOnInit() {
              var _this118 = this;
              this.inputSub = this.inputService.actions$.subscribe(function (n) {
                var r = _this118.roundCards().find(function (o) {
                  return o.isAnswer;
                });
                if (r) {
                  if (_this118.answerCardAudioSrc.set(r.audio), "play" === n && !_this118.isPlayingSound() && _this118.playAnswerSound(), !_this118.isPlayingSound() && _this118.hasPlayedSound()) {
                    var o = _this118.guess();
                    _this118.guess.set(o + 1);
                    var s = {
                      select_a: 0,
                      select_b: 1,
                      select_c: 2
                    }[n];
                    if (void 0 !== s) {
                      var u = _this118.roundCards()[s];
                      u && (u === r ? (_this118.audio.play("audio/success.wav"), _this118.game.addUsedAnswerId(r.id), _this118.game.setLastAnswer(r), _this118.game.showResults()) : (_this118.isInError.set(!0), setTimeout(function () {
                        _this118.isInError.set(!1);
                      }, 1e3), _this118.audio.play("audio/error.mp3")));
                    }
                  }
                } else console.error("No answer card found for the current round");
              });
            }
          }, {
            key: "playAnswerSound",
            value: function playAnswerSound() {
              this.answerCardAudioSrc && this.isPlayingSound.set(!0);
            }
          }, {
            key: "handlePlaybackEnded",
            value: function handlePlaybackEnded() {
              this.isPlayingSound.set(!1), this.hasPlayedSound.set(!0);
            }
          }, {
            key: "ngOnDestroy",
            value: function ngOnDestroy() {
              this.inputSub.unsubscribe(), this.outputService.setPinsToZero();
            }
          }]);
        }();
        _e71 = e;
        _e71.ɵfac = function (r) {
          return new (r || _e71)();
        };
        _e71.ɵcmp = Nt({
          type: _e71,
          selectors: [["app-round"]],
          decls: 7,
          vars: 4,
          consts: [[1, "absolute", "inset-0"], [4, "ngIf"], ["class", "text-center text-white h-[90vh] w-full flex items-center", 4, "ngIf"], ["class", "animate-fade animate-delay-250", 4, "ngIf"], [1, "text-center", "text-white", "h-[90vh]", "w-full", "flex", "items-center"], [1, "mx-auto"], [1, "animate-jump-in"], [1, "uppercase", "tracking-[2.25vh]", "text-[3.375vh]", "ml-[1.6875vh]"], [1, "font-8-bit", "text-[20.25vh]", "text-primary", "uppercase", "text-center", "leading-[1.0]"], [1, "animate-fade", "animate-delay-1000", "animate-duration-1500", "animate-infinite", "animate-alternate", "mt-[4vh]", "text-[2.25vh]", "uppercase", "leading-[1.25]", "tracking-[0.5625vh]"], [1, "text-center"], [1, "text-primary", "text-[6.75vh]", "leading-[1.0]", "tracking-wider", "uppercase", "px-[2.25vh]", "pt-[16vh]"], [1, "h-[60vh]"], [3, "audioUrl", "playbackEnded", 4, "ngIf"], [3, "playbackEnded", "audioUrl"], [1, "animate-fade", "animate-delay-250"], [1, "text-center", "text-[2.25vh]", "uppercase", "leading-[1]", "tracking-[0.28125vh]", "text-center"], ["class", "w-full h-[9vh] bg-black/20 flex items-center justify-center opacity-75", 4, "ngIf"], ["class", "w-full h-[9vh] text-red-500 bg-black/40 flex items-center justify-center", 4, "ngIf"], [1, "mt-[1.6875vh]"], [4, "ngFor", "ngForOf"], [1, "w-full", "h-[9vh]", "bg-black/20", "flex", "items-center", "justify-center", "opacity-75"], [1, "w-full", "h-[9vh]", "text-red-500", "bg-black/40", "flex", "items-center", "justify-center"], [3, "image", "title", "buttonColor", "isReverseLayout", "imageRotation", "isAnswer", "cardIndex"]],
          template: function template(r, o) {
            1 & r && (O(0, "div", 0), kn(1, L$, 2, 0, "div", 1), O(2, "main"), kn(3, j$, 11, 1, "div", 2)(4, B$, 6, 1, "div", 1)(5, z$, 6, 3, "div", 3), N(), pe(6, "app-footer"), N()), 2 & r && (ae(), xe("ngIf", o.hasPlayedSound() && !o.isPlayingSound()), ae(2), xe("ngIf", !o.hasPlayedSound() && !o.isPlayingSound()), ae(), xe("ngIf", o.isPlayingSound()), ae(), xe("ngIf", o.hasPlayedSound() && !o.isPlayingSound()));
          },
          dependencies: [yM, wg, Eg, Vc, HM, t$, eM],
          encapsulation: 2
        });
        return e;
      }(),
      $M = function (_e72) {
        var e = /*#__PURE__*/_createClass(function e() {
          _classCallCheck(this, e);
        });
        _e72 = e;
        _e72.ɵfac = function (r) {
          return new (r || _e72)();
        };
        _e72.ɵcmp = Nt({
          type: _e72,
          selectors: [["app-play-again"]],
          decls: 3,
          vars: 0,
          consts: [[1, "absolute", "bottom-[11vh]", "left-0", "right-0", "text-center", "text-[2.25vh]", "uppercase", "leading-[1]", "tracking-[0.2.8125vh]", "text-center"], [1, "w-full", "h-[9vh]", "bg-black/20", "flex", "items-center", "justify-center", "opacity-75"]],
          template: function template(r, o) {
            1 & r && (O(0, "div", 0)(1, "div", 1), W(2, " Press play to continue "), N()());
          },
          encapsulation: 2
        });
        return e;
      }();
    function G$(e, t) {
      if (1 & e && (O(0, "div", 6), pe(1, "img", 7), N()), 2 & e) {
        var n = t.$implicit;
        ae(), qu("opacity", n.opacity / 100), xe("src", n.src, Ji);
      }
    }
    function W$(e, t) {
      if (1 & e && (O(0, "div", 8)(1, "div", 9)(2, "h3", 10), W(3), N(), pe(4, "img", 11), N(), O(5, "div", 9)(6, "p", 12), W(7), N()()()), 2 & e) {
        var n = t.ngIf;
        ae(3), Zh(n.title), ae(), ec("src", n.image, Ji), ec("alt", n.title), ae(3), At(" ", n.description, " ");
      }
    }
    var Z$ = [{
        path: "",
        component: HU
      }, {
        path: "round",
        component: q$
      }, {
        path: "results",
        component: function (_e73) {
          var e = /*#__PURE__*/function () {
            function e(n) {
              var _this119 = this;
              _classCallCheck(this, e);
              this.config = n, this.game = w(Wr), this.inputService = w(Ys), this.outputService = w(Bc), this.guess = this.game.guess, this.score = this.game.score, this.answerCard = this.game.lastAnswerCard, this.earnedPoints = Pn(function () {
                var r = _this119.game.guess();
                return 1 === r ? _this119.config.pointsPerInitialCorrectAnswer : 2 === r ? _this119.config.pointsPerSubsequentCorrectAnswer : 0;
              }), this.starImages = Pn(function () {
                var r = _this119.game.guess();
                return [0, 1, 2].map(function (o) {
                  return o < 3 - r + 1 ? {
                    src: "images/star-on.png",
                    opacity: 100
                  } : {
                    src: "images/star-off.png",
                    opacity: 25
                  };
                });
              }), this.game.score.set(this.game.score() + this.earnedPoints());
            }
            return _createClass(e, [{
              key: "ngOnInit",
              value: function ngOnInit() {
                var _this120 = this;
                this.outputService.startBlinkingPin0(), this.inputSub = this.inputService.actions$.subscribe(function (n) {
                  if ("play" === n) {
                    if (_this120.game.round() >= _this120.config.totalRounds) return void _this120.game.end();
                    _this120.game.nextRound();
                  }
                });
              }
            }, {
              key: "ngOnDestroy",
              value: function ngOnDestroy() {
                this.inputSub.unsubscribe(), this.outputService.setPinsToZero();
              }
            }]);
          }();
          _e73 = e;
          _e73.ɵfac = function (r) {
            return new (r || _e73)(S(ug));
          };
          _e73.ɵcmp = Nt({
            type: _e73,
            selectors: [["app-results"]],
            decls: 12,
            vars: 4,
            consts: [[1, "absolute", "inset-0"], [1, "mt-[6vh]", "flex", "justify-center"], ["class", "px-[1.125vh]", 4, "ngFor", "ngForOf"], [1, "font-8-bit", "text-[6.75vh]", "text-primary", "uppercase", "text-center", "leading-[1.0]", "my-[2vh]"], [1, "font-8-bit", "text-[3vh]", "text-white", "uppercase", "text-center", "leading-[1]", "my-[1vh]"], ["class", "mt-[5vh] flex px-[2.5vh] py-[1vh] gap-[3.375vh]", 4, "ngIf"], [1, "px-[1.125vh]"], ["alt", "", 1, "h-[5.625vh]", 3, "src"], [1, "mt-[5vh]", "flex", "px-[2.5vh]", "py-[1vh]", "gap-[3.375vh]"], [1, "w-1/2"], [1, "text-[3vh]", "uppercase", "mb-[1vh]", "leading-[1.2]"], [1, "border-[0.84375vh]", "border-white", "shadow-[0.75vh_0.75vh_0_0.375vh_rgba(0,0,0,0.20)]", "w-full", "transform", "rotate-[-5deg]", 3, "src", "alt"], [1, "text-[2.25vh]"]],
            template: function template(r, o) {
              1 & r && (O(0, "div", 0)(1, "main"), pe(2, "app-header"), O(3, "div", 1), kn(4, G$, 2, 3, "div", 2), N(), O(5, "div", 3), W(6), N(), O(7, "div", 4), W(8), N(), kn(9, W$, 8, 4, "div", 5), pe(10, "app-play-again"), N(), pe(11, "app-footer"), N()), 2 & r && (ae(4), xe("ngForOf", o.starImages()), ae(2), At(" ", 1 === o.guess() ? "Nice!" : 2 === o.guess() ? "Correct" : "Good Guess", " "), ae(2), At(" ", o.earnedPoints() ? "You earned ".concat(o.earnedPoints(), " points") : "You earned no points", " "), ae(), xe("ngIf", o.answerCard()));
            },
            dependencies: [yM, wg, Eg, Vc, HM, $M],
            encapsulation: 2
          });
          return e;
        }()
      }, {
        path: "end",
        component: function (_e74) {
          var e = /*#__PURE__*/function () {
            function e(n, r) {
              _classCallCheck(this, e);
              this.audio = n, this.config = r, this.game = w(Wr), this.inputService = w(Ys), this.outputService = w(Bc), this.score = this.game.score, this.perfectScore = this.config.totalRounds * this.config.pointsPerInitialCorrectAnswer, this.audio.play("audio/game-end.mp3");
            }
            return _createClass(e, [{
              key: "ngOnInit",
              value: function ngOnInit() {
                var _this121 = this;
                this.outputService.startBlinkingPin0(), this.inputSub = this.inputService.actions$.subscribe(function (n) {
                  "play" === n && _this121.game.reset();
                });
              }
            }, {
              key: "ngOnDestroy",
              value: function ngOnDestroy() {
                this.inputSub.unsubscribe(), this.outputService.setPinsToZero();
              }
            }]);
          }();
          _e74 = e;
          _e74.ɵfac = function (r) {
            return new (r || _e74)(S(cg), S(ug));
          };
          _e74.ɵcmp = Nt({
            type: _e74,
            selectors: [["app-end"]],
            decls: 15,
            vars: 5,
            consts: [[1, "absolute", "inset-0"], [1, "mt-[12vh]", "flex", "justify-center", "h-[24vh]", "items-end", "relative"], ["src", "images/trophy_shadow.gif", "alt", "", 1, "absolute", "left-1/2", "-translate-x-1/2", "bottom-0", "h-[24vh]", "opacity-25", "max-w-none"], ["src", "images/trophy.gif", "alt", "", 1, "relative", "min-h-[12vh]"], [1, "font-8-bit", "text-[5vh]", "px-[4vh]", "text-primary", "uppercase", "text-center", "leading-[1.0]", "my-[3vh]"], [1, "font-8-bit", "text-[12vh]", "text-primary", "uppercase", "text-center", "leading-[0.8]", "text-white"], [1, "font-8-bit", "text-[3vh]", "text-white", "uppercase", "text-center", "leading-[1.25]", "my-[2vh]"]],
            template: function template(r, o) {
              1 & r && (O(0, "div", 0)(1, "main")(2, "div", 1), pe(3, "img", 2)(4, "img", 3), N(), O(5, "div", 4), W(6), N(), O(7, "div", 5), W(8), N(), O(9, "div", 6), W(10, " Out of a possible"), pe(11, "br"), W(12), N(), pe(13, "app-play-again"), N(), pe(14, "app-footer"), N()), 2 & r && (ae(4), qu("height", o.score() / 100 * 24 + "vh"), ae(2), At(" ", o.score() === o.perfectScore ? "Perfect Score!" : o.score() >= .7 * o.perfectScore ? "Pretty Good!" : "Better Luck Next Time!", " "), ae(2), At(" ", o.score(), " "), ae(4), At("", o.perfectScore, " points "));
            },
            dependencies: [Vc, $M],
            encapsulation: 2
          });
          return e;
        }()
      }],
      Y$ = {
        providers: [function pL(e) {
          var t = e === null || e === void 0 ? void 0 : e.ignoreChangesOutsideZone,
            n = e === null || e === void 0 ? void 0 : e.scheduleInRootZone,
            r = rp({
              ngZoneFactory: function ngZoneFactory() {
                var o = op(e);
                return o.scheduleInRootZone = n, o.shouldCoalesceEventChangeDetection && wt("NgZone_CoalesceEvent"), new ee(o);
              },
              ignoreChangesOutsideZone: t,
              scheduleInRootZone: n
            });
          return wn([{
            provide: hL,
            useValue: !0
          }, {
            provide: ki,
            useValue: !1
          }, r]);
        }({
          eventCoalescing: !0
        }), function RU(e) {
          for (var _len12 = arguments.length, t = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
            t[_key12 - 1] = arguments[_key12];
          }
          return wn([{
            provide: ng,
            multi: !0,
            useValue: e
          }, [], {
            provide: ai,
            useFactory: Qb,
            deps: [or]
          }, {
            provide: Ds,
            multi: !0,
            useFactory: Yb
          }, t.map(function (n) {
            return n.ɵproviders;
          })]);
        }(Z$, function OU(e) {
          return function gn(e, t) {
            return {
              ɵkind: e,
              ɵproviders: t
            };
          }(5, [{
            provide: jc,
            useValue: e
          }]);
        }({
          onSameUrlNavigation: "reload"
        })), {
          provide: Gb,
          useClass: /*#__PURE__*/function () {
            function Q$() {
              _classCallCheck(this, Q$);
            }
            return _createClass(Q$, [{
              key: "shouldDetach",
              value: function shouldDetach() {
                return !1;
              }
            }, {
              key: "store",
              value: function store() {}
            }, {
              key: "shouldAttach",
              value: function shouldAttach() {
                return !1;
              }
            }, {
              key: "retrieve",
              value: function retrieve() {
                return null;
              }
            }, {
              key: "shouldReuseRoute",
              value: function shouldReuseRoute(t, n) {
                return t.routeConfig === n.routeConfig && t.url.toString() !== n.url.toString();
              }
            }]);
          }()
        }, function k$() {
          var t = [RM, LM, PM, {
            provide: Kc,
            useExisting: PM
          }, {
            provide: Xc,
            useFactory: function useFactory() {
              var _w8;
              return (_w8 = w(xM, {
                optional: !0
              })) !== null && _w8 !== void 0 ? _w8 : w(LM);
            }
          }, {
            provide: ta,
            useValue: x$,
            multi: !0
          }, {
            provide: Ag,
            useValue: !0
          }, {
            provide: BM,
            useClass: A$
          }];
          for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            e[_key13] = arguments[_key13];
          }
          for (var _i22 = 0, _e75 = e; _i22 < _e75.length; _i22++) {
            var n = _e75[_i22];
            t.push.apply(t, _toConsumableArray(n.ɵproviders));
          }
          return wn(t);
        }()]
      };
    var J$ = function (_e76) {
      var e = /*#__PURE__*/function () {
        function e() {
          var _this122 = this;
          _classCallCheck(this, e);
          this.inputService = w(Ys), this.game = w(Wr), this.timeoutId = null, this.timeoutDuration = 18e4, this.inputService.actions$.subscribe(function () {
            return _this122.resetTimer();
          }), this.startTimer();
        }
        return _createClass(e, [{
          key: "startTimer",
          value: function startTimer() {
            var _this123 = this;
            this.clearTimer(), this.timeoutId = setTimeout(function () {
              _this123.game.reset();
            }, this.timeoutDuration);
          }
        }, {
          key: "resetTimer",
          value: function resetTimer() {
            this.startTimer();
          }
        }, {
          key: "clearTimer",
          value: function clearTimer() {
            this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null);
          }
        }]);
      }();
      _e76 = e;
      _e76.ɵfac = function (r) {
        return new (r || _e76)();
      };
      _e76.ɵprov = b({
        token: _e76,
        factory: _e76.ɵfac,
        providedIn: "root"
      });
      return e;
    }();
    (function rV(e, t) {
      return UL(_objectSpread({
        rootComponent: e
      }, k_(t)));
    })(function (_e77) {
      var e = /*#__PURE__*/_createClass(function e(n) {
        _classCallCheck(this, e);
        this.inactivity = n, this.title = "Guess That Technology Sound Game";
      });
      _e77 = e;
      _e77.ɵfac = function (r) {
        return new (r || _e77)(S(J$));
      };
      _e77.ɵcmp = Nt({
        type: _e77,
        selectors: [["app-root"]],
        decls: 2,
        vars: 0,
        consts: [[1, "min-h-screen", "bg-secondary", "text-white"]],
        template: function template(r, o) {
          1 & r && (O(0, "div", 0), pe(1, "router-outlet"), N());
        },
        dependencies: [Zp],
        encapsulation: 2
      });
      return e;
    }(), Y$).catch(function (e) {
      return console.error(e);
    });
  },
  936: function _(hi) {
    hi.exports = require("@brightsign/legacy/controlport");
  }
}, function (hi) {
  hi(hi.s = 808);
}]);